export default {
    labels: {
        clear: 'Κενό',
        refresh: 'Ανανέωση',
        nextStep: 'Επόμενο βήμα',
        prevStep: 'Προηγούμενο βήμα',
        closeDriver: 'Έξοδος εκκίνησης',
        complete: 'Ολοκληρώθηκε',
        viewStatistics: 'Προβολή στατιστικών',
        colon: '：',
        splitter: '/',
        remark: 'Παρατηρήσεις',
        correction: 'Διόρθωση σφάλματος',
        save: 'Αποθήκευση',
        reset: 'Επαναφοράς',
        increase: 'Προσθήκη',
        preview: 'Προεπισκόπησης',
        unit: 'Άρθρο',
        cancel: 'Ακύρωση',
        all: 'Όλα',
        searchPlaceHolder: 'Εισάγετε ερώτηση λέξεων κλειδιά',
        greaterThan: 'Μεγαλύτερο',
        lessThan: 'Λιγότερα',
        second: 'Δευτερόλεπτα',
        description: 'Περιγραφή',
        column: 'Στήλη',
        pleaseChoice: 'Παρακαλώ επιλέξτε.',
        filter: 'Φίλτρος',
        saveAndSubmit: 'Αποθήκευση και υποβολή',
        submit: 'Υποβολή',
        appeal: 'Καταγγελία',
        review: 'Αναθεώρηση',
        choose: 'Επιλογή',
        manage: 'Διαχείριση',
        delete: 'Διαγραφή',
        add: 'Νέο',
        create: 'Νέο',
        edit: 'Επεξεργασία',
        name: 'Όνομα',
        describe: 'Περιγραφή',
        next: 'Επόμενο βήμα',
        percent: '%',
        export: 'Εξαγωγή',
        exportAll: 'Εξαγωγή όλους',
        confirm: 'Προσδιορίστε την ένδειξη αυτών',
        back: 'Επιστροφή',
        versionUpdate: 'Χαίρομαι που σας ενημερώνω ότι η ιστοσελίδα μας μόλις κυκλοφόρησε μια νέα έκδοση! Για να εξασφαλιστεί η κανονική σας χρήση, θέλουμε να σώσετε την τρέχουσα δουλειά σας αμέσως. και στη συνέχεια ανανεώστε τη σελίδα (κάντε κλικ στο κουμπί ανανέωσης του προγράμματος περιήγησης, ή πατήστε το πλήκτρο F5) να κάνουμε τη νέα μας έκδοση να ισχύει. Σας ευχαριστώ πολύ για τη συνεργασία σας!',
        more: 'Περισσότερα.',
        selected: 'Επιλεγμένα',
        deduct: 'Πόρπη',
        maxScore: 'Περισσότεροι',
        scoreUnit: 'Σημεία',
        pointUnit: 'Ένας',
        comma: '，',
        view: 'Προβολή',
        batchingImport: 'Εισαγωγή',
        deleteContent: 'Είστε σίγουροι ότι θέλετε να το διαγράψετε; Δεν μπορείτε να την επαναφέρετε μετά τη διαγραφή',
        import: 'Εισαγωγή',
        uploadFile: 'Αποστολή αρχείου',
        downloadFile: 'Εξαγωγή αρχείου',
        upload: 'Αποστολής',
        click: 'Κλικ',
        downloadTemplate: 'Πρότυπο λήψης',
        fillInTheForm: 'Συμπλήρωση ανά μορφή',
        UploadExcelfile: 'Αποστολή Excel για να ολοκληρώσετε την εισαγωγή παρτίδας',
        uploadIdentical: 'Αν υπάρχει το όνομα API, τα υπάρχοντα δεδομένα στο σύστημα θα ενημερωθούν κατά την εισαγωγή.',
        numOne: '1',
        numTwo: '2',
        numThree: '3',
        apply: 'Εφαρμόζεται',
        leftBracket: '(',
        rightBracket: ')',
        question: 'Ερώτηση',
        answer: 'Απάντηση',
        content: 'Περιεχόμενο',
        search: 'Αναζήτησης',
        query: 'Ερώτηση',
        cancelEdit: 'Ακύρωση επεξεργασίας',
        noValue: 'Χωρίς δεδομένα',
        selectAll: 'Επιλογή όλων',
        changeAGroup: 'Τροποποίηση μιας ομάδας',
        arrow: ' ---> ',
        saveReview: 'Αναθεώρηση υποβολής',
        saveSpotCheck: 'Επιθεώρηση δειγματοληψίας και υποβολή',
        rapidSampling: 'Γρήγορη δειγματοληψία',
        file: 'Αρχειοθετήσεις',
        download: 'Λήψης',
        lastPage: 'Προηγούμενη σελίδα:',
        nextPage: 'Επόμενη σελίδα',
        batchActions: 'Λειτουργία παρτίδας',
        cancelDistribution: 'Μη αναστολής',
        againDistribution: 'Επαναθεωρήση',
        deleteRecord: 'Διαγραφή εγγραφής',
        oneOptionOpertor: 'Προαιρετικός επιθεωρητής ποιότητας',
        allOptionOpertor: 'Όλοι οι επιθεωρητές ποιότητας',
        distributionInfoFirstOne: 'Επιβεβαίωση',
        distributionInfoFirstTwo: 'Θέλεις να μεταθέσεις αρχεία; Παρακαλώ επιλέξτε έναν στόχο ανάθεσης.',
        distributionInfoSecondOne: 'OK να ακυρώσετε την αίτηση για ακύρωση.',
        distributionInfoSecondTwo: 'Είναι η πληροφόρηση αυτού του αρχείου; Μετά την ακύρωση, θα γίνει ένα μη αναθεωρημένο αρχείο αναθεώρησης.',
        distributionInfoSecondThree: 'Είναι η πληροφορία εκχώρησης αυτής της εγγραφής, θα γίνει μη ανατεθειμένη δειγματοληψία μετά την ακύρωση.',
        distributionInfoThirdOne: 'Οι επιλεγμένες εγγραφές έχουν',
        distributionInfoThirdTwo: 'Τα αναθεωρημένα αρχεία δεν θα επεξεργαστούν.',
        distributionInfoThirdThree: 'Τα αρχεία που έχουν υποβληθεί σε δειγματοληψία δεν θα επεξεργαστούν.',
        exportError: 'Η εξαγωγή απέτυχε',
        exportSuccess: 'Εξαγωγή',
        deleteRecordInfo: 'Επιθυμείτε σίγουρα τη διαγραφή του {0} εγγραφών; Τα δεδομένα δεν μπορούν να ανακτηθούν μετά τη διαγραφή',
        pleaseSetFilter: 'Παρακαλώ επιλέξτε κριτήρια φίλτρου',
        noCountAfterFilter: 'Χωρίς δεδομένα εξαγωγής, παρακαλώ επαναφέρετε τα κριτήρια φίλτρου',
        redo: 'Επανεκτέλεση',
        batchMove: 'Μετακίνηση παρτίδας',
        websiteName: 'Ευφυής επιθεώρηση ποιότητας',
        salesEnable: 'Ενίσχυση των πωλήσεων',
        systemName: 'Ευφυής επιθεώρηση ποιότητας',
        initSystemError: 'Εξαίρεση δικτύου ή αποτυχία αρχικοποίησης σελίδας, παρακαλώ επικοινωνήστε με την εξυπηρέτηση πελατών',
        day: 'Ημέρα',
        hour: 'Ώρες',
        minute: 'Σημεία',
        questionMark: '？',
        personalSettings: 'Προσωπικές ρυθμίσεις',
        logout: 'Διαγραφή',
        ok: 'Προσδιορίστε την ένδειξη αυτών',
        saveAs: 'Αποθήκευση',
        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
        executeMessage: {
            executeSuccess: '{0} εκτελέστηκε με επιτυχία.',
            executeError: 'Αποτυχία εκτέλεσης του {0}',
        },
        field: 'Πεδίο',
        operator: 'Αερομεταφορέας',
        value: 'Αξία',
        placeholder: 'Παρακαλώ επιλέξτε.',
        pleaseSelect: 'Παρακαλώ επιλέξτε.',
        totalScore: 'Συνολική βαθμολογία',
        hyphen: '-',
        semicolon: '；',
        wfm: 'Ευφυής προγραμματισμός',
        user: 'Χρήστης',
        none: 'Κανένα',
        plusSign: '+',
        minusSign: '-',
        saveSuccessAndReload: 'Αποθήκευση με επιτυχία! Αποτελεσματικό μετά την ανανέωση του σχετικού εργαζομένου σελίδα',
        saveAsName: '{0}( Αντίγραφο)',
        systemInformation: 'Προβολή δεδομένων συστήματος',
        billingCenter: 'Κέντρο τιμολόγησης',
        financeCenter: 'Οικονομική διαχείριση',
        warningMessage: 'Η υπόλοιπη ποσόστωση είναι ανεπαρκής, παρακαλούμε επαναφόρτιση το συντομότερο δυνατό',
        fileTypeHolder: 'Η μορφή αρχείου είναι λανθασμένη. Παρακαλώ ανεβάστε ένα αρχείο σε μορφή {0}.',
        dataNo: 'Χωρίς δεδομένα',
        move: 'Μετακίνηση',
        study: 'Έχετε μη σηματοδοτημένα σημεία επιθεώρησης αυτο-μαθητείας',
        studySuccess: 'Επιτυχία επισήμανσης',
        studyError: 'Η επισήμανση απέτυχε',
        editType: 'Επεξεργασία ετικέτων κατηγορίας',
        copyed: 'Αντιγραφή στο πρόχειρο',
        clickToCopy: 'Κάντε κλικ στην αντιγραφή',
        addFilterConditions: 'Προσθήκη κατάστασης φίλτρου',
        filterConditions: 'Κατάσταση φίλτρου',
        messageTime: 'Ώρα μηνύματος',
        messageType: 'Τύπος μηνύματος',
        pushType: 'Κανάλι μηνύματος',
        messageContent: 'Περιεχόμενο μηνύματος',
        messageName: 'Όνομα μηνύματος',
        messageStatus: 'Κατάσταση μηνύματος',
        configuration: 'Πληροφορίες ρυθμίσεων',
        sendTarget: 'Αποστολή προορισμού',
        guideUrl: 'Εκκίνηση URLName',
        noticeDetail: 'Λεπτομέρειες μηνύματος',
        action: 'Λειτουργία',
        seeDetail: 'Λεπτομέρειες προβολής',
        theDay: 'Ημέρα {0}',
        theLastDayOfMonth: 'Η τελευταία μέρα κάθε μήνας',
        ignore: 'Αγνόηση',
        seeNow: 'Προβολή τώρα',
        exportConfirmText: {
            export: 'Ένα σύνολο {0} τεμάχια δεδομένων, επιβεβαιώνεται για εξαγωγή;',
            exportAll: 'Επιβεβαίωση εξαγωγής όλου του περιεχομένου;',
        },
        samrTagAdd: 'Προσθήκη ετικέτες',
        deletePopconfirmContent: 'Επιθυμείτε σίγουρα τη διαγραφή;',
        TheLastThirtyDays: 'Τελευταίες 30 ημέρες',
        addNumber: 'Συν.',
        subNumber: 'Μείονς',
        addStrategy: 'Πολιτική προσθήκης',
        minutes: 'Πρακτικά',
        status: 'Ενεργοποιημένη κατάσταση',
        pushConfig: 'Ρύθμιση push',
        category: 'Ταξινόμηση',
        and: 'Με τη μηχανή',
        interval: 'Χρονικό διάστημα',
        switchOn: 'Άνοιγμα:',
        switchOff: 'Κλείσιμο',
        batchDel: 'Διαγραφή παρτίδας',
        exportTxt: 'Εξαγωγή κειμένου TXT',
        playSpeed: 'Διπλή ταχύτητα',
        messageLogBtn: 'Δείτε κοινοποιήσεις/συνομιλίες που ενεργοποιούν τις κοινοποιήσεις',
        dataLink: 'Σύνδεση δεδομένων',
        yes: 'Μάλιστα.',
        no: 'Οχι',
        sentenceUnit: 'Ποινή',
        appealDetail: 'Λεπτομέρειες καταγγελίας',
        detail: 'Λεπτομέρειες',
        default: 'Προκαθορισμένο',
        customer: 'Πελάτη',
        agent: 'Υπηρεσία πελατών',
        sort: 'Ταξινόμηση',
        applyNow: 'Εφαρμογή',
        index: 'Αύξων αριθμός',
        allColumns: 'Στήλες που μπορούν να προστεθούν.',
        selectedColumns: 'Προστιθέμενες στήλες',
        syn: 'Συγχρονισμός',
        saveAndNext: 'Αποθήκευση και δημιουργία επόμενου',
        viewReference: 'Προβολή αναφορών',
        referenceDetail: 'Στοιχεία αναφοράς',
        goToQaList: 'Πηγαίνετε στην επιθεώρηση ποιοτικού ελέγχου',
        goToCheck: 'Πήγαινε σε έλεγχο',
        businessCard: 'Επαγγελματική κάρτα',
        weapp: 'Μικρό πρόγραμμα',
        redpacket: 'Κόκκινο φάκελο',
        externalRedpacket: 'Ανταλλαγή κόκκινων φακέλων',
        sphfeed: 'Αριθμός βίντεο',
        exportTaskCreated: 'Η εξαγωγή εργασιών δημιουργήθηκε με επιτυχία',
        plzGoTo: 'Παρακαλώ πήδα.',
        importTaskCreated: 'Η εργασία εισαγωγής δημιουργήθηκε με επιτυχία',
        taskCreated: 'Η εργασία δημιουργήθηκε με επιτυχία',
        reply: 'Απάντηση',
        replied: 'Απάντηση',
        release: 'Δημοσίευση:',
        expandMore: 'Ανάπτυξη άλλων απαντήσεων {0}',
        comment: 'Παρατηρήσεις',
    },
    business: {
        notifyMessage: {
            IsNullErrorFormat: 'Παρακαλώ έχετε τουλάχιστον ένα {0}',
            canNotBeEmptyFormat: 'Το {0} δεν μπορεί να είναι κενό',
            repeatErrorTipFormat: 'Το {0} έχει αντίγραφα',
            getInformationFailedFormat: 'Αποτυχία λήψης πληροφοριών {0}, παρακαλώ ελέγξτε τη σύνδεση του δικτύου σας ή δοκιμάστε ξανά αργότερα.',
            deleteSuccessFormat: 'Το {0} διαγράφηκε επιτυχώς.',
            deleteFailedFormat: '{0} απέτυχε τη διαγραφή. Παρακαλώ δοκιμάστε ξανά αργότερα.',
            saveSuccessFormat: '{0} αποθηκευμένη με επιτυχία.',
            saveFailedFormat: '{0} απέτυχε την αποθήκευση. Παρακαλώ δοκιμάστε ξανά αργότερα.',
            fileSuccessFormat: '{0} αρχειοθετήθηκε με επιτυχία.',
            fileFailedFormat: '{0} αρχειοθέτηση απέτυχε. Παρακαλώ δοκιμάστε ξανά αργότερα.',
            exportSuccessFormat: '{0} εξαγωγή',
            exportFailedFormat: '{0} εξαγωγή απέτυχε. Παρακαλώ δοκιμάστε ξανά αργότερα.',
            submitSuccessFormat: '{0} υποβλήθηκε με επιτυχία.',
            submitFailedFormat: '{0} απέτυχε η υποβολή, παρακαλώ δοκιμάστε ξανά αργότερα.',
            confirmSuccessFormat: 'Η επιβεβαίωση {0} ήταν επιτυχής.',
            confirmFailedFormat: 'Η επιβεβαίωση {0} απέτυχε. Παρακαλώ δοκιμάστε ξανά αργότερα.',
            pleaseUploadFile: 'Παρακαλώ ανεβάστε το αρχείο πρώτα!',
            importFileSuccess: 'Επιτυχής εισαγωγή αρχείου!',
            importFildFailed: 'Αποτυχία εισαγωγής αρχείου!',
            deleteSuccess: 'Διαγραφή επιτυχώς!',
            deleteFailed: 'Αποτυχία διαγραφής, παρακαλώ προσπαθήστε ξανά αργότερα!',
            illegalTitle: 'Ανεπαρκές άδειες',
            illegalMessage: 'Δεν έχετε κάποιες ή όλες τις άδειες για το επόμενο βήμα, παρακαλώ επικοινωνήστε με τον διαχειριστή για τη ρύθμιση, Κάντε κλικ στο κουμπί OK θα βγει από την εκκίνηση',
            illegalMessageCurrent: 'Δεν έχετε κάποιες ή όλες τις άδειες για το τρέχον βήμα, παρακαλώ επικοινωνήστε με τον διαχειριστή για τη ρύθμιση, Κάντε κλικ στο κουμπί OK θα βγει από την εκκίνηση',
            skipMessage: 'Αν θέλετε να παραλείψετε αυτό το βήμα προς το παρόν, κάντε κλικ στο Παραλίγο',
            errorMsg500: 'Η αίτηση εξυπηρετητή απέτυχε, παρακαλώ ελέγξτε τη λειτουργία σας ή ανανέωση και δοκιμάστε ξανά.',
            errorMsg404: 'Η σελίδα που ψάχνετε λείπει.',
            errorMsg400: 'Η αίτηση εξυπηρετητή απέτυχε, παρακαλώ ελέγξτε τα δεδομένα σας και δοκιμάστε ξανά.',
            pageOverFlow: 'Επί του παρόντος, μπορούν να εμφανιστούν μόνο 10000 ράβδοι. Παρακαλώ ορίστε τα κριτήρια φιλτραρίσματος για να δείτε την περίσσεια.',
            isHandAddSmartTag: 'Είναι μια χειροκίνητα προστίθεται έξυπνη ετικέτας',
            defaultGradeMustAtLast: 'Η προκαθορισμένη αξιολόγηση πρέπει να τοποθετηθεί στο τέλος του τέλους.',
            AutomaticAllocationInspectorsIsNull: 'Παρακαλούμε εισάγετε τη σελίδα βασικών πληροφοριών για να προσθέσετε την ποιότητα επιθεωρητή',
            timePickerTips: 'Για να μην επηρεάσουν την κανονική σας χρήση, 23:00~2:00 είναι ο χρόνος συντήρησης του συστήματος, δεν εκτελούν προγραμματισμένες εργασίες.',
            batchDeleteInfo: 'Οι καταχωρήσεις {0} διαγράφηκαν και οι καταχωρήσεις {1} απέτυχαν επειδή τα δεδομένα έχουν χρησιμοποιηθεί.',
            batchDeleteTips: 'Ελέγξτε {0} κομμάτια δεδομένων, επιβεβαίωση διαγραφής;',
            correctionSuccess: 'Επιτυχία διόρθωσης σφάλματος',
        },
        pages: {
            qualityInspectionForm: {
                list: {
                    IsMaxFormNumberError: 'Προσθέστε μέχρι 10 έντυπα επιθεώρησης ποιότητας',
                },
                specialProject: {
                    sumOfScoresErrorTip: 'Τα μετρικά αντικείμενα {0} πρέπει να προσθέσουν μέχρι 100.',
                    banProjectMaxErrorTip: 'Προσθήκη μέχρι 2000 απαγορευμένα αντικείμενα',
                    deadlyProjectMaxErrorTip: 'Προσθέστε μέχρι και 500 θανατηφόρα αντικείμενα',
                },
            },
        },
        info: {
            creatSuccess: 'Δημιουργήθηκε επιτυχώς.',
            creatError: 'Αποτυχία δημιουργίας',
            editSuccess: 'Επιτυχία τροποποίησης',
            editError: 'Η τροποποίηση απέτυχε',
            deleteSuccess: 'Διαγραφή με επιτυχία',
            addSuccess: 'Νέα Επιτυχία',
            deleteError: 'Η διαγραφή απέτυχε',
            conditionError: 'Σφάλμα λογικής έκφρασης του χειριστή',
            customJudgeLogic: 'Συνδυασμός συνθήκης λογικής έκφρασης σφάλματος συνδυασμού κατάστασης',
            exportError: 'Η εξαγωγή απέτυχε',
            searchError: 'Το φίλτρο απέτυχε',
            loadError: 'Αποτυχία φόρτωσης του {0}',
            saveSuccess: 'Αποθήκευση με επιτυχία',
            saveError: 'Αποτυχία αποθήκευσης',
            fileSuccess: 'Επιτυχία αρχειοθέτησης',
            fileError: 'Το αρχείο απέτυχε',
            cannotBeNull: '{0} δεν μπορεί να είναι κενό!',
            pleaseSearchAndSelect: 'Παρακαλώ εισάγετε μια αναζήτηση λέξεων-κλειδιών',
            clickAndToggle: 'Κάντε κλικ για την επιλογή διακόπτης',
            deleteWarning: '{0} διαγραφή δεν θα ανακτηθεί, είστε σίγουροι ότι θέλετε να συνεχίσετε;',
            getOssAuthFailed: 'Αποτυχία λήψης εξουσιοδότησης του OSS. Ελέγξτε τη σύνδεση του δικτύου ή δοκιμάστε ξανά αργότερα.',
            getInsightAuthFailed: 'Αποτυχία λήψης εξουσιοδότησης Insight. Ελέγξτε τη σύνδεση του δικτύου σας ή δοκιμάστε ξανά αργότερα.',
            pictureUploadFailed: 'Αποτυχία αποστολής εικόνας',
            pictureUploadFailedSize: 'Το μέγεθος της εικόνας υπερβαίνει το όριο, αποστολή εικόνας απέτυχε',
            wecomTagsSyncInfo: 'Τελευταία ενημέρωση: {0}, συγχρονισμός {1} μηνυμάτων',
            collectSuccess: 'Επιτυχία συλλογής.',
        },
    },
    components: {
        common: {
            qcReportEcharts: {
                errorMessage: 'Αποτυχία λήψης δεδομένων αναφοράς',
            },
            waveAudio: {
                noWaveMessage: 'Προκειμένου να διατηρηθεί η εμπειρία σας, η κυματική μορφή δεν θα εμφανιστεί για ηχογραφήσεις άνω των {0} λεπτών. Μπορείς να παίξεις απευθείας.',
            },
            customFilter: {
                del: 'Διαγραφή',
                edit: 'Επεξεργασία',
                new: 'Προσαρμοσμένο φίλτρο',
                apply: 'Εφαρμογή',
                cancel: 'Ακύρωση',
                onlyApply: 'Εφαρμόζονται μόνον',
                ohterSave: 'Αποθήκευση',
                save: 'Αποθήκευση',
                customFilter: 'Κοινό φίλτρο',
                reset: 'Επαναφοράς',
                holderKeyWord: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
                customFilterRule: 'Κανόνες λογικής φίλτρου:',
                customFilterName: 'Όνομα φίλτρου:',
                holderCustomFilterName: 'Παρακαλώ εισάγετε ένα όνομα φίλτρου',
                manualConfiguration: 'Χειροκίνητη ρύθμιση',
                holderCustomRule: 'Παρακαλώ εισάγετε μια προσαρμοσμένη λογική κατάσταση',
                example: 'Παράδειγμα:',
                dragConfiguration: 'Ρυθμίσεις σύρισης και πτώσης',
                condition: 'Κατάσταση',
                operation: 'Λειτουργία',
                infoDel: 'Σύρετε περιεχόμενο από την περιοχή για τη διαγραφή',
                toConfigure: 'Ρύθμιση',
                holderCustomFilterNameLength: 'Το μέγιστο μήκος ενός ονόματος φίλτρου είναι 10',
                customFilterNameNone: 'Το όνομα φίλτρου δεν μπορεί να είναι κενό',
                and: 'Και,',
                or: 'Ή',
                not: 'Άλλα',
                delSuccess: 'Διαγραφή με επιτυχία',
                saveSuccess: 'Αποθήκευση με επιτυχία',
                updateSuccess: 'Επιτυχία τροποποίησης',
                customFilterCondition: 'Κατάσταση φίλτρου',
                conditionRule: 'Κανόνες κατάστασης',
                none: 'Κανένα',
                filterPlaceholder: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
            },
            labelTabs: {
                addThis: 'Προσθήκη σε αυτόν',
                goThis: 'Μετακίνηση σε αυτόν',
                saveGo: 'Αποθήκευση και εκπαίδευση',
            },
            datePicker: {
                today: 'Σήμερα',
                yesterday: 'Χθες το βράδυ.',
                theDayBeforeYesterday: 'Προχθές μέρα.',
                thisWeek: 'Αυτή την εβδομάδα.',
                lastWeek: 'Την περασμένη εβδομάδα.',
                thisMonth: 'Αυτό το μήνα',
                lastMonth: 'Τον περασμένο μήνα.',
                lastSevenDay: 'Τελευταίες 7 ημέρες',
                lastThirtyDay: 'Τελευταίες 30 ημέρες',
                thisQuarter: 'Αυτό το τρίμηνο.',
                lastQuarter: 'Τελευταίο τρίμημα',
                thisYear: 'Φέτος φέτος.',
                lastYear: 'Πέρυσι',
                lastYearFromToday: 'Πέρυσι',
            },
            pagination: {
                page: 'Σελίδα {1} του {0}',
            },
            wechatRecord: {
                loadMoreBtn: {
                    top: 'Φόρτωση προηγούμενων μηνυμάτων',
                    bottom: 'Φόρτωση περισσότερων μηνυμάτων',
                },
            },
        },
        pages: {
            menuTitleList: {
                tasksManageTitle: 'Εργασία επιθεώρησης',
                informationCollectTasksManageTitle: 'Εργασίες συλλογής',
                customerServiceCenterTitle: 'Κέντρο Εξυπηρέτησης Πελατών',
                informationTitle: 'Κέντρο δεδομένων',
                intelligentAnalysisTitle: 'Ευφυής ανάλυση',
                semanticIntelligence: 'Σημασιολογική νοημοσύνη',
                trainingCenterTitle: 'Κέντρο Εκπαίδευσης',
                adminTitle: 'Διαχείριση συστήματος',
            },
            qualityCheckingTask: {
                title: 'Επιθεώρηση ποιότητας κλήσης',
                index: {
                    tipOne: 'Επιθεώρηση ποιότητας κλήσης χρησιμοποιείται για την αξιολόγηση της ποιότητας των εργασιών τηλεφωνικού κέντρου. Μπορείτε να δημιουργήσετε κατάλληλα έντυπα επιθεώρησης ποιότητας με βάση την επιχείρησή σας.',
                    tipTwo: 'Μπορούν να καθοριστούν κατάλληλοι κανόνες για τις εργασίες επιθεώρησης ποιότητας, συμπεριλαμβανομένης της φιλτράρισης και της δειγματοληψίας. Μετά τη βαθμολογία του επιθεωρητή ποιότητας, η εξυπηρέτηση πελατών μπορεί να δει τα αποτελέσματα της ποιότητας επιθεώρησης και περαιτέρω έφεση,',
                    addTaskTitle: 'Προσθήκη εργασίας επιθεώρησης ποιότητας',
                    deleteTipTitle: 'Διαγραφή εργασίας επιθεώρησης ποιότητας',
                    deleteTipContent: 'Οι εργασίες επιθεώρησης ποιότητας δεν μπορούν να αποκατασταθούν μετά τη διαγραφή τους. Επιθυμείτε σίγουρα τη διαγραφή τους;',
                    checkingTask: 'Εργασία επιθεώρησης',
                    checkingTaskList: 'Κατάλογος εργασιών επιθεώρησης ποιότητας',
                    formList: 'Λίστα φόρμας',
                    viewHelpDocuments: 'Προβολή τεκμηρίωσης βοήθειας',
                },
                manage: {
                    taskSetting: {
                        title: 'Ρυθμίσεις εργασιών',
                        form: 'Μορφή',
                        basicInfo: 'Βασικές πληροφορίες',
                        visibleRange: 'Ορατό εύρος',
                        visibleRangeTip: 'Η επιλεγμένη εξυπηρέτηση πελατών και η ομάδα εξυπηρέτησης πελατών μπορούν να δουν την ποιοτική επιθεώρηση. Επιπλέον, ο επικεφαλής της ομάδας εξυπηρέτησης πελατών, εξυπηρέτησης πελατών και επιθεωρητής ποιότητας μπορούν να συνδυαστούν με τις ρυθμίσεις άδειας για αυτό το έργο.',
                        automaticSampling: 'Αυτόματη δειγματοληψία',
                        automaticSamplingTip: 'Μπορείτε να θέσετε αυτόματους κανόνες δειγματοληψίας, έτσι ώστε το σύστημα να προσθέτει περιοδικά εργασίες επιθεώρησης ποιότητας σύμφωνα με τους κανόνες που θέτετε, Όπως το 5% των κλήσεων της περασμένης εβδομάδας κάθε Δευτέρα.',
                        samplingRate: 'Συχνότητα δειγματοληψίας',
                        samplingTime: 'Χρόνος δειγματοληψίας',
                        samplingRange: 'Εύρος δειγματοληψίας',
                        samplingRule: 'Κανόνες δειγματοληψίας',
                        fillterCondition: 'Κατάσταση φίλτρου',
                        workflow: 'Ροή εργασίας επιθεώρησης ποιότητας',
                        appealsTime: 'Επίτρεψε χρόνο έφεσης',
                        appealsTimeTipOne: 'Μετά την υποβολή βαθμολογίας',
                        appealsTimeTipTwo: 'Μέσα σε λίγες ημέρες',
                        appealsTimeTipThree: 'Σε περίπτωση υπέρβασης του χρόνου προσφυγής, η κατάσταση ελέγχου ποιότητας αρχείου θα μεταβληθεί αυτομάτως σε Επιβεβαιωμένη»',
                        auditTime: 'Χρόνος επεξεργασίας ελέγχου',
                        auditTimeTipOne: 'Μετά την υποβολή καταγγελίας',
                        auditTimeTipTwo: 'Μέσα σε λίγες ημέρες',
                        auditTimeTipThree: 'Μετά την υπέρβαση του χρόνου επεξεργασίας έγκρισης, το αρχείο διατηρεί την αρχική βαθμολογία, και η κατάσταση ελέγχου ποιότητας αλλάζει αυτόματα σε Επιβεβαίωση"',
                        noAppealsMode: 'Καμία λειτουργία παραποίησης',
                        appealsMode: 'Επίτρεψε λειτουργία έφεσης',
                        noAppealsModeImage: 'no-appeal.png',
                        appealsModeImage: 'appeal.png',
                        customerServices: 'Υπηρεσία πελατών',
                        customerServicesGroup: 'Ομάδα εξυπηρέτησης πελατών',
                        surveyList: 'Κατάλογος αξιολόγησης',
                        customFields: 'Προσαρμοσμένα πεδία',
                        fieldConfig: 'Ρύθμιση πεδίουName',
                        from: 'Από:',
                        owner: 'Υπεύθυνο άτομο',
                        inspectorAndReviewerAuthority: 'Αρχή επιθεώρησης ποιοτικού ελέγχου',
                        inspector: 'Επιθεωρητής ποιότητας',
                        reviewer: 'Αξιολογητής',
                        inspectorTip: 'Ο επιθεωρητής μπορεί να σκοράρει.',
                        reviewerTip: 'Ο αναθεωρητής μπορεί να βαθμολογήσει την εργασία.',
                        dataStatisticsAuthority: 'Άδεια στατιστικών δεδομένων',
                    },
                    samplingRecords: {
                        title: 'Αρχεία δειγματοληψίας',
                        manualSampling: {
                            title: 'Δειγματοληψία',
                            fillterCondition: 'Κατάσταση φίλτρου',
                            samplingRule: 'Κανόνες δειγματοληψίας',
                            agent: 'Υπηρεσία πελατών',
                            type: 'Τύπος',
                            result: 'Αποτελέσματα',
                            evaluate: 'Αξιολόγηση',
                            relayNumber: 'Αριθμός ανακοίνωσης',
                            source: 'Πηγή',
                            task: 'Καθήκοντα',
                            queueState: 'Κατάσταση ουράς',
                            callHanger: 'Κλείσε το πάρτι.',
                            queueTime: 'Χρονοανατολική ουράς',
                            talkTime: 'Διάρκεια κλήσης',
                            bellTime: 'Διάρκεια δαχτυλιδιού',
                            recordCountTipOne: 'Σύνολο',
                            recordCountTipTwo: 'Καταγραφή',
                            customerServices: 'Υπηρεσία πελατών',
                            customerServicesGroup: 'Ομάδα εξυπηρέτησης πελατών',
                            surveyList: 'Κατάλογος αξιολόγησης',
                            customFields: 'Προσαρμοσμένα πεδία',
                            fieldConfig: 'Ρύθμιση πεδίουName',
                            defaultFields: 'Προκαθορισμένα πεδία',
                        },
                    },
                    taskList: {
                        title: 'Λίστα εργασιών',
                        index: {
                            batchDelete: 'Διαγραφή παρτίδας',
                            batchSubmit: 'Υποβολή παρτίδας',
                            batchConfirm: 'Επιβεβαίωση παρτίδας',
                            itemFields: 'Διαβάθμιση πεδίου αντικειμένου',
                            categoryFields: 'Πεδίο δευτεροβάθμιας ταξινόμησης',
                            forbidsAndDeadlies: 'Απαγορευμένα και θανατηφόρα αντικείμενα',
                            scoreFieldList: 'Κατάλογος πεδίου βαθμολογίας αντικειμένου',
                            customerName: 'Όνομα πελατών',
                            cellphone: 'Τηλέφωνο',
                            email: 'Ηλεκτρονικό ταχυδρομείο',
                            organization: 'Εταιρεία',
                            description: 'Περιγραφή',
                            tags: 'Ετικέτας',
                            taskUserRole: 'Τρέχον ρόλο χρήστη εργασίας',
                        },
                        workBench: {
                            title: 'Λεπτομέρειες εγγραφής',
                            checkForm: 'Έντυπο επιθεώρησης ποιότητας',
                            waitEvaluate: 'Προς αξιολόγηση',
                            alreadyEvaluate: 'Αξιολογήθηκε',
                            waitSubmit: 'Προς υποβολή',
                            alreadySubmit: 'Υποβολή',
                            waitConfirm: 'Επιβεβαίωση',
                            alreadyConfirm: 'Επιβεβαιώθηκε',
                            waitReview: 'Προς επανεξέταση',
                            alreadyReview: 'Επανεξέταση',
                            alreadyDone: 'Ολοκληρώθηκε',
                            comment: 'Παρατηρήσεις αξιολόγησης',
                            totalScore: 'Συνολική βαθμολογία',
                            score: 'Σημεία',
                            remark: 'Παρατηρήσεις',
                            changeRecords: 'Τροποποίηση εγγραφής',
                            subject: 'Θέμα:',
                            secondLevelScore: 'Βαθμός ΙΙ',
                            deadlyList: 'Θανατηφόρο αντικείμενο',
                            forbidList: 'Απαγορευμένα αντικείμενα',
                            addToCheckTask: 'Προσθήκη στην ποιότητα εργασίας',
                            submitCheckRemark: 'Υποβληθείσα αξιολόγηση επιθεώρησης ποιοτικού ελέγχου',
                            changeCheckRemark: 'Αναθεωρημένη αξιολόγηση ποιοτικού ελέγχου',
                            doneCheckRemark: 'Ολοκληρώθηκε αξιολόγηση επιθεώρησης ποιοτικού ελέγχου',
                            submitCheckReview: 'Υποβλήθηκε για επανεξέταση ποιοτικού ελέγχου',
                            submitCheckAppeal: 'Προσφυγή επιθεώρησης ποιοτικού ελέγχου',
                            saveFlowSuccess: 'Αξιολογήστε την επιτυχία.',
                            saveFlowFailed: 'Η αξιολόγηση απέτυχε, παρακαλώ προσπαθήστε ξανά αργότερα.',
                            FormDetail: 'Λεπτομέρειες φόρμας',
                            callDetail: 'Λεπτομέρειες καταγραφής κλήσεων',
                            sampleCalllogDetail: 'Λεπτομέρειες εγγραφής',
                            appealReasonTip: 'Παρακαλώ εισάγετε λόγο προσφυγής (απαιτείται)',
                            appeal: 'Καταγγελία',
                            appealReason: 'Λόγοι καταγγελίας',
                        },
                    },
                },
            },
            qualityInspectionForm: {
                formformat: '{0} Έντυπο ελέγχου ποιότητας',
                basicInformationTitle: 'Βασικές πληροφορίες',
                indicatorsProjectTitle: 'Αντικείμενο δείκτης',
                specialProjectTitle: 'Ειδικά αντικείμενα',
                totalScore: 'Συνολική βαθμολογία',
                indicatorsName: 'Όνομα δείκτης',
                score: 'Κλάσματα',
                singleScore: 'Βαθμολογία ενός αντικειμένου',
                weight: 'Βάρος',
                maxDeductScore: 'Μέγιστες αφαίρεσης',
                add: 'Αύξηση',
                detail: 'Λεπτομέρειες φόρμας',
                list: {
                    title: 'Έντυπο επιθεώρησης ποιότητας',
                    tipOne: 'Η ρύθμιση ενός έντυπου επιθεώρησης ποιότητας αποτελεί το πρώτο βήμα στην επιθεώρηση ποιότητας. Μπορείτε να ρυθμίσετε την πιο κατάλληλη φόρμα επιθεώρησης ποιότητας με βάση την επιχείρηση της εταιρείας σας.',
                    tipTwo: 'Υποστηρίζουμε μια ποικιλία από μορφές όπως άμεση βαθμολογία, σταθμισμένη βαθμολογία και σημεία έκπτωσης. Συνιστάται να ρυθμίσετε τους κανόνες πριν τους προσθέσετε στο σύστημα.',
                },
                basicInformation: {
                    formTemplate: 'Πρότυπο φόρμας',
                    directScore: 'Άμεση βαθμολογία',
                    weightedScore: 'Βαθμολογία βάρους',
                    deductScore: 'Μειώσεις',
                    directScoreSecondLevel: 'Άμεση αξιολόγηση-επίπεδο 2',
                    weightedScoreSecondLevel: 'Βάρος-Επίπεδο 2',
                    deductScoreSecondLevel: 'Σημεία έκπτωσης-επίπεδο 2',
                    deductScoreImageFileName: 'deduct-score.png',
                    weightedScoreImageFileName: 'weighted-score.png',
                    directScoreImageFileName: 'direct-score.png',
                    deductScoreSecondLevelImageFileName: 'deduct-score-second-level.png',
                    weightedScoreSecondLevelImageFileName: 'weighted-score-second-level.png',
                    directScoreSecondLevelImageFileName: 'direct-score-second-level.png',
                },
                specialProject: {
                    banProject: 'Απαγορευμένα αντικείμενα',
                    banProjectTip: 'Μπορεί να χρησιμοποιηθεί για τον έλεγχο κατά τη διάρκεια της ποιότητας επιθεώρησης. Μπορεί να θεωρηθεί ως παραβίαση ή συμπλήρωμα στα σχόλια χωρίς να επηρεάζει την πραγματική βαθμολογία.',
                    deadlyProject: 'Θανατηφόρο αντικείμενο',
                    deadlyProjectTip: 'Θανατηφόρα αντικείμενα μπορούν να χρησιμοποιηθούν για τον έλεγχο κατά τη διάρκεια της ποιότητας επιθεώρησης. Εάν ελέγχεται ένα μοιραίο αντικείμενο, το έργο επιθεώρησης ποιότητας βαθμολογείται απευθείας 0 βαθμοί.',
                },
            },
            qualityInspectionStatisticalReports: {
                reports: {
                    title: 'Επιθεώρηση ποιότητας κλήσης',
                    entiretyReportTitle: 'Συνολική έκθεση:',
                    serviceGroupReportTitle: 'Έκθεση του ομίλου εξυπηρέτησης πελατών',
                    serviceReportTitle: 'Έκθεση εξυπηρέτησης πελατών',
                    entiretyReport: {
                        pandect: 'Επισκόπηση',
                        contrast: 'Αντίθεση',
                        trend: 'Τάση',
                        analyze: 'Ανάλυση',
                        totalScore: 'Συνολική βαθμολογία',
                        banProject: 'Απαγορευμένα αντικείμενα',
                        deadlyProject: 'Θανατηφόρο αντικείμενο',
                    },
                },
            },
            appealChekingTask: {
                list: {
                    title: 'Κατάλογος αποτελεσμάτων επιθεώρησης ποιοτικού ελέγχου',
                    taskSelectPlaceholder: 'Επιλογή εργασίας ποιότητας',
                    agentSelectPlaceholder: 'Επιλέξτε υπηρεσία πελατών',
                    refresh: 'Ανανέωση',
                    all: 'Όλα',
                    unread: 'Μη αναγνωσμένο',
                    inComplaint: 'Σε Παραπόνιο',
                    reviewed: 'Επανεξέταση',
                    totalScore: 'Γενικές παρατηρήσεις',
                    detail: 'Λεπτομέρειες επιθεώρησης ποιότητας',
                    audioText: 'Ηχογραφημένο κείμενο',
                    callInfo: 'Πληροφορίες κλήσης',
                    ticketInfo: 'Πληροφορίες παραγγελίας εργασίας',
                    wechatInfo: 'Πληροφορίες συνεδρίας',
                    dialogText: 'Κείμενο διαλόγου',
                    dialogInfo: 'Πληροφορίες διαλόγου',
                    customer: 'Πελάτη',
                    agent: 'Υπηρεσία πελατών',
                    none: 'Χωρίς δεδομένα επιθεώρησης ποιότητας',
                    appealSuccess: 'Επιτυχημένη έφεση!',
                    appealFailed: 'Η έφεση απέτυχε, παρακαλώ προσπαθήστε ξανά αργότερα!',
                    pointListIsNull: 'Το σημείο επιθεώρησης της καταγγελίας δεν μπορεί να είναι κενό!',
                    pleaseSelectPoint: 'Παρακαλώ επιλέξτε ένα σημείο επιθεώρησης ποιότητας!',
                    unsupportedFormat: 'Αυτή η μορφή δεν υποστηρίζεται.',
                    shardingInformation: 'Το ακόλουθο είναι κοινόχρηστο {0}',
                    smartTags: 'Έξυπνη ετικέταName',
                    businessRecords: 'Επιχειρηματικά αρχεία',
                    selectedPointsWarning: 'Παρακαλείσθε να ελέγξετε τα στοιχεία επιθεώρησης ποιότητας προς προσφυγή και να προσδιορίσετε τις σχετικές δηλώσεις για τα στοιχεία προσφυγής, και μετά κάντε κλικ στο Υποβολή.',
                    applyReason: 'Λόγοι αναιρέσεως (έως 50 λέξεις)',
                    chatMessageTypes: {
                        all: 'Όλα',
                        text: 'Κείμενο',
                        image: 'Εικόνα',
                        agree: 'Περιεχόμενο συνεδρίας',
                        video: 'Βίντεο',
                        voice: 'Φωνή',
                        file: 'Αρχείο',
                        emotion: 'Έκφραση',
                        link: 'Δεσμός',
                        chatrecord: 'Εγγραφή συνομιλίας',
                        mixed: 'Μικτό μήνυμα',
                        default: 'Μη υποστηριζόμενο μήνυμα',
                        deleteFriend: 'Διαγραφή φίλου',
                        redpacket: 'Κόκκινο φάκελο',
                        card: 'Επαγγελματική κάρτα',
                        disAgree: 'Διαφωνείτε με το περιεχόμενο συζήτησης',
                        weapp: 'Μικρό πρόγραμμα',
                        externalRedpacket: 'Ανταλλαγή κόκκινων φακέλων',
                        meetingVoicevCall: 'Μήνυμα κλήσης',
                        uRL: 'Ιστοσελίδας',
                        replyTimeout: 'Απάντηση',
                        sphfeed: 'Αριθμός βίντεο',
                        chatRecordTitle: 'Εγγραφή συνομιλίας',
                    },
                },
                components: {
                    qualityCheckScore: {
                        totalScore: 'Συνολική βαθμολογία',
                        actualScore: 'Αξιολόγηση',
                        actualGrade: 'Αξιολόγηση',
                        appeal: 'Καταγγελία',
                        remark: 'Χειροκίνητες παρατηρήσεις',
                        none: 'Δεν υπάρχουν λεπτομερή στοιχεία για επιθεώρηση ποιότητας',
                        pointEdit: 'Ταξινόμηση',
                    },
                    changeList: {
                        title: 'Τροποποίηση εγγραφής',
                        user: 'Χρήστης',
                        point: 'Σημείο επιθεώρησης ποιότητας',
                    },
                    relatedRecord: {
                        title: 'Σχετικές αρχείες',
                        qualityList: 'Εργασία επιθεώρησης',
                        none: 'Κανένα',
                        check: 'Προβολή',
                        loadMore: 'Φόρτωσε περισσότερα',
                    },
                },
            },
            grade: {
                title: 'Αξιολόγηση επιθεώρησης ποιότητας',
                subTitle: 'Η βαθμολογία επιθεώρησης ποιότητας χρησιμοποιείται για την ταξινόμηση αντικειμένων επιθεώρησης ποιότητας μετά την ολοκλήρωση της βαθμολογίας επιθεώρησης ποιότητας. Για παράδειγμα, μπορεί να διαμορφωθεί ως μη κατάλληλο εάν είναι μικρότερο από 60, καλό αν είναι μεγαλύτερο από 60, και εξαιρετική αν είναι μεγαλύτερη από 80.',
                list: {
                    up: 'Μετακίνηση πάνω',
                    down: 'Μετακίνηση προς τα κάτι',
                    del: 'Διαγραφή',
                    case: 'Αυτόματη συμμετοχή στη βιβλιοθήκη περίπτωσης',
                    orderCase: 'Προκαθορισμένη βιβλιοθήκη περίπτωσης',
                    info: 'Η προκαθορισμένη αξιολόγηση δεν έχει ταυτόχρονα κριτήρια και δεν μπορεί να διαγραφεί. Εάν οποιαδήποτε από τις ανωτέρω αξιολογήσεις δεν ικανοποιηθεί, θα ληφθεί η αξιολόγηση αθέτησης.',
                    add: 'Προσθήκη αξιολόγησης',
                    save: 'Αποθήκευση',
                    close: 'Ακύρωση',
                    max: 'Η βαθμολογία επιθεώρησης ποιότητας μπορεί να ρυθμιστεί μέχρι 20.',
                    name: 'Χωρίς όνομα',
                    success: 'Αποθήκευση με επιτυχία',
                },
            },
            qualityInspectionList: {
                title: 'Κατάλογος επιθεωρήσεων ποιότητας',
                fastFilter: 'Παραβίαση επιθεώρησης ποιότητας',
                fastFilterTip: 'Ένα χτύπημα στο σύστημα μειωμένου σημείου είναι παραβίαση, και η αστοχία στο σύστημα συν-σημείο είναι παραβίαση.',
                titleWechat: 'Κατάλογος ανάλυσης',
                titleCollect: 'Κατάλογος εξαγορών',
                status: 'Κατάσταση ανάλυσης',
                reQualityInspectionConfig: 'Επιλογές εργασίας',
                pleaseSelectRecheckPoints: 'Παρακαλώ επιλέξτε το σημείο επιθεώρησης ποιότητας που θα εκ νέου υπολογιστεί.',
                beginReQualityInspection: 'Έναρξη εκτέλεσης',
                cancelReQualityInspection: 'Ακύρωση εργασίας',
                reQualityInspection: 'Επανεπιθεώρηση',
                reQualityInspectionWechat: 'Επανεκατευθυντήρια ανάλυση',
                reQualityInspectionUnderWay: 'Επαναληψία επιθεώρησης...',
                reQualityInspectionUnderWayTip: 'Η έξοδος από τη σελίδα μετά το κλείσιμο του παραθύρου δεν επηρεάζει την εργασία.',
                reQualityInspectionDone: 'Ολοκληρώθηκε επανεπιθεώρησης',
                reQualityInspectionDoneTip: 'Η επανεξέταση έχει ολοκληρωθεί με επιτυχία, παρακαλώ κάντε κλικ στο κουμπί επιβεβαίωσης.',
                endReQualityInspection: 'Τερματισμός εργασίας',
                alreadyDoneTip: '{0} ολοκληρώθηκε',
                totalTip: 'Σύνολο {0}',
                endReInspectionSuccess: 'Τέλος εργασίας επανα- ποιότητας',
                closeWindow: 'Κλείσιμο παραθύρου',
                endReInspectionFailed: 'Αποτυχία εργασίας επανα- ποιότητας, παρακαλώ προσπαθήστε ξανά αργότερα!',
                detail: {
                    title: 'Λεπτομέρειες επιθεώρησης ποιότητας',
                    wechatTitle: 'Λεπτομέρειες ανάλυσης',
                    titleCollect: 'Λεπτομέρειες συλλογής',
                    callIndex: 'Σχετική κλήση',
                    textIndex: 'Σχετικές συζητήσεις',
                    fileConfirm: 'Να επιβεβαιώσω την αρχειοθέτηση;',
                    fileConfirmDesc: 'Μετά την αρχειοθέτηση, η βαθμολογία επιθεώρησης ποιότητας δεν μπορεί να επεξεργαστεί. Παρακαλώ επιβεβαιώστε αν θα αρχειοθετήσετε.',
                },
                sysCloumnsContal: 'Διαχείριση πεδίου στήλης συστήματος',
                personCloumnsContal: 'Διαχείριση προσωπικού πεδίου στηλών',
            },
            spotCheckList: {
                title: 'Κατάλογος δειγματοληψίας',
                onlyMyTip: 'Προβολή δειγματοληψίας μου',
                plInspector: 'Παρακαλώ επιλέξτε το προσωπικό δειγματοληψίας.',
                allInspector: 'Προβολή όλων',
                seInspector: 'Δείτε τον καθορισμένο επιθεωρητή δειγματοληψίας',
                myInspector: 'Δείτε μόνο το δικό μου.',
                noInspector: 'Ελέγξτε τον επιθεωρητή δειγματοληψίας',
                detail: {
                    title: 'Στοιχεία δειγματοληψίας',
                },
            },
            reviewList: {
                title: 'Λίστα αναθεώρησης',
                onlyMyTip: 'Δείτε μόνο την κριτική μου',
                plInspector: 'Παρακαλώ επιλέξτε έναν κριτιστή',
                allInspector: 'Προβολή όλων',
                seInspector: 'Προβολή Ορισμένος κριτή',
                myInspector: 'Δείτε μόνο το δικό μου.',
                noInspector: 'Προβολή μη ανατεθειμένου κριτή',
                detail: {
                    title: 'Στοιχεία αναθεώρησης',
                },
            },
            caseBaseList: {
                title: 'Βιβλιοθήκη περίπτωσης',
                del: 'Διαγραφή',
                delTitle: 'Όλο το περιεχόμενο δεν θα αποθηκευτεί μετά τη διαγραφή',
                cancel: 'Ακύρωση',
                actions: 'Λειτουργία',
                seeCaseBase: 'Προβολή κεφαλαίων',
                seeDetail: 'Λεπτομέρειες προβολής',
                edit: 'Επεξεργασία',
                save: 'Αποθήκευση',
                addCaseBase: 'Νέα βιβλιοθήκη περίπτωσης',
                export: 'Εξαγωγή',
                ok: 'Προσδιορίστε την ένδειξη αυτών',
                tip: 'Τυπικά δεδομένα κλήσης και συνομιλίας στη λίστα επιθεώρησης ποιότητας μπορούν να αποθηκευτούν στη βιβλιοθήκη περίπτωση για εύκολη μάθηση και κοινή χρήση.',
                detail: {
                    choiceCaseBase: 'Παρακαλώ επιλέξτε μια υπόθεση.',
                    delCaseBase: 'Διαγραφή περίπτωση',
                    addCaseBase: 'Προσθήκη περίπτωση',
                    successed: 'Αποθήκευση με επιτυχία',
                    info: 'Παρακαλώ αποθήκευση ή ακύρωση του περιεχομένου που επεξεργάζεστε πρώτα.',
                    caseType: 'Παρακαλώ επιλέξτε μια βιβλιοθήκη περίπτωσης που θα συμμετάσχει',
                },
            },
            testSetList: {
                title: 'Σύνολο δοκιμών επιθεώρησης ποιότητας',
                tip: 'Τα δεδομένα που υποβάλλονται σε δειγματοληψία από τον επιθεωρητή ποιότητας θα αποθηκευτούν στο σύνολο δοκιμών επιθεώρησης ποιότητας, η οποία είναι βολικό για τη βελτιστοποίηση της διαμόρφωσης των συνθηκών επιθεώρησης ποιότητας και κανόνων για ορισμένα σφάλματα μηχανών επιθεώρησης σε σύγκριση μετά την επιθεώρηση δειγματοληψίας τι;',
                refresh: 'Ανανέωση',
                reQualityInspectionUnderWay: 'Επαναξιολόγηση της αποστολής...',
                reQualityInspectionUnderWayTip: 'Η έξοδος από τη σελίδα μετά το κλείσιμο του παραθύρου δεν επηρεάζει την εργασία.',
                reQualityInspectionDone: 'Ολοκληρώθηκε επαναξιολόγηση',
                reQualityInspectionDoneTip: 'Η επαναξιολόγηση έχει ολοκληρωθεί με επιτυχία, παρακαλώ κάντε κλικ στο κουμπί Επιβεβαίωσης',
                endReQualityInspection: 'Τερματισμός εργασίας',
                alreadyDoneTip: '{0} ολοκληρώθηκε',
                totalTip: 'Σύνολο {0}',
                endReInspectionSuccess: 'Τέλος αποστολής επαναξιολόγησης',
                closeWindow: 'Κλείσιμο παραθύρου',
                endReInspectionFailed: 'Η εργασία επαναξιολόγησης απέτυχε, παρακαλώ δοκιμάστε ξανά αργότερα!',
                recheckPoint: 'Επαναυπολογίστε τα σημεία επιθεώρησης ποιότητας και την ακρίβεια',
                recheckPointTitle: 'Επιλογές επαναξιολόγησης',
                delete: {
                    reQualityInspectionUnderWay: 'Διαγραφή εργασιών παρτίδας...',
                    reQualityInspectionUnderWayTip: 'Η έξοδος από τη σελίδα μετά το κλείσιμο του παραθύρου δεν επηρεάζει την εργασία.',
                    reQualityInspectionDone: 'Εργασία διαγραφής παρτίδων ολοκληρώθηκε',
                    reQualityInspectionDoneTip: 'Η διαγραφή χύδην ολοκληρώθηκε με επιτυχία, παρακαλώ κάντε κλικ στο κουμπί Επιβεβαίωσης',
                    endReQualityInspection: 'Τερματισμός εργασίας',
                    alreadyDoneTip: '{0} ολοκληρώθηκε',
                    totalTip: 'Σύνολο {0}',
                    endReInspectionSuccess: 'Διαγραφή παρτίδας',
                    closeWindow: 'Κλείσιμο παραθύρου',
                    endReInspectionFailed: 'Η διαγραφή παρτίδας απέτυχε, παρακαλώ δοκιμάστε ξανά αργότερα!',
                },
                reultList: {
                    assessmentTime: 'Τελευταία ώρα αξιολόγησης',
                    assessmentAll: 'Σύνολο εκτίμησης',
                    strip: 'Άρθρο',
                    spot: 'Σημείο',
                    deviation: 'Απόκλιση',
                    accuracyRate: 'Ακρίβεια',
                    info: 'Κανένα αποτέλεσμα αξιολόγησης, παρακαλώ αξιολογήστε.',
                    onlyDeviationInfo: 'Προβολή αρχείων παρεκκλίσεων',
                    againAssessment: 'Επανεξιολόγηση',
                    screen: 'Φίλτρος',
                    batchDelete: 'Αφαίρεση παρτίδας',
                    matching: 'Ταίριασμα',
                    ok: 'Μάλιστα.',
                    noCancel: 'Οχι',
                },
            },
            smartWordsLibrary: {
                title: 'Έξυπνος θησαυρός.',
                tip1: 'Συνώνυμα: χρησιμοποιούνται για τη μείωση της ποσότητας εκπαίδευσης σημασιολογικών ετικετών, παρόμοιες προτάσεις συνώνυμων δεν χρειάζεται να εκπαιδεύονται επανειλημμένα.',
                tip2: 'Επαγγελματικές ονομασίες: μεταγράψτε τη βελτιστοποίηση και τη φυσική γλώσσα κατανόηση βελτιστοποίηση για τα σωστά ουσιαστικά, όπως τα ονόματα της επιχείρησης, ονόματα προϊόντων και λέξεις βιομηχανίας που δεν αναγνωρίζονται ακριβώς για να βελτιώσουν την ακρίβεια αναγνώρισης και την ακρίβεια της ανάλυσης.',
                tip3: 'Εστίαση στις λέξεις: Επικεντρωθείτε στις λέξεις που θέλετε να επικεντρωθείτε στην ανάλυση σύννεφου λέξης για να βοηθήσετε τα hotspots ανάλυσης τεχνητής τεχνητής ικανοποίησης της τρέχουσας επιχείρησης.',
                tip4: 'Μπλοκ λέξεις: Μπλοκάρετε λέξεις στις οποίες δεν θέλετε να δώσετε προσοχή στην ανάλυση σύννεφου λέξης για να βοηθήσετε την AI να αναλύσει καυτό σημείο σύμφωνα με το ρεύμα. Δουλειά.',
                tip5: 'Βάρος λέξης: χρησιμοποιείται για τη διόρθωση και τη βελτιστοποίηση της αναγνώρισης των σημασιολογικών ετικετών. Με την τροποποίηση του βάρους επιρροής των λέξεων σε προτάσεις, το σημασιολογικό αποτέλεσμα αναγνώρισης σε συγκεκριμένα σενάρια μπορεί να βελτιστοποιηθεί όποτε χρειαστεί.',
                tip6: 'Δεδομένα Corpus: Εισάγετε μεγάλες παραγράφους του κειμένου για τα αντίστοιχα επιχειρηματικά σενάρια τους για τη διόρθωση σφαλμάτων και εκπαίδευση ASR για τη βελτίωση της ακρίβειας ανακωδικοποίησης ASR.',
                upload: {
                    uploadSynonymWords: 'Εισαγωγή συνώνυμα',
                    uploadProfessionalWords: 'Εισαγωγή επαγγελματικών όρων',
                    uploadAttentionWords: 'Εισαγωγή λέξεων ενδιαφέροντος',
                    uploadIgnoreWords: 'Εισαγωγή παραβλέψεων λέξεων',
                    uploadWordsWeight: 'Εισαγωγή λέξεων βάρους',
                    uploadTypo: 'Εισαγωγή λέξεων τυπογραφής',
                    uploadCorpusData: 'Εισαγωγή δεδομένων σώματος',
                    uploadCorpusContent: 'Εισαγωγή περιεχομένου δεδομένων σώματος',
                    firstUploadStep: '1. Κατεβάστε το πρότυπο και συμπληρώστε το σύμφωνα με το πρότυπο μορφή',
                    downloadTemplateMessage: 'Πρότυπο λήψης:',
                    firstUploadJSONButton: 'JSON',
                    firstUploadExcelButton: 'EXCEl',
                    firstUploadTxtButton: 'TXT',
                    secondUploadStep: '2. Κάντε κλικ στο κουμπί Εισαγωγή για να ανεβάσετε το αρχείο EXCEl σύμφωνα με το μορφότυπο πρότυπο',
                    secondUploadCorpusDataStep: '2. Κάντε κλικ στο κουμπί Εισαγωγής για να ανεβάσετε το αρχείο TXT που συμμορφώνεται με το πρότυπο.',
                    postUploadDataFail: 'Αποτυχία υποβολής και αποστολής δεδομένων.',
                    pleaseUploadTemplate: 'Παρακαλώ ανεβάστε το αρχείο EXCEl/JSON/TXT',
                    templateNeedJSONOrXLSX: 'Τα πρότυπα αρχείων μπορούν να είναι μόνο σε μορφή JSON ή xlsx',
                    templateNeedTxt: 'Το πρότυπο αρχείο δεδομένων Corpus μπορεί να είναι μόνο ένα αρχείο TXT',
                    uploadSuccess: 'Επιτυχία εισαγωγής',
                    uploadFailed: 'Εισαγωγή απέτυχε',
                    downloadError: 'Αποτυχία λήψης',
                    downLoadTxtTitle: 'Ο Κόρπος υποστηρίζει. Txt',
                },
                navTabNames: {
                    synonymWords: 'Συνώνυμα',
                    professionalWords: 'Επαγγελματική ονομασία',
                    attentionWords: 'Ανησυχητικές λέξεις',
                    ignoreWords: 'Αγνόηση λέξεων',
                    wordsWeight: 'Βάρος λέξης',
                    corpusData: 'Δεδομένα σώματος',
                    typoLibrary: 'Σύνολο λέξης τυπογράφος',
                },
                synonymWords: {
                    createSynonymWords: 'Νέο Συνώνυμο',
                    editSynonymWords: 'Επεξεργασία συνώνυμων',
                    addSynonymWords: 'Προσθήκη συνώνυμος',
                    pleaseEnterStandardWords: 'Παρακαλώ εισάγετε μια τυπική λέξης',
                    synonymWordsExists: 'Το συνώνυμο υπάρχει ήδη και δεν μπορεί να προστεθεί.',
                    synonymWordsCanNotNull: 'Το συνώνυμο που προστέθηκε δεν μπορεί να είναι κενό',
                    pleaseAddSynonymWords: 'Παρακαλώ προσθέστε συνώνυμα',
                    addSuccess: 'Νέα Επιτυχία',
                    editSuccess: 'Επιτυχία τροποποίησης',
                    deleteSuccess: 'Διαγραφή με επιτυχία',
                    deleteError: 'Η διαγραφή απέτυχε',
                    required: '*',
                },
                professionalWords: {
                    create: 'Νέα επαγγελματική ουσία',
                    edit: 'Επαγγελματικό επεξεργαστή ουσιαστικών επεξεργαστή',
                    addTargetWords: 'Προσθήκη αντικατάστασης λέξης',
                    targetWordsExists: 'Η λέξη αντικατάστασης υπάρχει ήδη και δεν μπορεί να προστεθεί.',
                    targetWordsCanNotNull: 'Η λέξη αντικατάστασης που προστίθεται δεν μπορεί να είναι κενή',
                    pleaseAddTargetWords: 'Παρακαλώ προσθέστε μια λέξη αντικατάστασης',
                    pleaseEnter: 'Παρακαλώ εισάγετε έναν επαγγελματικό όρο',
                    wordsExists: 'Ο όρος υπάρχει ήδη.',
                    createSuccess: 'Προστέθηκε με επιτυχία',
                    editSuccess: 'Επιτυχία τροποποίησης',
                    deleteSuccess: 'Διαγραφή με επιτυχία',
                    deleteError: 'Η διαγραφή απέτυχε',
                    saveError: 'Αποτυχία αποθήκευσης',
                    addTargetWordsMaxNumberError: 'Μπορείτε να προσθέσετε μέχρι και 100 λέξεις αντικατάστασης',
                    addHomophonyWordsMaxNumberError: 'Μπορείτε να προσθέσετε μέχρι και 100 μασκοφόρες λέξεις',
                },
                attentionWords: {
                    create: 'Νέα λέξη ενδιαφέροντος',
                    edit: 'Ενδιαφερόμενος Επεξεργαστής Λόγων',
                    pleaseEnter: 'Παρακαλώ εισάγετε μια λέξη ενδιαφέροντος',
                    wordsExists: 'Η λέξη ανησυχίας υπάρχει ήδη.',
                    createSuccess: 'Προστέθηκε με επιτυχία',
                    editSuccess: 'Επιτυχία τροποποίησης',
                    deleteSuccess: 'Διαγραφή με επιτυχία',
                    deleteError: 'Η διαγραφή απέτυχε',
                },
                ignoreWords: {
                    create: 'Νέα λέξη παραβλέψεων',
                    edit: 'Παράβλεψη επεξεργασίας λέξεων',
                    pleaseEnter: 'Παρακαλώ εισάγετε αγνόηση λέξης',
                    wordsExists: 'Η λέξη αγνόησης υπάρχει ήδη',
                    createSuccess: 'Προστέθηκε με επιτυχία',
                    editSuccess: 'Επιτυχία τροποποίησης',
                    deleteSuccess: 'Διαγραφή με επιτυχία',
                    deleteError: 'Η διαγραφή απέτυχε',
                },
                wordsWeight: {
                    createWordsWeight: 'Νέο βάρος',
                    editWordsWeight: 'Επεξεργασία λέξη βάρους',
                    addWordsWeight: 'Προσθήκη λέξη βάρους',
                    pleaseEnterWeightWords: 'Παρακαλώ εισάγετε μια λέξη βάρης',
                    pleaseEnterWeight: 'Παρακαλώ εισάγετε ένα βάρος',
                    weightNeedInZeroToHundred: 'Το βάρος πρέπει να είναι μεταξύ 0 και 100.',
                    synonymWordsExists: 'Η λέξη βάρους υπάρχει ήδη',
                    weightNeedNumber: 'Το βάρος απαιτεί μορφή ακέραιου',
                    standardWeightInformation: 'Το βάρος αναφοράς είναι 50, και όσο μεγαλύτερο είναι το βάρος, τόσο ισχυρότερη είναι η επιρροή στην ανάλυση.',
                    createSuccess: 'Προστέθηκε με επιτυχία',
                    editSuccess: 'Επιτυχία τροποποίησης',
                    deleteSuccess: 'Διαγραφή με επιτυχία',
                    deleteError: 'Η διαγραφή απέτυχε',
                },
                corpusData: {
                    createCorpusData: 'Νέα δεδομένα Corpus',
                    editCorpusData: 'Επεξεργασία δεδομένων CorpusName',
                    addCorpusData: 'Προσθήκη δεδομένων Corpus',
                    pleaseEnterCorpusDescription: 'Παρακαλώ εισάγετε μια περιγραφή',
                    pleaseEnterCorpusContent: 'Παρακαλώ εισάγετε το περιεχόμενο του σώματος',
                    synonymWordsExists: 'Αυτά τα δεδομένα Corpus υπάρχουν ήδη',
                    CorpusContentWordsOverSetting: 'Ο αριθμός των λέξεων στην περιεκτικότητα υπερβαίνει τις 20000 λέξεις,',
                    download: 'Λήψης',
                    upload: 'Αποστολής',
                    see: 'Προβολή',
                    canNotSave: 'Παρακαλώ χρησιμοποιήστε τη συνάρτηση εισαγωγής, αλλιώς δεν μπορεί να αποθηκευτεί.',
                    createSuccess: 'Προστέθηκε με επιτυχία',
                    editSuccess: 'Επιτυχία τροποποίησης',
                    deleteSuccess: 'Διαγραφή με επιτυχία',
                    deleteError: 'Η διαγραφή απέτυχε',
                    required: '*',
                },
                typoLibrary: {
                    fields: {
                        rightWord: 'Σωστή λέξης',
                        wrongWord: 'Λάθος λέξης',
                        wrongWordCount: 'Αριθμός λανθασμένων λέξεων',
                        wrongWordTip: 'Πατήστε Enter για την προσθήκη',
                        status: 'Αποτελεσματικότητα',
                    },
                    create: 'Σύνολο νέων λέξεων τυπογραφής',
                    edit: 'Επεξεργασία τυπογράφων',
                    tip: 'Το σύνολο τυπογραφικών λέξεων χρησιμοποιείται για να βελτιστοποιήσει το αποτέλεσμα της "ανίχνευσης τύπου". Για παράδειγμα, εάν "επιστροφή" αποστέλλεται λανθασμένα ως "πλάτος επιστροφή", κοινές τυπογραφίες και σωστές λέξεις μπορούν να ρυθμιστούν μέσω αυτής της λειτουργίας, και θα τεθεί σε ισχύ την επόμενη μέρα μετά την αποταμίευση.',
                    onlyChinese: 'Υποστήριξη μόνο κινεζικών λέξεων',
                    wrongWordLengthErr: 'Το μήκος κάθε λάθος λέξης πρέπει να είναι 2 ~ 10 λέξεις',
                },
            },
            semanticTags: {
                title: 'Σημασιολογική ετικέτας',
                current: 'Τρέχουσα σημασιολογική ετικέταName',
                reference1: 'Εργασία επιθεώρησης ποιότητας: {0} - {1}',
                reference2: 'Έξυπνη ετικέτα: {0}',
                reference3: 'Προεπεξεργασία δεδομένων: {0}',
                reference4: 'Βάση γνώσεων: {0}',
                index: {
                    import: 'Εισαγωγή σημασιολογικών ετικετών',
                },
                detail: {
                    new: 'Νέα σημασιολογική ετικέταName',
                    edit: 'Επεξεργασία σημασιολογικής ετικέτας',
                    name: 'Όνομα',
                    standardSentences: 'Τυποποιημένη φράση',
                    effectiveness: 'Αποτελεσματικότητα',
                    similarSentences: 'Παρόμοιες προτάσεις',
                    tip: 'Υποστήριξη χρησιμοποιώντας μέσ# για να καλέσετε την οντότητα API, παράδειγμα: Είναι το κινητό σας αριθμός τηλεφώνου# sys_phone;',
                    excludeSimilarSentences: 'Εξαιρούνται παρόμοιες προτάσεις',
                    intelligentRecommend: 'Smart συνιστά παρόμοιο περιεχόμενο',
                    fastTraining: 'Γρήγορη εκπαίδευση:',
                    qualify: 'Τακτικός',
                    recallKeyWord: 'Ανάκληση λέξεων-κλειδιών',
                    excludeKeywords: 'Εξαίρεση λέξεων-κλειδιών',
                    excludeKeywordsInfo1: 'Εξαιρούνται οι λέξεις-κλειδιά και οι κανονικές εκφράσεις έχουν προτεραιότητα σε όλες τις λογικές. Αν εξαιρεθούν, η σημασιολογική ετικέτα δεν θα χτυπηθεί.',
                    keyWordInfo1: 'Πολλαπλές λέξεις-κλειδιά μπορούν να συμπληρωθούν σε κάθε γραμμή, χωρίζονται από αγγλικά κόμματα. Όταν πολλαπλές λέξεις-κλειδιά συμπληρώνονται, η λογική είναι ότι όλες οι επιτυχίες έχουν χτυπηθεί.',
                    keyWordInfo2: 'Λέξεις-κλειδιά ανάκλησης μπορούν να συμπληρωθούν σε πολλές γραμμές. Όταν συμπληρώνονται πολλαπλές γραμμές, η λογική μπορεί να ρυθμιστεί όπως κάθε χτύπημα.',
                    recallRegular: 'Ανάκληση κανονικά',
                    excludeRegular: 'Αποκλείονται τακτικά',
                    similaSentences: 'Εξαιρούνται παρόμοιες προτάσεις',
                    simim: 'Ομοιότητας',
                    keyWordInfo3: 'Η εξαίρεση παρόμοιων προτάσεων έχει προτεραιότητα σε όλη τη λογική. Αν μια παρόμοια πρόταση χτυπηθεί, η σημασιολογική ετικέτα δεν θα χτυπηθεί. Η προεπιλεγμένη ομοιότητα είναι 80%, και όσο μεγαλύτερη είναι η ομοιότητα, τόσο πιο παρόμοια είναι.',
                    keyWordInfo4: 'Ο κανόνας είναι παρόμοιος με τον κανονικό κανόνα, ο οποίος έχει μια αρχή και τέλος εξ προεπιλογής. Δεν χρησιμοποιείται απαραίτητα με παρενθέσεις, π.χ. [όχι XXXX]',
                    keyWordInfo5: 'Οι λειτουργίες της προηγμένης μονάδας είναι συνήθως πειραματικές λειτουργίες για εμπειρογνώμονες που είναι εξοικειωμένοι με την λειτουργία. Εάν δεν είστε σίγουροι πώς να λειτουργείτε, συνιστάται να μην αλλάξετε αυτό το τμήμα.',
                    keyWordInfo6: 'Το χαρακτηριστικό ανίχνευσης διασταύρωσης δίνει τις σημασιολογικές ετικέτες την ικανότητα να ανιχνεύσουν σε όλες τις προτάσεις.',
                    keyWordInfo7: 'Στην περισσότερη συνεχόμενη από τον ίδιο ρόλο.',
                    keyWordInfo8: 'Αγνόηση',
                    keyWordInfo9: 'Προτάσεις λέξεων για ανίχνευση διασταύρωσης',
                    keyWordInfo10: 'Το μήκος της μεγαλύτερης οριακής πρότασης δεν είναι περισσότερο',
                    keyWordInfo11: 'Αφαίρεση παρόμοιου ποσοστού όχι λιγότερους',
                    keyWordInfo12: 'Η ομοιότητα δεν είναι χαμηλότερη.',
                    keyWordInfo13: '% Των παρόμοιων προτάσεων θα είναι παρόμοια αντιστοιχία (προεπιλογή ομοιότητα 80%)',
                    keyWordInfo14: 'Παρόμοια αποκάλυψη ταιριάζει με προτάσεις που βασίζονται στην ομοιότητα τους. Συνιστάται να αφαιρεθούν προτάσεις που είναι πολύ παρόμοιες για να βελτιωθεί η απόδοση ανίχνευσης.',
                    keyWord: 'Λέξεις-κλειδιά',
                    entity: 'Οντότητα:',
                    ruleField: 'Λέξεις έννοιας',
                    customRule: 'Σχεδιασμός κανόνων ομιλίας',
                    fanhua: 'Παρόμοιες Ερωτήσεις',
                    test: 'Δοκιμή',
                    testOk: 'Δοκιμή χτυπήσεων',
                    senior: 'Προχωρημένες ρυθμίσεις',
                    seniorList: 'Ανίχνευση διασταύρωσης',
                    up: 'Ενεργοποίηση ενεργοποίησης',
                    down: 'Κλείσιμο',
                    ju: 'Ποινή',
                    oneWord: 'Λόγο',
                    simimNo: 'Παρόμοια με το Βάρος',
                    seniorField: 'Όριο ομοιότητας',
                    save: 'Αποθήκευση',
                    cancel: 'Ακύρωση',
                    specialElements: 'Ειδικά στοιχεία',
                    logicRule: 'Λογικοί κανόνες',
                    every: 'Πολλαπλά αγώνες',
                    recallOk: 'Πατήστε ανακάλυψη λέξη:',
                    recallNo: 'Αποτυχημένη λέξη ανακαλύψεων',
                    ruleOk: 'Χτυπήστε τακτική ανάκληση ανάκλησης',
                    ruleNo: 'Αποτυχία κανονικής',
                    rularOk: 'Κανόνες',
                    rularNo: 'Αποτυχία κανόνας',
                    infoOk: 'Πατήστε τυπική πρόταση ή παρόμοια πρόταση:',
                    infoNo: 'Παρατηρημένη τυπική πρόταση ή παρόμοια πρόταση.',
                    fieldOk: 'Χτύπημα για να αποκλείσει παρόμοιες προτάσεις:',
                    fieldNo: 'Αστόχησε για να αποκλείσει παρόμοιες προτάσεις.',
                    excludeRuleNo: 'Δεσποινίς Αποκλεισμός',
                    excludeRuleOk: 'Πλήττει τακτική αποκλεισμός',
                    excludeKeywordNo: 'Αποκλείονται λέξεις-κλειδιά',
                    excludeKeywordOk: 'Εξαίρεση λέξεων-κλειδιών',
                    update: 'Επιτυχία ενημέρωσης',
                    fanhuaList: 'Υποβλήθηκε σε παρόμοια λίστα προτάσεων γενικοποίησης',
                    wordList: 'Η λίστα εκπαίδευσης είναι κενή και δεν μπορεί να υποβληθεί στη λίστα γενίκευσης',
                    start: 'Εκκίνηση',
                    end: 'Τέλος:',
                    keyWordInfo15: 'Παρόμοια',
                    saveSuccess: 'Αποθήκευση με επιτυχία',
                    errInfo: 'Ορισμένα πεδία δεν συμπληρώνονται ή δεν συμπληρώνονται εσφαλμέντα',
                },
                table: {
                    deepTraining: 'Βαθιά εκπαίδευση {0}',
                    fastTraining: 'Γρήγορη εκπαίδευση',
                },
            },
            intelligentCollection: {
                title: 'Ευφυής απόκτηση',
                classification: 'Λίστα ομάδας',
                new: 'Νέα συλλογή',
                table: {
                    name: 'Όνομα πεδίου',
                    props: 'Χαρακτηριστικά πελατών',
                    type: 'Τύπος πεδίου',
                    desc: 'Περιγραφή πεδίου',
                },
                detail: {
                    isCustomerProps: 'Αποθήκευση σε χαρακτηριστικά πελατών',
                    customerPropsHelper: 'Μετά την αποθήκευση, οι πληροφορίες που συλλέγονται θα ενημερωθούν για τις πληροφορίες πελατών. Αν δεν αποθηκεύσετε, δεν θα ενημερωθεί για πληροφορίες πελατών',
                    name: 'Όνομα πεδίου',
                    type: 'Τύπος πεδίου',
                    text: 'Κείμενο',
                    desc: 'Περιγραφή πεδίου',
                    descPlaceHolder: 'Περιγράψτε τη χρήση αυτού του πεδίου για τη συλλογή πληροφοριών',
                    condition: 'Κατάσταση',
                    logic: 'Κανόνες',
                    method: 'Λειτουργία απόκτησης',
                    message: 'Πληροφορίες',
                    range: 'Εύρος εξαγωγής',
                    entity: 'Εξαγωγή οντοτήτων',
                    base: 'Βασικές πληροφορίες',
                    collect: 'Συλλογή πληροφοριών',
                },
            },
            intelligentTags: {
                title: 'Έξυπνη ετικέταName',
                sessionLabelTitle: 'Σενάρια συνεδρίας',
                keyEventsTitle: 'Γεγονότα κλειδιά',
                customerLabelTitle: 'Ετικέτα πελατών',
                addClassification: 'Δημιουργία νέας ταξινόμησης ετικέτας',
                defaultCategoryName: 'Προκαθορισμένη κατάταξη',
                index: {
                    createTag: 'Νέα ετικέταName',
                    createEvent: 'Νέο γεγονότο',
                    editTagClassification: 'Επεξεργασία ταξινόμησης ετικέτας',
                    selectTagClassification: 'Επιλογή ταξινόμησης ετικέτας',
                    editTagGrounp: 'Επεξεργασία ομαδοποίησης',
                    callTimeError: 'Το επιλεγμένο χρονικό εύρος έναρξης κλήσεων / συνομιλίας δεν μπορεί να υπερβαίνει το ένα μήνα (31 ημέρες)',
                    callRecordCountError: 'Ο αριθμός των εγγραφών είναι 0, παρακαλούμε επανεπιλέξτε τον χρόνο κλήσης / συνομιλίας χρόνος',
                    selectItmeCountError: 'Παρακαλώ επιλέξτε την έξυπνη ετικέτα για την οποία επιθυμείτε να εκτελέσετε τη λειτουργία χύδην',
                    redoSuccess: 'Η επανεκτέλεση είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
                    redoError: 'Η επανεκτέλεση απέτυχε, παρακαλώ δοκιμάστε ξανά αργότερα.',
                    timeError: 'Ο χρόνος ερωτήματος δεν μπορεί να υπερβεί ένα μήνα (31 ημέρες)',
                    categoryName: 'Όνομα κατηγορίας',
                    categoryColor: 'Χρώμα ταξινόμησης',
                    newTagClassification: 'Ταξινόμηση νέας ετικέτας',
                    newEventClassification: 'Νέα κατηγορία',
                    tagClassification: 'Ταξινόμηση ετικέτας',
                    eventClassification: 'Ταξινόμηση γεγονότων',
                },
                detail: {
                    new: 'Νέα έξυπνη ετικέτας',
                    edit: 'Επεξεργασία έξυπνης ετικέτας',
                    tagName: 'Όνομα',
                    tagDesc: 'Περιγραφή',
                    category: 'Ταξινόμηση',
                    tagStatus: 'Αποτελεσματικότητα',
                    operator: 'Αερομεταφορέας',
                    rule: 'Κανόνες',
                    labelClassAtion: 'Τύπος ετικέτας',
                    labelClassAtionTip1: 'Ετικέτες προσκλήσεως: επισήμανση με βάση τους κανόνες',
                    labelClassAtionTip2: 'Ταξινόμηση επισήμανσης: Επισήμανση με βάση το πρότυπο εκπαίδευσης',
                    group: 'Ομαδοποίηση',
                    checkLabel: 'Επιλογή κατηγορίας',
                    warn: 'Προειδοποίηση',
                    warnTips: 'Μετά την ενεργοποίηση του συναγερμού, όταν η συνεδρία ικανοποιεί αυτόν τον κανόνα βασικού γεγονότος, το άτομο που έχει καθοριστεί θα ζητηθεί και μπορεί να λάβει την υπενθύμιση στη λίστα εργασίας.',
                    warnError: 'Παρακαλώ επιλέξτε Προσωπικό Καθορισμένο Προσωπικό.',
                },
                subTitle: {
                    common: 'Ετικέτες έξυπνης συνεδρίας',
                    wecom: 'Επιχείρηση μικροετικέτας',
                },
            },
            customerPortrait: {
                title: 'Πορτραίτο πελατών',
                index: {
                    import: 'Εισαγωγή πορτραίτου πελατών',
                },
                searchPlaceHolder: 'Ταυτότητα πελατών, ψευδώνυμο ή τηλέφωνο',
                callCount: 'Αριθμός συζητήσεων:',
                callDuration: 'Συνολική διάρκεια κλήσης:',
                dialogCount: 'Συνολικός αριθμός συζητήσεων:',
                keyWordsStatistics: 'Στατιστικές λέξεων-κλειδιών ( Top 20 & λέξεις που ανησυχούν)',
                keyWordsCount: '({0})',
                businessTag: 'Επιχειρηματική ετικέτα:',
                keyWordsCloudImg: 'Λέξεις-κλειδιά Διάγραμμα Cloud',
                customerEmotionTrend: 'Τάσεις συναισθημάτων πελατών',
                notFoundCustomer: 'Δεν ανακτήθηκαν συνδεδεμένοι πελάτες.',
                noKeyWords: 'Δε βρέθηκαν σχετικές λέξεις-κλειδιά',
                noBusinessTags: 'Δεν βρέθηκαν σχετικές ετικέτες επιχειρήσεων',
                getKeyWordsStatisticsDataError: 'Στατιστική ερώτηση λέξη κλειδί πελάτη απέτυχε',
                getBusinessTagsStatisticsDataError: 'Η ερώτηση επιχειρήσεων πελατών απέτυχε',
                personCustome: 'Πληροφορίες για τους πελάτες που δεν έχουν ερωτηθεί.',
                notimeInfo: 'Δεν βρέθηκαν πληροφορίες για τα συναισθήματα.',
                timeList: 'Εύρος ημερομηνίας',
                operator: 'Έξυπνη ετικέταName',
                placeHolder: 'Παρακαλώ επιλέξτε.',
                placeOperator: 'Παρακαλώ επιλέξτε μια έξυπνη ετικέτα.',
                search: 'Ερώτηση',
                reset: 'Επαναφοράς',
                searchHolder: 'Αναζήτησης',
                call: 'Κλήση',
                text: 'Διάλογος',
            },
            sentimentAnalysis: {
                title: 'Ανακάλυψη της κοινής γνώμης',
            },
            saleSentimentAnalysis: {
                title: 'Ανάλυση της κοινής γνώμης',
            },
            dataPreprocess: {
                title: 'Προεπεξεργασία δεδομένων',
                index: {
                    createData: 'Νέα δεδομένα',
                    selectDataSource: 'Επιλογή πηγής δεδομένων',
                    selectStatus: 'Επιλογή αποτελεσματικότητας',
                    callTimeError: 'Το επιλεγμένο χρονικό εύρος έναρξης κλήσεων / συνομιλίας δεν μπορεί να υπερβαίνει το ένα μήνα (31 ημέρες)',
                    callRecordCountError: 'Ο αριθμός των εγγραφών είναι 0, παρακαλούμε επανεπιλέξτε τον χρόνο κλήσης / συνομιλίας χρόνος',
                    selectItmeCountError: 'Παρακαλώ επιλέξτε δεδομένα για εκτέλεση λειτουργίας χύδην',
                    redoSuccess: 'Η επανεκτέλεση είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
                    redoError: 'Η επανεκτέλεση απέτυχε, παρακαλώ δοκιμάστε ξανά αργότερα.',
                },
                detail: {
                    new: 'Νέα δεδομένα',
                    edit: 'Επεξεργασία δεδομένων',
                    name: 'Όνομα',
                    desc: 'Περιγραφή',
                    dataSource: 'Πηγή δεδομένων',
                    status: 'Αποτελεσματικότητα',
                    entity: 'Εξαγωγή οντοτήτων',
                    operator: 'Αερομεταφορέας',
                    rule: 'Κανόνες',
                },
            },
            connectedByConversation: {
                title: 'Συλλογή Επικοινωνιών Συνομιλίας',
                list: {
                    title: 'Λειτουργία σύνδεσης επικοινωνίας',
                    info: 'Η λειτουργία σύνδεσης συζήτησης μπορεί να συνδέει διαφορετικές κλήσεις και συνομιλίες σύμφωνα με προκαθορισμένους κανόνες.',
                    rule: 'Κανόνες συζητήσεων',
                    source: 'Παρακαλώ επιλέξτε μια πηγή δεδομένων',
                    classification: 'Παρακαλώ επιλέξτε μια κατηγορία',
                    choose: 'Παρακαλώ επιλέξτε.',
                    input: 'Παρακαλώ εισάγετε εισόδου',
                    save: 'Αποθήκευση',
                    cancel: 'Ακύρωση',
                    fieldwei: 'Biti',
                    fieldNot: 'Υπάρχουν ακατέργαστα πεδία',
                    fiedldlengthNo: 'Το μήκος του πεδίου υπερβαίνει το όριο',
                },
            },
            components: {
                operatorListGather: {
                    conditionTitle: 'CK',
                    keywordTip: 'Πολλαπλές λέξεις-κλειδιά μπορούν να ρυθμιστούν, χωρίζονται με κόμμα',
                    applyRole: 'Ανίχνευση ρόλου',
                    preOperator: 'Προχρηματοδότης',
                    applyOperatorScope: 'Εύρος ανίχνευσης',
                    addOperator: 'Προσθήκη χειριστής',
                    noPreOperator: 'Κανένα',
                    from: 'Τομέα',
                    to: 'Ποινή στο Όχι.',
                    end: 'Ποινή',
                    testRegular: 'Δοκιμή κανονικών εκφράσεων',
                    test: 'Δοκιμή',
                    matchSuccess: 'Ταίριασμα με επιτυχία',
                    matchError: 'Το ταίριασμα απέτυχε',
                    querySementicTags: 'Επιλογή σημασιολογικής ετικέτας',
                    reQuerySementicTags: 'Επαναεπιλογή σημασιολογικών ετικετών',
                    sementicTag: 'Σημασιολογική ετικέτας',
                    standardSentence: 'Τυποποιημένη φράση',
                    similarity: 'Ομοιότητας',
                    actions: 'Λειτουργία',
                    noFitTag: 'Δεν βρήκα τη σωστή ετικέτα,',
                    addSemanticTag: 'Προσθήκη μιας νέας σημασιολογικής ετικέτας',
                    pleaseEnterRegular: 'Παρακαλώ εισάγετε μια κανονική έκφραση',
                    pleaseEnterRegularText: 'Παρακαλώ εισάγετε το περιεχόμενο που θα επαληθευτείν',
                    newAssociateComponentTip: 'Εάν η τιμή είναι ένας αριθμητικός τύπος, χρησιμοποιήστε την κληρονομική λειτουργία',
                },
                filterManage: {
                    noValueTip: 'Χωρίς δεδομένα',
                    allCall: 'Όλες οι κλήσεις',
                    allDialogue: 'Όλοι οι διαλόγοι',
                    allWechat: 'Όλες οι συνεδρίες',
                    getFiltersListFailed: 'Αποτυχία λήψης λίστας φίλτρων, παρακαλώ προσπαθήστε ξανά αργότερα!',
                    getFilterDetailFailed: 'Αποτυχία λήψης λεπτομερειών φίλτρου, παρακαλώ προσπαθήστε ξανά αργότερα!',
                    getAllCountFailed: 'Αποτυχία να πάρετε τον συνολικό αριθμό των κλήσεων / συνομιλίες, παρακαλώ δοκιμάστε ξανά αργότερα!',
                },
                listManage: {
                    searchPlaceHolder: 'Παρακαλώ εισάγετε μια αναζήτηση λέξεων-κλειδιών',
                    filterConditions: 'Κατάσταση φίλτρου',
                    records: 'Καταγραφή',
                    getRecordsFailed: 'Αποτυχία λήψης εγγραφής, παρακαλώ δοκιμάστε ξανά αργότερα!',
                },
                miniListManage: {
                    getRecordsFailed: 'Αποτυχία λήψης εγγραφής, παρακαλώ δοκιμάστε ξανά αργότερα!',
                },
                applyTemplates: {
                    title: 'Εφαρμοστέο πρότυπο επιθεώρησης ποιότητας',
                    collectionTitle: 'Εφαρμοστέο πρότυπο Αποκτήσεων',
                },
                recordDetail: {
                    showWaveAudio: 'Εμφάνιση εγγραφής',
                    getDetailFailed: 'Αποτυχία λήψης λεπτομερειών, παρακαλώ δοκιμάστε ξανά αργότερα!',
                    getSmartTagsFailed: 'Αποτυχία λήψης έξυπνης ετικέτας, παρακαλώ δοκιμάστε ξανά αργότερα!',
                    getTemplatesFailed: 'Αποτυχία λήψης εφαρμοστέου προτύπου, παρακαλώ δοκιμάστε ξανά αργότερα!',
                },
                changeList: {
                    sampleStatus: 'Καθεστώς δειγματοληψίας',
                    sampleAssignInspector: 'Ορισμός επιθεωρητή δειγματοληψίας',
                    reviewAssignInspector: 'Ανέθεση',
                    read: 'Ανάγνωση:',
                    distributivePerson: 'Πρόσωπο που χορηγήθηκε πρόσωπος',
                    totalScore: 'Συνολική βαθμολογία',
                },
                qualityCheckScore: {
                    totalScore: 'Συνολική βαθμολογία',
                    actualScore: 'Βαθμολογία',
                    actualGrade: 'Αξιολόγηση',
                    appeal: 'Καταγγελία',
                    remark: 'Παρατηρήσεις',
                    manualRemark: 'Χειροκίνητες παρατηρήσεις',
                    none: 'Δεν υπάρχουν λεπτομερή στοιχεία για επιθεώρηση ποιότητας',
                    interactiveTip: 'Χρησιμοποιήστε την αναγνώριση αλληλεπίδρασης για να ανιχνεύσετε τη χρήση της εξυπηρέτησης πελατών FAQ',
                    interactiveIsEmptyTip: 'Δεν εντοπίστηκε περιεχόμενο διαδραστικής αναγνώρισης',
                },
                semanticMark: {
                    semanticContent: 'Πρόταση σήμανσης',
                    markedSimilarTitel: 'Παρόμοιες σημασιολογικές ετικέτες',
                    markedExcludeTitle: 'Σημειωμένο για να αποκλείσει παρόμοιες σημασιολογικές ετικέτες',
                    taskTagTitle: 'Σημασιολογικές ετικέτες που σχετίζονται με το έργο',
                    similarTagTitle: 'Προσδιορίστε παρόμοιες σημασιολογικές ετικέτες (παράθεση > 40%, Top 20)',
                    delete: 'Διαγραφή',
                    markSimilar: 'Σημείωση παρόμοιου',
                    markExclude: 'Εξαιρούνται παρόμοια',
                    none: 'Κανένα',
                },
                selectCallTime: {
                    callTime: 'Ώρα έναρξης ώρας ομιλίας/σέσσεων',
                    callTimeRemind: 'Μπορείτε να επιλέξετε έως ένα μήνα (31 ημέρες) αρχεία συζήτησης τον τελευταίο χρόνο.',
                    callRecordCount: 'Έχετε επιλέξει ένα σύνολο αρχείων κλήσεων / συνομιλίας {0}',
                    getCallRecordError: 'Αποτυχία λήψης εγγραφής, παρακαλώ δοκιμάστε ξανά αργότερα.',
                },
            },
            informationEntities: {
                title: 'Φορέας πληροφορίας',
                index: {
                    import: 'Οργανισμοί πληροφοριών Εισαγωγής',
                },
                detail: {
                    new: 'Νέα Οντότητα Πληροφοριών:',
                    edit: 'Επεξεργασία οντότητας πληροφοριών',
                    name: 'Όνομα',
                    apiName: 'Όνομα API',
                    activeFlag: 'Αποτελεσματικότητα',
                    remark: 'Περιγραφή',
                    logicExp: 'Τακτική οντότητα οντότητας',
                    sentenceList: 'Περιεχόμενο οντότητας',
                    tip: 'Το περιεχόμενο της οντότητας υποστηρίζει πολλαπλές καταχωρίσεις, χωρισμένες από χώρους, τα οποία είναι συνώνυμα της ίδιας οντότητας.',
                    remarkLengthError: 'Το μήκος περιγραφής δεν μπορεί να υπερβεί 255',
                    nameLengthError: 'Το μήκος του ονόματος δεν μπορεί να υπερβαίνει το 40.',
                    entityDuplicateError: 'Περιεχόμενο διπλής οντότητας',
                },
            },
            interactiveRecognition: {
                title: 'Διαδραστική αναγνώριση',
                classify: 'Ταξινόμηση',
                addClassify: 'Προσθήκη κατηγορίας',
                editClassify: 'Επεξεργασία κατηγορίας',
                index: {
                    import: 'Εισαγωγή αναγνώρισης αλληλεπίδρασης',
                },
                detail: {
                    new: 'Νέα έξυπνη αλληλεπίδρασης',
                    edit: 'Επεξεργασία Έξυπνη αλληλεπίδρασης',
                    type: 'Τύπος',
                    standardQuestion: 'Τυπικά ζητήματα',
                    similarQList: 'Παρόμοιο πρόβλημα.',
                    exceptSimilarQList: 'Εξάλειψη παρόμοιων προβλημάτων',
                    category: 'Ταξινόμηση',
                    targetType: 'Στόχος ανίχνευσης προβλημάτων',
                    status: 'Αποτελεσματικότητα',
                    standardAnswer: 'Τυπική απάντηση',
                    similarAList: 'Παρόμοιες απαντήσεις',
                    wrongAList: 'Λάθος απάντηση',
                },
            },
            businessAnalysis: {
                title: 'Ανάλυση επιχειρήσεων',
                tip1: 'Ανάλυση επιχειρηματικών τάσεων: η κάθετη συντεταγμένη είναι ο αριθμός των συνομιλιών, I . E. ο συνολικός αριθμός των συνομιλιών που πληρούν τις προϋποθέσεις, και η οριζόντια συντεταγμένη είναι η ώρα.',
                tip2: 'Ανάλυση αντιστοιχίας: ανάλυση της συσχέτισης των πολλαπλών δεικτών, στοιχεία συσχέτισης ποντικιού, όγκος δεδομένων, συσχέτιση, ρυθμός επανάληψης',
                tip3: 'Ανάλυση μετατροπής: η ανάλυση πολλαπλών δεικτών μπορεί να αποτελέσει μια αμοιβαία σχέση μετατροπής, τα κριτήρια μετατροπής για την ίδια κλήση/συνομιλία, αν μπορείτε να χτυπήσετε δύο διαφορετικούς δείκτες, μπορείτε να θεωρήσετε ότι οι δύο δείκτες έχουν μια σχέση μετατροπής.',
            },
            knowledgeBase: {
                title: 'Βάση γνώσης',
                list: {
                    add: 'Προσθήκη υποκατηγορίας',
                    delete: 'Διαγραφή ταξινόμησης',
                    categoryName: 'Όνομα κατηγορίας',
                    createSuccess: 'Η υποκατηγορία δημιουργήθηκε με επιτυχία',
                    keyWord: 'Λέξεις-κλειδιά',
                },
                detail: {
                    type: 'Τύπος',
                    status: 'Κατάσταση',
                    classification: 'Ταξινόμηση',
                    standardQuestion: 'Τυπικά ζητήματα',
                    answerDetectionRange: 'Εύρος ανίχνευσης απαντήσεων',
                    standardAnswer: 'Τυπική απάντηση',
                },
            },
            callManage: {
                title: 'Φίλτρα εγγραφής κλήσης',
                listTitle: 'Διαχείριση κλήσεων',
                detailTitle: 'Λεπτομέρειες κλήσης',
            },
            dialogueManage: {
                title: 'Φίλτρο κειμένου συζήτησης',
                listTitle: 'Διαχείριση διαλόγου',
                detailTitle: 'Λεπτομέρειες διαλόγου',
            },
            weChatManage: {
                title: 'Φίλτρο συνεδρίας Enterprise',
                listTitle: 'Enterprise WeChat Διαχείριση Συνεδρίας',
                detailTitle: 'Λεπτομέρειες συνεδρίας WeChat Enterprise',
            },
            speechRecognition: {
                title: 'Αναγνώριση ομιλών',
                asr: 'Αναγνώριση ομιλών',
                asrRemind: 'Η απενεργοποίηση αυτού του διακόπτη θα προκαλέσει τη λειτουργία φωνής σε κείμενο και τη λειτουργία επιθεώρησης ποιότητας μηχανής να απενεργοποιηθεί.',
                asrConfig: 'Διήθηση ASR',
                imAsrConfig: 'IMASR',
                imAsrConfigRemind: 'Όταν ενεργοποιείται, η μεταγραφή ASR του IM εκτελείται.',
                asrConfigRemind: 'Όταν ενεργοποιείται, μόνο επιλέξιμες κλήσεις εκτελούν περιεχόμενο ASR.',
                correction: 'Ευφυής διόρθωση σφαλμάτων:',
                correctionRemind: 'Όταν ενεργοποιηθεί, το περιεχόμενο στο "<a href = \'/site/semantic- intence/smart-words-bibrary/επαγγελματική-word-word- "στόχος = \'_blank\'> Smart Θησαυρός-Επαγγελματικές ονομασίες επιβατών" θα χρησιμοποιηθεί για να εξαναγκάσει τη διόρθωση λάθους μετατροπής',
                correctionConfig: 'Διόρθωση λάθης',
                advancedSettings: 'Προχωρημένες ρυθμίσεις',
                advancedSettingsTip: 'Επιλέγει το καθορισμένο μοντέλο ASR για τα καθορισμένα δεδομένα.',
                mandarinASRModel: 'Μανταρίνη μοντέλο ASR μοντέλο',
                cantoneseASRModel: 'Καντονικό μοντέλο ASR.',
                englishASRModel: 'Αγγλικό μοντέλο ASR',
                correctionConfigRemind: 'Όταν ενεργοποιείται, θα διορθωθούν μόνο οι κλήσεις που πληρούν τις παρακάτω προϋποθέσεις.',
                customJudgeLogicIsNull: 'Η προσαρμοσμένη λογική δεν μπορεί να είναι κενή',
                redoCorrection: 'Διόρθωση σφαλμάτων επανεμβάσεις',
                callTime: 'Επιλέξτε χρόνο ομιλίας',
                callTimeRemind: 'Μπορείτε να επιλέξετε έως ένα μήνα (31 ημέρες) αρχεία κλήσεων το τελευταίο έτος.',
                callRecordCount: 'Έχετε επιλέξει ένα σύνολο αρχείων κλήσεων {0}',
                redoCorrectionSubmit: 'Υποβολή προς εκτέλεση',
                callTimeError: 'Το επιλεγμένο χρονικό εύρος κλήσης δεν μπορεί να υπερβαίνει το ένα μήνα (31 ημέρες)',
                callRecordCountError: 'Ο αριθμός των αρχείων κλήσεων είναι 0, παρακαλώ επανεπιλέξτε την ώρα κλήσης.',
                redoCorrectionSuccess: 'Η διόρθωση επανάληψης είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
                redoCorrectionError: 'Αποτυχία επανάληψης. Παρακαλώ δοκιμάστε ξανά αργότερα.',
            },
            role: {
                title: 'Διαχείριση ρόλων',
                create: 'Νέος Ρόλος',
                detail: {
                    title: 'Ρόλος',
                    new: 'Νέος Ρόλος',
                    view: 'Προβολή ρόλων',
                    edit: 'Επεξεργασία ρόλου',
                    navTabNames: {
                        basicInfo: 'Άδειες μενού',
                        taskPermissions: 'Άδεια επιθεώρησης ποιότητας εργασίας',
                        dataPermissions: 'Άδειες δεδομένων',
                    },
                    basicInfo: {
                        roleName: 'Όνομα',
                        permissions: 'Άδειες',
                    },
                    taskPermissions: {
                        allTask: 'Όλες οι εργασίες επιθεώρησης ποιότητας',
                        myCreatedTask: 'Η ποιοτική επιθεώρηση που δημιούργησα',
                    },
                    dataPermissions: {
                        dataPermissionsConfig: 'Ρύθμιση άδειας δεδομένων',
                        tips: 'Ο ρόλος αυτός μπορεί να δει τα δεδομένα υπό την επιλεγμένη ταξινόμηση',
                        select: 'Επιλογή κατηγορίας',
                        selectPlaceholder: 'Παρακαλώ επιλέξτε μια ταξινόμηση που απαιτεί άδεια ορατότητας στοιχείων',
                    },
                },
            },
            dataMigration: {
                title: 'Μετανάστευση δεδομένων',
                dataUpload: 'Μετανάστευση δεδομένων',
                dataDowload: 'Μετανάστευση δεδομένων',
                error: 'Παρακαλώ επιλέξτε μια ποιοτική εργασία για εξαγωγή',
                list: {
                    info: 'Παρακαλώ επιλέξτε την εργασία επιθεώρησης ποιότητας για να μετακινηθείτε έξω',
                    listInfo: 'Παρακαλούμε επιλέξτε αν θα μεταβιβάσετε δεδομένα σχετικά με την εργασία επιθεώρησης ποιότητας (όπως ευφυής θησαυρός, σημασιολογική ετικέτα, φορέας πληροφοριών, ευφυής αλληλεπίδραση κ.λπ.)',
                    noInfo: 'Παρακαλώ επιλέξτε αν θα μετακινηθείτε άλλα δεδομένα μη QC',
                    ownInfo: 'Μετακίνηση μόνο εργασιών',
                    everyInfo: 'Σχετική εργασία μετακίνησης έξω',
                    allInfo: 'Φύγε από όλα.',
                    callFilter: 'Φίλτρο κλήσης',
                    talkFilter: 'Φίλτρο διαλόγου',
                    smartTag: 'Έξυπνη ετικέταName',
                },
                upload: {
                    info: '1. Κάντε κλικ στο κουμπί Ανεβάστε για να ανεβάσετε ένα αρχείο JSON που συμμορφώνεται με τη μορφή.',
                    uploadSuccess: 'Αποστολή επιτυχή',
                    uploadError: 'Αποτυχία αποστολής',
                },
            },
            dataAnalysis: {
                businessStatistics: 'Στατιστικές επιχειρήσεων',
                qualityEffect: 'Υγειονομική επιθεώρηση',
                qualityAnalysis: 'Ανάλυση ποιότητας επιθεώρησης',
                generalInspecitionReport: 'Γενική Έκθεση (έγγρ.',
                fullAmountWork: 'Εργασία του επιθεωρητή ποιότητας',
                intelligentTagsAnalysis: 'Ανάλυση ετικέτας',
                saleIntelligentTagsAnalysis: 'Ανάλυση έξυπνης ετικέτας',
                generalInspecitionReportTip: 'Συνολικά δεδομένα: μετρά το συνολικό ποσό των δεδομένων κλήσης και συνομιλίας εντός της τρέχουσας προθεσμίας και εύρος εργασίας, συμπεριλαμβανομένου του αριθμού και του ποσοστού των έξυπνων δεδομένων ποιότητας, του αριθμού και του ποσοστού των δεδομένων δειγματοληψίας, του αριθμού των προσφυγών, το ποσοστό δειγματοληψίας και το χρονικό διάγραμμα τάσης.',
                groupTest: 'Δοκιμή ομάδας',
            },
            uploadDownloadList: {
                title: 'Κέντρο Αποστολής',
                tabs: {
                    upload: 'Αποστολή εισαγωγής',
                    download: 'Λήψη εξαγωγής',
                    taskCenter: 'Εκτέλεση εργασίας',
                },
            },
            uploadDownloadModel: {
                title: 'Ανεβάσεις και λήψης',
                list: {
                    clear: 'Κενό',
                    success: 'Επιτυχία',
                    fail: 'Αποτυχία',
                    hand: 'Σε εξέλιξη.',
                    noInfo: 'Χωρίς δεδομένα',
                },
            },
            financeCenter: {
                title: 'Οικονομική διαχείριση',
                unavailable: 'Το σύστημα χρέωσης δεν έχει ρυθμιστεί στο τρέχον περιβάλλον',
                loadError: 'Αποτυχία φόρτωσης του συστήματος χρέωσης. Δοκιμάστε ξανά αργότερα.',
            },
            billingCenter: {
                title: 'Κέντρο τιμολόγησης',
                export: 'Εξαγωγή',
                limit: 'Όριο υπενθύμισης',
                tips: 'Τα αποτελέσματα χρέωσης θα είναι μεροληπτικά λόγω της στρογγυλοποίησης, για αναφορά μόνον',
                dashboard: {
                    remainingQuota: 'Τρέχουσα εναπομένουσα ποσόστωση',
                    usedQuota: 'Σωρευτικές μεταχειρισμένες ποσόστωσης',
                    voiceQuality: 'Επιθεώρηση φωνητικής ποιότητας:',
                    voice: 'Φωνή:',
                    textQuality: 'Επιθεώρηση ποιότητας κειμένου:',
                    text: 'Κείμενο:',
                    hour: 'Ώρες',
                    tenThousandHour: 'Εκατομμύρια ώρες.',
                    day: 'Ημέρα',
                    cutoff: 'Περικοπή',
                    warning: '(Η υπόλοιπη ποσόστωση είναι ανεπαρκής, παρακαλούμε επαναφόρτιση το συντομότερο δυνατόν)',
                    isClosed: '(Κλεισμένη κατάσταση)',
                },
                table: {
                    quotaRecord: 'Αρχείο ποσόστωσης',
                    timeFilter: 'Επιλέξτε ημερομηνία:',
                    search: 'Ερώτηση',
                    reset: 'Επαναφοράς',
                    id: 'Αύξων αριθμός',
                    type: 'Τύπος',
                    qualityType: 'Τύπος επιθεώρησης ποιότητας',
                    quotaChange: 'Αλλαγή',
                    surplus: 'Υπόλοιπος',
                    changeTime: 'Χρόνο',
                    voiceQuality: 'Επιθεώρηση φωνητικής ποιότητας',
                    textQuality: 'Επιθεώρηση ποιότητας κειμένου:',
                    sizeChangeText: 'Εμφάνιση ανά σελίδα',
                    used: 'Χρήση',
                    give: 'Επιχορήγηση',
                    deduction: 'Μείωση',
                    callTime: 'Ώρα για ομιλία.',
                    count: 'Επεξεργασία όγκου δεδομένων',
                    page: 'Σελίδα {1} του {0}',
                },
                limitModal: {
                    call: 'Η ποσόστωση επιθεώρησης φωνητικής ποιότητας είναι χαμηλότερης',
                    callFix: 'Ώρες για να υπενθυμίσεις',
                    dialogue: 'Ο υπόλοιπος χρόνος της επιθεώρησης της ποιότητας του κειμένου είναι λιγότερος',
                    dialogueFix: 'Μέρες για να υπενθυμίσω',
                },
            },
            messageCenter: {
                replyTitle: 'Απάντησέ μου.',
                answerTitle: '@ Μου',
                shareTitle: 'Μοιράσου το δικό μου.',
            },
            columnsManage: {
                title: 'Διαχείριση πεδίου επιθεώρησης ποιότητας',
            },
            recordUpload: {
                list: {
                    task: 'Εργασία επιθεώρησης',
                    user: 'Αερομεταφορέας',
                    uploadTime: 'Χρόνος αποστολής',
                    endTime: 'Τέλος χρόνου',
                    total: 'Σύνολο αποστολής',
                    success: 'Επιτυχία επιθεώρησης ποιότητας',
                    failed: 'Η επιθεώρηση ποιότητας απέτυχε',
                    progress: 'Πρόοδος επιθεώρησης ποιότητας',
                    inProgress: 'Σε εξέλιξη.',
                    finished: 'Ολοκληρώθηκε',
                },
                steps: {
                    uploading: 'Αποστολή αρχείου εγγραφής',
                    baseInfo: 'Συμπληρώστε τις βασικές πληροφορίες',
                    start: 'Έναρξη επιθεώρησης ποιότητας',
                },
                uploadComponent: {
                    dragger: 'Σύρετε και ρίξτε για την προσθήκη αρχείων',
                    or: 'Ή',
                    selectFile: 'Επιλογή αρχείου',
                    des: 'Υποστήριξη wav, μορφή mp3, ρυθμός δειγματοληψίας 8000Hz, 16-bit αρχείου',
                    limit1: 'Αποστολή το πολύ μια φορά.',
                    limit2: 'Αρχεία, κάθε μέγεθος αρχείου δεν υπερβαίνει του',
                    uploading: 'Αποστολής',
                    finished: 'Αποστολή ολοκληρώθηκε',
                    success: 'Επιτυχία',
                    failure: 'Αποτυχία',
                },
                baseInfo: {
                    task: 'Επιλογή εργασίας ποιότητας',
                    type: 'Επιλέξτε τη φόρμα εγγραφής',
                    agentSide: 'Το κανάλι όπου βρίσκεται η εξυπηρέτηση πελατών',
                    excel: 'Αποστολή δεδομένων κατά μήκος της διαδρομής',
                    checkFileInfo: 'Επαλήθευση πληροφοριών αρχείου',
                    excelFileError: 'Παρακαλώ ανεβάστε τα δεδομένα στην πορεία.',
                    checking: 'Βαθμονόμηση σε...',
                    reCheck: 'Επαναβαθμονόμηση',
                    success: 'Επιτυχία επαλήθευσης',
                    excelUoloadFail: 'Αποτυχία αποστολής δεδομένων κατά μήκος της διαδρομής.',
                    tips: {
                        tip1: '1. Το όνομα του αρχείου καταγραφής στο ecxel πρέπει να είναι το ίδιο με το όνομα της ηχογράφησης και δεν μπορεί να είναι το ίδιο όνομα.',
                        tip2: '2. Το σύστημα ελέγχει το αντίγραφο με το όνομα αρχείο καταγραφής και την κλήση ID. Τα επαναλαμβανόμενα δεδομένα θα οδηγήσουν σε αποτυχία επιθεώρησης ποιότητας.',
                        tip3: '3. Για το λήψη Excel πρότυπο εγγραφής, το χρώμα γραμματοσειράς είναι κόκκινο, το οποίο είναι ένα απαιτούμενο πεδίο.',
                        tip4: '4. Η μορφή πεδίου του τύπου χρόνου είναι: yyyy-mm-dd hhh:mm:ss, για παράδειγμα, 2021-04-20 17:36:30',
                    },
                },
                title: 'Τοπική αποστολή εγγραφής',
                checkTitle: 'Επιθεώρηση ποιότητας καταγραφής',
                start: 'Έναρξη επιθεώρησης ποιότητας',
                disabledTips: 'Παρακαλώ επαληθεύστε το αρχείο καταγραφής πριν από την επιθεώρηση ποιότητας',
                tips: 'Το αρχείο καταγραφής με το ίδιο όνομα αντιγράφει τα αποτελέσματα επιθεώρησης ποιότητας και τις βασικές πληροφορίες.',
                tips1: 'Σύρετε και ρίξτε το αρχείο εδώ, ή κάντε κλικ στο αποστολή αποστολής',
                tips2: 'Υποστήριξη',
                tips3: 'Μορφή',
                type: 'wav、mp3',
                tips4: 'Αποστολή το πολύ μια φορά.',
                tips5: 'Αρχεία, κάθε μέγεθος αρχείου δεν υπερβαίνει του',
                tipsOverSize: 'Η τρέχουσα ουρά είναι πλήρης, παρακαλώ αφαιρέστε τα αρχεία στην ουρά πριν από την αποστολή.',
                size: '500M',
                count: '20',
                uploaded: 'Καταγραφή αρχείου',
                uploading: '({0}%)',
                uploadFinished: '(Ολοκληρώθηκε)',
                bottomTitle: 'Συλλογή πληροφοριών:',
                recordType: 'Επιλέξτε τη φόρμα εγγραφής:',
                double: 'Καταγραφή κλήσεων διπλού καναλιού',
                single: 'Καταγραφή ενός καναλιού',
                recordBaseInfo: 'Αποστολή βασικών πληροφοριών καταγραφής:',
                addBtn: 'Προσθήκη αρχείου',
                downloadTemplate: 'Λήψη προτύπου. excel',
                checkRecord: 'Επαλήθευση πληροφοριών καταγραφής',
                checking: 'Βαθμονόμηση σε...',
                reCheck: 'Επαναβαθμονόμηση',
                checkAll: 'Επιλογή όλων',
                cancelCheckAll: 'Ακύρωση επιλογής όλων',
                delete: 'Διαγραφή',
                deleteLotSize: 'Διαγραφή παρτίδας',
                agentChannel: 'Κανάλι εξυπηρέτησης πελατών:',
                left: 'Αριστερό καναλί',
                right: 'Δεξιά κανάλια',
                donotKonw: 'Δεν ξέρω.',
                mission: 'Επιλέξτε μια ποιοτική εργασία:',
                uploadFail: 'Αποτυχία αποστολής',
                repeat: 'Αντίγραφο αρχείου',
                overCount: 'Αριθμός αρχείων υπερβαίνει το όριο',
                overSize: 'Μέγεθος αρχείου υπερβαίνει το όριο',
                uoloadFail: 'Αποτυχία αποστολής στο cloud',
                formatError: 'Σφάλμα μορφής',
                seccess: 'Επιτυχία επαλήθευσης',
                fail: 'Η επαλήθευση απέτυχε',
                recordChecking: 'Καταγραφή στην επιθεώρηση ποιότητας, παρακαλώ αργότερα...',
                recordCheckSuccess: 'Ολοκληρώθηκε επιθεώρηση ποιότητας καταγραφής',
                recordCheckFail: 'Η επιθεώρηση ποιότητας απέτυχε, παρακαλώ ελέγξτε αν η εγγραφή είναι διπλή ή άκυρη',
                backToIndex: 'Επιστροφή στη λίστα αποστολής',
                recordCheckIsStarted: 'Αυτή τη στιγμή εκτελείται έργο επιθεώρησης ποιότητας. Παρακαλώ έναρξη μιας νέας εργασίας μετά την ολοκλήρωση της τρέχουσας εργασίας.',
            },
            customerServicePortrait: {
                title: 'Πορτραίτο εξυπηρέτησης πελατών',
                tip1: 'Ο νόμος διανομής του μήκους της ποινής: η κατανομή του μήκους πρότασης υπολογίζεται σε τμήματα ανάλογα με τον αριθμό των λέξεων στο μήκος της πρότασης, και μόνον της εξυπηρέτησης πελατών',
                tip2: 'Νόμος διανομής ταχύτητας: η κατανομή της ταχύτητας, ανάλογα με την ταχύτητα (λέξεις/ λεπτό), στατιστικές τμήματος, μόνο υπολογίστε την εξυπηρέτηση πελατών',
                tip3: 'Νόμος διανομής χρόνου απόκρισης: η κατανομή του χρόνου απόκρισης, μόνο η κατάσταση απόκρισης εξυπηρέτησης πελατών υπολογίζεται.',
                tip4: 'Συμμόρφωση της ποιότητας επιθεώρησης: ποσοστό συμμόρφωσης των σημείων επιθεώρησης ποιότητας',
                tip5: 'Μέση ποιότητα επιθεώρηση εργασίας: μέση βαθμολογία επιθεώρησης ποιότητας εργασίας',
                contol: {
                    date: 'Επιλέξτε ημερομηνία:',
                    today: 'Σήμερα',
                    thisMonth: 'Αυτό το μήνα',
                    lastMonth: 'Τον περασμένο μήνα.',
                    thisQuarter: 'Αυτό το τρίμηνο.',
                    lastQuarter: 'Τελευταίο τρίμημα',
                    thisYear: 'Φέτος φέτος.',
                    lastYear: 'Πέρυσι',
                    customer: 'Υπηρεσία πελατών:',
                    search: 'Ερώτηση',
                    reset: 'Επαναφοράς',
                    export: 'Εξαγωγή',
                    indicator: 'Διαχείριση δεικτών',
                    selectPlaceholder: 'Παρακαλώ επιλέξτε την εξυπηρέτηση πελατών που πρέπει να συγκρίνει',
                    warning: 'Επιλέξτε μέχρι 5 παράγοντες για σύγκριση.',
                    warning2: 'Παρακαλώ επιλέξτε τουλάχιστον έναν πράκτορα για να ρωτήσετε.',
                    dataWarning: 'Μόνο τα δεδομένα έως 366 ημέρες μετά την ημερομηνία έναρξης μπορούν να αναζητηθούν.',
                    seccuss: 'Επιτυχής εγγραφή εξαγωγής',
                },
                echarts: {
                    distributionLaw: 'Δίκαιο διανομής',
                    count: 'Αριθμός φορών',
                    bout: 'Χρόνια',
                },
                portrait: {
                    ability: 'Διάσταση της ικανότητας εξυπηρέτησης πελατών',
                    option: 'Ρύθμιση',
                    abilityOption: 'Ρύθμιση διαστάσεων ικανότητας',
                    placeholder: 'Αναζήτηση λέξεων-κλειδιάστατης ικανότητας εισόδου',
                    save: 'Αποθήκευση',
                    warning: 'Παρακαλώ επιλέξτε τουλάχιστον 3 δείκτες για να ρυθμίσετε, και μπορείτε να επιλέξετε έως και 10 δείκτες',
                },
                label: {
                    title: 'Ετικέτα εξυπηρέτησης πελατών',
                },
            },
            customerServiceRankList: {
                routerTitle: 'RankList',
                title: 'Κατάταξη εξυπηρέτησης πελατών',
                select: {
                    date: 'Επιλέξτε ημερομηνία:',
                    today: 'Σήμερα',
                    thisMonth: 'Αυτό το μήνα',
                    lastMonth: 'Τον περασμένο μήνα.',
                    thisQuarter: 'Αυτό το τρίμηνο.',
                    lastQuarter: 'Τελευταίο τρίμημα',
                    thisYear: 'Φέτος φέτος.',
                    lastYear: 'Πέρυσι',
                    group: 'Ομάδα εξυπηρέτησης πελατών:',
                    groupPlaceholder: 'Παρακαλώ επιλέξτε μια ομάδα πράκτορας',
                    customer: 'Υπηρεσία πελατών:',
                    customerPlaceholder: 'Παρακαλώ επιλέξτε εξυπηρέτηση πελατών',
                    search: 'Ερώτηση',
                    reset: 'Επαναφοράς',
                    compared: 'Αντίθεση',
                    export: 'Εξαγωγή',
                    column: 'Στήλη',
                    warning: 'Επιλέξτε μέχρι 5 παράγοντες για σύγκριση.',
                    warning2: 'Παρακαλώ επιλέξτε τουλάχιστον έναν πράκτορα',
                    dataWarning: 'Μόνο τα δεδομένα έως 366 ημέρες μετά την ημερομηνία έναρξης μπορούν να αναζητηθούν.',
                    selected: 'Επιλεγμένος παράγοντας:',
                    seccuss: 'Επιτυχής εγγραφή εξαγωγής',
                },
                compared: {
                    title: 'Επιλέξτε υπηρεσία πελατών',
                    return: 'Ακύρωση',
                    compared: 'Αντίθεση',
                    tips: 'Παρακαλώ επιλέξτε 2-5 πράκτορες για σύγκριση.',
                    warning: 'Μόνο 2-5 παράγοντες υποστηρίζονται για σύγκριση.',
                },
                transfer: {
                    leftTitle: 'Αντικείμενο λίστας',
                    rightTitle: 'Εμφάνιση αντικειμένου',
                },
                table: {
                    page: 'Σελίδα {1} του {0}',
                    actionTitle: 'Λειτουργία',
                    action: 'Προβολή',
                },
            },
            conceptWord: {
                title: 'Λέξεις έννοιας',
                new: 'Νέα έννοια λέξης',
                control: {
                    search: 'Αναζήτηση:',
                    searchPlaceholder: 'Όνομα ή λέξη-κλειδί αναζήτησης',
                    commit: 'Ερώτηση',
                    reset: 'Επαναφοράς',
                    import: 'Εισαγωγή',
                    export: 'Εξαγωγή',
                    seccuss: 'Επιτυχής εγγραφή εξαγωγής',
                },
                modal: {
                    title: 'Εισαγωγή λέξεων',
                },
                table: {
                    sizeChangeText: 'Εμφάνιση ανά σελίδα',
                    page: 'Σελίδα {1} του {0}',
                    edit: 'Επεξεργασία',
                    delete: 'Διαγραφή',
                    request: 'Μετά τη διαγραφή, δεν μπορεί να ανακτηθεί. Είστε σίγουροι ότι θέλετε να το διαγράψετε;',
                    cancel: 'Ακύρωση',
                    title: {
                        conceptWord: 'Λέξεις έννοιας',
                        describeWordsNum: 'Αριθμός των περιγραφόμενων',
                        updateTime: 'Ώρα ενημέρωσης',
                        status: 'Αποτελεσματικότητα',
                        effective: 'Αποτελεσματικό',
                        invalid: 'Μη έγκυρο',
                        action: 'Λειτουργία',
                    },
                },
                detail: {
                    title: {
                        new: 'Νέα έννοια λέξης',
                        edit: 'Επεξεργασία λέξεων ιδέας',
                    },
                    name: 'Όνομα λέξης έννοιας',
                    namePlaceholder: 'Παρακαλώ εισάγετε ένα όνομα λέξης',
                    effectiveness: 'Αποτελεσματικότητα',
                    effective: 'Αποτελεσματικό',
                    invalid: 'Μη έγκυρο',
                    description: 'Περιγραφή:',
                    descriptionPlaceholder: 'Παρακαλώ εισάγετε έναν περιγραφέα',
                    add: 'Προσθήκη',
                    repeat: 'Διπλό περιεχόμενο',
                    empty: 'Η περιγραφή δεν μπορεί να είναι κενή',
                    recommendEmpty: 'Όχι άλλες συνιστώ περιγραφή λέξεις, παρακαλώ εισάγετε και προσθέστε τα χειροκίνητα.',
                    recommend: 'Σύσταση Smart Descriptives',
                    cancel: 'Ακύρωση',
                    change: 'Τροποποίηση μιας ομάδας',
                    descriptionSelected: 'Προστιθέμενος περιγραφέας:',
                    save: 'Αποθήκευση',
                    success: 'Οι λέξεις έννοιας αποθηκεύτηκαν με επιτυχία',
                    warning: 'Το όνομα της λέξης έννοιας δεν μπορεί να είναι κενό',
                    warning2: 'Προσθέστε τουλάχιστον 1 περιγραφέα',
                    submitBtnHandle: {
                        title: 'Ο επιλεγμένος περιγραφέας δεν προστέθηκε. Η αποθήκευση θα απορρίψει τον άδειο περιγραφέα.',
                        content: 'Κάντε κλικ OK για να επιστρέψετε στην έννοια αρχική σελίδα λέξη, επιβεβαιώστε να συνεχίσετε;',
                    },
                },
            },
            smartTools: {
                btn: 'Έξυπνα εργαλεία',
                title: {
                    similarWords: 'Βρέθηκαν σχετικές λέξεις',
                    search: 'Με λέξη.',
                    semanticTags: 'Σημασιολογική ετικέτας',
                },
                sentenceSearch: {
                    placeholder: 'Παρακαλώ εισάγετε αναζήτηση λέξεων-κλειδιών, υποστηρίξτε πολλαπλές λέξεις-κλειδιά',
                    more: 'Προβολή πλήρους κειμένου',
                    pageUp: 'Προηγούμενη σελίδα:',
                    pageDown: 'Επόμενη σελίδα',
                    total: 'Σύνολο αρχείων {0}',
                },
                similarDiscover: {
                    placeholder: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
                    copyed: 'Αντιγραφή',
                    none: 'Καμία σχετική λέξη, παρακαλώ δοκιμάστε άλλες λέξεις-κλειδιά',
                },
                smartTags: {
                    searchPlaceHolder: 'Παρακαλώ εισάγετε λέξεις-κλειδιά ή προτάσεις',
                    createSmartTag: 'Νέο',
                    createClusteringSmartTag: 'Δημιουργία νέου με {0} κομμάτια δεδομένων',
                    addFromKeyword: 'Προσθήκη περιεχομένου αναζήτησης σε παρόμοιες προτάσεις',
                    hit: 'Χτύπημα.',
                    similar: 'Παρόμοια',
                    name: 'Όνομα σημασιολογικής ετικέτας',
                    namePlaceHolder: 'Παρακαλώ εισάγετε ένα σημασιολογικό όνομα ετικέτας',
                    recallWords: 'Ανάκληση λέξης',
                    recallWordsPlaceHolder: 'Παρακαλώ εισάγετε μια λέξη-κλειδί ανάκλησης',
                    recallRegular: 'Ανάκληση κανονικά',
                    recallRegularPlaceHolder: 'Παρακαλώ εισάγετε αναπαραγωγή κανονικά',
                    rules: 'Κανόνες',
                    standardSentences: 'Τυποποιημένη φράση',
                    standardSentencesPlaceHolder: 'Παρακαλώ εισάγετε μια τυπική πρόταση',
                    similaSentences: 'Παρόμοιες προτάσεις',
                    similaSentencesPlaceHolder: 'Παρακαλώ εισάγετε μια παρόμοια πρόταση.',
                    notSaveError: 'Παρακαλώ αποθήκευση της σημασιολογικής ετικέτας πριν την αναζήτηση',
                    add: 'Προσθήκη',
                    newPage: 'Άνοιγμα σε νέα σελίδα',
                    querryError: 'Παρόμοια',
                    detailTitle: 'Λεπτομέρειες ετικέτας',
                },
            },
            trainingCenter: {
                title: 'Κέντρο Εκπαίδευσης',
                edit: 'Επεξεργασία',
                delete: 'Διαγραφή',
                seleteAll: 'Επιλογή όλων',
                cancelCheckAll: 'Ακύρωση επιλογής όλων',
                add: 'Προσθήκη',
                remove: 'Αφαίρεση',
                save: 'Αποθήκευση',
                cancel: 'Ακύρωση',
                fastTraining: {
                    title: 'Γρήγορη εκπαίδευση',
                    titleDes: 'Η γρήγορη εκπαίδευση έχει σχεδιαστεί για να βοηθήσει τις σημασιολογικές ετικέτες γρήγορα να γενικευθούν σε 20 παρόμοιες προτάσεις.',
                    semanticTags: 'Σημασιολογική ετικέτας',
                    semanticTagsPlaceholder: 'Παρακαλώ εισάγετε αναζήτηση λέξεων κλειδιού διεργασίας',
                    standardSentence: 'Τυποποιημένη πρόταση:{0}',
                    similarSentencesPlaceholder: 'Εισάγετε παρόμοιες προτάσεις για προσθήκη ή αναζήτηση',
                    similarSentencesAdd: 'Προσθήκη',
                    similarSentencesSearch: 'Αναζήτησης',
                    similarSentences: 'Παρόμοια πρόταση προστέθηκε',
                    trainingCount: 'Αριθμός εκπαίδευσης:{0}',
                    similarSentencesRecommend: 'Συνιστά παρόμοιες προτάσεις.',
                    noResp: 'Δεν υπάρχει σχετική σημασιολογική ετικέτα, παρακαλώ αλλάξτε τη λέξη κλειδί.',
                    similarSentencesModalTitle: 'Παρόμοια αναζήτηση πρότασης',
                    moreInfo: 'Προβολή περιεχομένων',
                    moreInfoBtn: 'Περιεχόμενο',
                    modalSearchType: {
                        all: 'Όλα',
                        customer: 'Υπηρεσία πελατών',
                        client: 'Πελάτη',
                    },
                    repetWarning: 'Η ίδια πρόταση υπάρχει ήδη, παρακαλώ μην την προσθέσετε επανειλημμένα.',
                    repetRemoveTip: 'Υπάρχει διπλό περιεχόμενο στην αποθηκευμένη παρόμοια πρόταση, η οποία έχει αποσυρθεί αυτόματα.',
                },
                trainingHistory: {
                    title: 'Ιστορία εκπαίδευσης',
                    select: {
                        date: 'Επιλογή χρόνου:',
                        today: 'Σήμερα',
                        thisMonth: 'Αυτό το μήνα',
                        lastMonth: 'Τον περασμένο μήνα.',
                        thisQuarter: 'Αυτό το τρίμηνο.',
                        lastQuarter: 'Τελευταίο τρίμημα',
                        thisYear: 'Φέτος φέτος.',
                        lastYear: 'Πέρυσι',
                        search: 'Ερώτηση',
                        reset: 'Επαναφοράς',
                    },
                    table: {
                        time: 'Χρόνο',
                        user: 'Αερομεταφορέας',
                        tag: 'Σημασιολογική ετικέτας',
                        similarCount: 'Αριθμός παρόμοιων προτάσεων',
                        deleteCount: 'Αριθμός προτάσεων που αφαιρέθηκε',
                        page: 'Σελίδα {1} του {0}',
                    },
                },
                classifiedTraining: {
                    title: 'Κατάρτιση ταξινόμησης',
                    tagsGrounp: 'Ομάδα ετικέτας',
                    placeHolder: 'Παρακαλώ επιλέξτε.',
                    cellTime: 'Επιλογή ώρας',
                    search: 'Ερώτηση',
                    reset: 'Επαναφοράς',
                    classifiedFlag: 'Κατάρτιση ταξινόμησης',
                    num: 'Αριθμητικός',
                    gas: 'Ποσοστό',
                    noData: 'Μη διαβαθμισμένη εκπαίδευση',
                    noDataHeight: 'Τα δεδομένα που δεν έχουν ταξινομηθεί είναι υψηλά και απαιτείται επείγουσα κατάρτιση.',
                    noDataSmall: 'Τα μη χαρακτηριστικά δεδομένα αντιστοιχούν σε σχετικά υψηλό ποσοστό και συνιστάται η κατάρτιση.',
                    noDataDays: '{0} ημέρες πριν την τελευταία εκτέλεση',
                    training: 'Κατάρτιση',
                    start: 'Εκκίνηση',
                    addClass: 'Προσθήκη ταξινόμησης',
                    custom: 'Προχωρημένη φιλτράριση',
                    marked: 'Ετικέτα δεδομένα',
                    markedHeight: 'Το Errata δεν έχει εκτελεστεί για {0} ημέρες, και συνιστάται να γίνει αυτό.',
                    markedSmall: 'Το Errata δεν έχει εκτελεστεί για {0} ημέρες. Η Errata είναι επειγόντως απαραίτητη.',
                    mark: 'Ερράτα.',
                    dataCheck: 'Επαλήθευση διαβαθμισμένων δεδομένων',
                    dataCheckSmall: 'Η απόκλιση K-L είναι υψηλότερη από 0,5, συνιστάται η εκπαίδευση.',
                    dataCheckHeight: 'Η απόκλιση του K-L είναι υψηλότερη από 0,8 και απαιτείται επείγουσα κατάρτιση.',
                    check: 'Βαθμονόμηση',
                    history: 'Ιστορία κλήσης',
                    historyTime: 'Η καθημερινή σημείωση και η τροποποίηση θα εκτελέσει αυτόματα την εκπαίδευση μοντέλου στις 2:00 π.μ.',
                    today: 'Ετικέτα σήμερα',
                    article: 'Άρθρο',
                    none: 'Κανένα',
                    historyCheck: 'Ιστορικό σύνολο κάλυψης',
                    look: 'Προβολή εγγραφών',
                    historyluate: 'Επαναυπολογισμός ιστορικών δεδομένων',
                    startluate: 'Υπολογισμός γερανών',
                    classData: 'Διαβαθμισμένα στοιχεία',
                    classStatus: 'Πρόοδος κατάρτισης',
                    next: 'Επόμενο άρθρο:',
                    prev: 'Προηγούμενο άρθρο:',
                    finish: 'Πλήρης εκπαίδευση',
                    stop: 'Τέλος της εκπαίδευσης',
                    classDetail: 'Λεπτομέρειες εκπαίδευσης',
                    trainingNone: 'Καμία εκπαίδευση για την έξυπνη ετικέτα.',
                },
                classifiedTrainingHistory: {
                    title: 'Ιστορία εκπαίδευσης',
                    time: 'Επιλογή χρόνου:',
                    tag: 'Τύπος ετικέτας:',
                    user: 'Χειριστής:',
                    data: 'Επιλέξτε μια πηγή δεδομένων:',
                    search: 'Ερώτηση',
                    searchBar: 'Αναζήτηση:',
                    searchBarPlaceholder: 'Παρακαλώ εισάγετε αναζήτηση αναγνώρισης κλήσεων / συνομιλία',
                    reset: 'Επαναφοράς',
                    export: 'Εξαγωγή',
                    all: 'Όλα',
                    select: {
                        today: 'Σήμερα',
                        thisMonth: 'Αυτό το μήνα',
                        lastMonth: 'Τον περασμένο μήνα.',
                        thisQuarter: 'Αυτό το τρίμηνο.',
                        lastQuarter: 'Τελευταίο τρίμημα',
                        thisYear: 'Φέτος φέτος.',
                        lastYear: 'Πέρυσι',
                        search: 'Ερώτηση',
                        reset: 'Επαναφοράς',
                    },
                    table: {
                        user: 'Αερομεταφορέας',
                        date: 'Χρόνος λειτουργίας',
                        data: 'Πηγή δεδομένων',
                        id: 'Κωδικός ID/Συνομιλίας',
                        tagType: 'Ομάδα Έξυπνης ετικέτας',
                        tagName: 'Όνομα ετικέτας',
                        state: 'Κατάσταση',
                        sizeChangeText: 'Εμφάνιση ανά σελίδα',
                        page: 'Σελίδα {1} του {0}',
                        call: 'Κλήση',
                        dialogue: 'Διάλογος',
                    },
                },
                clusteringAnnotation: {
                    title: 'Σημείωση συστάδωσης',
                    left: {
                        title: 'Συσκευασία αποτελεσμάτων',
                    },
                    right: {
                        title: 'Συμμετοχή Προτάσεις',
                        checkAll: 'Επιλογή όλων της σελίδας',
                        tagging: 'Κλήρωση',
                        detail: 'Προβολή',
                        meaningless: 'Αγνόηση',
                        meaninglessTips: 'Τα αγνοούμενα αποτελέσματα συστάδας δεν θα εμφανιστούν στο μέλλον. Είσαι σίγουρος ότι θέλεις να τους αγνοήσεις;',
                        cancel: 'Ακύρωση',
                    },
                },
            },
            clientCenter: {
                clientManage: {
                    title: 'Διαχείριση πελατών',
                    tabTitle: 'Κέντρο Εξυπηρέτησης πελατών',
                },
                wechatClientManage: {
                    title: 'Επιχειρηματικός μικροειδή',
                    table: {
                        id: 'Κωδικός ID πελατών',
                        name: 'Πελάτη',
                        tag: 'Ετικέτα πελατών',
                    },
                },
            },
            collectionRule: {
                title: 'Κανόνες συλλογής',
                form: {
                    info: 'Ευφυής συλλογή πληροφοριών',
                    infoPlaceholder: 'Παρακαλώ επιλέξτε μια κατηγορία',
                },
                table: {
                    name: 'Όνομα πεδίου',
                    props: 'Χαρακτηριστικά πελατών',
                    type: 'Τύπος πεδίου',
                    desc: 'Περιγραφή πεδίου',
                },
            },
            dataAdd: {
                title: 'Προσθήκη δεδομένων',
                types: {
                    auto: 'Προσθήκη αυτόματης',
                    manual: 'Προσθήκη χειροκίνητα',
                },
            },
            wechatStaff: {
                table: {
                    name: 'Όνομα',
                    part: 'Υπηρεσία',
                    phone: 'Αριθμός κινητού τηλεφώνου:',
                    email: 'Ηλεκτρονικό ταχυδρομείο',
                    wechartId: 'Enterprise WeChat ID',
                    status: 'Κατάσταση επί της εργασίας',
                },
                info: 'Παρακαλώ επιλέξτε την υπηρεσία που πρέπει να συγχρονίσει τα δεδομένα πρώτα',
                synSuccess: 'Επιτυχία συγχρονισμούς',
                init: 'Αρχικοποίησης',
                syn: 'Συγχρονισμός',
            },
            appealHistory: {
                appealTime: 'Χρόνος προσφυγής',
                cancelTime: 'Χρόνος ανάκλησης',
                reviewTime: 'Ώρα αναθεώρησης',
                inspector: 'Επιθεωρητής ποιότητας',
                result: 'Αποτέλεσμα της καταγγελίας',
                complainResult: 'Σύνολο {0} ποιητικών ελέγχων, επιτυχημένες {1} καταγγελίες, απορρίψεις {2}',
                reason: 'Αιτιολογία καταγγελίας',
                rejection: 'Λόγος απόρριψης',
                cancel: 'Ανακαλώθηκε',
                tip: 'Επιβεβαιώστε να αποσύρετε την καταγγελία;',
            },
            appealSdk: {
                time: 'Χρόνος διαλόγου',
                externalIdCall: 'ID καταγραφής κλήσεων',
                externalIdText: 'ID εγγραφής συζήτησης',
                callCenterCallID: 'Αναγνωριστικό κλήσης τηλεφωνικού κέντρου',
                imDialogRecordID: 'Αναγνωριστικό εγγραφής συνομιλίας άμεσων μηνυμάτων',
                customerNickName: 'Πελάτη',
                readStatus: 'Κατάσταση αναθεώρησης',
                status: 'Καθεστώς καταγγελίας',
                isManual: 'Χειροκίνητη επιθεώρηση ποιότητας',
                complainButtonInfo: 'Επιτρέπονται προσφυγές {0}, {1} αναιρέσεις που έχουν ήδη υποβληθεί, {2} απομένουν προσφυγές. Μπορείτε να κάνετε έφεση πριν από το {3}',
                submit: 'Υποβολή καταγγελίας',
                complain: 'Καταγγελία',
                allComplain: 'Καταγγελίες',
                pendingSubmit: 'Προς υποβολή',
                taskIds: 'Εργασία επιθεώρησης',
                graded: 'Αξιολόγηση',
                complainSuccess: 'Η καταγγελία υποβλήθηκε με επιτυχία',
                appealSdkIndex: {
                    title: 'Ευφυή αποτελέσματα επιθεώρησης ποιότητας',
                },
            },
        },
        lookupRecords: {
            getFiltersListError: 'Αποτυχία λήψης πληροφοριών λίστας φίλτρων, παρακαλώ ελέγξτε τη σύνδεση δικτύου ή δοκιμάστε ξανά αργότερα!',
            columns: 'Στήλη',
            filter: 'Φίλτρος',
            noSearchResult: 'Δε βρέθηκαν αρχείες',
            pleaseSearch: 'Παρακαλώ επιλέξτε ένα φίλτρο και δοκιμάστε αναζήτηση',
            sift: 'Φίλτρος',
            create: 'Νέο',
            search: 'Αναζήτησης',
            createTaskTitle: 'Νέα εργασίας',
            title: 'Τίτλος',
            deadline: 'Προθεσμία:',
            principal: 'Υπεύθυνο άτομο',
            enqueueTime: 'Ώρα καταχώρισης',
            computeError: 'Ο υπολογισμός απέτυχε, παρακαλώ περιμένετε!',
            sum: 'Άθροιση',
            max: 'Μέγιστος',
            min: 'Ελάχιστο',
            avg: 'Μέσος',
            count: 'Μετρητά',
            maxDate: 'Μέγιστο (Τελευταία)',
            minDate: 'Ελάχιστο (παλικό)',
        },
        mainMenu: {
            insight: {
                name: 'Insight',
                getInsightUrlError: 'Αποτυχία λήψης διεύθυνσης σύνδεσης Insight, παρακαλώ δοκιμάστε ξανά αργότερα!',
            },
            template: {
                learningReminder: 'Υπενθύμιση μάθησης',
                subscriptionDynamics: 'Δυναμική συνδρομών',
            },
        },
        tasks: {
            subMenu: {
                manageHome: {
                    text: 'Διαχείριση εργασιών',
                    chaneg: 'Εναλλαγή',
                },
                qualityCheckTemplate: {
                    text: 'Πρότυπο επιθεώρησης ποιότητας',
                    collectText: 'Πρότυπο απόκτησης',
                    condition: {
                        text: 'Όροι επιθεώρησης ποιότητας',
                    },
                    checkPoint: {
                        text: 'Ρυθμίσεις κανόνας',
                    },
                    automaticAdd: {
                        text: 'Αυτοματοποίηση διεργασίας',
                    },
                    manualAdd: {
                        text: 'Προσθήκη χειροκίνητα',
                    },
                    roleConfig: {
                        text: 'Ρύθμιση ρόλων',
                    },
                    basicInfo: {
                        text: 'Βασικές πληροφορίες',
                    },
                    smartWordsLibrary: {
                        text: 'Έξυπνος θησαυρός.',
                    },
                    grade: {
                        text: 'Αξιολόγηση επιθεώρησης ποιότητας',
                    },
                    collectionRule: {
                        text: 'Κανόνες συλλογής',
                    },
                    addData: {
                        text: 'Προσθήκη δεδομένων',
                    },
                    collectionList: {
                        text: 'Κατάλογος εξαγορών',
                    },
                },
                qualityCheckWorkbench: {
                    text: 'Επιθεώρηση εργασίας',
                    wechatText: 'Ανάλυση πάγκος',
                    informationCollectText: 'Αγορά Εργασίας',
                    qualityInspectionList: {
                        text: 'Κατάλογος επιθεωρήσεων ποιότητας',
                        wechatText: 'Κατάλογος ανάλυσης',
                        informationCollectText: 'Κατάλογος εξαγορών',
                    },
                    condition: {
                        text: 'Κατάλογος επιθεωρήσεων ποιότητας (Obsolete)',
                    },
                    reviewList: {
                        text: 'Λίστα αναθεώρησης',
                    },
                    spotCheckList: {
                        text: 'Κατάλογος δειγματοληψίας',
                    },
                    caseBaseList: {
                        text: 'Βιβλιοθήκη περίπτωσης',
                    },
                    testSetList: {
                        text: 'Σύνολο δοκιμών επιθεώρησης ποιότητας',
                    },
                },
                statisticsAndReports: {
                    text: 'Στατιστικές και εκθέσεις',
                    wholeReport: {
                        text: 'Συνολική έκθεση:',
                    },
                    groupReport: {
                        text: 'Έκθεση του ομίλου εξυπηρέτησης πελατών',
                    },
                    agentReport: {
                        text: 'Έκθεση εξυπηρέτησης πελατών',
                    },
                    customerServiceExecution: {
                        text: 'Ανάλυση εξυπηρέτησης πελατών',
                    },
                    analysisOverview: {
                        text: 'Επισκόπηση ανάλυσης',
                    },
                    inspectionItemsAnalysis: {
                        text: 'Ανάλυση αντικειμένου επιθεώρησης ποιότητας',
                    },
                },
                wechatQa: {
                    text: 'Επιθεώρηση ποιότητας Enterprise WeChat',
                    task: {
                        text: 'Ανάλυση',
                    },
                    baseInfo: {
                        text: 'Βασικές πληροφορίες',
                    },
                    checkPoint: {
                        text: 'Ρύθμιση μοντέλου ανάλυσης',
                    },
                    setting: {
                        text: 'Ρύθμιση ανάλυσης WeChat Enterprise',
                    },
                    automaticAdd: {
                        text: 'Αυτοματοποίηση διεργασίας',
                    },
                    manualAdd: {
                        text: 'Προσθήκη χειροκίνητα',
                    },
                },
                clientCenter: {
                    text: 'Κέντρο Εξυπηρέτησης Πελατών',
                },
            },
            conditionDictionaries: {
                title: 'Όλοι οι όροι',
                searchDefaultText: 'Παρακαλώ εισάγετε ένα ID ή όνομα.',
                id: 'ID',
                name: 'Όνομα',
                conditionDetailedShow: 'Επέκταση',
                conditionDetailedHide: 'Αποθήκη',
                remark: 'Περιγραφή:',
                checkRole: 'Ρόλος:',
                operator: 'Χειριστής:',
                operatorLogic: 'Λογική:',
            },
            audioTextView: {
                customer: 'Πελάτη',
                agent: 'Υπηρεσία πελατών',
                unsupportedFormat: 'Αυτή η μορφή δεν υποστηρίζεται.',
            },
            checkPointClassifications: {
                add: 'Προσθήκη κατηγορίας',
                name: 'Όνομα',
                enterToSave: 'Πιέστε Enter για αποθήκευσης',
                highestScore: 'Μέγιστο κάλυμμα βαθμολογίας',
                minimumScore: 'Ελάχιστη βαθμολογία',
                defaultMinScore: 'Το προκαθορισμένο είναι 0 πόντοι',
                minimumScoreTitle: 'Κατώτερο όριο βαθμολογίας',
                beginScore: 'Συνολική αξία αρχικής βαθμολογίας',
                beginScoreTitle: 'Αρχική τιμή βαθμολογίας',
                scoreSetTip: 'Η μέγιστη βαθμολογία είναι μικρότερη από το άθροισμα όλων των βαθμών. Μπορείτε να επιλέξετε:',
                ignoreExcessSpillover: 'Παράβλεψη υπερχείλισης',
                automaticWeightCalculation: 'Αυτόματη λογιστική βάρη',
            },
        },
        fieldSelect: {
            field: 'Πεδίο',
        },
        checkRange: {
            numberTipOne: 'Τομέα',
            numberTipTwo: 'Ποινή',
            numberTipThree: 'Ποινή στο Όχι.',
            conditionLimit: 'Περιορισμοί υπό όρους:',
            roleLimit: 'Περιορισμοί ρόλο',
            contextLimit: 'Περιορισμοί πρότασης',
            notZero: 'Η είσοδος 0 δεν υποστηρίζεται για τον περιορισμό πρότασης',
            startMustLessThanEnd: 'Η θέση εκκίνησης πρέπει να είναι μικρότερη από τη θέση τελικής πρότασης',
        },
        waveAudio: {
            play: 'Αναπαραγωγή',
            pause: 'Παύση',
            rateOne: '0.5',
            rateTwo: '1.0',
            rateThree: '1.5',
            rateFour: '2.0',
            rateFive: '1.2',
        },
        operatorListGather: {
            pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
            pleaseEnterRegular: 'Παρακαλώ εισάγετε μια κανονική έκφραση',
            pleaseEnterGrammar: 'Παρακαλώ εισάγετε έναν κανόνα γραμματικής',
            pleaseEnterTestText: 'Παρακαλώ εισάγετε το περιεχόμενο που θα επαληθευτείν',
            pleaseEnterLoudness: 'Παρακαλώ εισάγετε τη δυναμικότητα ντεσιμπέλ.',
            pleaseEnterRangeAbility: 'Παρακαλώ εισάγετε το εύρος αλλαγής',
            afterHit: 'Έλεγχος μετά το χτύπημα:',
            pleaseEnterContext: 'Παρακαλώ εισάγετε μια δήλωση αναφοράς',
            wordNumber: 'Κενό λέξης',
            intervalSecond: 'Χρονικό διάστημα μεγαλύτερο',
            minute: 'Κάθε λεπτό.',
            wordUnit: 'Λόγο',
            test: 'Δοκιμή',
            testRegular: 'Δοκιμή κανονικών εκφράσεων',
            testGrammar: 'Γραμματική δοκιμή',
            testGrammarError: 'Δοκιμή γραμματικής απέτυχε',
            regularError: 'Σφάλμα κανονικής έκφρασης, παρακαλώ εισάγετε ξανά',
            pleaseEnterSemanticSentence: 'Παρακαλώ εισάγετε μια πρόταση που απαιτεί σημασιολογική ανίχνευση.',
            pleaseEnterAssociate: 'Ανατρέξτε στις οδηγίες για το δικαίωμα να δημιουργήσετε μια έκφραση δεδομένων σε συνδυασμό δεδομένων',
            querySemanticTags: 'Επιλογή σημασιολογικής ετικέτας',
            reQuerySemanticTags: 'Επαναεπιλογή σημασιολογικών ετικετών',
            semanticTags: 'Σημασιολογική ετικέτας',
            standardSentence: 'Τυποποιημένη φράση',
            semanticName: 'Σημασιολογική ετικέτας',
            sentence: 'Τυποποιημένη φράση',
            similarity: 'Ομοιότητας',
            actions: 'Λειτουργία',
            tipOne: 'Δεν βρήκα τη σωστή ετικέτα,',
            tipTwo: 'Προσθήκη μιας νέας σημασιολογικής ετικέτας',
            notLessThan: 'Όχι λιγότερο.',
            notGreaterThan: 'Όχι μεγαλύτερο',
            ignoreLessThan: 'Αγνόηση λιγότερα',
            wordUnitSet: 'Η πρόταση της λέξης',
            speedWordNotNull: 'Ο ελάχιστος αριθμός λέξεων και ο μέγιστος αριθμός λέξεων στην ανίχνευση ταχύτητας ομιλίας δεν μπορούν να είναι κενοί.',
            speedWordMinValueLessThanMaxValue: 'Ο ελάχιστος αριθμός λέξεων στην ανίχνευση ταχύτητας ομιλίας δεν μπορεί να είναι μεγαλύτερος από τον μέγιστο αριθμό λέξεων.',
            speechGrabbingIntervalTip: 'Διάστημα>',
            speechLengthTip: 'Η πρόταση είναι μεγάλη>',
            msUnit: 'ms',
            sUnit: 'Δευτερόλεπτα',
            grabIntervalNotNull: 'Το χρονικό διάστημα λήψης δεν μπορεί να είναι κενό',
            grabLengthNotNull: 'Η πρόταση δεν μπορεί να είναι άδεια.',
            pleaseSelectEntity: 'Παρακαλώ επιλέξτε μια οντότητα πληροφοριών',
            pleaseSelectOperator: 'Παρακαλώ επιλέξτε μια ενέργεια',
            pleaseSelectBasicInfo: 'Παρακαλώ επιλέξτε βασικές πληροφορίες',
            pleaseEnterFixedValue: 'Παρακαλώ εισάγετε μια σταθερή τιμή',
            loudnessUnit: 'db',
            percent: '%',
            matchSuccess: 'Ταίριασμα με επιτυχία',
            matchError: 'Το ταίριασμα απέτυχε',
            mindetectionStatement: 'Ελάχιστη δήλωση ανίχνευσης',
            conceptWordholder: 'Παρακαλώ επιλέξτε μια λέξη έννοιας',
            elementHolder: 'Παρακαλώ εισάγετε ένα στοιχείοName',
            associateMedol: {
                tabs: {
                    data: 'Δεδομένα',
                    operator: 'Αερομεταφορέας',
                },
            },
            repet: 'Επαναλαμβάνω',
            bout: 'Χρόνια',
            ignore: 'Αγνόηση λιγότερα',
            ignoreAffix: 'Η πρόταση της λέξης',
            associateData: 'Στοιχεία παρακολούθησης των οδών',
            pretreatmentData: 'Προεπεξεργασία δεδομένων',
            reviewTaskData: 'Επανεξέταση δεδομένων εργασίας',
            taskData: 'Δεδομένα επιθεώρησης ποιοτικού ελέγχου',
            businessData: 'Επιχειρηματικά αρχεία',
            functionOperator: 'Λειτουργοί λειτουργίας',
            operation: 'Ο φορέας εκμετάλλευσης λειτουργίας',
            notAnyMatch: 'Όταν δεν χτυπηθούν οποιαδήποτε ζητήματα:',
            times: 'Αριθμός περιστατικών',
            newAssociateDataTip: 'Εάν η τιμή είναι ένας αριθμητικός τύπος, χρησιμοποιήστε την κληρονομική λειτουργία',
        },
        conditionGather: {
            cycle: 'Κύκλος',
            rlue: 'Κανόνες',
            delete: 'Αφαίρεση',
            sampling: 'Εξαγωγή',
            item: 'Άρθρο',
            percent: '%',
            samplingSame: 'Ίδιος αριθμός εξαγωγής ανά παραγόντος',
            samplingRecheck: 'Επιτρέπεται η επαναλαμβανόμενη εκχύλιση ειδών δειγματοληψίας',
            dateUnit: '- Όχι.',
            samplingTip: 'Διαφορετικοί κανόνες που καλύπτουν την ίδια πρόσκληση δεν θα εξαχθούν επανειλημμένα, και τα αρχεία που έχουν εξαχθεί αλλά δεν έχουν ελεγχθεί δεν θα εξαχθούν ξανά.',
            add: 'Νέος κανόνας',
        },
        ruleGather: {
            title: 'Κανόνες',
            screeningCondition: 'Κατάσταση φίλτρου',
            addRule: 'Νέος κανόνας',
            inspector: 'Επιθεωρητής ποιότητας',
            ruleTip: 'Ο τρόπος κατανομής πρώτης κανόνας, από πάνω έως κάτω, δεν επαναλαμβάνει την κατανομή, εντός του κανόνα ή δεν ταιριάζει με κανέναν κανόνα τα στοιχεία θα κατανέμονται τυχαία.',
            moveUp: 'Μετακίνηση πάνω',
            moveDown: 'Μετακίνηση προς τα κάτι',
            top: 'Πρώτον',
        },
        pushRulesGather: {
            title: 'Κανόνες',
            delete: 'Αφαίρεση',
            newPush: 'Νέα ώθηση',
            newRule: 'Νέος κανόνας',
            sampling: 'Εξαγωγή',
            item: 'Άρθρο',
            percent: '%',
            samplingSame: 'Ίδιος αριθμός εξαγωγής ανά παραγόντος',
            dateUnit: '- Όχι.',
            screeningCondition: 'Κατάσταση φίλτρου',
            email: 'Ηλεκτρονικό ταχυδρομείο',
            emailPlaceholder: 'Εισάγετε τα γραμματοκιβώτια, χωρισμένα με κόμματα',
            updateType: 'Τύπος ενημέρωσης',
            pushDetail: 'Λεπτομέρειες',
            pushUrl: 'Πίεση URLName',
            pushWay: 'Τύπος ώθησης',
            pushMethod: 'Λειτουργία ώθησης',
            pushContentType: 'Μορφή δεδομένων',
            pushData: 'Πίεση δεδομένων',
            additionalData: 'Πρόσθετα δεδομένα',
            inspectionType: 'Τύπος επιθεώρησης ποιότητας',
            all: 'Όλα',
        },
        taskAdditionalData: {
            newData: 'Νέα δεδομένα',
            delete: 'Αφαίρεση',
            placeholder: 'Παρακαλώ εισάγετε ένα όνομα',
            dataPlaceholder: 'Παρακαλώ εισάγετε περιεχόμενο',
        },
        UdeskQaReact: {
            loadSdkError: 'Η φόρτωση SDK απέτυχε, παρακαλώ δοκιμάστε ξανά αργότερα!',
        },
        gearOptionList: {
            evaluation: 'Αξιολόγηση',
        },
        tableComponentTransfer: {
            leftTitle: 'Αντικείμενο λίστας',
            rightTitle: 'Εμφάνιση αντικειμένου',
        },
        kmTinymce: {
            link: 'Εισαγωγή/Επεξεργασία δεσμού',
            modalTitle: 'Εισαγωγή δεσμού',
            href: 'Διεύθυνση',
            text: 'Εμφάνιση κειμένου',
            title: 'Τίτλος',
            target: 'Λειτουργία ανοιχτής',
            none: 'Κανένα',
            newWindow: 'Άνοιγμα σε νέο παράθυρο',
            buttonStyle: 'Στυλ κουμπιού',
            close: 'Κλείσιμο',
            open: 'Άνοιγμα:',
            answerMessage: 'Άλμα/Αποστολή μηνύματος',
            answerMessageTitle: 'Αποστολή κουμπί μηνύματος',
            answerMessageText: 'Εμφάνιση κειμένου',
            answerMessageContent: 'Περιεχόμενο μηνύματος',
            answerMessageButtonStyle: 'Στυλ κουμπιού',
            answerMessageTips: 'Σημείωση: Το κουμπί αποστολή μηνύματος υποστηρίζει μόνο το κανάλι ιστού, παρακαλώ ρυθμίστε το προσεκτικά.',
            answerSwitchStaff: 'Εγχειρίδιο μεταφοράς/στροφής',
            answerSwitchStaffTitle: 'Γυρίστε το χειροκίνητο κουμπί',
            answerSwitchStaffText: 'Εμφάνιση κειμένου',
            answerSwitchStaffRule: 'Κανόνες κουμπιού',
            answerSwitchStaffButtonStyle: 'Στυλ κουμπιού',
            answerSwitchStaffTips: 'Σημείωση: Το χειροκίνητο κουμπί διακόπτη υποστηρίζει μόνο το διαδικτυακό κανάλι, παρακαλώ ρυθμίστε το προσεκτικά.',
            textButton: 'Κουμπί κειμένου',
            borderButton: 'Πλαισιωμένο κουμπί',
            message: 'Αποστολή μηνύματος',
            switchStaff: 'Στροφή χειροκίνητου',
            messageError: 'Το περιεχόμενο του κουμπιού δεν μπορεί να υπερβεί 10 λέξεις',
            messageIsEmptyError: 'Το περιεχόμενο του κουμπιού δεν μπορεί να είναι κενό',
            okText: 'Προσδιορίστε την ένδειξη αυτών',
            cancelText: 'Ακύρωση',
            video: 'Βίντεο',
            uploadVideo: 'Αποστολή βίντεο',
            uploadText: 'Μόνο υποστήριξη MP4 μορφή, μέγεθος όχι περισσότερο από 20M',
            videoEmptyOrUploading: 'Το βίντεο είναι κενό ή αποστολέα',
            customEmoji: 'Έκφραση',
        },
        massageConfiguration: {
            pushTarget: 'Στόχος κοινοποίησης',
            customizePushTarget: 'Προσαρμοσμένος προορισμός ώθησης',
            sysUser: 'Τρέχων χρήστης συστήματος',
            sysRole: 'Τρέχον ρόλος συστήματος',
            emailPushTarget: 'Αποστολή προορισμού',
            targetEmailsPlaceholder: 'Παρακαλώ εισάγετε τα γραμματοκιβώτια χωρισμένα με κόμματα',
            subject: 'Όνομα μηνύματος',
            SDKID: 'ID SDK',
            content: 'Περιεχόμενο κοινοποίησης',
            sdkPushType: 'Σχήμα προώθησης',
            sdkPushURL: 'Πίεση URLName',
            pushData: 'Πίεση δεδομένων',
            sdkPushWay: 'Λειτουργία ώθησης',
            dataType: 'Μορφή δεδομένων',
            additionalData: 'Πρόσθετα δεδομένα',
            name: 'Όνομα μηνύματος',
            filter: 'Κατάσταση φίλτρου',
            triggerType: 'Μηχανισμός ενεργοποίησης',
            pushCycle: 'Σταθερή συχνότητα χρονοδιαγράμματος',
            pushContent: 'Περιεχόμενο αναφοράς',
            qualityList: 'Κατάλογος αποτελεσμάτων επιθεώρησης ποιοτικού ελέγχου',
            designated: 'Καθορισμένο προσωπικό',
            messageType: 'Τύπος μηνύματος',
        },
        taskCard: {
            template: {
                flyingBookGroupChat: 'Συνομιλία ομάδας ιπτάμενων βιβλίων',
                questionnaire: 'Ερωτηματολόγο',
                ecommerceSession: 'Σύνοδος ηλεκτρονικού εμπορίου',
                eCommerceReview: 'Επισκόπηση ηλεκτρονικού εμπορίου',
                socialMediaComments: 'Σχόλια Κοινωνικών Μέσων',
                mixing: 'Ανάμειξη',
                video: 'Βίντεο',
                cancelCollection: 'Ακύρωση αγαπημένων',
                collection: 'Συλλογή',
            },
        },
        semanticTagsSelect: {
            index: {
                delete: 'Διαγραφή',
                standardSentence: 'Τυπική πρόταση:',
            },
        },
        gong: {
            filesOpen: {
                folderItem: {
                    collection: 'Συλλογή',
                    calls: 'Κλήσης',
                    createdBy: 'Δημιουργήθηκε:',
                    createdOn: 'Χρόνος δημιουργίας:',
                },
                fileItem: {
                    uIProvidesIcon: 'Το ui παρέχει εικονίδιο',
                    minute: 'Πρακτικά',
                    callClip: 'Κλίμα κλήσης',
                    start: 'Εκκίνηση',
                    End: 'Τέλος:',
                    employees: 'Μισθωτοί:',
                    Customer: 'Πελάτης:',
                    sessionTime: 'Ώρα συνεδρίας:',
                    reasonForRecommendation: 'Λόγος για την πρόταση:',
                    addedBy: 'Προστίθεται:',
                    addTime: 'Ώρα προσθήκης:',
                },
                modalAddFile: {
                    caseTitle: 'Τίτλος υποθέσεως',
                    addSomeClipsToTheCaseLibrary: 'Προσθήκη μερικών δείκτων στη βιβλιοθήκη περίπτωσης',
                    addToCaseBase: 'Προσθήκη στη βιβλιοθήκη περίπτωσης',
                    storedIn: 'Φυλάσσεται σε φύλλο',
                    pleaseSelect: 'Παρακαλώ επιλέξτε.',
                    reasonsForRecommendation: 'Λόγοι για τη σύσταση',
                    pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                },
            },
            shareModal: {
                index: {
                    customer: 'Πελάτης:',
                    employees: 'Μισθωτοί:',
                    timeliness: 'Προθεσμία:',
                    recordingLinkValidWithinDays: 'Ο σύνδεσμος εγγραφής ισχύει μέσα σε λίγες ημέρες',
                    sharingInstructions: 'Περιγραφή Share:',
                    shareSuccess: 'Μοιραζόμαστε την επιτυχία!',
                    cancel: 'Ακύρωση',
                    share: 'Μοιρασία',
                    copySucceeded: 'Αντίγραφο επιτυχημένο!',
                    copyShareLink: 'Αντιγραφή δεσμού κοινής χρήσης',
                    shareWithColleagues: 'Μοιραστείτε με τους συναδέλφους',
                    shareWithCustomers: 'Μοιραστείτε με τους πελάτες',
                    staff: 'Εργαζόμενος',
                    selectColleagues: 'Επιλέξτε συνεργάτες',
                    pleaseSelectColleaguesToShare: 'Παρακαλώ επιλέξτε έναν συνάδελφο για να μοιραστείτε.',
                    pleaseEnterTheSharingDescription: 'Παρακαλώ εισάγετε οδηγίες κοινής',
                    taskName: 'Καθήκοντα:',
                    recordingShareValidWithinDays: 'Σύνδεσμος κοινής χρήσης ισχύος εντός ημερών',
                },
            },
            waveAudio: {
                index: {
                    theFileCannotBeFound: 'Το αρχείο δεν μπορεί να βρεθεί!',
                    sale: 'Πωλήσεις:',
                    customer: 'Πελάτης:',
                    topicDetection: 'Ανίχνευση θεμάτων:',
                    keyEvents: 'Βασικά γεγονότα:',
                },
            },
            helpCommentModal: {
                index: {
                    selectColleagues: 'Επιλέξτε συνεργάτες',
                    helpContent: 'Περιεχόμενο βοήθεια',
                    visibleRange: 'Ορατό εύρος',
                    seekCounseling: 'Αναζητήστε συμβουλή',
                },
            },
            commentDispalyItem: {
                index: {
                    seekAdvice: 'Ζητήστε συμβουλή',
                    concatText: 'Στον',
                },
            },
            customerInsight: {
                index: {
                    customerInformation: 'Πληροφορίες πελατών',
                    customerInsight: 'Στοιχεία πελατών',
                    customerLabel: 'Ετικέτα πελατών',
                },
            },
            intelligentRecommend: {
                index: {
                    scriptRecommendation: 'Σύσταση ομιλίας',
                    objectionHandlingScripts: 'Χειρισμός ένστασης',
                    productSellingPointScripts: 'Σημεία πώλησης προϊόντων',
                    knowledgePointRecommendation: 'Σημείο γνώσης συστήνει',
                    relatedKnowledgePoints: 'Σχετικά σημεία γνώσης',
                    recommendedCases: 'Συστήστε περιπτώσεις',
                },
            },
            supervision: {
                index: {
                    scriptRecommendation: 'Σύσταση ομιλίας',
                    caseRecommendation: 'Συνιστάται η υπόθεση.',
                    hit: 'Χτύπημα.',
                    miss: 'Αστόχηση',
                    supervisionItem: 'Είδη εποπτείας',
                    implementation: 'Καθεστώς εφαρμογής',
                    reInspection: 'Επανεπιθεώρηση',
                    supervisionItemSettings: 'Ρύθμιση αντικειμένου εποπτείας',
                },
            },
            supervisionClassificationModal: {
                index: {
                    telephoneCall: 'Τηλεφωνικές κλήσεις',
                    enterpriseWeChatCall: 'Μικρολόγια επιχειρήσεων',
                    enterpriseMicroConversation: 'Πολιτική συνόδου επιχειρήσεων',
                    open: 'Άνοιγμα:',
                    close: 'Κλείσιμο',
                    conversationScenario: 'Σενάρια συνεδρίας',
                    monitorConversationChannels: 'Επιβλέπετε το κανάλι συζήτησης',
                    permanentlyValid: 'Μόνιμα αποτελεσματικό',
                    permanentlyInvalid: 'Μόνιμα μη έγκυρο',
                    customValidity: 'Περίοδος τελωνειακής ισχύς',
                    termOfValidity: 'Περίοδος ισχύος',
                    newRating: 'Νέα βαθμολογία',
                    whenConversation: 'Όταν η συνεδρίαση',
                    hit: 'Χτύπημα.',
                    miss: 'Αστόχηση',
                    time: 'Ποτε.',
                    rated: 'Η αξιολόγηση είναι',
                    qualified: 'Προσδιορισμένο',
                    unqualified: 'Μη επιλέξιμε',
                    modifiedSuccessfully: 'Επιτυχία τροποποίησης',
                    classificationName: 'Όνομα κατηγορίας',
                    supervisionObject: 'Αντικείμενο εποπτείας',
                    entryintoforceTime: 'Αποτελεσματικός χρόνος',
                    supervisionItemRating: 'Αξιολόγηση στοιχείων εποπτείας',
                    pleaseCheckWhetherTheRatingOfSupervisionItemIsCorrect: 'Παρακαλώ ελέγξτε αν η βαθμολογία παρακολούθησης είναι σωστή',
                    ratingRules: 'Κανόνες αξιολόγησης',
                    settingOfRatingRulesForSupervisionItems: 'Ρύθμιση κανόνας αξιολόγησης στοιχείων εποπτείας',
                },
            },
            reInspect: {
                index: {
                    keyEvents: 'Γεγονότα κλειδιά',
                    supervisionItem: 'Είδη εποπτείας',
                    conversationScenario: 'Σενάρια συνεδρίας',
                    customerLabel: 'Ετικέτα πελατών',
                    reDetectionRules: 'Αναγνώριση κανόνων',
                },
            },
            audioPlayerBar: {
                index: {
                    downloadRecording: 'Λήψη εγγραφής',
                    downloadText: 'Λήψη κειμένου:',
                },
            },
        },
        imgUpload: {
            index: {
                uploadPictures: 'Αποστολή εικόνας',
                pleaseSelectAPictureWithASizeOfNoMoreThankb: 'Παρακαλώ επιλέξτε μια εικόνα με μέγεθος που δεν υπερβαίνει τα 2048kb',
            },
        },
        chatRecord: {
            chatRecordItem: {
                components: {
                    debugInfo: {
                        or: 'Ή',
                        and: 'Και,',
                        wrong: 'Άλλα',
                        matchTo: 'Ταίριασμα',
                        rule: 'Κανόνες',
                        satisfactionOperator: 'Ικανοποιεί τον χειριστή',
                        customerLabel: 'Ετικέτα πελατών',
                        keyEvents: 'Γεγονότα κλειδιά',
                        knowledgePoints: 'Σημεία γνώσης',
                        sessionLabel: 'Ετικέτα συνεδρίας',
                        supervisionItem: 'Είδη εποπτείας',
                    },
                    linkExplorer: {
                        linkInTheText: 'Σύνδεσμος στο άρθρο:',
                    },
                    index: {
                        unsupportedMessageType: 'Μη υποστηριζόμενο τύπο μηνύματος',
                        locationInformation: 'Πληροφορίες τοποθεσίας',
                        businessCard: 'Επαγγελματική κάρτα',
                        smallProgram: 'Μικρό πρόγραμμα',
                        videoNumber: 'Αριθμός βίντεο',
                    },
                    translate: {
                        index: {
                            translation: 'Μετάφραση',
                        },
                    },
                    imageRecognition: {
                        index: {
                            imageRecognitionSuccessful: 'Επιτυχής αναγνώριση εικόνας',
                            imageRecognitionFailed: 'Η αναγνώριση της εικόνας απέτυχε',
                        },
                    },
                },
                index: {
                    system: 'Σύστημα',
                    customerService: 'Υπηρεσία πελατών',
                    robot: 'Ρομπότ',
                    customer: 'Πελάτη',
                    silence: 'Σιωπή',
                    theFollowingIsTheBotServiceMessage: 'Το παρακάτω είναι το μήνυμα υπηρεσίας bot μήνυμα',
                    theFollowingIsTheHumanServiceMessage: 'Το ακόλουθο είναι το μήνυμα της ανθρώπινης υπηρεσίας',
                },
            },
        },
        createForm: {
            field: {
                customComponentNotFound: 'Το προσαρμοσμένο στοιχείο δε βρέθηκε:',
            },
        },
        sdkLoaderBase: {
            component: {
                custom: 'Προσαρμοσμένο',
            },
            dropdownMonit: {
                updateSucceeded: 'Επιτυχία ενημέρωσης',
                areYouSureToDelete: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                custom: 'Προσαρμοσμένο',
            },
            modalMonit: {
                saveCurrentReportConfigurationForm: 'Αποθήκευση ρύθμισης τρέχουσας αναφοράς === Φόρμαν',
                saveCurrentReportConfiguration: 'Αποθήκευση της τρέχουσας ρύθμισης αναφοράς',
                pleaseEnterTheNameOfCommonSettingsTheMaximumLengthIs: 'Παρακαλώ εισάγετε ένα κοινό όνομα ρύθμισης, το μέγιστο μήκος είναι 20!',
                preservation: 'Αποθήκευση',
            },
            template: {
                saveCurrentReportConfiguration: 'Αποθήκευση της τρέχουσας ρύθμισης αναφοράς',
                updateCurrentReportConfiguration: 'Ενημέρωση της τρέχουσας ρύθμισης αναφοράς',
            },
        },
        audioCallBasicInfoV2: {
            template: {
                processingTime: 'Χρόνος επεξεργασίας',
                customFields: 'Προσαρμοσμένα πεδία',
                customerInformation: 'Πληροφορίες πελατών',
                associatedWorkOrder: 'Σχετική σειρά εργασίας',
                workOrderInformation: 'Πληροφορίες παραγγελίας εργασίας',
                workOrder: 'Σειρά εργασίας',
                triggerScenario: 'Σενάριο ενεργοποίησης',
                associatedCallConversation: 'Συνδεδεμένη κλήση/συνομιλία',
            },
        },
        audioCallContentInfoV2: {
            components: {
                testBtn: {
                    testWithCurrentCommunicationDialogueText: 'Δοκιμή με τρέχον κείμενο διέλευσης/διαλόγου',
                },
            },
            index: {
                originalSentence: 'Αρχική φράση',
                clause: 'Ρήτρα',
            },
        },
        checkPointOperatorListGather: {
            template: {
                whetherOverlappingStatementsAreIgnored: 'Αν οι αλληλοκαλυπτόμενες δηλώσεις',
                overlappingSpeechResponse: 'Επικαλυπτόμενη ανταπόκριση',
                section: 'Τομέα',
                day: 'Ημέρα',
            },
            businessSummary: {
                normal: {
                    equalTo: 'Ίση',
                    notEqualTo: 'Δεν είναι ίσο',
                    contain: 'Περιέχει',
                    excluding: 'Δεν περιέχει',
                },
            },
            externalInterfaceCheck: {
                normal: {
                    equalTo: 'Ίση',
                    contain: 'Περιέχει',
                    informationEntity: 'Φορέας πληροφορίας',
                    followthepathField: 'Πεδίο παρακολούθησης',
                    fixedValue: 'Σταθερή αξία',
                    pleaseSelectAnOperator: 'Παρακαλώ επιλέξτε έναν χειριστή',
                    pleaseSelectADataType: 'Παρακαλώ επιλέξτε έναν τύπο δεδομένων',
                    pleaseSelect: 'Παρακαλώ επιλέξτε.',
                    whenNoResultIsReturned: 'Όταν δεν επιστρέφεται αποτέλεσμα',
                    theResultIsYes: 'Το αποτέλεσμα είναι "Ναι"',
                    resultIsNo: 'Το αποτέλεσμα είναι "όχι"',
                },
            },
            associate: {
                advanced: {
                    valueTemplate: 'Πρότυπο τιμής',
                },
                normal: {
                    processingTime: 'Χρόνος επεξεργασίας',
                    customFields: 'Προσαρμοσμένα πεδία',
                    customerInformation: 'Πληροφορίες πελατών',
                    workOrderInformation: 'Πληροφορίες παραγγελίας εργασίας',
                    anyWorkOrder: 'Οποιαδήποτε σειρά εργασίας',
                    allWorkOrders: 'Όλες οι εντολές εργασίας',
                },
                index: {
                    operatorHitResultWhenTheDataSourceIsNot: 'Χειριστής χτύπησε αποτέλεσμα όταν η πηγή δεδομένων δεν είναι πηγή',
                    yes: 'Μάλιστα.',
                    no: 'Οχι',
                },
            },
            semanticMatching: {
                index: {
                    pleaseEnterALargeModelPrompt: 'Παρακαλώ εισάγετε ένα μεγάλο μοντέλο',
                },
            },
            multiModal: {
                normal: {
                    pleaseEnterALargeModelPrompt: 'Παρακαλώ εισάγετε ένα μεγάλο μοντέλο',
                    whenThereIsNoSuchData: 'Όταν δεν υπάρχουν τέτοια δεδομένα',
                },
            },
        },
        massagePushConfiguration: {
            component: {
                iAmMeItsADifferentFireworksxxxx8827: 'Είμαι αυτός που είμαι, ένα διαφορετικό πυροτεχνήματα @ 156xxxx8827.',
                hiThisIsTheNotificationOfRobotQualityInspectionWarningMessageSinceItWasAddedToTheGroupOnOctober: 'Γεια σας, είμαι η ειδοποίηση του προειδοποιητικού μηνύματος επιθεώρησης ρομπότ, το οποίο προστέθηκε στην ομάδα στις 17 Οκτωβρίου.',
            },
            interfacePush: {
                component: {
                    iAmMeItsADifferentFireworksxxxx8827: 'Είμαι αυτός που είμαι, ένα διαφορετικό πυροτεχνήματα @ 156xxxx8827.',
                    hiThisIsTheNotificationOfRobotQualityInspectionWarningMessageSinceItWasAddedToTheGroupOnOctober: 'Γεια σας, είμαι η ειδοποίηση του προειδοποιητικού μηνύματος επιθεώρησης ρομπότ, το οποίο προστέθηκε στην ομάδα στις 17 Οκτωβρίου.',
                },
            },
            associateSelect: {
                const: {
                    communicationTheme: 'Θέματα επικοινωνίας',
                    conversationSummary: 'Περίληψη συνεδρίας',
                    serviceSuggestions: 'Συστάσεις υπηρεσιών',
                },
                template: {
                    associatedWorkOrder: 'Σχετική σειρά εργασίας',
                    smartTags: 'Έξυπνη ετικέταName',
                },
            },
            otherPush: {
                template: {
                    customPushDestination: 'Προσαρμοσμένος προορισμός ώθησης',
                },
                components: {
                    ticketConfig: {
                        index: {
                            pleaseEnterTheAcceptanceCustomerServiceEmailOnlyOneIsSupported: 'Παρακαλώ εισάγετε την ηλεκτρονική υπηρεσία πελατών αποδοχής, μόνο ένα υποστηρίζεται.',
                            acceptCustomerService: 'Αποδοχή εξυπηρέτησης πελατών',
                            customerService: 'Υπηρεσία πελατών',
                            dontSetUpAcceptCustomerService: 'Μην δημιουργήσετε αποδοχή εξυπηρέτησης πελατών',
                            specifyMailbox: 'Καθορισμός γραμματοκιβωτίου',
                            workOrderTitle: 'Τίτλος παραγγελίας εργασίας',
                        },
                    },
                    callingRobotConfig: {
                        index: {
                            workingTimeID: 'Κωδικός ID χρόνου εργασίας',
                            taskName: 'Όνομα εργασίας',
                            pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                            outcallTemplateID: 'ID προτύπου εκτός κλήσεων',
                            pleaseEnterIntOnly: 'Παρακαλώ εισάγετε.',
                            outcallRobotDefinitionID: 'ID ορισμού ρομπότ εξόδου',
                            callingNumberType: 'Τύπος αριθμού κλήσης',
                            relayNumber: 'Αριθμός ανακοίνωσης',
                            numberPool: 'Αριθμός πισίνας',
                            pleaseSelect: 'Παρακαλώ επιλέξτε.',
                            callingNumberValue: 'Αξία αριθμού κλήσης',
                            contactListID: 'ID λίστας επαφής',
                            workEventID: 'ID γεγονότος εργασίας',
                        },
                    },
                },
            },
        },
        productMatrix: {
            index: {
                clickToLearnMore: 'Κάντε κλικ για να μάθετε περισσότερα',
            },
            schema: {
                textRobot: 'Ρομπότ κειμένου',
                trainerEscortDocumentQATaskDialogueTableQAAtlasQA: 'Συνοδεία εκπαιδευτής, ερώτηση και απάντηση εγγράφων, διάλογο βασισμένο σε εργασία, ερώτηση και απάντηση, γραφή ερώτηση και απάντηση.',
                capitalRetentionRobot: 'Ρομπότ κατακράτησης',
                richInquiryAndRetentionStrategiesHighPersonificationCommunicationEnsuringHighRetentionRateAndEfficientAutomaticConversionOfClues: 'Πλούσια παρακολούθηση στρατηγική διατήρησης, υψηλή επικοινωνία προσωποποίησης, για να εξασφαλίσει υψηλό ποσοστό διατήρησης, ενδείξει αποτελεσματική αυτόματη μετατροπή.',
                outboundRobot: 'Εξερχόμενη κλήση ρομπότ',
                workOrderCompletionReturnVisitServiceSatisfactionSurveyOperationAndMaintenanceFaultWarningPromptOrderDeliveryReminderEcommerceActivityNoticeCandidateAppointmentAndHelpBusinessAutomationAndBusinessEfficiencyImprovement: 'Επαγγελματική ολοκλήρωση εντολών, έρευνα ικανοποίησης υπηρεσιών, προειδοποίηση λειτουργίας και αστοχίας συντήρησης, υπενθύμιση παραγγελίας παράδοσης, Ειδοποίηση δραστηριοτήτων ηλεκτρονικού εμπορίου, υποψήφιος διορισμός, βοήθεια στην αυτοματοποίηση των επιχειρήσεων και τη βελτίωση της αποδοτικότητας της επιχείρησης.',
                incomingRobot: 'Εισερχόμενο ρομπότ',
                flexiblyIntegrateWorkOrdersOrdersAndOtherBusinessSystemsToRealizeProcessAutomationCustomizedRecognitionOfSpeechSemanticModelAndTheBusinessEffectIsImmediateEntitymobilePhoneNumberOrderAmountOrderTimeAddressIdentificationToQuicklySupportComplexBusiness: 'Ευέλικτη ενσωμάτωση των εντολών εργασίας, των εντολών και άλλων επιχειρηματικών συστημάτων για την επίτευξη αυτοματισμού της διαδικασίας. τα αποτελέσματα των επιχειρήσεων άμεσα; οντότητα (κινητό αριθμό τηλεφώνου, ποσό παραγγελίας, χρόνος παραγγελίας, διεύθυνση,...)',
                intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας',
                fullQualityInspectionTimelyAndEfficientWithAnAccuracyRateOf: 'Πλήρης επιθεώρηση ποιότητας, έγκαιρη και αποτελεσματική, με ποσοστό ακρίβειας 85%',
                intelligentSessionAnalysis: 'Ευφυής ανάλυση συνεδρίας',
                insightIntoBusinessWeaknessesListenToTheVoiceOfCustomersAndImproveMarketingTransformation: 'Ενόραση στο σύντομο επιχειρηματικό συμβούλιο, ακούστε τη φωνή των πελατών, βελτιώστε το μάρκετινγκ μετασχηματισμό',
                enterpriseWechatConversationAnalysis: 'Ανάλυση συνεδρίας Enterprise WeChat',
                effectivelyIdentifyPotentialBusinessOpportunitiesAndRisksAndIncreaseTheMarketingConversionRateBy: 'Αποτελεσματικός προσδιορισμός των δυνητικών επιχειρηματικών ευκαιριών, κινδύνων, συντελεστής μετατροπής εμπορίας αυξήθηκε κατά 20%.',
                assistant: 'Βοηθός έδρας',
                theAgentAssistantCanGuaranteeTheNoviceCustomerServiceToCompleteTheServiceAndImproveTheCallQualityOfTheSkilledCustomerServiceLetEverySeatBeYourTrumpCard: 'Ο βοηθός πράκτορας μπορεί να εξασφαλίσει την υπηρεσία της αρχάριου εξυπηρέτησης πελατών και να βελτιώσει την ποιότητα της κλήσης εξυπηρέτησης εξειδίκευσης πελατών. Κάθε θέση να είναι η κάρτα σου.',
                digitalPeople: 'Ο Ψηφιακός άνθρωπος',
                FaceToFaceAnthropomorphicCommunicationSupportVoiceTextVideoTouchMultimodalInteractionAchieveImmersiveCommunicationExperienceAndImproveBrandImageAndUserServiceExperience: 'Ανθρωπομορφική επικοινωνία, υποστηρικτική φωνή, κείμενο, βίντεο, πολυ-modal αλληλεπίδραση, να επιτύχει εμβρυωτική εμπειρία επικοινωνίας, να βελτιώσει την εμπειρία εικόνας και την εμπειρία υπηρεσίας χρήστης',
                aIKnowledgeZhongtaiEnterpriseSearch: 'Γνώση AI Μέση σταδία Αναζήτηση επιχειρηματικών επιχειρήσεων',
                knowledgeSearchKnowledgeSharingDocumentSearchDatabaseDockingSearch: 'Αναζήτηση γνώσεων, κοινή γνώση, αναζήτηση εγγράφων, Αναζήτηση βάσης δεδομένων προσάρτησης',
                aIKnowledgeCenterKCsKnowledgeBase: 'Γνώση γνώσεων · Βάση γνώσεων KCS',
                provideFullLifecycleManagementOfKnowledgeUnifiedMaintenanceOfRobotAndImKnowledgeBaseSupportDockingWithThirdpartyKnowledgeBaseKnowledgeTemplateAtomicKnowledgeAndOtherPowerfulFunctionsToBringMoreConvenientKnowledgeManagementExperience: 'Παρέχει πλήρη διαχείριση κύκλου ζωής της γνώσης, ενοποιημένη συντήρηση ρομπότ και βάσεις γνώσης ΔΜ, υποστηρίζει προσάρτηση με βάσεις γνώσεων τρίτων, πρότυπα γνώσης, ατομική γνώση και άλλες ισχυρές λειτουργίες για να φέρουν πιο βολική εμπειρία διαχείρισης γνώσεων.',
                aIKnowledgeCenterKnowledgeMap: 'Γραφικό γνώση Πλατφόρμα Γνώσης',
                oneStopMapConstructionIntegratesEnterpriseKnowledgeLargescaleMapShowsKnowledgeDetailsDockingAbilityAndCustomizedExperience: 'Η κατασκευή χαρτογράφησης ενσωματώνει τις επιχειρηματικές γνώσεις, η μεγάλη εικόνα δείχνει λεπτομέρειες γνώσης, και δυνατότητες προσάρτησης για τη δημιουργία προσαρμοσμένης εμπειρίας.',
                modularDevelopmentPlatformOriginalEngineASR: 'Προσαρμογή ανάπτυξης πλατφόρμα- αρχική καρδιά μηχανή-ASR',
                theEndtoendAlgorithmIsAdoptedToRealizeTheEffectExperienceOfBusinessCustomizationTheNaturalSceneRecognitionRateExceedsAndThePersonalizedVocabularyRecognitionRateExceeds97: 'Υιοθετήστε αλγόριθμο end-to-end για την πραγματοποίηση προσαρμοσμένη εμπειρία υπηρεσίας, με ποσοστό αναγνώρισης φυσικής σκηνής που υπερβαίνει το 90% και εξατομικευμένη αναγνώριση λεξιλογίου άνω του 97%',
                modularDevelopmentPlatformIntelligentMarketing: 'Προσαρμοσμένη πλατφόρμα ανάπτυξης',
                makeUseOfDeepLearningAlgorithmsAndUserPortraitsToAchieveAccurateRecommendationOfGoodsAndImproveSalesConversion: 'Χρησιμοποιήστε βαθιά μάθηση αλγόριθμους, σε συνδυασμό με πορτρέτα χρηστών, για την επίτευξη ακριβούς σύστασης των αγαθών και τη βελτίωση της μετατροπής των πωλήσεων.',
                modularDevelopmentPlatformUserPortrait: 'Προσαρμογή ανάπτυξης',
                accuratelyBuildUserPortraitsBasedOnUserDataAndConversationDataToFullyDescribeCustomerCharacteristics: 'Κατασκευή ακριβώς προφίλ χρηστών με βάση τα δεδομένα χρηστών και διαλόγου, περιγράφοντας πλήρως χαρακτηριστικά των πελατών',
                modularDevelopmentPlatformIntelligentRecommendation: 'Προσαρμοσμένη πλατφόρμα ανάπτυξης',
                automaticallyRecommendProductsThatUsersMayBeInterestedInAccordingToUserPortraitsAndProductPortraitsAndRealizePersonalizedRecommendationForThousandsOfPeople: 'Αυτόματα ενεργοποιώντας εξατομικευμένη συστάσεις για χιλιάδες ανθρώπους.',
                modularDevelopmentPlatformNLPPAAS: 'Πλατφόρμα Προσαρμογής Ανάπτυξης · NLP PaaS',
                provideNLPBasicCapabilitiesWithHighAccuracyCoveringTheUnderlyingCapabilitiesOfDifferentGranularitySuchAsWordsSentencesAndArticles: 'Παρέχει βασικές ικανότητες NLP με υψηλή ακρίβεια, καλύπτοντας ικανότητες χαμηλού επιπέδου διαφορετικής κόκκινης, όπως λέξεις, προτάσεις, και άρθρα.',
            },
        },
        qualityScore: {
            index: {
                show: 'Εμφάνιση:',
                displayBySecondaryClassification: 'Προβολή ανά δευτερογενή ταξινόμηση',
                showByRule: 'Εμφάνιση με κανόνα',
                pleaseEnterClassificationruleName: 'Παρακαλώ εισάγετε όνομα ταξινόμησης/Κανόνας',
                clickCopy: 'Κάντε κλικ στην αντιγραφή',
                hitDetailsOfOperatorsInRules: 'Ο χειριστής χτύπησε λεπτομέρειες στον κανόνα:',
                hit: 'Χτύπημα.',
                miss: 'Αστόχηση',
                filter: 'Φίλτρο:',
                clickToViewDetails: 'Κάντε κλικ για να προβάλετε λεπτομέρειες',
            },
            components: {
                flowNodeList: {
                    branch: 'Σημεία',
                    pleaseSelect: 'Παρακαλώ επιλέξτε.',
                    viewTheCompleteProcess: 'Προβολή πλήρους διεργασίας',
                    thereIsCurrentlyNoProcessAvailable: 'Καμία διαδικασία',
                },
                pointItem: {
                    xiangHit: 'Χτύπημα αντικειμένου',
                },
                flowNodeListModal: {
                    index: {
                        completeProcess: 'Πλήρης διαδικασία:',
                    },
                },
                reviewComponent: {
                    theProcessQualityInspectionTaskHasChangedPleaseAppealAgain: 'Η εργασία επιθεώρησης ποιότητας της διαδικασίας έχει αλλάξει, παρακαλώ έφεση και πάλι.',
                    components: {
                        reviewDetail: {
                            index: {
                                reasonsForAdoption: 'Λόγοι για την έγκριση:',
                                reasonForRejection: 'Λόγος απόρριψης:',
                                secondaryReview: 'Δευτεροβάθμια επανεξέταση',
                                firstlevelReview: 'Επισκόπηση',
                            },
                        },
                    },
                    index: {
                        pleaseEnterAReason: 'Παρακαλώ εισάγετε έναν λόγο',
                        reasonsForAdoption: 'Λόγοι για την έγκριση:',
                        reasonForRejection: 'Λόγος απόρριψης:',
                        attachments: 'Συνημμένα:',
                    },
                },
                annotation: {
                    index: {
                        annotation: 'Σημειώσεις',
                        ruleAnnotation: 'Σημείωση κανόνας',
                        areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                        preserve: 'Αποθήκευση',
                        cancel: 'Ακύρωση',
                        callout: 'Κλήρωση',
                    },
                },
                uplaod: {
                    index: {
                        uploadFile: 'Αποστολή αρχείου',
                    },
                },
            },
        },
        recordDetail: {
            template: {
                processingTime: 'Χρόνος επεξεργασίας',
                communicationDialogueInformation: 'Πληροφορίες διαλόγου επικοινωνίας',
                problemExtraction: 'Εξαγωγή προβλήματος',
                customFields: 'Προσαρμοσμένα πεδία',
                customerInformation: 'Πληροφορίες πελατών',
                information: 'Πληροφορίες',
                associatedWorkOrder: 'Σχετική σειρά εργασίας',
                commentInformation: 'Πληροφορίες σχόλιο',
                theDataHasBeenClearedPeriodically: 'Τα δεδομένα αυτά έχουν καθαριστεί περιοδικά',
                subject: 'Θέμα:',
                description: 'Περιγραφή:',
            },
            components: {
                addToTask: {
                    index: {
                        addToQualityInspectionTask: 'Προσθήκη στην ποιότητα εργασίας',
                    },
                },
            },
        },
        relatedDetail: {
            index: {
                associatedCallConversation: 'Συνδεδεμένη κλήση/συνομιλία',
            },
        },
        samplingTarget: {
            index: {
                time: 'Ποτε.',
                samplingQuantityIsLessThan: 'Η ποσότητα δειγματοληψίας είναι χαμηλότερη.',
                alertWhen: 'Πρόωρη προειδοποίηση',
                everyday: 'Καθημερινά',
                weekly: 'Εβδομαδιαία',
                monthly: 'Μηνιαία',
                samplingInspectionTargetSavedSuccessfully: 'Στόχος επιθεώρησης δειγματοληψίας αποθηκευμένη με επιτυχία',
                personnel: 'Προσωπικό',
                eachCustomerService: 'Κάθε εξυπηρέτηση πελατών',
                cycle: 'Κύκλος',
                samplingInspectionTarget: 'Στόχος επιθεώρησης δειγματοληψίας',
                strip: 'Άρθρο',
                alertSettings: 'Ρυθμίσεις προειδοποίησης',
            },
        },
        samplingTargetBanner: {
            index: {
                customerService: 'Υπηρεσία πελατών',
                complete: 'Ολοκληρώθηκε',
                Objective: 'Στόχος',
                everyday: 'Καθημερινά',
                weekly: 'Εβδομαδιαία',
                monthly: 'Μηνιαία',
            },
        },
        sessionInsights: {
            components: {
                groupChatInteractionRate: 'Ποσοστό αλληλεπίδρασης ομαδικής συνομιλίας',
                maximumResponseIntervalTime: 'Μέγιστο διάστημα μεταξύ απαντήσεων',
                numberOfPreemptiveCalls: 'Αριθμός λήψης',
                numberOfMessages: 'Αριθμός μηνυμάτων',
                strip: 'Άρθρο',
                proportionOfMessages: 'Ποσοστό αριθμού μηνυμάτων',
                speechPercentage: 'Αναλογία ομιλίας',
                longestCustomerTalk: 'Ο μεγαλύτερος πελάτης που μιλάει.',
                numberOfIndepthDiscussions: 'Αριθμός διεξοδικών συζητήσεων',
                second: 'Χρόνια',
                maximumDurationOfContinuousSpeech: 'Μέγιστη συνεχής διάρκεια ομιλής',
                questionFrequency: 'Συχνότητα ερωτήσεων',
                customer: 'Πελάτη',
                keyEvents: 'Βασικά γεγονότα:',
                opportunity: {
                    index: {
                        generationFailed: 'Η κατασκευή απέτυχε',
                        generateOpportunityPoints: 'Δημιουργία σημείων ευκαιρίας',
                    },
                },
                sessionSummary: {
                    index: {
                        generationFailed: 'Η κατασκευή απέτυχε',
                        generateSummary: 'Δημιουργία περίληψης',
                    },
                },
            },
            index: {
                areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                add: 'Προσθήκη',
                opportunityPoints: 'Σημείο ευκαιρίας',
                conversationSummary: 'Περίληψη συνεδρίας',
                cancel: 'Ακύρωση',
                determine: 'Προσδιορίστε την ένδειξη αυτών',
                edit: 'Επεξεργασία',
                establish: 'Δημιουργία δημιουργίας',
                conversationalInsights: 'Στοιχεία συνεδρίασης',
                keyEvents: 'Γεγονότα κλειδιά',
                numKeyEvents: 'Γεγονότα κλειδιά',
                questionAnalysis: 'Ανάλυση των ερωτημάτων',
                find: 'Βρέθηκε',
                questions: 'Δεύτερη ερώτηση.',
                conversationAction: 'Ενέργεια συνεδρίας',
                customer: 'Πελάτη',
                sale: 'Πωλήσεις',
                sessionLabel: 'Σενάρια συνεδρίας',
                employeeQuestions: 'Ερωτήσεις προσωπικού',
                customerQuestions: 'Ερωτήσεις πελατών',
            },
        },
        ticketTextInfo: {
            index: {
                customer: 'Πελάτη',
                customerService: 'Υπηρεσία πελατών',
                replyTo: 'Απάντηση',
                addressee: 'Προς:',
            },
            components: {
                call: {
                    index: {
                        initiateOutcall: 'Έναρξη εξόδου',
                        callInformation: 'Πληροφορίες κλήσης:',
                        assignedNumber: 'Αριθμός εκχώρησης:',
                        assignAgent: 'Ανέθεσε πράκτορα:',
                        answerDelay: 'Καθυστέρηση απάντησης:',
                        answerNumber: 'Αριθμός απάντησης:',
                        callMode: 'Λειτουργία κλήσης:',
                        status: 'Κατάσταση:',
                        callDuration: 'Διάρκεια κλήσης:',
                        yourBrowserDoesNotSupportTheAudioElement: 'Ο περιηγητής σας δεν υποστηρίζει το στοιχείο ήχου.',
                    },
                },
                remark: {
                    index: {
                        notesAdded: 'Σημειώσεις',
                        recipient: 'Αποδέκτης',
                    },
                },
                textMessage: {
                    index: {
                        sendSMS: 'Αποστολή SMS',
                        basicInformation: 'Βασικές πληροφορίες:',
                        mobilePhoneNumber: 'Αριθμός κινητού τηλεφώνου:',
                        sendObject: 'Αποστολή αντικειμένου:',
                        sMSTemplate: 'Πρότυπο SMS:',
                        sendResults: 'Αποστολή αποστολής:',
                        sMSContent: 'Περιεχόμενο SMS:',
                    },
                },
                changeRecord: {
                    index: {
                        workOrderCreated: 'Δημιουργήθηκε σειρά εργασίας',
                        triggeredTheFollowingActions: 'Ενεργοποίησε τις ακόλουθες ενέργειες',
                    },
                },
            },
        },
        listManage: {
            template: {
                reerrorCorrection: 'Διόρθωση επανάληψης',
                areYouSureYouWantToRecorrectTheError: 'Είστε σίγουροι ότι θέλετε να επανορθώσετε το σφάλμα;',
                retranslation: 'Μετάφραση',
                areYouSureYouWantToRetranslate: 'Είστε σίγουροι ότι θέλετε να ανασχεθείτε;',
                sort: 'Ταξινόμηση',
                theSelectedDataLanguageIsInconsistentAndCannotBeAddedToTheQualityInspectionTask: 'Η επιλεγμένη γλώσσα δεδομένων δεν είναι συνεπής και δεν μπορεί να προστεθεί στην εργασία επιθεώρησης ποιότητας.',
                reIdentification: 'Επαναγνωμόνιση',
                rerecognitionWillConsumeTranscriptionTimePleaseOperateWithCaution: 'Η επαναληπτική ταυτοποίηση θα καταναλώσει το χρόνο μεταφοράς, παρακαλώ να λειτουργεί με προσοχή.',
                determine: 'Προσδιορίστε την ένδειξη αυτών',
                executionSuccessful: 'Επιτυχής εκτέλεση',
                addToQualityInspectionTask: 'Προσθήκη στην ποιότητα εργασίας',
                batchOperation: 'Λειτουργία παρτίδας',
            },
        },
        addToTaskModal: {
            index: {
                successfullyAdded: 'Προστέθηκε με επιτυχία',
                addToQualityInspectionTask: 'Προσθήκη στην ποιότητα εργασίας',
                qualityInspectionTask: 'Εργασία επιθεώρησης',
            },
        },
        customFilterModal: {
            component: {
                saveSuccessful: 'Αποθήκευση με επιτυχία',
                detectRoles: 'Ανίχνευση ρόλου',
                detectionRange: 'Εύρος ανίχνευσης',
                sentence: 'Ποινή',
            },
            template: {
                cancelDefault: 'Ακύρωση προκαθορισμένου',
                setAsDefault: 'Ορισμός ως προκαθορισμένου',
                default: 'Προκαθορισμένο',
            },
        },
        inspectionDetail: {
            template: {
                theDataHasBeenClearedPeriodically: 'Τα δεδομένα αυτά έχουν καθαριστεί περιοδικά',
            },
        },
        backToSubSystem: {
            index: {
                returnToBusinessSystem: 'Επιστροφή στο επιχειρηματικό σύστημα',
            },
        },
        qualityCheckScoreTalk: {
            template: {
                overallMood: 'Συνολική διάθεση',
                problemExtraction: 'Εξαγωγή προβλήματος',
                businessSummary: 'Περίληψη επιχειρήσεων',
                keyWord: 'Λέξεις-κλειδιά',
            },
            components: {
                problemExtraction: {
                    personalityIssues: 'Θέματα προσωπικότητας',
                    generalQuestions: 'Γενικές ερωτήσεις',
                    positiveEmotions: 'Θετικά συναισθήματα',
                    negativeEmotion: 'Αρνητικό συναίσθημα',
                    neutralEmotion: 'Ουδέτερο συναίσθημα',
                    no: 'Οχι',
                    customerServiceDidNotAnswer: 'Η εξυπηρέτηση πελατών δεν απαντήθηκε.',
                    customerServiceHasAnswered: 'Η εξυπηρέτηση πελατών απάντησε',
                    problemUnresolved: 'Το πρόβλημα δεν λύθηκε.',
                    theProblemHasBeenResolved: 'Το πρόβλημα επιλύθηκε.',
                    customerIssue: 'Θέματα πελατών:',
                    customerServiceAnswer: 'Απάντηση εξυπηρέτησης πελατών:',
                    reExtractQuestions: 'Πρόβλημα επανεξαγωγής',
                    clickToExtractQuestions: 'Κάντε κλικ για να εξαγάγετε ερωτήσεις',
                },
            },
        },
        coach: {
            customerPortrait: {
                detail: {
                    index: {
                        portraitName: 'Όνομα πορτρέτου',
                        backgroundDescription: 'Περιγραφή φόντου',
                        customerLabel: 'Ετικέτα πελατών',
                        labelManagement: 'Διαχείριση ετικέτας',
                    },
                },
                list: {
                    components: {
                        addCustomerPortraitItemBtn: {
                            index: {
                                newlyBuild: 'Νέο',
                            },
                        },
                    },
                },
            },
            detailedInquiryConfig: {
                components: {
                    detailedInquiryConfigTitle: {
                        index: {
                            questioningSettings: 'Ρυθμίσεις ερωτήσεων',
                        },
                    },
                    detailedInquiryList: {
                        index: {
                            increaseQuestioning: 'Αύξηση των ερωτήσεων',
                            remove: 'Αφαίρεση',
                            addQuestioning: 'Προσθήκη ερωτήσεων',
                            section: 'Τομέα',
                            secondInquiry: 'Δεύτερη ερώτηση.',
                            questioningScore: 'Βαθμολογία ερωτήσεων',
                        },
                    },
                },
                index: {
                    accordingToRules: 'Κανόνα',
                    byScore: 'Κατά βαθμό',
                    whenMissRule: 'Όταν λείπει ο κανόνας',
                    whenConductingQuestioning: 'Όταν κάνετε ερωτήσεις',
                    pleaseSelectARule: 'Παρακαλώ επιλέξτε έναν κανόνα',
                    ruleCannotBeEmpty: 'Ο κανόνας δεν μπορεί να είναι κενός.',
                    currentScriptScore: 'Όταν η ομιλία βαθμολογήσει ≤',
                    pleaseEnterTheScore: 'Παρακαλώ εισάγετε ένα βαθμό',
                    scoreCannotBeEmpty: 'Το βαθμό δεν μπορεί να είναι κενό',
                },
            },
            dialogue: {
                components: {
                    narrator: {
                        narrator: 'Αφηγητής:',
                    },
                    pPT: {
                        slide: 'Κύλιση',
                    },
                    realTimeAnalyzer: {
                        index: {
                            scriptReview: 'Παρατηρήσεις',
                            script: 'Λέξεις',
                            semantics: 'Σημασιολογικό',
                            violatingWords: 'Παραβίαση των λέξεων',
                            speechSpeed: 'Ταχύτητα λόγου',
                            emotion: 'Συναίσθημα',
                        },
                    },
                    scoreDetail: {
                        index: {
                            scriptReview: 'Παρατηρήσεις',
                            regenerate: 'Αναζωογόνο',
                            generate: 'Δημιουργία δημιουργίας',
                            hitSituation: 'Θήκη επιτυχίας',
                            noSemanticTagsMatched: 'Δεν ταιριάζει με τη σημασιολογική ετικέτα.',
                            matchToSemanticTags: 'Ταίριασμα με τη σημασιολογική ετικέτας',
                            appealToBeSubmitted: 'Προς υποβολή καταγγελίας',
                            ratingHasBeenReviewed: 'Βαθμολογία αναθεωρήθηκε.',
                            ratingAppealInProgress: 'Αποτελέσματα βαθμολογίας',
                            expressionScore: 'Βαθμολογία έκφρασης',
                            moodParticlesTimes: 'Τόνος λέξης, {0} φορές',
                            changeTheModalParticlesTo: 'Για τις λέξεις μορφής',
                            second: 'Χρόνια',
                            interrogation: 'Ανακοίνωση',
                            questioningWithoutScoring: 'Ρωτήστε χωρίς βαθμολογία',
                            branch: 'Σημεία',
                            matchingRate: 'Ποσοστό αντιστοίχισης',
                            ratingAppeal: 'Βαθμολογία',
                            changeTo: 'Αλλαγή',
                            wordPerMinute: 'Λέξεις ανά λεπτό',
                            completeScript: 'Πλήρης ομιλίας',
                            incompleteScript: 'Ημιτελής ομιλίας',
                            semanticHit: 'Σημασιολογικό χτύπημα.',
                            semanticMisses: 'Σημασιολογικές παραλείψες',
                            scriptViolation: 'Παραβίαση λόγου',
                            modified: 'Τροποποιήθηκε',
                            notChanged: 'Δεν τροποποιήθηκε',
                            keyWord: 'Λέξεις-κλειδιά',
                            semanticLabels: 'Σημασιολογική ετικέτας',
                            semanticMatchingRate: 'Ποσοστό σημασιολογικής αντιστοίχισης',
                            violatingWords: 'Παραβίαση της λέξης"',
                            delete: 'Διαγραφή',
                            unmatched: 'Δεν ταιριάζεται',
                            matching: 'Ταίριασμα',
                            matchTo: 'Ταίριασμα',
                            notMatchedTo: 'Δεν ταιριάζεται',
                            scriptScore: 'Βαθμολογία ομιλίας',
                            standardScript: 'Πρότυπο λόγος',
                            emotionalScore: 'Συναισθηματικό Σκορ',
                            speechSpeedScore: 'Βαθμολογία ταχύτητας',
                            viewResolution: 'Προβολή ανάλυσης',
                            nodeConfiguration: 'Ρύθμιση κόμβου',
                        },
                    },
                    userNode: {
                        theAnswerTimeForThisQuestionHasExceededAndTheAnswerContentWillBeAutomaticallySubmitted: 'Ο χρόνος απάντησης αυτής της ερώτησης είναι υπερωρία, και το περιεχόμενο της απάντησης υποβάλλεται αυτόματα.',
                    },
                    knowledgeNode: {
                        theAnswerTimeForThisQuestionHasExceededAndTheAnswerContentWillBeAutomaticallySubmitted: 'Ο χρόνος απάντησης αυτής της ερώτησης είναι υπερωρία, και το περιεχόμενο της απάντησης υποβάλλεται αυτόματα.',
                    },
                    correctBtn: {
                        saveSuccessful: 'Αποθήκευση με επιτυχία',
                        errorCorrection: 'Διόρθωση σφάλματος',
                        cancel: 'Ακύρωση',
                        preserve: 'Αποθήκευση',
                    },
                },
            },
            scoringRules: {
                components: {
                    drawerTitle: {
                        scoringRules: 'Κανόνες βαθμολογίας',
                        cancel: 'Ακύρωση',
                        determine: 'Προσδιορίστε την ένδειξη αυτών',
                    },
                    scoringRuleItem: {
                        whole: 'Όλα',
                        arbitrarily: 'Αρχαιολογικό',
                        pleaseEnterARuleName: 'Παρακαλώ εισάγετε ένα όνομα κανόνας',
                        standardScript: 'Πρότυπο λόγος',
                        if: 'Εάν αυτές οι οποίες οφείλονται να θεωρηθούν υπεύθυνοι για τον έλεγχο της ασφάλειας.',
                        and: 'Και,',
                        or: 'Ή',
                        thenScore: 'Στη συνέχεια.',
                        pleaseEnterAScore: 'Παρακαλώ εισάγετε ένα βαθμό',
                        bonusPoints: 'Πόντοι μπόνους',
                        minusPoints: 'Μείον πόντοι',
                        hit: 'Χτύπημα.',
                        misses: 'Αστόχηση',
                        keyWord: 'Λέξεις-κλειδιά',
                        semantics: 'Σημασιολογικό',
                    },
                    title: {
                        ruleValidation: 'Επαλήθευση κανόνας',
                        scoringRulestheTotalScoreOfTheCurrentScriptIs: 'Κανόνες βαθμολογίας (η συνολική βαθμολογία της τρέχουσας ομιλίας είναι η',
                        points: 'Βαθμοί)',
                        editRules: 'Επεξεργασία κανόνας',
                    },
                },
            },
            userTagsSelect: {
                index: {
                    noLabelsCurrentlyAvailable: 'Χωρίς ετικέτα.',
                },
            },
            aiGenDialogFrame: {
                components: {
                    description: {
                        index: {
                            communicationObjectives: 'Στόχοι επικοινωνίας',
                            scoringCriteria: 'Κριτήρια βαθμολογίας',
                        },
                    },
                },
                index: {
                    generating: 'Δημιουργία',
                    generateDialogueFramework: 'Δημιουργία ενός πλαισίου διαλόγου',
                    theme: 'Θέμα:',
                },
            },
            aiGenPrompt: {
                components: {
                    title: {
                        hintLanguage: 'Ζήτηση',
                        generatePromptLanguage: 'Δημιουργήθηκε άμεση',
                    },
                },
            },
            aiGenScore: {
                index: {
                    communicationStage: 'Φάση επικοινωνίας',
                    communicationObjectives: 'Στόχοι επικοινωνίας',
                    scoringCriteria: 'Κριτήρια βαθμολογίας',
                    suggestionsForImprovement: 'Συστάσεις προώθησης',
                },
            },
            score: {
                overview: {
                    index: {
                        processScore: 'Βαθμολογία διεργασίας',
                        contentIntegrity: 'Ακεραιότητα περιεχομένου:',
                        NumberOfCompletedProcesses: '%, Αριθμός ολοκληρωμένων διεργασιών',
                        keyHitPointsTotal: 'Βασικές επιτυχίες: Σύνολο',
                        notReached: 'Δεν επιτεύχθηκε',
                        accurateFollowupAccumulationOfStandardScripts: 'Ακριβής παρακολούθηση: Τυπική συσσώρευση ομιλίας',
                        theTotalNumberOfWordsHitByTheStudentAfterReading: 'Μια λέξη, ο αριθμός των λέξεων που χτύπησε ο μαθητής.',
                        aWord: 'Λόγο',
                        languageNormsYes: 'Προδιαγραφές γλώσσας: Ναι',
                        emotionsAppearing: 'Συναισθήματα: εμφανίζονται',
                        speechSpeedSpeakingTooFast: 'ΠΕΡΙΣΜΟΣ:',
                        modalParticlesExcessiveOccurrenceOfModalParticles: 'Λέξεις τόνου: υπερβολική εμφάνιση των λέξεων',
                    },
                },
            },
            randomBranchConfig: {
                index: {
                    nextNodeRandomTrigger: 'Επόμενος κόμβος τυχαία ενεργοποίησης',
                    ifTheUserPortraitIsEnabledTheNodePathWillBeBasedOnTheUserPortraitAndDefaultSpeechAndTheRandomFunctionWillNotTakeEffect: 'Εάν το πορτρέτο χρήστη είναι ενεργοποιημένο, η διαδρομή κόμβων θα βασίζεται στο πορτρέτο χρήστη και την προεπιλεγμένη ομιλία, και η τυχαία λειτουργία δεν θα τεθεί σε ισχύ.',
                    pleaseSelectRandomMode: 'Παρακαλώ επιλέξτε τυχαία λειτουργία',
                    completelyRandom: 'Εντελώς τυχαίο',
                    pathCoverageRandom: 'Τυχαία κάλυψη διαδρομής',
                },
            },
        },
        smartTags: {
            template: {
                addToIgnoreTags: 'Προσθήκη σε αγνόηση ετικετών',
                areYouSureYouWantToReExecuteTheSmartLabel: 'Είστε σίγουροι ότι θέλετε να επανεκτελέσετε την έξυπνη ετικέτα;',
                reExecute: 'Επανεκτέλεση',
            },
            component: {
                successfullyAdded: 'Προστέθηκε με επιτυχία',
            },
        },
        reInspectionResultModal: {
            index: {
                turnOffAllNotifications: 'Κλείσιμο όλων των ειδοποιήσεων',
                reQualityInspectionTask: 'Εργασία επανεπιθεώρησης',
                requalityInspection: 'Επανεπιθεώρηση',
                waiting: 'Αναμονή',
                viewDetails: 'Λεπτομέρειες προβολής',
            },
        },
        checkPointConditionListGather: {
            checkPointCondition: {
                components: {
                    applyTimeType: {
                        index: {
                            detectionTime: 'Χρόνος ανίχνευσης:',
                        },
                    },
                    problemDetectionMode: {
                        index: {
                            singleSentenceDetection: 'Ανίχνευση μίας πρότασης',
                            multisentenceDetection: 'Ανίχνευση πολλαπλών σχέσεων',
                            crosssentenceDetection: 'Ανίχνευση διασταύρωσης',
                            problemDetectionMethod: 'Μέθοδος ανίχνευσης προβλημάτων:',
                            mostAcross: 'Τα περισσότερα απέναντι.',
                            sentence: 'Ποινή',
                            ignoreNotGreater: 'Αγνόηση μη μεγαλύτερης',
                            theSentenceOfTheWord: 'Η πρόταση της λέξης',
                            theCrosssentenceLimitIsNotGreater: 'Το όριο διασταύρωσης δεν είναι μεγαλύτερο',
                            word: 'Λόγο',
                        },
                    },
                    info: {
                        index: {
                            useLargeModelsForSemanticMatching: 'Χρησιμοποιήστε μεγάλα μοντέλα για τη σημασιολογική ταίριαση.',
                            keywordsUseStrictMatchingOneLineCanEnterMultipleKeywordsKeywordsAreSeparatedByCommas: 'Λέξεις-κλειδιά χρησιμοποιούν αυστηρή ταίριασμα, μία γραμμή μπορεί να εισάγει πολλαπλές λέξεις-κλειδιά, λέξεις-κλειδιά χωρίζονται με κόμματα.',
                            semanticTagsSupportBothStrictMatchingAndSemanticMatchingWhereSemanticTagsNeedToBeConfiguredInTheSidebarOfSmartToolsOrSemanticIntelligencesemanticTags: 'Οι σημασιολογικές ετικέτες υποστηρίζουν αυστηρή ταίριασμα και σημασιολογική ταίριασμα, όπου οι σημασιολογικές ετικέτες πρέπει να διαμορφώνονται στην πλευρική μπάρα έξυπνων εργαλείων ή σημασιολογικών ετικετών νοημοσύνης-semantic.',
                            conceptWordsAresemanticLabelsDesignedForWordsWhichCanMatchWordsStrictlyOrSemanticallyWhereConceptWordsAreConfiguredInSemanticIntelligenceconceptWords: 'Οι λέξεις της ιδέας είναι "σεμαντικές ετικέτες" σχεδιασμένες για λέξεις, οι οποίες μπορούν να ταιριάζουν αυστηρά ή σημασιολογικά, όπου οι λέξεις έννοιας διαμορφώνονται σε λέξεις σημασιολογικής νοημοσύνης.',
                            checkWhetherTheCustomerServiceResponseTimedOutWhetherTheCustomerRespondedTimedOutAndWhetherTheCustomerDidNotRespondTheResponseStartSentenceRefersToWhetherTheResponseOfRoleAIsDetectedFromTheFirstSentenceOrTheLastSentenceOfMultipleMessagesSentContinuouslyWhenRoleAContinuouslySendsMessagesAndDetectsTheResponseOfRoleBResponseTimeoutIsAnUpgradedVersionOfSilentDetection: 'Ελέγξτε εάν η απάντηση της εξυπηρέτησης πελατών τελείωσε, εάν ο πελάτης απάντησε χρονικό τέλος, και αν ο πελάτης δεν απάντησε. Η πρόταση έναρξης απάντησης αναφέρεται στο αν η αντίδραση του ρόλου Α εντοπίζεται από την πρώτη πρόταση ή την τελευταία πρόταση των πολλαπλών μηνυμάτων που αποστέλλονται συνεχή όταν ο ρόλος Α στέλνει συνεχώς μηνύματα και ανιχνεύει την απάντηση του ρόλου Β. Το χρονικό διάστημα απόκρισης είναι μια αναβαθμισμένη έκδοση της σιωπηλής ανίχνευσης.',
                            theSilenceDurationOfEachCharacterIsDetectedByDefaultTheLastSentenceIsDetected: 'Ανιχνεύεται η διάρκεια σιωπής κάθε χαρακτήρας. Εξ ορισμού, ανιχνεύεται η τελευταία πρόταση.',
                            inTheDialogueBetweenTwoDifferentRolesTheEndTimeOfThePreviousSentencetheStartTimeOfTheCurrentSentenceTheSnatchingIntervalAndTheEndTimeOfTheCurrentSentencetheStartTimeOfTheCurrentSentenceTheLengthOfTheSnatchingSentenceIfItIsSatisfiedAtTheSameTimeItWillBeJudgedAsSnatchingWords: 'Στο διάλογο μεταξύ δύο διαφορετικών ρόλων, η ώρα λήξης της προηγούμενης πρότασης-η ώρα έναρξης της τρέχουσας πρότασης> = το διάστημα αρπαγής· Και η ώρα λήξης της τρέχουσας πρότασης-η ώρα έναρξης της τρέχουσας πρότασης> το μήκος της αρπαγής ποινής. Αν ικανοποιηθεί ταυτόχρονα, Θα κριθεί ως αρπακτικές λέξεις.',
                            itIsSuitableForBusinessKnowledgeAnswerDetectionOfOneQuestionAndOneAnswerTypeTheOperatorPreferentiallyDetectsProblemsFromTheCustomersMessagesIfTheProblemIsNotDetectedFollowTheConfigurationOfTheConfigurationItemWhenTheProblemIsNotDetectedIfAProblemIsDetectedTheAnswerIsDetectedFromTheCustomerServiceMessageWhenAnAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsCorrectIfNoAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsWrongThisOperatorIsTheOldVersionOfTheKnowledgeSolutionAndTheCorrespondingOptionsAreConfiguredInSemanticIntelligenceInteractiveRecognition: 'Είναι κατάλληλο για την ανίχνευση της επιχειρηματικής γνώσης απάντησης μιας ερώτησης και μιας τύπου απάντησης. Ο φορέας εκμετάλλευσης ανιχνεύει προτιμότερα προβλήματα από τα μηνύματα του πελάτη. Εάν το πρόβλημα δεν ανιχνευθεί, ακολουθήστε τη διαμόρφωση του αντικειμένου ρύθμισης «Όταν το πρόβλημα δεν είναι ανιχνευμένο. Εάν εντοπιστεί κάποιο πρόβλημα, η απάντηση ανιχνεύεται από το μήνυμα εξυπηρέτησης πελατών. Όταν εντοπίζεται απάντηση, καθορίζεται ότι η λύση γνώσης εξυπηρέτησης πελατών είναι σωστή. καθορίζεται ότι η λύση γνώσης εξυπηρέτησης πελατών είναι λάθος. Αυτός ο φορέας είναι η παλιά έκδοση της λύσης γνώσης, και οι αντίστοιχες επιλογές ρυθμίζονται στο Semantic Intelligence-Interactive Recognition.',
                            detectingWhetherThereAreDuplicateMessagesInASessionSupportsBothStrictAndSemanticDuplication: 'Η ανίχνευση αν υπάρχουν διπλά μηνύματα σε μια συνεδρία υποστηρίζει τόσο την αυστηρή όσο και τη σημασιολογική επικάλυψη.',
                            itSupportsTheDetectionOfTheIntervalBetweenTwoSemanticsInWhichSemanticLabelsCanBeSetInTheSidebarOfIntelligentToolsOrSemanticIntelligencesemanticLabels: 'Υποστηρίζει την ανίχνευση του διαστήματος μεταξύ δύο σημασιολογικών, όπου οι σημασιολογικές ετικέτες μπορούν να ρυθμιστούν στην πλευρά των ευφυών εργαλείων ή των σημασιολογικών ετικετών νοημοσύνης-επεισόησης.',
                            itIsSuitableForBusinessKnowledgeAnswerDetectionOfOneQuestionAndOneAnswerTypeTheOperatorPreferentiallyDetectsProblemsFromTheCustomersMessagesIfTheProblemIsNotDetectedFollowTheConfigurationOfTheConfigurationItemWhenTheProblemIsNotDetectedIfAProblemIsDetectedTheAnswerIsDetectedFromTheCustomerServiceMessageWhenAnAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsCorrectIfNoAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsWrongThisOperatorIsANewVersionOfTheKnowledgeSolutionAndTheCorrespondingOptionsAreConfiguredInTheSemanticIntelligenceknowledgeBase: 'Είναι κατάλληλο για την ανίχνευση της επιχειρηματικής γνώσης απάντησης μιας ερώτησης και μιας τύπου απάντησης. Ο φορέας εκμετάλλευσης ανιχνεύει προτιμότερα προβλήματα από τα μηνύματα του πελάτη. Εάν το πρόβλημα δεν ανιχνευθεί, ακολουθήστε τη διαμόρφωση του αντικειμένου ρύθμισης «Όταν το πρόβλημα δεν είναι ανιχνευμένο. Εάν εντοπιστεί κάποιο πρόβλημα, η απάντηση ανιχνεύεται από το μήνυμα εξυπηρέτησης πελατών. Όταν εντοπίζεται απάντηση, καθορίζεται ότι η λύση γνώσης εξυπηρέτησης πελατών είναι σωστή. καθορίζεται ότι η λύση γνώσης εξυπηρέτησης πελατών είναι λάθος. Αυτός ο φορέας είναι μια νέα έκδοση της λύσης γνώσης, και οι αντίστοιχες επιλογές ρυθμίζονται στη βάση σημασιολογικής νοημοσύνης-γνώσης.',
                            checkWhetherTheCustomerServiceSentenceIsTooShortOrTooLong: 'Ελέγξτε αν η πρόταση εξυπηρέτησης πελατών είναι πολύ μικρή ή πολύ μεγάλη.',
                            detectTheEmotionsOfAgentsOrCustomers: 'Ανιχνεύστε τα συναισθήματα των πρακτόρων ή των πελατών.',
                            onlyApplicableToTextConversationQualityInspectionToDetectWhetherTheSentMessageContainsTyposTheTyposCanBeEnrichedInTheSemanticIntelligenceintelligentThesaurustyposToOptimizeTheDetectionOfTypos: 'Εφαρμόζεται μόνο για την επιθεώρηση ποιότητας συνομιλίας κειμένου, για να ανιχνεύσει εάν το αποσταλεί μήνυμα περιέχει τυπογραφίες. Οι τυπογραφίες μπορούν να εμπλουτιστούν στο σημασιολογικό-ευφυές θησαυρό για να βελτιστοποιήσουν την ανίχνευση τυπογράφων.',
                            itIsOnlyApplicableToVoiceCallQualityInspectionWhichDetectsWhetherInterrogativeSentencesAppearInTheSession: 'Εφαρμόζεται μόνο για την επιθεώρηση ποιότητας φωνητικών κλήσεων, η οποία εντοπίζει εάν ερωτηματικές προτάσεις εμφανίζονται στη συνεδρίαση.',
                            itIsOnlyApplicableToVoiceCallQualityInspectionWhichDetectsWhetherTheVolumeOfTheCustomerServiceOrCustomerIsTooHighOrTooLowAndWhetherTheVolumeChangesSuddenly: 'Εφαρμόζεται μόνο στην επιθεώρηση ποιότητας φωνητικών κλήσεων, που ανιχνεύει αν ο όγκος της εξυπηρέτησης πελατών ή του πελάτη είναι πολύ υψηλός ή πολύ χαμηλός, και αν ο όγκος αλλάζει ξαφνικά.',
                            itIsOnlyApplicableToVoiceCallQualityInspectionAndDetectsTheSpeechSpeedOfCustomerServiceOrCustomers: 'Εφαρμόζεται μόνο στην επιθεώρηση ποιότητας φωνητικών κλήσεων και ανιχνεύει την ταχύτητα ομιλίας της εξυπηρέτησης πελατών ή των πελατών.',
                            checkWhetherTheInformationEntityMentionedInTheSessionIsCorrectThatIsJudgeWhetherTheInformationEntityValueIsEqualToACertainPathassociatedDataOrFixedValueTheInformationEntityCanBeConfiguredInTheSemanticIntelligenceinformationEntity: 'Ελέγξτε αν η οντότητα πληροφοριών που αναφέρεται στη συνεδρία είναι σωστή, δηλαδή, κρίνει αν η αξία της οντότητας πληροφοριών είναι ίση με συγκεκριμένα δεδομένα που συνδέονται με τη διαδρομή ή σταθερή αξία. Η οντότητα πληροφοριών μπορεί να διαμορφωθεί στην οντότητα σημασιολογικής πληροφόρησης-πληροφοριών.',
                            theNewVersionOfTheAccompanyingFieldDetectsWhetherTheAccompanyingDataIsEqualToAFixedValueOldVersionOfDataWithTheRouteCanDetectWhetherTheDataWithTheRouteMeetsTheRelationshipExpressionWhereTheRelationshipExpressionSupportsUserdefinedYouCanSetTheAdditionSubtractionMultiplicationAndDivisionOperationWhetherToMatchTheSemanticLabelWhetherToContainKeywordsIFJudgmentEtc: 'Η νέα έκδοση του συνοδευτικού πεδίου: ανιχνεύει αν τα συνοδευτικά δεδομένα είναι ίσα με μια σταθερή τιμή. Παλιά έκδοση των δεδομένων με τη διαδρομή: μπορεί να ανιχνεύσει αν τα δεδομένα με τη διαδρομή ανταποκρίνονται στην έκφραση σχέσης, όπου η έκφραση σχέσης υποστηρίζει καθορισμένη από το χρήστη, μπορείτε να ρυθμίσετε τη λειτουργία της προσθήκης, της αφαίρεσης, του πολλαπλασιασμού και της διαίρεσης, αν θα ταιριάξει με την σημασιολογική ετικέτα, αν θα περιέχουν λέξεις-κλειδιά, κρίση IF, κλπ.',
                            determineWhetherTheSummaryContentOfTheSessionIsEqualToOrContainsAFixedValueTheSummaryIsSetInProcessAutomationBusinessSummary: 'Καθορίστε αν το συνοπτικό περιεχόμενο της συνεδρίας είναι ίσο ή περιέχει μια σταθερή τιμή. Η περίληψη ορίζεται στην Περίληψη της Διαδικασίας Αυτοματισμού-Business.',
                        },
                    },
                },
                template: {
                    IgnoreLess: ', Αγνοείτε λιγότερα',
                    theSentenceOfTheWord: 'Η πρόταση της λέξης',
                    secondsToNo: 'Δευτερόλεπτα στο No.',
                    seconds: 'Δευτερόλεπτα',
                    responseOpeningSentence: 'Πρόταση έναρξης απόκρισης',
                },
            },
            template: {
                multimodal: 'Πολυτροπική',
                model: 'Υπόδειγμα:',
            },
            component: {
                largeModel: 'Μεγάλο μοντέλο',
            },
        },
        businessSummary: {
            components: {
                fieldItem: {
                    index: {
                        generationFailed: 'Η κατασκευή απέτυχε',
                        generate: 'Δημιουργία δημιουργίας',
                    },
                },
                empty: {
                    index: {
                        thereIsCurrentlyNoDataAvailable: 'Χωρίς δεδομένα',
                    },
                },
            },
            index: {
                regenerate: 'Αναζωογόνο',
            },
        },
        applyTemplates: {
            component: {
                areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                operationSuccessful: 'Επιτυχία λειτουργίας',
            },
            template: {
                delete: 'Διαγραφή',
            },
        },
        similarQuestionRecommend: {
            index: {
                pleaseSelectAQuestion: 'Παρακαλώ επιλέξτε μια ερώτηση!',
                similarQuestionRecommendation: 'Παρόμοια Ζήτηση',
                selectAllOnPage: 'Κατά την επιλογή όλων των σελίδων',
                cancel: 'Ακύρωση',
                preserve: 'Αποθήκευση',
                changeBatch: 'Τροποποίηση μιας παρτίδας',
            },
        },
        listControl: {
            index: {
                columnControl: 'Έλεγχος στήλης',
            },
        },
        loginUserAvatar: {
            index: {
                switch: 'Εναλλαγή',
            },
        },
        autoAddComponent: {
            index: {
                whenAddingDataInRealTimeTheQualityInspectionTaskStillTakesTimeToExecuteTheSpecificTimeDependsOnTheSizeOfTheQualityInspectionDataRangingFromAFewMinutesToHours: 'Κατά την προσθήκη δεδομένων σε πραγματικό χρόνο, η εργασία επιθεώρησης ποιότητας εξακολουθεί να απαιτεί χρόνο για την εκτέλεση. Ο συγκεκριμένος χρόνος εξαρτάται από το μέγεθος των δεδομένων επιθεώρησης ποιότητας, που κυμαίνονται από λίγα λεπτά έως 2 ώρες.',
            },
        },
        bEditor: {
            index: {
                delete: 'Διαγραφή',
                cancel: 'Ακύρωση',
                confirm: 'Προσδιορίστε την ένδειξη αυτών',
                insert: 'Εισαγωγή',
                width: 'Πλάτος:',
                height: 'Ύψος',
                clearContent: 'Καθαρισμός περιεχομένο',
                revoked: 'Ανακαλώθηκε',
                redo: 'Επαναλαμβάνω',
                fontSize: 'Μέγεθος γραμματοσειράς',
                rowHeight: 'Ύψος γραμμής',
                wordSpacing: 'Διάστημα λέξεων',
                paragraphIndent: 'Παράγραφο εσοχής',
                increaseIndent: 'Αύξηση εσοχής',
                decreaseIndent: 'Μείωση εσοχής',
                border: 'Περιγράμματος',
                color: 'Χρώματα',
                textColor: 'Χρώμα κειμένου',
                backgroundColor: 'Χρώμα φόντου',
                temporaryColor: 'Προσωρινό χρώμα',
                bold: 'Τολμηρή',
                italic: 'Πλάγια',
                underline: 'Υπογραμμίσεις',
                strikethrough: 'Διαγραφή',
                font: 'Γραμματοσειράς',
                textAlignment: 'Προσαρμογή κειμένου',
                left: 'Αριστερά',
                centered: 'Κεντρωμένο',
                right: 'Δεξιά.',
                bothEnds: 'Και τα δύο άκρα',
                leftFloat: 'Αριστερή επιπλέωση',
                rightFloat: 'Δεξιά επιπλέωση',
                subrupt: 'Σούπερς',
                subscript: 'Ενδείκνυτη',
                clearStyle: 'Καθαρισμός στυλ',
                title: 'Τίτλος',
                regular: 'Κανονικό',
                orderedList: 'Κατάταξη',
                unorderedList: 'Αδιάλειπτη λίστας',
                reference: 'Παραπομπή',
                code: 'Κωδικός',
                link: 'Δεσμός',
                clearLink: 'Καθαρισμός δεσμού',
                horizontalLine: 'Οριζόντια γραμμής',
                media: 'Μέσα ενημέρωσης',
                mediaLibrary: 'Βιβλιοθήκη ΜΜΕ',
                smallExpression: 'Μικρή έκφραση',
                fullScreen: 'Πλήρης οθόνη',
                exitFullScreen: 'Έξοδος από την πλήρη οθόνη',
                enterLinkText: 'Εισάγετε κείμενο δεσμού',
                enterLinkAddress: 'Εισάγετε διεύθυνση δεσμού',
                enterTheLinkAddressAndPressEnter: 'Εισάγετε τη διεύθυνση σύνδεσης και εισάγετε τη διεύθυνση δεσμού',
                openInNewWindow: 'Άνοιγμα σε νέο παράθυρο',
                removeLink: 'Αφαίρεση δεσμού',
                playingAudioFiles: 'Αναπαραγωγή αρχείων ήχου',
                playVideoFiles: 'Αναπαραγωγή αρχείων βίντεο',
                embeddedMedia: 'Ενσωματωμένα μέσα ενημέρωσης',
                image: 'Εικόνα',
                video: 'Βίντεο',
                audio: 'Ήχος',
            },
        },
        verifyModal: {
            components: {
                verifyCodeInput: {
                    index: {
                        sentSuccessfully: 'Αποστολή με επιτυχία',
                        resend: 'Επαναφορά ()',
                        sendVerificationCode: 'Αποστολή κωδικού επαλήθευσης',
                    },
                },
            },
            index: {
                cAPTCHA: 'CAPTCA',
                confirm: 'Προσδιορίστε την ένδειξη αυτών',
                pleaseEnterTheVerificationCode: 'Παρακαλώ εισάγετε τον κωδικό επαλήθευσης',
            },
        },
        languageSelect: {
            const: {
                urdu: 'Ουρντού',
                kazakh: 'Καζακικά',
                americanEnglish: 'Αμερικανική Αγγλική',
                canadianEnglish: 'Καναδικά αγγλικά',
                africanEnglish: 'Αφρικανικά αγγλικά',
                french: 'Γαλλικά',
                spanish: 'Ισπανικά',
                russian: 'Ρωσική',
                arabic: 'Αραβικά',
                turkish: 'Τουρκικά',
                vietnamese: 'Βιετναμέζικα',
                portuguese: 'Πορτογαλική',
                german: 'Γερμανικός',
                italian: 'Ιταλική',
                polish: 'Πολωνικά',
                finnish: 'Φινλανδικά',
                dutch: 'Ολλανδικά',
                czech: 'Τσέχικα',
                bengali: 'Βενγκάλια',
                greek: 'Ελληνική',
                hindi: 'Ινδία',
                chineseTaiwan: 'Κινεζική Ταϊβάν',
                cambodian: 'Καμπότζη',
                allLanguages: 'Όλες οι γλώσσες',
                chinese: 'Κινέζικα',
                english: 'Αγγλική',
                cantonese: 'Καντονέζικα',
                thai: 'Ταϊλάνδης',
                malay: 'Μαλαισία',
                indonesian: 'Ινδονησιακά',
                korean: 'Κορεάτικα',
                filipino: 'Φιλιππινέζικα',
                japanese: 'Ιαπωνικά',
            },
            index: {
                pleaseSelectLanguage: 'Παρακαλώ επιλέξτε μια γλώσσα',
            },
        },
        languageSetting: {
            index: {
                aSRModel: 'Μοντέλο ASR',
                languageAdaptive: 'Προσαρμοστικό γλώσσα',
                mainLanguage: 'Κύρια γλώσσα',
                paraLanguage: 'Παρα γλώσσα',
                rules: 'Κανόνες',
                languageType: 'Τύπος γλώσσας:',
                preserve: 'Αποθήκευση',
                remove: 'Αφαίρεση',
                new: 'Νέο',
            },
        },
        smartToolBar: {
            smartTags: {
                template: {
                    language: 'Γλώσσα',
                },
            },
            aiReport: {
                component: {
                    submittedSuccessfully: 'Υποβολή με επιτυχία',
                },
                template: {
                    selectQualityTask: 'Επιλογή εργασιών επιθεώρησης ποιοτικής',
                    enterReportGenerationRequirements: 'Εισάγετε απαιτήσεις παραγωγής αναφοράς',
                    generateReport: 'Δημιουργία αναφοράς',
                    historicalReport: 'Ιστορική Αναφορά',
                    toBeGenerated: 'Προς δημιουργία',
                    exporting: 'Εξαγωγή',
                    failedToGenerate: 'Η κατασκευή απέτυχε',
                    complete: 'Ολοκληρώθηκε',
                },
            },
            component: {
                largeModelReport: 'Μεγάλη έκθεση μοντέλου',
            },
        },
        audioCallContentInfo: {
            components: {
                commentView: {
                    index: {
                        viewDetails: 'Λεπτομέρειες προβολής',
                    },
                },
            },
            template: {
                all: 'Όλα',
                theFollowingIsTheBotServiceMessage: 'Το παρακάτω είναι το μήνυμα υπηρεσίας bot μήνυμα',
                theFollowingIsTheHumanServiceMessage: 'Το ακόλουθο είναι το μήνυμα της ανθρώπινης υπηρεσίας',
            },
        },
        asrStatusModal: {
            index: {
                aSRTrainingStatus: 'Κατάσταση κατάρτισης ASR κατάρτισης',
                chineseASR: 'Κινέζικο ASR',
                aSRModelUpdateTimegeneric: 'Μοντέλο ASR ώρα ενημέρωσης (γενική):',
                aSRModelUpdateTimeexclusive: 'Μοντέλο ASR ώρα ενημέρωσης (αποκλειστική):',
                numberOfErrorCorrectionsTrained: 'Αριθμός εκπαιδευμένων διορθώσεων σφαλμάτων:',
                trainedErrorCorrectionDuration: 'Διάρκεια διόρθωσης σφάλματος:',
                minutes: 'Πρακτικά',
                numberOfUntrainedErrors: 'Αριθμός μη εκπαιδευμένων σφαλμάτων:',
                untrainedErrorCorrectionDuration: 'Διάρκεια διόρθωσης μη εκπαιδευμένων σφαλμάτων:',
            },
        },
        survey: {
            components: {
                question: {
                    index: {
                        singleTopic: 'Ενιαίο θέμα:',
                        multipleChoiceQuestions: 'Ερωτήσεις πολλαπλών επιλογών',
                        questionAndAnswer: 'Ερωτήσεις και Απάντηση',
                    },
                },
            },
        },
        soundtrackListManage: {
            component: {
                keyWords: 'Λέξεις-κλειδιά',
            },
        },
        audioStickersTalkV2: {
            index: {
                customerService: 'Υπηρεσία πελατών',
                customer: 'Πελάτη',
                topic: 'Θέμα:',
            },
        },
        infoEntitySelect: {
            index: {
                pleaseSelectAnInformationEntity: 'Παρακαλώ επιλέξτε μια οντότητα πληροφοριών',
            },
        },
        outerApiConfigsResponseSelect: {
            index: {
                pleaseSelectAReturnParameter: 'Παρακαλώ επιλέξτε μια παράμετρο επιστροφής',
            },
        },
        outerApiConfigsSelect: {
            index: {
                pleaseSelectExternalInterface: 'Παρακαλώ επιλέξτε εξωτερική διεπαφή',
            },
        },
        randomFieldSelect: {
            index: {
                pleaseSelect: 'Παρακαλώ επιλέξτε.',
            },
            utils: {
                customerInformation: 'Πληροφορίες πελατών',
                followtheroadData: 'Στοιχεία παρακολούθησης των οδών',
                preprocessingData: 'Προεπεξεργασία δεδομένων',
                businessRecords: 'Επιχειρηματικά αρχεία',
                workOrderInformation: 'Πληροφορίες παραγγελίας εργασίας',
            },
        },
        frequency: {
            index: {
                pleaseSelect: 'Παρακαλώ επιλέξτε.',
                no: '- Όχι.',
            },
        },
        roleSelect: {
            index: {
                pleaseSelect: 'Παρακαλώ επιλέξτε.',
            },
        },
        userSelect: {
            index: {
                pleaseSelect: 'Παρακαλώ επιλέξτε.',
            },
        },
        massageConfigurationV2: {
            index: {
                messageName: 'Όνομα μηνύματος',
                dataType: 'Τύπος δεδομένων',
                filterCondition: 'Κατάσταση φίλτρου',
                triggerMechanism: 'Μηχανισμός ενεργοποίησης',
                afterDataAcquisition: 'Μετά απόκτηση δεδομένων',
                afterDataAnalysis: 'Μετά την ανάλυση δεδομένων',
                pushMode: 'Λειτουργία ώθησης',
            },
        },
        evaluateDrawer: {
            index: {
                courseQuality: 'Ποιότητα μαθημάτων',
                higherValuesIndicateBetterCourseQuality: 'Υψηλότερες τιμές δείχνουν καλύτερη ποιότητα μαθημάτων',
                learningEffect: 'Μάθηση επίδραση',
                theHigherTheValueTheBetterTheLearningEffect: 'Όσο υψηλότερη είναι η αξία, τόσο καλύτερη είναι η μάθηση.',
                interactiveExperience: 'Διαδραστική εμπειρία',
                theHigherTheValueTheBetterTheInteractiveExperienceOfTheCourse: 'Όσο υψηλότερη είναι η αξία, τόσο καλύτερη η διαδραστική εμπειρία του μαθήματος.',
                suggestedFeedback: 'Προτεινόμενη ανάδραση',
                pleaseEnterAnEvaluationProposalForThisCourse: 'Παρακαλούμε εισάγετε μια πρόταση αξιολόγησης για αυτό το μάθημα',
                cancel: 'Ακύρωση',
                submission: 'Υποβολή',
            },
        },
        filterManage: {
            template: {
                default: 'Προκαθορισμένο',
            },
        },
        associatedTicket: {
            index: {
                associatedWorkOrder: 'Σχετική σειρά εργασίας',
            },
        },
        appealHistory: {
            index: {
                reasonsForPassing: 'Λόγοι παρέλευσης',
                reasonForRejection: 'Λόγος απόρριψης',
                secondaryReview: 'Δευτεροβάθμια επανεξέταση',
                firstlevelReview: 'Επισκόπηση',
            },
        },
        customSortModal: {
            component: {
                sorterNameCannotBeEmpty: 'Το όνομα ταξινόμησης δεν μπορεί να είναι κενό',
                ascending: 'Ανυψωτικός',
                descending: 'Καταβαλλόμενη',
            },
            customFilters: {
                ascending: 'Ανυψωτικός',
                descending: 'Καταβαλλόμενη',
            },
            template: {
                sorterName: 'Όνομα ταξινόμησης:',
                pleaseEnterASorterName: 'Παρακαλώ εισάγετε ένα όνομα Sorter',
                customSort: 'Προσαρμοσμένη ταξινόμηση',
                commonSort: 'Κοινό είδος:',
            },
        },
        waveAudioTalkV2: {
            template: {
                confirmRetranslation: 'Επιβεβαίωσε την επαναφορά;',
                retranslation: 'Μετάφραση',
            },
        },
        waveAudioTalk: {
            template: {
                confirmRetranslation: 'Επιβεβαίωσε την επαναφορά;',
                retranslation: 'Μετάφραση',
            },
        },
        variableFieldSelect: {
            const: {
                languageField: 'Πεδίο γλώσσας',
                businessRecords: 'Επιχειρηματικά αρχεία',
                smartLabel: 'Έξυπνη ετικέταName',
                pretreatment: 'Προαγωγή',
                workOrderFields: 'Πεδία εντολής εργασίας',
                customerInformation: 'Πληροφορίες πελατών',
                associatedWorkOrder: 'Σχετική σειρά εργασίας',
            },
            index: {
                pleaseEnterAKeywordQuery: 'Παρακαλώ εισάγετε ένα ερώτημα λέξεων-κλειδιού',
            },
        },
        customModelsQaMethod: {
            index: {
                qualityInspectionMethod: 'Μέθοδος επιθεώρησης ποιότητας',
                setTheLargeModelQualityInspectionMethodOfTheCurrentQualityInspectionRule: 'Καθορισμός του μεγάλου μοντέλου ποιοτικού ελέγχου του ισχύοντος κανόνα επιθεώρησης της ποιότητας·',
                batchQualityInspectionAfterTheCurrentRuleIsMergedWithOtherBatchQualityInspectionRulesUnderTheSameTaskTheLargeModelIsCalledToOutputTheQualityInspectionResultsOfMultipleRulesAtOneTimeThisIsApplicableToSimpleRules: 'Επιθεώρηση ποιότητας παρτίδας: Μετά τη συγχώνευση του ισχύοντος κανόνα με άλλους κανόνες επιθεώρησης ποιότητας παρτίδας υπό την ίδια εργασία, το μεγάλο μοντέλο καλείται να εκδώσει τα αποτελέσματα της επιθεώρησης της ποιότητας των πολλαπλών κανόνων ταυτόχρονα. Αυτό ισχύει για τους απλούς κανόνες.',
                separateQualityInspectionIndicatesThatTheCurrentRuleIsNotMergedWithOtherRulesAndQualityInspectionIsPerformedSeparatelyThisIsApplicableToComplexRules: 'Χωριστή ποιότητα επιθεώρηση: υποδηλώνει ότι ο ισχύος κανόνας δεν συγχωνεύεται με άλλους κανόνες, και η επιθεώρηση ποιότητας διενεργείται χωριστά. Αυτό εφαρμόζεται σε σύνθετους κανόνες.',
                noteThatTheConsumptionOfIndividualQualityInspectionTokenIsHigherThanThatOfBatchQualityInspection: 'Σημειώστε ότι η κατανάλωση ατομικής επιθεώρησης ποιότητας είναι υψηλότερη από αυτή της επιθεώρησης της ποιότητας των παρτίδων.',
                batchQualityInspection: 'Επιθεώρηση ποιότητας παρτίδας',
                separateQualityInspection: 'Χωριστή επιθεώρηση ποιότητας',
            },
        },
        dialogInformation: {
            index: {
                call: 'Κλήση',
                dialogue: 'Διάλογος',
            },
        },
        ticketRelateQa: {
            index: {
                detectionDataCannotBeEmpty: 'Τα δεδομένα ανίχνευσης δεν μπορούν να είναι κενά!',
                workOrder: 'Σειρά εργασίας',
                dialogue: 'Διάλογος',
                detectionData: 'Δεδομένα ανίχνευσης',
            },
        },
        customerServiceGrounp: {
            component: {
                maximumNameLengthIs: 'Το μέγιστο μήκος του ονόματος είναι 20.',
            },
        },
        agentGroupSelect: {
            index: {
                pleaseSelectAnAgentGroup: 'Παρακαλώ επιλέξτε μια ομάδα πράκτορας',
            },
        },
        agentSelect: {
            index: {
                pleaseSelectCustomerService: 'Παρακαλώ επιλέξτε εξυπηρέτηση πελατών',
            },
        },
        ticketTypeSelect: {
            index: {
                customer: 'Πελάτη',
                customerService: 'Υπηρεσία πελατών',
                internalRemarks: 'Εσωτερικές παρατηρήσεις',
                sMS: 'SMS',
                call: 'Κλήση',
                mail: 'Ταχυδρομείο',
                changeRecord: 'Τροποποίηση εγγραφής',
            },
        },
        agentDepartmentSelect: {
            index: {
                pleaseSelectDepartment: 'Παρακαλώ επιλέξτε το τμήμα',
            },
        },
        aSRModelSelect: {
            index: {
                pleaseSelect: 'Παρακαλώ επιλέξτε.',
            },
        },
        exportButton: {
            index: {
                exportTaskCreatedSuccessfully: 'Επιτυχής δημιουργία της εργασίας εξόδου',
                taskCreatedSuccessfully: 'Η εργασία δημιουργήθηκε με επιτυχία',
                downloadCenter: 'Λήψη κέντρου',
                taskCenter: 'Κέντρο Αποστολής',
            },
        },
    },
    fields: {
        qualityInspectionForm: {
            list: {
                name: 'Όνομα',
                description: 'Περιγραφή',
                type: 'Τύπος',
                status: 'Κατάσταση',
                actions: 'Λειτουργία',
            },
        },
        qualityCheckingTask: {
            index: {
                name: 'Όνομα εργασίας',
                description: 'Περιγραφή',
                form: 'Έντυπο επιθεώρησης ποιότητας',
                actions: 'Λειτουργία',
                createUser: 'Δημιουργός',
            },
            samplingRecords: {
                createTime: 'Χρόνο',
                type: 'Τύπος',
                operateUser: 'Αερομεταφορέας',
                number: 'Προσθήκη ποσότητας',
                filterConditionList: 'Κατάσταση φίλτρου',
                sampleRuleStr: 'Όροι δειγματοληψίας',
                timeGreaterThan: 'Ο χρόνος είναι μεγαλύτερος.',
                timeLessThan: 'Χρόνος λιγότερο',
            },
        },
        customFilters: {
            createdAt: 'Ώρα για ομιλία.',
            customerId: 'Πελάτη',
            agentId: 'Υπηρεσία πελατών',
            userGroupId: 'Ομάδα εξυπηρέτησης πελατών',
            state: 'Κατάσταση',
            lastEvaluateUserId: 'Τελευταίος αξιολογητής',
            submitTime: 'Τελευταία ώρα υποβολής',
            totalScore: 'Συνολική βαθμολογία',
            formItemForbidIdList: 'Απαγορευμένα αντικείμενα',
            formItemDeadlyIdList: 'Θανατηφόρο αντικείμενο',
        },
        samplingInspection: {
            callTime: 'Ώρα για ομιλία.',
            dialogTime: 'Χρόνος διαλόγου',
            originator: 'Πρόσωπο που χορηγήθηκε πρόσωπος',
            createTime: 'Χρόνος δημιουργίας',
            updateTime: 'Ώρα ενημέρωσης',
            status: 'Κατάσταση διεργασίας',
            score: 'Κλάσματα',
            actions: 'Λειτουργία',
            reviewer: 'Αξιολογητής',
            samplingOfficer: 'Επιθεωρητής δειγματοληψίας',
            id: 'ID καταγραφής κλήσεων',
            time: 'Ώρα για ομιλία.',
            phone: 'Τηλέφωνο πελατών',
            staff: 'Υπηρεσία πελατών',
            inspectionStatus: 'Κατάσταση επιθεώρησης ποιότητας',
            samplingStatus: 'Καθεστώς δειγματοληψίας',
            inspectionGrade: 'Αξιολόγηση',
        },
        smartWordsLibrary: {
            synonymWords: {
                standardWords: 'Τυποποιημένη λέξης',
                synonymWords: 'Συνώνυμα',
                synonymWordsNumber: 'Αριθμός συνώνυμων',
                useFrequency: 'Συχνότητα χρήσης',
                effectiveness: 'Αποτελεσματικότητα',
                operation: 'Λειτουργία',
            },
            common: {
                useFrequency: 'Συχνότητα χρήσης',
                effectiveness: 'Αποτελεσματικότητα',
                operation: 'Λειτουργία',
            },
            professionalWords: {
                professionalWords: 'Επαγγελματική ονομασία',
                useFrequency: 'Στατιστικές χρήσης',
                homophonic: 'Ζεστές λέξεις (υποκατάσταση ομοφώνου)',
                target: 'Υποκατάσταση ουσιαστικού',
                targetWords: 'Αντικατάσταση λέξεις',
                homophonyWords: 'Λέξη κάλυψης ομόφωνο',
                operation: 'Λειτουργία',
            },
            attentionWords: 'Ανησυχητικές λέξεις',
            ignoreWords: 'Αγνόηση λέξεων',
            wordsWeight: {
                selfDefineWeightWords: 'Προσαρμοσμένο βάρος λέξης',
                weightWords: 'Λέξεις βάρους',
                weight: 'Βάρος',
                useFrequency: 'Συχνότητα χρήσης',
                effectiveness: 'Αποτελεσματικότητα',
                operation: 'Λειτουργία',
            },
            corpusData: {
                corpusDescription: 'Περιγραφή του σώματος',
                updateTime: 'Ώρα ενημέρωσης',
                wordsCount: 'Αριθμός λέξεων',
                effectiveness: 'Αποτελεσματικότητα',
                operation: 'Λειτουργία',
                corpusContent: 'Περιεχόμενο',
            },
        },
        semanticTags: {
            title: 'Σημασιολογική ετικέτας',
            tags: 'Τυποποιημένη φράση',
            orgName: 'Οργάνωση',
            tagCount: 'Αριθμός εκπαίδευσης',
            usingCount: 'Αριθμός αναφορών',
            activeFlag: 'Αποτελεσματικότητα',
            suggestion: 'Συστάσεις κατάρτισης',
            actions: 'Λειτουργία',
        },
        intelligentTags: {
            tagName: 'Όνομα',
            tagDesc: 'Περιγραφή',
            tagRefCnt: 'Αριθμός σημάτων',
            categoryName: 'Ταξινόμηση ετικέτας',
            eventName: 'Ταξινόμηση γεγονότων',
            tagStatus: 'Αποτελεσματικότητα',
            actions: 'Λειτουργία',
            tagType: 'Τύπος ετικέτας',
        },
        dataPreprocess: {
            name: 'Όνομα',
            desc: 'Περιγραφή',
            dataSource: 'Όρια πηγής δεδομένων',
            type: 'Τύπος',
            status: 'Αποτελεσματικότητα',
            actions: 'Λειτουργία',
        },
        informationEntities: {
            name: 'Όνομα',
            apiName: 'Όνομα API',
            type: 'Τύπος',
            remark: 'Περιγραφή',
            activeFlag: 'Αποτελεσματικότητα',
            actions: 'Λειτουργία',
        },
        interactiveRecognition: {
            questionAndAnswer: 'Συνηθισμένες Ερωτήσεις & Απαντήσεις',
            type: 'Τύπος',
            status: 'Κατάσταση',
            actions: 'Λειτουργία',
            question: 'Ερώτηση',
        },
        role: {
            id: 'ID',
            name: 'Όνομα',
            actions: 'Λειτουργία',
        },
        uploadDownload: {
            taskName: 'Όνομα αρχείου',
            createTime: 'Ημερομηνία',
            size: 'Μέγεθος',
            createUserName: 'Αερομεταφορέας',
            status: 'Κατάσταση',
            result: 'Αποτελέσματα',
            actions: 'Λειτουργία',
        },
        taskCenterList: {
            name: 'Περιεχόμενο εργασίας',
            createTime: 'Χρόνος υποβολής',
            startTime: 'Ώρα έναρξης',
            endTime: 'Τέλος χρόνου',
            createUserName: 'Αερομεταφορέας',
            status: 'Κατάσταση',
            result: 'Αποτελέσματα',
            actions: 'Λειτουργία',
        },
        customerInformation: {
            title: 'Πληροφορίες εξυπηρέτησης πελατών',
            data: 'Προβολή δεδομένων μόνο εξαίρεσης',
            list: {
                agentNo: 'Αριθμός εργασίας',
                agentName: 'Υπηρεσία πελατών',
                agentTel: 'Τηλέφωνο',
                agentEmail: 'Ηλεκτρονικό ταχυδρομείο',
                updateTime: 'Ώρα ενημέρωσης',
                actions: 'Λειτουργία',
            },
            upload: {
                second: '2. Κάντε κλικ στο κουμπί Εισαγωγή για να ανεβάσετε το αρχείο EXCEl σύμφωνα με το μορφότυπο πρότυπο',
            },
        },
        IndexManagement: {
            title: 'Διαχείριση δεικτών',
            list: {
                indicatorName: 'Όνομα',
                indicatorDesc: 'Περιγραφή',
                activity: 'Αποτελεσματικότητα',
                inspectDataSource: 'Πηγή δεδομένων',
                sysType: 'Τύπος',
                agentGroups: 'Ομάδα εξυπηρέτησης πελατών',
                actions: 'Λειτουργία',
            },
            detail: {
                nameEmpty: 'Το όνομα δεν μπορεί να είναι κενό',
                descript: 'Περιγραφή',
                descriptEmpty: 'Η περιγραφή δεν μπορεί να είναι κενή',
                active: 'Αποτελεσματικότητα',
                activeEmpty: 'Η ισχύς δεν μπορεί να είναι κενή',
                dataSource: 'Πηγή δεδομένων',
                dataSourceEmpty: 'Η πηγή δεδομένων δεν μπορεί να είναι κενή',
                grounp: 'Ομάδα εξυπηρέτησης πελατών',
                grounpEmpty: 'Η ομάδα πράκτορα δεν μπορεί να είναι κενή',
                grounpHolder: 'Παρακαλώ επιλέξτε μια ομάδα πράκτορας',
                type: 'Μέθοδος βαθμολογίας',
                typeNone: 'Η μέθοδος βαθμολογίας δεν μπορεί να είναι κενή',
                base: 'Βασικά σημεία',
                baseNone: 'Το βαθμό βάσης δεν μπορεί να είναι κενό',
                positive: 'Θετικοί παράγοντες',
                positiveNone: 'Ο θετικός παράγοντας δεν μπορεί να είναι κενός.',
                customAdd: 'Προσθήκη φίλτρου',
                negative: 'Αρνητικοί παράγοντες',
                negativeNone: 'Οι αρνητικοί παράγοντες δεν μπορούν να είναι κενοί.',
                customOK: 'Κριτήρια φίλτρου:',
                judgeStrategy: 'Κανόνες κατάστασης:',
                other: 'Άλλοι παράγοντες',
                otherAdd: 'Προσθήκη συντελεστής',
                agent: 'Ακατέργαστα δεδομένα',
                section: 'Αριθμός διαστημάτων',
                sectionNone: 'Αριθμός διαστημάτων δεν μπορεί να είναι κενή',
                step: 'Μέγεθος βήματος διαστήματος',
                stepNone: 'Μέγεθος βήματος διαστήματος',
                save: 'Αποθήκευση',
                cancel: 'Ακύρωση',
            },
        },
    },
    enums: {
        gongRolesTypes: {
            all: 'Όλα',
            staff: 'Μόνο τον εαυτό μου.',
            department: 'Υπηρεσία και κατωτέρω',
        },
        gongStatisticsDate: {
            week: 'Εβδομάδα',
            month: 'Μήνας',
            season: 'Εποχή',
        },
        gongCoachTaskStatus: {
            wait: 'Για να γίνει καθοδήγηση',
            already: 'Προπονημένοι',
            ignore: 'Αγνόητα',
        },
        callRangeStatus: {
            all: 'Όλες οι κλήσεις',
            sale: 'Εκκίνηση εργαζομένων',
            customer: 'Εκκίνηση πελάτης',
        },
        todoListType: {
            later: 'Ακούστε αργότερα.',
            help: 'Συμβουλευτική βοήθεια για βοήθεια.',
            contact: 'Επαφή αργότερα.',
            send: 'Αποστολή δεδομένων',
            warn: 'Έγκαιρη προειδοποίηση κινδύνου',
        },
        frequencyTypes: {
            everyDay: 'Καθημερινά',
            everyWeek: 'Εβδομαδιαία',
            everyMonth: 'Μηνιαία',
        },
        classifiedTraing: {
            trainTypeList: {
                noneDataTrain: 'Μη διαβαθμισμένη εκπαίδευση δεδομένων',
                markedDataCorrigenda: 'Ετικέτα δεδομένα',
                classifiedDataCheck: 'Επαλήθευση διαβαθμισμένων δεδομένων',
                markedHistoryRecord: 'Ιστορία κλήσης',
                historyDataRecalculate: 'Επαναυπολογισμός ιστορικών δεδομένων',
            },
            dataExtractMode: {
                random: 'Εντελώς τυχαίο',
                intelligentRecommend: 'Ευφυής σύσταση',
                custom: 'Προσαρμοσμένο',
                specifiedClass: 'Προσδιορίστε την ταξινόμηση',
            },
            smartRatesList: {
                markRate: 'Ρυθμός σήμανσης',
                corrigendaRate: 'Ποσοστό αέρας',
                kl: 'Απόκλιση K-L',
                signalNoiseRate: 'Αναλογία σήματος/θορύβου/θορύβου',
            },
        },
        visibleRangeTypes: {
            all: 'Όλα',
            customerGroup: 'Ομάδα εξυπηρέτησης πελατών',
            userDefined: 'Προσαρμοσμένο',
        },
        samplingRateTypes: {
            everyDay: 'Σχεδίαση καθημερινά',
            everyWeek: 'Εβδομαδιαία',
        },
        taskRemindTypes: {
            confirm: 'Στείλτε υπενθύμιση όταν πρέπει να επιβεβαιωθεί η επιθεώρηση εργασιών ποιότητας.',
            appeal: 'Όταν το αρχείο εργασιών επιθεώρησης ποιότητας προκαλεί καταγγελία, στείλτε μια υπενθύμιση.',
        },
        weekDays: {
            monday: 'Δευτέρα.',
            tuesday: 'Τρίτη.',
            wednesday: 'Τετάρτη.',
            thursday: 'Πέμπτη',
            friday: 'Παρασκευή',
            saturday: 'Σάββατο.',
            sunday: 'Κυριακή.',
        },
        reportDateTypes: {
            dailyReport: 'Ημερήσια έκθεση:',
            weeklyReport: 'Εβδομαδιαία',
        },
        samplingRangeDayTypes: {
            today: 'Σήμερα',
            yesterday: 'Χθες το βράδυ.',
        },
        samplingRangeWeekTypes: {
            thisWeek: 'Αυτή την εβδομάδα.',
            lastWeek: 'Την περασμένη εβδομάδα.',
        },
        samplingRuleTypes: {
            proportion: 'Αναλογική δειγματοληψία',
            random: 'Τυχαία δειγματοληψία',
        },
        taskStatusTypes: {
            waitEvaluate: 'Προς αξιολόγηση',
            waitSubmit: 'Προς υποβολή',
            waitConfirm: 'Επιβεβαίωση',
            waitReview: 'Προς επανεξέταση',
            completed: 'Ολοκληρώθηκε',
            all: 'Όλα',
        },
        qualityInspectionForm: {
            formTemplateTypes: {
                directScore: 'Άμεση βαθμολογία',
                weightedScore: 'Βαθμολογία βάρους',
                deductScore: 'Μειώσεις',
                directScoreSecondLevel: 'Άμεση αξιολόγηση-επίπεδο 2',
                weightedScoreSecondLevel: 'Βάρος-Επίπεδο 2',
                deductScoreSecondLevel: 'Σημεία έκπτωσης-επίπεδο 2',
            },
        },
        fieldOperators: {
            is: 'Ίση',
            not: 'Δεν είναι ίσο',
            contains: 'Περιέχει',
            notContains: 'Δεν περιέχει',
            not_contains: 'Δεν περιέχει',
            containsAny: 'Περιέχει όλο',
            contains_any: 'Περιέχει όλο',
            is_any: 'Περιέχει όλο',
            not_any: 'Δεν περιέχει κανένα',
            notContainsAny: 'Δεν περιέχει κανένα',
            not_contains_any: 'Δεν περιέχει κανένα',
            containsAll: 'Περιέχει όλα τα σύνορα',
            contains_all: 'Περιέχει όλα τα σύνορα',
            notContainsAll: 'Δεν περιέχει όλο',
            nont_contains_all: 'Δεν περιέχει όλο',
            isNull: 'Κενό',
            is_null: 'Κενό',
            isNotNull: 'Μη κενό',
            is_not_null: 'Μη κενό',
            greaterThan: 'Μεγαλύτερο',
            greater_than: 'Μεγαλύτερο',
            greaterThanEq: 'Μεγαλύτερη ή ίση',
            greater_than_eq: 'Μεγαλύτερη ή ίση',
            lessThan: 'Λιγότερα',
            less_than: 'Λιγότερα',
            lessThanEq: 'Λιγότερο ή ίσο',
            less_than_eq: 'Λιγότερο ή ίσο',
            between: 'Μεταξύ',
            notBetween: 'Όχι',
            not_between: 'Όχι',
            relative: 'Ίση',
            set: 'Ορισμός',
            belongs: 'Ανήκω',
            notBelongs: 'Δεν ανήκουν εδώ.',
            not_belongs: 'Δεν είναι ίσο',
            today: 'Σήμερα',
            yesterday: 'Χθες το βράδυ.',
            the_day_before_yesterday: 'Προχθές μέρα.',
            tomorrow: 'Αύριο.',
            next_seven_day: 'Τις επόμενες επτά ημέρες',
            last_seven_day: 'Τελευταίες επτά ημέρες',
            this_week: 'Αυτή την εβδομάδα.',
            next_week: 'Την επόμενη εβδομάδα.',
            last_week: 'Την περασμένη εβδομάδα.',
            this_month: 'Αυτό το μήνα',
            next_month: 'Ο επόμενος μήνας',
            last_month: 'Τον περασμένο μήνα.',
            this_year: 'Φέτος φέτος.',
            next_year: 'Το επόμενο έτος',
            last_year: 'Πέρυσι',
            exact_match: 'Ακριβής ταίριασμα',
            add_value: 'Νέα προστιθέμενη αξία',
            remove_value: 'Διαγραφή τιμής',
            set_null: 'Κενό',
            isAny: 'Εξαιτίας αυτού ισούται.',
            notAny: 'Αυθαίρετο μη ίσος',
            belongTo: 'Ανήκω',
            notBelongTo: 'Δεν ανήκουν εδώ.',
            hasAny: 'Περιέχει όλο',
            notHasAny: 'Δεν περιέχει κανένα',
            prefixContains: 'Αρχή ίσης',
            prefixNotContains: 'Η έναρξη δεν είναι ίση',
            suffixContains: 'Τέλος ίσο με',
            suffixNotContains: 'Τέλος δεν είναι ίσος',
            nextSevenDay: 'Επόμενες 7 ημέρες',
            lastSevenDay: 'Τελευταίες 7 ημέρες',
            thisWeek: 'Αυτή την εβδομάδα.',
            nextWeek: 'Την επόμενη εβδομάδα.',
            lastWeek: 'Την περασμένη εβδομάδα.',
            thisMonth: 'Αυτό το μήνα',
            nextMonth: 'Ο επόμενος μήνας',
            lastMonth: 'Τον περασμένο μήνα.',
            thisYear: 'Φέτος φέτος.',
            nextYear: 'Το επόμενο έτος',
            lastYear: 'Πέρυσι',
            after: 'Αργότερα από (συμπεριλαμβανομένης της τρέχουσας ημέρας)',
            before: 'Νωρίτερα από (συμπεριλαμβανομένης της τρέχουσας ημέρας)',
            allMatching: 'Ταίριασμα όλων',
            allNotMatching: 'Όλα δεν ταιριάζουν όλα',
            hit: 'Χτύπημα.',
            not_hit: 'Αστόχηση',
        },
        fieldsOperators: {
            is: 'Ίση',
            is_null: 'Επίσης κενό',
            head_equal: 'Αρχή ίσης',
            tail_equal: 'Τέλος ίσο με',
            is_not_null: 'Επίσης δεν είναι άδειο',
            not: 'Δεν είναι ίσο',
            diff_equal: 'Η διαφορά είναι ίση',
            diff_greater_than: 'Η διαφορά είναι μεγαλύτερη.',
            diff_greater_than_eq: 'Διαφορά μεγαλύτερη ή ίση',
            diff_less_than: 'Η διαφορά είναι μικρότερη.',
            diff_less_than_eq: 'Διαφορά μικρότερη ή ίση',
            hour_equal: 'Την ίδια ώρα.',
            day_equal: 'Ίδια μέρα.',
            week_equal: 'Ίδια εβδομάδα',
            month_equal: 'Ίδιο μήνα',
            year_equal: 'Ίδιο έτος',
            day: 'Ημέρα',
            minute: 'Πρακτικά',
            hour: 'Ώρες',
            part_equal: 'Μερικώς ίσο',
        },
        samplingColumnCaptions: {
            created_at: 'Ώρα για ομιλία.',
            agent_id: 'Υπηρεσία πελατών',
            get_direction: 'Τύπος κλήσης',
            call_result: 'Αποτελέσματα κλήσης',
            survey: 'Αξιολόγηση',
            derived_from_id: 'Πηγή',
            quit_queue_why: 'Κατάσταση ουράς',
            queuing_duration: 'Χρονοανατολική ουράς',
            talking_seconds: 'Διάρκεια κλήσης',
            ringing_seconds: 'Ώρα δακτυλίους',
            hangup_by: 'Κλείσε το πάρτι.',
        },
        callTypes: {
            callIn: 'Εισερχόμενη κλήση.',
            callOut: 'Εκπνοή',
            threeParty: '(Τριμερώς)',
            consultation: '(Συμβουλευτική)',
            insert: '(Ισχυρή εισαγωγή)',
            monitor: '(Ακούγοντας)',
            transfer: '(Μεταφορά)',
            intercept: '(Διακοπή)',
            transferOutside: '(Εξωτερική γραμμή μεταφοράς)',
            threePartyOutside: '(Τριμερής εξωτερική γραμμή)',
            consultingOutside: '(Συμβουλευτείτε έξω)',
        },
        callResults: {
            staffAnswer: 'Απάντηση εξυπηρέτησης πελατών',
            staffNotAnswer: 'Εξυπηρέτηση πελατών',
            customerAnswer: 'Απάντηση',
            customerNotAnswer: 'Αποτυχία πελάτης',
            phoneBusy: 'Τηλέφωνο απασχολημένο',
            phoneOffline: 'Τηλέφωνο εκτός σύνδεσηςComment',
            customerSpeedHangUp: 'Γρήγορη κρεμασμένη πελάτης',
            customerHangUp: 'Ο πελάτης το κλείνει.',
            queueTimeout: 'Χρονικό όριο αναμονής',
            queueGiveUp: 'Εγκατάλειψη ουράς',
            outlineAnswer: 'Εξωτερική απάντηση',
            outlineNotAnswer: 'Εξωτερική γραμμή που δεν συνδέεται',
            noChooseQueue: 'Δεν επιλέχθηκε αναμονή',
        },
        defaultSurveys: {
            noEvaluation: 'Δεν αξιολογήθηκε',
            noNeedToEvaluate: 'Δεν χρειάζεται αξιολόγηση',
        },
        queueStates: {
            queueSuccess: 'Επιτυχία ουράς',
            queueTimeout: 'Χρονικό όριο αναμονής',
            queueGiveUp: 'Εγκατάλειψη ουράς',
            noStaffOnline: 'Καμία υπηρεσία πελατών σε απευθείας σύνδεση',
        },
        callHangers: {
            customer: 'Πελάτη',
            staff: 'Υπηρεσία πελατών',
            outline: 'Έξω.',
        },
        workFlowTypes: {
            noAppealsMode: 'Καμία λειτουργία παραποίησης',
            appealsMode: 'Επίτρεψε λειτουργία έφεσης',
        },
        fieldCategories: {
            standardCondition: 'Τυπικά κριτήρια φίλτρου',
            customerCondition: 'Καθορισμένα από χρήστη κριτήρια φίλτρου',
        },
        sampleTypes: {
            automatic: 'Αυτόματη δειγματοληψία',
            manual: 'Χειροκίνητη δειγματοληψία',
        },
        defaultFields: {
            createdAt: 'Ώρα για ομιλία.',
            agentId: 'Υπηρεσία πελατών',
            getDirection: 'Τύπος κλήσης',
            callResult: 'Αποτελέσματα κλήσης',
            survey: 'Αξιολόγηση',
            derivedFrom: 'Πηγή',
            quitQueueWhy: 'Κατάσταση ουράς',
            queuingDuration: 'Χρονοανατολική ουράς',
            talkingSeconds: 'Διάρκεια κλήσης',
            ringingSeconds: 'Ώρα δακτυλίους',
            hangupBy: 'Κλείσε το πάρτι.',
        },
        conditionFieldCategories: {
            fixedField: 'Σταθερό πεδίο',
            customField: 'Προσαρμοσμένα πεδία',
            secondLevelScore: 'Δευτερεύουσα ταξινόμηση',
            formItemScore: 'Αντικείμενο βαθμολογίας',
            forbids: 'Απαγορευμένα αντικείμενα',
            deadlies: 'Θανατηφόρο αντικείμενο',
        },
        columnFieldCategories: {
            agent: 'Υπηρεσία πελατών',
            callLog: 'Καταγραφή κλήσεων',
            businessFields: 'Επιχειρηματικές πληροφορίες',
            customer: 'Πελάτη',
            customerCustomFields: 'Προσαρμογή πελατών',
            source: 'Πηγή',
            queue: 'Σειρά αναμονής',
            fixed: 'Σταθερή',
            secondLevelScore: 'Δευτερεύουσα ταξινόμηση',
            formItemScore: 'Αντικείμενο βαθμολογίας',
            forbids: 'Απαγορευμένα αντικείμενα',
            deadlies: 'Θανατηφόρο αντικείμενο',
        },
        taskListDefaultFields: {
            startTime: 'Ώρα για ομιλία.',
            name: 'Υπηρεσία πελατών',
            state: 'Κατάσταση',
            totalScore: 'Συνολική βαθμολογία',
            formItemForbidList: 'Απαγορευμένα αντικείμενα',
            formItemDeadlyList: 'Θανατηφόρο αντικείμενο',
            comment: 'Παρατηρήσεις αξιολόγησης',
            inspector: 'Αξιολόγηση',
            review: 'Αξιολογητής',
        },
        evaluationStates: {
            initial: 'Αρχικοποίησης',
            waitEvaluate: 'Προς αξιολόγηση',
            evaluated: 'Προς υποβολή',
            waitConfirm: 'Επιβεβαίωση',
            waitCheck: 'Προς επανεξέταση',
            complete: 'Ολοκληρώθηκε',
        },
        workBenchInfoTypes: {
            callInfo: 'Πληροφορίες κλήσης',
            businessInfo: 'Επιχειρηματικές πληροφορίες',
            customerInfo: 'Πληροφορίες πελατών',
        },
        evaluationEventStates: {
            create: 'Δημιουργία δημιουργίας',
            valuate: 'Αξιολόγηση',
            edit: 'Επεξεργασία',
            submit: 'Υποβολή',
            confirm: 'Επιβεβαίωση',
            appeal: 'Καταγγελία',
            checkConfirm: 'Επιβεβαίωση επανεξέτασης',
            check: 'Αναθεώρηση',
        },
        formItemTypes: {
            direct: 'Άμεση βαθμολογία',
            weight: 'Βάρος',
            deduct: 'Μειώσεις',
            forbid: 'Απαγορευμένα αντικείμενα',
            deadly: 'Θανατηφόρο αντικείμενο',
        },
        appealCheckCallTypes: {
            callIn: 'Εισερχόμενη κλήση.',
            callBack: 'Διπλής κλήσης',
            callOut: 'Απευθείας κλήση',
            autoCall: 'Αυτόματη κλήση εξόδου',
        },
        appealCheckCallStatus: {
            waitReview: 'Προς επανεξέταση',
            reviewed: 'Επανεξέταση',
            filed: 'Αρχειοθετημένο',
        },
        samplingStatus: {
            all: 'Όλα',
            unchecked: 'Δεν ελέγχθη η εξαγωγή',
            checked: 'Δειγματοληψία',
        },
        inspectionStatus: {
            all: 'Όλα',
            unread: 'Μη αναγνωσμένο',
            readed: 'Ανάγνωση:',
            appeal: 'Καταγγελία',
            review: 'Αναθεώρηση',
            filed: 'Αρχειοθετημένο',
        },
        gradeChooseHits: {
            yes: 'Μάλιστα.',
            no: 'Οχι',
        },
        appealCheckStatus: {
            all: 'Όλο το κατάσταση',
            unread: 'Μη αναγνωσμένο',
            inComplaint: 'Σε Παραπόνιο',
            reviewed: 'Επανεξέταση',
            readed: 'Ανάγνωση:',
            filed: 'Αρχειοθετημένο',
            spotchecked: 'Δειγματοληψία',
        },
        flowStatus: {
            unread: 'Μη αναγνωσμένο',
            alreadyRead: 'Ανάγνωση:',
            complaining: 'Σε Παραπόνιο',
            reviewed: 'Επανεξέταση',
            sampling: 'Δεν ελέγχθη η εξαγωγή',
            samplingCompleted: 'Δειγματοληψία',
            complainCancel: 'Ανακαλώθηκε',
        },
        complainStatus: {
            success: 'Επιτυχία',
            fail: 'Αποτυχία',
            default: 'Σε Παραπόνιο',
            canceled: 'Ανακαλώθηκε',
        },
        reviewInspectionStatus: {
            inComplaint: 'Σε Παραπόνιο',
            reviewed: 'Επανεξέταση',
        },
        gradeChangeTypes: {
            edit: 'Επεξεργασία',
            check: 'Αναθεώρηση',
            file: 'Αρχειοθετήσεις',
            remark: 'Παρατηρήσεις',
            complain: 'Καταγγελία',
            review: 'Αναθεώρηση',
            reviewEvaluation: 'Αξιολόγηση επανεξέτασης',
            sample: 'Τυχαία επιθεώρηση',
            sampleEvaluation: 'Επιθεώρηση δειγματοληψίας και αξιολόγηση',
            sampleSubmit: 'Επιθεώρηση δειγματοληψίας και υποβολή',
            sampleAssign: 'Κατανομή δειγματοληψίας',
            reviewAssign: 'Κατανομή επανεξέτασης',
            read: 'Ανάγνωση:',
            reviewConfirm: 'Επιβεβαίωση επανεξέτασης',
            sampleConfirm: 'Επιβεβαίωση επιθεώρησης δειγματοληψίας',
            caseBase: 'Προσθήκη στην ομάδα υποθέσεων',
            sampleCancel: 'Δειγματοληψία Ακύρωση κατανομής',
            reviewCancel: 'Αναθεώρηση ακύρωσης',
            sampleAgain: 'Επανακατανομή δειγματοληψίας',
            reviewAgain: 'Αναθεώρηση',
            btachDelete: 'Διαγραφή τυχαίων αρχείων επιθεώρησης',
            rapidSampling: 'Γρήγορη δειγματοληψία',
            reInspection: 'Επανεπιθεώρηση',
            smartTagsChange: 'Αλλαγές έξυπνης ετικέτας',
            cancelAppeal: 'Απόσυρση καταγγελίας',
        },
        appealTypes: {
            transliterationError: 'Μεταγραφή σφάλματος:',
            discriminationError: 'Σφάλμα απόφασης',
            otherError: 'Άλλα σφάλματα',
        },
        inspectDataSources: {
            voiceCall: 'Κλήση φωνής',
            textDialogue: 'Διάλογο κειμένου',
            realTimeVoiceCall: 'Κλήσεις φωνής σε πραγματικό χρόνο.',
            realTimeTextDialogue: 'Συνομιλίες κειμένου σε πραγματικό χρόνο.',
            wechatDialogue: 'Πολιτική συνόδου επιχειρήσεων',
            taobao: 'Διάλογος κειμένου ηλεκτρονικού εμπορίου',
            ticket: 'Σειρά εργασίας',
            wechatRadio: 'Μικροφωνία του Enterprise',
        },
        inspectTaskType: {
            all: 'Όλα',
            common: 'Τακτική επιθεώρηση ποιότητας',
            relate: 'Σχετική επιθεώρηση ποιότητας',
        },
        inspectApproveType: {
            all: 'Όλα',
            resolve: 'Εγκρίθηκε',
            resolving: 'Σε Αναθεώρηση',
            reject: 'Ο έλεγχος δεν πραγματοποιήθηκε',
        },
        dataSourceFlags: {
            all: 'Χωρίς περιορισμοί',
            voiceCall: 'Κλήση',
            textDialogue: 'Διάλογος',
        },
        smartWordsLibrary: {
            hotWords: 'Καυτές λέξεις',
            effective: 'Αποτελεσματικό',
            invalid: 'Μη έγκυρο',
        },
        activeFlags: {
            effiective: 'Αποτελεσματικό',
            invalid: 'Μη έγκυρο',
        },
        labelTypes: {
            dimensionLabel: 'Ετικέτες κλήσης',
            classificationLabel: 'Κατηγορία ετικέτας',
        },
        pointTypes: {
            automatic: 'Αυτόματη αξιολόγηση',
            manual: 'Χειροκίνητη αξιολόγηση',
            interactiveDetection: 'Ανίχνευση αλληλεπίδρασης',
            smartRules: 'Έξυπνοι κανόνες',
            machineLearning: 'Τρόπος μάθησης',
            intelligentModel: 'Ευφυές μοντέλο',
        },
        pointGradeTypes: {
            radio: 'Ενιαία επιλογή',
            input: 'Εισαγωγή',
            select: 'Επιλογή',
            all: 'Γνωρίστε όλοι.',
            any: 'Συναντήστε αυθαίρετα',
            customize: 'Προσαρμοσμένο',
        },
        pointNaChecked: {
            check: 'N/A',
        },
        operatorTypes: {
            keyword: 'Ταιριάζουν λέξη κλειδιά',
            question: 'Ερωτηματική ποινή',
            regular: 'Κανονική έκφραση',
            context: 'Επαναπαραγωγή',
            semantics: 'Σημασιολογικό ταίριασμα',
            word: 'Παρόμοιες λέξεις',
            dialogue: 'Διάστημα διαλόγου',
            speed: 'Ανίχνευση ταχύτητας ομιλίας',
            grabDetection: 'Ανίχνευση αρπαγών',
            semanticTags: 'Σημασιολογική ετικέτας',
        },
        applyRoles: {
            all: 'Όλα',
            customer: 'Πελάτη',
            agent: 'Υπηρεσία πελατών',
            robot: 'Ρομπότ',
        },
        saleApplyRoles: {
            all: 'Όλα',
            customer: 'Πελάτη',
            agent: 'Εργαζόμενος',
        },
        applyOperatorScopes: {
            all: 'Πλήρες κείμενο',
            preCondition: 'Προϋποθέση',
            scope: 'Καθορισμένο εύρος',
        },
        keywordScopes: {
            all: 'Ανίχνευση όλων των λέξεων-κλειδιών.',
            any: 'Ανίχνευση αυθαίρετων λέξεων-κλειδιών',
        },
        preOperatorHitTypes: {
            first: 'Πρώτη ταίριασμα',
            every: 'Κάθε ταίριασμα',
            last: 'Τελευταία ταίριασμα',
            any: 'Οποιαδήποτε ταιριάζει.',
            none: 'Δεν ταιριάζεται',
        },
        operatorRuleTypes: {
            all: 'Γνωρίστε όλοι.',
            any: 'Συναντήστε αυθαίρετα',
            custom: 'Προσαρμοσμένη λογική',
        },
        informationEntityTypes: {
            system: 'Σύστημα',
            custom: 'Προσαρμοσμένο',
            moduleCompany: 'Ενότητα:',
        },
        organizationTypes: {
            null: 'Κανένα',
            moduleCompany: 'Ενότητα:',
        },
        customType: {
            smartTag: 'Εξαγωγή οντοτήτων',
            scriptTimes: 'Μέτρηση λόγου',
            dataCategory: 'Ταξινόμηση δεδομένων',
        },
        interactiveQuestionTypes: {
            standard: 'Πρότυπο Ε & Α',
            multiElement: 'Πολλαπλή ερώτηση και απάντηση',
            guideMultiRound: 'Καθοδηγούμενη αλληλεπίδραση πολλών τροχών',
        },
        targetTypes: {
            all: 'Όλα',
            customerService: 'Υπηρεσία πελατών',
            customer: 'Πελάτη',
        },
        interactiveTypes: {
            similarQList: 'Παρόμοιο πρόβλημα.',
            exceptSimilarQList: 'Εξάλειψη παρόμοιων προβλημάτων',
            similarAList: 'Παρόμοιες απαντήσεις',
            wrongAList: 'Λάθος απάντηση',
        },
        filterTypes: {
            call: 'Καταγραφή κλήσεων',
            dialogue: 'Κείμενο διαλόγου',
            wechat: 'Enterprise WeChat',
            wechatAll: 'Enterprise WeChat Όλο το διάλογο',
            ticket: 'Συνεδρία εντολής εργασίας',
            taobao: 'Σύνοδος ηλεκτρονικού εμπορίου',
            wechatRadio: 'Μικροφωνία του Enterprise',
        },
        fieldTypes: {
            keyword: 'Λέξεις-κλειδιά',
            agent: 'Υπηρεσία πελατών',
            agentGroup: 'Ομάδα εξυπηρέτησης πελατών',
            sigleListbox: 'Ενιαία επιλογή',
            multiListbox: 'Πολλαπλή επιλογή',
            text: 'Μοναδική γραμμή του κειμένου:',
            textArea: 'Πολλαπλές γραμμές κειμένου',
            dateTime: 'Χρόνο',
            number: 'Αριθμοί',
            voice: '',
            customer: 'Πελάτη',
            fieldWithLink: 'Πεδίο με σύνδεση',
            percentage: 'Ποσοστό',
            intelligentClassification: 'Ευφυής ταξινόμηση',
            testSetList: 'Δυναμικά πεδία δοκιμής',
            inspector: 'Επιθεωρητής ποιότητας',
        },
        saveTypes: {
            save: 'Αποθήκευση',
        },
        knowledgeType: {
            oneToOne: 'Μια ερώτηση και μία απάντηση',
        },
        updateTypes: {
            update: 'Ενημέρωση',
            saveAs: 'Αποθήκευση',
        },
        recommendItemActionTypes: {
            similar: 'Παρόμοια',
            exclude: 'Εξαίρεση',
            ignore: 'Αγνόηση',
        },
        gradeStatus: {
            unread: 'Μη αναγνωσμένο',
            alreadyReview: 'Επανεξέταση',
            alreadyFiled: 'Αρχειοθετημένο',
            waitReview: 'Προς επανεξέταση',
            alreadyRead: 'Ανάγνωση:',
        },
        qualityCheckDetailTypes: {
            review: 'Αναθεώρηση',
            spotCheck: 'Τυχαία επιθεώρηση',
        },
        sampleAndReviewStatus: {
            init: 'Μη εκχυλισμένα',
            unread: 'Μη αναγνωσμένο',
            alreadyRead: 'Ανάγνωση:',
            complaining: 'Σε Παραπόνιο',
            reviewed: 'Επανεξέταση',
            sampling: 'Δεν ελέγχθη η εξαγωγή',
            samplingCompleted: 'Δειγματοληψία',
        },
        interactiveAnswerTypes: {
            noAnswer: 'Δεν ανιχνεύθηκε απάντηση',
            answer: 'Ανιχνεύθηκε απάντηση',
            wrongAnswer: 'Ανιχνεύθηκε εσφαλμένη απάντηση.',
        },
        interactiveMatchedQuestionTypes: {
            noQuestion: 'Δεν εντοπίστηκαν προβλήματα.',
            question: 'Ανιχνεύθηκε πρόβλημα.',
            eliminateQuestion: 'Ανιχνεύθηκε πρόβλημα αντιμετώπισης προβλημάτων',
        },
        isManual: {
            yes: 'Χειροκίνητη επιθεώρηση ποιότητας',
            no: 'Χωρίς χειροκίνητη επιθεώρηση ποιότητας',
        },
        readStatus: {
            yes: 'Ανάγνωση:',
            no: 'Μη αναγνωσμένο',
        },
        reInspectionType: {
            recalcScore: 'Μόνο εκ νέου υπολογίστε τις βαθμολογίες (με αξιολογήσεις)',
            recheckPoint: 'Επαναυπολογίστε τα σημεία επιθεώρησης ποιότητας και βαθμολογία',
        },
        common: {
            processingTime: 'Χρόνος επεξεργασίας',
            noResponseFromCustomerService: 'Καμία απάντηση από την εξυπηρέτηση πελατών',
            businessRecords: 'Επιχειρηματικά αρχεία',
            customFields: 'Προσαρμοσμένα πεδία',
            flyingBookGroupChat: 'Συνομιλία ομάδας ιπτάμενων βιβλίων',
            associatedWorkOrder: 'Σχετική σειρά εργασίας',
            dataSourceManagement: 'Διαχείριση πηγών δεδομένων',
            qualityInspectionList: 'Κατάλογος επιθεωρήσεων ποιότητας',
            reviewList: 'Λίστα αναθεώρησης',
            samplingList: 'Κατάλογος δειγματοληψίας',
            theRobotAnswers: 'Το ρομπότ απαντά.',
            voiceOfCustomer: 'Φωνή του Πελάτη',
            questionnaire: 'Ερωτηματολόγο',
            originalSoundManagement: 'Αρχική διαχείριση ήχου',
            eCommerceReview: 'Επισκόπηση ηλεκτρονικού εμπορίου',
            socialMediaComments: 'Σχόλια Κοινωνικών Μέσων',
            mixedQualityInspection: 'Επιθεώρηση μεικτής ποιότητας',
            videoCall: 'Κλήση βίντεο',
            customer: 'Πελάτη',
            customerService: 'Υπηρεσία πελατών',
            robot: 'Ρομπότ',
            customerInformation: 'Πληροφορίες πελατών',
            workOrderFields: 'Πεδία εντολής εργασίας',
            intelligentConversationAnalysis: 'Ευφυής ανάλυση συνεδρίας',
            insightIntoBusinessWeaknessesListenToCustomerVoicesAndEnhanceMarketingTransformation: 'Ενόραση στο σύντομο επιχειρηματικό συμβούλιο, ακούστε τη φωνή των πελατών, βελτιώστε το μάρκετινγκ μετασχηματισμό',
            intelligentAccompanyingPractice: 'Έξυπνο ρεζέρι',
            createImmersiveAIAccompanimentExercisesThatSimulateRealBusinessScenariosEnablingAllEmployeesToMasterGoldMedalScriptsAndQuicklyImproveDialogueSkills: 'Δημιουργήστε μια βυθιστική τεχνική τεχνολογία που προσομοιώνει πραγματικές επιχειρηματικές σκηνές για την επίτευξη πλήρους κυριαρχίας των ικανοτήτων ομιλίας χρυσού μετάλλιου και γρήγορη βελτίωση του διαλόγου ικανότητες.',
            intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας',
            fullQualityInspectionTimelyAndEfficientWithAccuracyRateAbove: 'Πλήρης επιθεώρηση ποιότητας, έγκαιρη και αποτελεσματική, με ποσοστό ακρίβειας άνω του 85%',
            salesEmpowerment: 'Ενίσχυση των πωλήσεων',
            aIReshapesSalesManagementRealizesDigitalAndVisualCommunicationProcessTransparentlyManagesEveryLinkOfSalesIntelligentlyInsightIntoEveryStepOfCommunicationFinelyDiagnosesBusinessProblemsAndPerfectlyReplicatesSalesExperience: 'Η τεχνολογία αναμορφώνει τη διαχείριση των πωλήσεων, πραγματοποιεί την ψηφιοποίηση και την οπτικοποίηση της διαδικασίας επικοινωνίας, διαχειρίζεται με διαφανή τρόπο κάθε σύνδεση των πωλήσεων, Αντιλαμβάνεται έξυπνα κάθε βήμα της επικοινωνίας, διαγνωρίζει λεπτά επιχειρηματικά προβλήματα και αναπαράγει τέλεια την εμπειρία πωλήσεων.',
            algorithmPlatform: 'Πλατφόρμα αλγόριθμου',
            basedOnSelfdevelopedOriginalHeartEngineVoiceSemanticsASRAndNLPModelCustomizationGetThroughBusinessScenarioDataRealizeSystemSelflearningAndAchieveTheGoalOfMoreIntelligentAndMoreAccurateWhenUsed: 'Με βάση τις σημασιολογικές ομιλίες της αυτο-ανεπτυγμένης αρχικής καρδιακής μηχανής, Τα μοντέλα ASR και NLP είναι προσαρμοσμένα για να περάσει μέσα από τα δεδομένα επιχειρηματικού σενάριο και να πραγματοποιήσει αυτόματη μάθηση του συστήματος, ώστε να επιτευχθεί ο σκοπός της πιο ευφυής και πιο ακριβής χρήσης.',
            generalSettings: 'Γενικές ρυθμίσεις',
            unifiedSettingAndManagementOfDataPermissionsAndEmployeeRoles: 'Ρύθμιση και διαχείριση άδειων δεδομένων και ρόλων των εργαζομένων με ένα ενοποιημένο τρόπο.',
            callLog: 'Καταγραφή κλήσεων',
            intelligentRules: 'Έξυπνοι κανόνες',
            customFilter: {
                call: 'Κλήση φωνής',
                text: 'Διάλογο κειμένου',
                smartTags: 'Έξυπνη ετικέταName',
                pretreatment: 'Προαγωγή',
                smartTagGroup: 'Έξυπνη ομάδα σήμανσης',
                currency: 'Γενικά δεδομένα',
                wechat: 'Enterprise WeChat',
                spotCheck: 'Τυχαία επιθεώρηση',
                personaField: 'Κατάλογος πελατών',
                ticket: 'Συνεδρία εντολής εργασίας',
                taobao: 'Σύνοδος ηλεκτρονικού εμπορίου',
                wechatRadio: 'Μικροφωνία του Enterprise',
                reviewList: 'Αναθεώρηση',
            },
            talkerRecognitionType: {
                API: 'Το API αναγνωρίζει το ρόλο κομματιού',
                text: 'Αναγνώριση κειμένου:',
            },
            operatorTypes: {
                keyword: 'Ταιριάζουν λέξη κλειδιά',
                question: 'Ερωτηματική ποινή',
                regular: 'Κανονική έκφραση',
                context: 'Επαναπαραγωγή',
                semantics: 'Σημασιολογικό ταίριασμα',
                word: 'Παρόμοιες λέξεις',
                dialogue: 'Διάστημα διαλόγου',
                speed: 'Ανίχνευση ταχύτητας ομιλίας',
                grabDetection: 'Ανίχνευση αρπαγών',
                semanticTags: 'Σημασιολογική ετικέτας',
                keywordStrict: 'Ταίριασμα λέξεων κλειδιών (αυστηρός)',
                link: 'Πεδίο δεσμού',
                entityInfoDetection: 'Ανίχνευση πληροφοριών οντοτήτων',
                basicInfoDetection: 'Ανίχνευση βασικών πληροφοριών',
                volume: 'Ανίχνευση όγκου',
                emotion: 'Ανάλυση συναισθημάτων ανάλυσης',
                grammar: 'Κανόνες γραμματικής',
                sentenceLength: 'Ανίχνευση μήκους πρότασης',
                conceptWord: 'Λέξεις έννοιας',
                questionsAndAnswers: 'Λύση βάσης γνώσεων (παλιά)',
                element: 'Βασικά Ερωτήματα και Απαντήσεις',
                silent: 'Χρονικό όριο απόκρισης',
                associate: 'Στοιχεία παρακολούθησης των οδών',
                repeat: 'Επανάληψη αποστολής',
                timeInterval: 'Διάρκεια διαστήματος',
                typoDetection: 'Ανίχνευση τυπογράφου',
                silentOld: 'Σιωπή',
                knowledge: 'Λύση Γνώσης',
                wecomRemark: 'Επιχείρηση πελατών',
                customerAddTime: 'Χρόνος προσθήκης πελατών',
            },
            keywordOperators: {
                all: 'Ταίριασμα όλων',
                allNot: 'Όλα δεν ταιριάζουν όλα',
                any: 'Οποιαδήποτε ταιριάζει.',
            },
            applyRoles: {
                all: 'Όλα',
                customer: 'Πελάτη',
                agent: 'Υπηρεσία πελατών',
            },
            sentenceLength: {
                less: 'Λιγότερα',
                greater: 'Μεγαλύτερο',
                equal: 'Ίση',
                greater_or_equal: 'Μεγαλύτερη ή ίση',
                less_or_equal: 'Λιγότερο ή ίσο',
            },
            dialogueApplyScopes: {
                differentRoles: 'Μεταξύ διαφορετικών ρόλων',
                agent: 'Υπηρεσία πελατών',
                customer: 'Πελάτη',
                agentResponse: 'Ανταπόκριση πελατών',
                customerResponse: 'Ανταπόκριση πελατών',
                customerNoResponse: 'Πελάτης που δεν απαντά',
            },
            applyConditionHitTypes: {
                first: 'Το πρώτο χτύπημα.',
                every: 'Κάθε χτύπημα.',
                last: 'Τελευταία επίπτωσης',
            },
            applyConditionScopes: {
                current: 'Τρέχοντα',
                before: 'Πριν',
                after: 'Μετά.',
                beforeAll: 'Όλα πριν',
                afterAll: 'Στο κάτω-κάτω.',
                around: 'Σε κοντινή απόσταση',
            },
            voiceDemoTypes: {
                singleChannel: 'Καταγραφή ενός καναλιού',
                dualChannel: 'Καταγραφή κλήσεων διπλού καναλιού',
            },
            sendStatus: {
                sending: 'Αποστολής',
                arrive: 'Παραδόθηκε',
                fail: 'Αποτυχία αποστολής',
                off_sending: 'Αποστολή μη αναγνωσμένη',
                off_arrive: 'Ανάγνωση:',
                rollback: 'Αποσύρθηκε',
            },
            collectionMethod: {
                assignment: 'Απευθείας εκχώρηση',
                entity: 'Εξαγωγή οντοτήτων',
            },
            systemTypes: {
                qa: 'Ευφυής επιθεώρηση ποιότητας',
                wfm: 'Ευφυής προγραμματισμός',
            },
            entityOperators: {
                equals: 'Ισότητα πληροφοριών',
                notEquals: 'Δεν ισούται με πληροφορία',
                contains: 'Περιέχει πληροφορίες',
                notContains: 'Δεν περιέχει πληροφορίες',
                equalsFix: 'Ίση με σταθερή τιμή',
                notEqualsFix: 'Δεν ισούται με σταθερή τιμή',
                containsFix: 'Περιέχει σταθερές τιμές',
                notContainsFix: 'Δεν περιέχει μια σταθερή τιμή',
            },
            basicInfoOperators: {
                equals: 'Ίση',
                notEquals: 'Δεν είναι ίσο',
                contains: 'Περιέχει',
                notContains: 'Δεν περιέχει',
                isNull: 'Κενό',
                isNotNull: 'Μη κενό',
            },
            volumeDetectionWays: {
                loudness: 'Δυναμικότητα',
                rangeAbilitySelf: 'Εύρος της αλλαγής (ότι έκανα στην προηγούμενη πρόταση)',
                rangeAbilityOth: 'Εύρος μεταβολής (σε σύγκριση με την παραπάνω πρόταση)',
                rangeAbility3: 'Μέγεθος της αλλαγής (ότι είμαι σε αυτή την πρόταση)',
            },
            volumeDetectionOperators: {
                is: 'Ίση',
                not: 'Δεν είναι ίσο',
                greaterThan: 'Μεγαλύτερο',
                greaterThanEq: 'Μεγαλύτερη ή ίση',
                lessThan: 'Λιγότερα',
                lessThanEq: 'Λιγότερο ή ίσο',
            },
            sentimentTypes: {
                positive: 'Θετικά συναισθήματα',
                negative: 'Αρνητικό συναίσθημα',
                neutral: 'Ουδέτερο συναίσθημα',
                thankful: 'Ευχαριστώ.',
                happy: 'Χαρούμενη.',
                complaining: 'Καταγγελία',
                angry: 'Θυμωμένος',
                post: 'Εμπρός',
                negat: 'Αρνητικό',
                neut: 'Ουδέτερο',
            },
            emotionOperators: {
                is: 'Συμμόρφωση',
                not: 'Μη συμμόρφωσης',
            },
            propTypes: {
                system: 'Σύστημα',
                user: 'Προσαρμοσμένο',
            },
            valueTypes: {
                text: 'Κείμενο',
                number: 'Αριθμοί',
            },
        },
        tasks: {
            agent: 'Πράκτορα',
            assignToDesignatedPersons: 'Αναθέστε σε Καθορισμένα Πρόσωπα',
            bigModelRules: 'Μεγάλοι κανόνες μοντέλου',
            topicAnalysis: 'Θεματική ανάλυση',
            customerService: 'Υπηρεσία πελατών',
            addAutomatically: 'Προσθήκη αυτόματης',
            createAQualitySparringTask: 'Δημιουργία μιας ποιότητας εργασία',
            forcedCustomerServiceOffline: 'Υπηρεσία εξαναγκασμένων πελατών offline υπηρεσίας',
            allowCustomGrievance: 'Επίτρεψε προσαρμοσμένο παράπομη',
            businessSummary: 'Περίληψη επιχειρήσεων',
            theDayBeforeYesterday: 'Προχθές μέρα.',
            assessActionTypes: {
                reassess: 'Επανεξιολόγηση',
            },
            scoreType: {
                aiScore: 'Έξυπνη αξιολόγηση',
                manualScore: 'Χειροκίνητη αξιολόγηση',
                interactiveDetection: 'Ανίχνευση αλληλεπίδρασης',
                smartRules: 'Έξυπνοι κανόνες',
                machineLearning: 'Τρόπος μάθησης',
            },
            inspectType: {
                inspectTrue: 'Έλεγχος',
                inspectFalse: 'Δεν ελέγχθηκε',
            },
            operatorType: {
                keyword: 'Ταιριάζουν λέξη κλειδιά',
                notKeyword: 'Ανάληψη λέξεων κλειδιών',
            },
            applyRole: {
                all: 'Όλα',
                customer: 'Πελάτη',
                agent: 'Υπηρεσία πελατών',
            },
            applyScope: {
                all: 'Όλα',
                specific: 'Καθορισμένη πρόταση',
                scope: 'Καθορισμένο εύρος',
            },
            judgeStrategy: {
                all: 'Πληρούν όλες τις προϋποθέσεις',
                arbitrarily: 'Πληρούν οποιοδήποτε όρο',
                custom: 'Προσαρμοσμένη λογική',
            },
            checkPointStatus: {
                waitFor: 'Αναμένει αναθεώρηση',
                notDeductScore: 'Καμία αφαίρεση.',
                deductScore: 'Μειώσεις',
            },
            applyOptions: {
                hit: 'Χτύπημα κατάστασης',
                notHit: 'Δεν καθορίστηκαν προϋποθέσεις',
            },
            gradeTypes: {
                yesOrNo: 'Συμμόρφωση',
                input: 'Χειροκίνητη είσοδος',
                level: 'Αξιολόγηση βαθμού',
                multipleFactors: 'Πολλαπλά στοιχεία',
            },
            gradeChooseHits: {
                yes: 'Μάλιστα.',
                no: 'Οχι',
            },
            gradeChangeTypes: {
                edit: 'Επεξεργασία',
                check: 'Αναθεώρηση',
                file: 'Αρχειοθετήσεις',
                remark: 'Παρατηρήσεις',
                complain: 'Καταγγελία',
                review: 'Αναθεώρηση',
                reviewEvaluation: 'Αξιολόγηση επανεξέτασης',
                sample: 'Τυχαία επιθεώρηση',
                sampleEvaluation: 'Επιθεώρηση δειγματοληψίας και αξιολόγηση',
                sampleSubmit: 'Επιθεώρηση δειγματοληψίας και υποβολή',
                sampleAssign: 'Κατανομή δειγματοληψίας',
                reviewAssign: 'Κατανομή επανεξέτασης',
                read: 'Ανάγνωση:',
                reviewConfirm: 'Επιβεβαίωση επανεξέτασης',
                sampleConfirm: 'Επιβεβαίωση επιθεώρησης δειγματοληψίας',
            },
            gradeStatus: {
                unread: 'Μη αναγνωσμένο',
                alreadyReview: 'Επανεξέταση',
                alreadyFild: 'Αρχειοθετημένο',
                waitReview: 'Προς επανεξέταση',
                alreadyRead: 'Ανάγνωση:',
            },
            samplingFrequencyTypes: {
                everyDay: 'Καθημερινά',
                everyWeek: 'Εβδομαδιαία',
                everyMonth: 'Μηνιαία',
            },
            samplingEveryDayTimeTypes: {
                yesterday: 'Χθες το βράδυ.',
                today: 'Σήμερα',
            },
            samplingEveryWeekTimeTypes: {
                thisWeek: 'Αυτή την εβδομάδα.',
                lastWeek: 'Την περασμένη εβδομάδα.',
            },
            samplingEveryMonthTimeTypes: {
                thisMonth: 'Αυτό το μήνα',
                lastMonth: 'Τον περασμένο μήνα.',
            },
            samplingTypes: {
                random: 'Τυχαία δειγματοληψία',
                proportional: 'Αναλογική δειγματοληψία',
            },
            weekdays: {
                Monday: 'Δευτέρα.',
                Tuesday: 'Τρίτη.',
                Wednesday: 'Τετάρτη.',
                Thursday: 'Πέμπτη',
                Friday: 'Παρασκευή',
                Saturday: 'Σάββατο.',
                Sunday: 'Κυριακή.',
            },
            distributeTypes: {
                rule: 'Κατανομή προτεραιότητας κανόνας',
                average: 'Μέση τυχαία κατανομή',
            },
            notMatchAnyRuleTypes: {
                random: 'Τυχαία μέση κατανομή',
                assign: 'Αναθέστε σε Καθορισμένα Πρόσωπα',
                ignore: 'Δεν εκχωρήθηκε',
            },
            inspectorTypes: {
                all: 'Όλοι οι επιθεωρητές ποιότητας',
                some: 'Καθορισμένος επιθεωρητής ποιότητας',
            },
            pushFrequencyTypes: {
                everyDay: 'Καθημερινά',
                everyWeek: 'Εβδομαδιαία',
                everyMonth: 'Μηνιαία',
                inspectionUpdate: 'Επικαιροποιημένη επιθεώρηση ποιοτικού ελέγχου',
                timelyInspection: 'Επιθεώρηση ποιότητας σε πραγματικό χρόνο.',
            },
            pushObjectTypes: {
                email: 'Καθορισμός γραμματοκιβωτίου',
                staff: 'Υπηρεσία πελατών',
            },
            reviewOptions: {
                reviewResult: 'Εμφάνιση αποτελεσμάτων ποιότητας επιθεώρησης κατά τη διάρκεια της επανεξέτασης',
                reviewRecord: 'Εμφάνιση σχετικών αρχείων κατά τη διάρκεια επανεξέτασης',
                reviewAgentHidden: 'Απόκρυψη πληροφοριών πράκτορα κατά τη διάρκεια της επανεξέτασης',
                samplingResult: 'Εμφάνιση αποτελεσμάτων ποιότητας επιθεώρησης κατά την τυχαία επιθεώρησης',
                samplingRecord: 'Εμφάνιση σχετικών αρχείων κατά την τυχαία επιθεώρησης',
                sampleAgentHidden: 'Απόκρυψη πληροφοριών εξυπηρέτησης πελατών κατά τη διάρκεια τυχαίας επιθεώρησης',
                checkExportAddCallInfoIphone: 'Επισύναψη καταγραφών κλήσεων κατά την εξαγωγή μιας λίστας',
                sampleExportAddCallInfoIphone: 'Επισύναψη καταγραφών κλήσεων κατά την εξαγωγή μιας λίστας',
                checkExportAddCallInfoText: 'Επισύναψη αρχείων συνομιλίας κατά την εξαγωγή μιας λίστας',
                sampleExportAddCallInfoText: 'Επισύναψη αρχείων συνομιλίας κατά την εξαγωγή μιας λίστας',
                inspectionExportAddCallInfoIphone: 'Επισυνάψτε τα αρχεία κλήσεων κατά την εξαγωγή του καταλόγου (μέχρι 10000 μπορεί να εξαχθεί τη στιγμή)',
                inspectionExportAddCallInfoText: 'Επισυνάψτε αρχεία συζήτησης κατά την εξαγωγή ενός λίστας (μέχρι 10000 μπορεί να εξαχθεί τη στιγμή)',
            },
            fastSampleInDetailList: {
                fastSampleInInspectDetail: 'Επιτρέψτε γρήγορη θέση έλεγχο στις λεπτομέρειες ποιότητας',
                fastSampleInSampleDetail: 'Επιτρέπεται η γρήγορη εκτέλεση της τυχαίας επιθεώρησης σε λεπτομέρειες τυχαίας επιθεώρησης',
                fastSampleInReviewDetail: 'Επιτρέπει την γρήγορη εκτέλεση των επιτόπιων ελέγχων στις λεπτομέρειες',
            },
            permitCustomReasonList: {
                permitCustomReason: 'Επιτρέψτε προσαρμοσμένους λόγους για απαιτήσεις',
            },
            autoMateTasks: {
                autoLoad: 'Προσθήκη αυτόματης',
                sample: 'Αυτόματη επιθεώρηση δειγματοληψίας',
                assign: 'Αυτόματη κατανομή',
                pushes: 'Αυτόματη ώθηση',
                assess: 'Αυτόματη αξιολόγηση',
                check: 'Επανεξέταση της καταγγελίας',
                case: 'Συγχρονισμός βιβλιοθήκης περίπτωσης',
            },
            qualityCheckDetailTypes: {
                review: 'Αναθεώρηση',
                spotCheck: 'Τυχαία επιθεώρηση',
            },
            appealTypes: {
                transliterationError: 'Μεταγραφή σφάλματος:',
                discriminationError: 'Σφάλμα απόφασης',
                otherError: 'Άλλα σφάλματα',
            },
            inspectDataSources: {
                voiceCall: 'Κλήση φωνής',
                textDialogue: 'Διάλογο κειμένου',
                realTimeVoiceCall: 'Κλήσεις φωνής σε πραγματικό χρόνο.',
                realTimeTextDialogue: 'Συνομιλίες κειμένου σε πραγματικό χρόνο.',
            },
            pointTypes: {
                automatic: 'Αυτόματη αξιολόγηση',
                manual: 'Χειροκίνητη αξιολόγηση',
                interactiveDetection: 'Ανίχνευση αλληλεπίδρασης',
            },
            pointGradeTypes: {
                radio: 'Ενιαία επιλογή',
                input: 'Εισαγωγή',
                select: 'Επιλογή',
            },
            sampleAndReviewStatus: {
                init: 'Μη εκχυλισμένα',
                unread: 'Μη αναγνωσμένο',
                alreadyRead: 'Ανάγνωση:',
                complaining: 'Σε Παραπόνιο',
                reviewed: 'Επανεξέταση',
                sampling: 'Δεν ελέγχθη η εξαγωγή',
                samplingCompleted: 'Δειγματοληψία',
            },
            wayOverUpperLimits: {
                ignoreExcessSpillover: 'Παράβλεψη υπερχείλισης',
                automaticWeightCalculation: 'Αυτόματη λογιστική βάρη',
            },
            calculateScoreTypes: {
                add: 'Πόντοι μπόνους',
                sub: 'Μείον πόντοι',
            },
            naChecked: {
                check: 'Αυτό το στοιχείο δεν εμπλέκεται στην επιτρεπόμενη ανίχνευση.',
            },
            pointNaChecked: {
                check: 'N/A',
            },
            interactiveRules: {
                proportional: 'Ποσοστιαίες μονάδες',
                allRight: 'Όλα τα σωστά σημεία',
                anyRight: 'Οποιαδήποτε σωστή βαθμολογία',
            },
            noHitQuestionResults: {
                true: 'Το αποτέλεσμα είναι "Ναι"',
                false: 'Το αποτέλεσμα είναι "όχι"',
            },
            repetRules: {
                same: 'Περιεχόμενο ακριβώς το ίδιο',
                similar: 'Σημασιολογική ομοιότητας',
            },
            relateConditions: {
                highlightQuestion: 'Επισήμανση προβλήματος',
                highlightAnswer: 'Απάντηση',
                hightlightFoctors: 'Στοιχείο επισήμανσης',
            },
            interactiveQuestionTypes: {
                question: 'Ανιχνεύθηκε πρόβλημα.',
                eliminateQuestion: 'Ανιχνεύθηκε πρόβλημα αντιμετώπισης προβλημάτων',
            },
            interactiveAnswerTypes: {
                noAnswer: 'Δεν ανιχνεύθηκε απάντηση',
                answer: 'Ανιχνεύθηκε απάντηση',
                wrongAnswer: 'Ανιχνεύθηκε εσφαλμένη απάντηση.',
            },
            inspectionUpdateTypes: {
                autoInspection: 'Αυτόματη επιθεώρηση ποιότητας',
                autoInspectionWechat: 'Αυτόματη ανάλυση',
                artificialSampling: 'Χειροκίνητη δειγματοληψία',
                artificialReview: 'Χειροκίνητη ανασκόπηση',
                manualModification: 'Γρήγορη δειγματοληψία',
                timelyInspection: 'Επιθεώρηση ποιότητας σε πραγματικό χρόνο.',
                samplingAssign: 'Κατανομή δειγματοληψίας',
                artificialComplain: 'Υποβολή αίτησης',
                fastSampling: 'Επιθεώρηση και υποβολή γρήγορης δειγματοληψίας',
                recheckInspection: 'Επανεπιθεώρηση',
                recheckInspectionWechat: 'Επανεκατευθυντήρια ανάλυση',
            },
            timelyInspectionTypes: {
                timelyInspection: 'Επιθεώρηση ποιότητας σε πραγματικό χρόνο.',
            },
            pushActionTypes: {
                email: 'Ταχυδρομείο',
                interfacePush: 'Διεπαφή ώθηση',
            },
            pushDetailWays: {
                riskAlert: 'Συναγερμός κινδύνου',
                subscribe: 'Εγγραφή σε μηνύματα',
            },
            riskAlertPushDataTypes: {
                dialogueMessage: 'Μήνυμα κλήσης/Συνομιλίας',
                inspectionResults: 'Αποτελέσματα επιθεώρησης ποιότητας',
            },
            subscribePushDataTypes: {
                dialogueMessage: 'Μήνυμα κλήσης/Συνομιλίας',
                textContent: 'Περιεχόμενο κειμένου κλήσεων / συνομιλίας',
                inspectionResults: 'Αποτελέσματα επιθεώρησης ποιότητας',
            },
            pushRequestMethods: {
                post: 'POST',
            },
            pushContentTypes: {
                json: 'JSON',
            },
            notMatchPreRule: {
                average: 'Μέσος όρος βαθμολογίας εντός ομάδας',
                addOrSubtract: 'Άμεσο συν ή μείον σημείο',
                noChange: 'Χωρίς συν ή μείον πόντοι',
            },
            defaultScore: {
                empty: 'Κενό',
                add: 'Πόντοι μπόνους',
                notAdd: 'Χωρίς επιπλέον πόντοι',
                sub: 'Μείον πόντοι',
                notSub: 'Δεν μειώθηκαν πόντοι',
                na: 'N/A',
                input: 'Χειροκίνητη είσοδος',
                choose: 'Επιλογή',
            },
            strategyTypes: {
                hitAdd: 'Πατήστε μπόνους',
                hitNotAdd: 'Δεν υπάρχουν πόντοι για χτύπημα.',
                hitSub: 'Χτύπημα μείον πόντοι',
                hitNotSub: 'Χτύπημα δεν μειώνει τα σημεία',
            },
        },
        download: {
            exportStatus: {
                prepare: 'Σε προετοιμασία',
                process: 'Σε εξέλιξη.',
                faild: 'Η εξαγωγή απέτυχε',
                success: 'Επιτυχία',
            },
        },
        messageType: {
            all: 'Όλα',
            monitor: 'Άμεση παρακολούθηση',
            trigger: 'Ειδοποίηση ενεργοποίησης',
            timing: 'Έκθεση χρονομέτρησης',
        },
        messagePushType: {
            all: 'Όλα',
            system: 'Μηνύματα συστήματος',
            sdk: 'Μήνυμα SDK',
            push: 'Διεπαφή ώθηση',
            email: 'Ταχυδρομείο',
            udesk: 'Κοινοποιήσεις',
            udeskWhite: 'Κοινοποίηση του συστήματος εξυπηρέτησης πελατών',
            weChat: 'Μήνυμα επιχειρήσεων',
        },
        autoAddPushTarget: {
            sampleAssignInspector: 'Ορισμός επιθεωρητή δειγματοληψίας',
            sampleInspector: 'Επιθεωρητής δειγματοληψίας',
            assignReviewer: 'Ανέθεση',
            reviewer: 'Αξιολογητής',
            taskInspector: 'Επιθεωρητής εργασίας',
        },
        sdkPushType: {
            webHook: 'Τυπικό ιστό',
            dingDing: 'Ρομπότ DingTalk',
            weChat: 'Ρομπότ WeChat Enterprise',
            customer: 'Προσαρμοσμένο περιεχόμενο JsonName',
        },
        inspectionRemarksType: {
            inspection: 'Επιθεώρηση ποιότητας',
            check: 'Τυχαία επιθεώρηση',
            review: 'Αναθεώρηση',
        },
        segmentationStrategyType: {
            count: 'Αριθμός μηνυμάτων',
            spacing: 'Διάστημα μηνυμάτων',
        },
        segmentationStrategy: {
            byTime: 'Διάταξη χρονικού τμήματος',
            customize: 'Τεμαχισμός συνδυασμού',
        },
        inspectType: {
            commonInspect: 'Τακτική επιθεώρηση ποιότητας',
            associateInspect: 'Σχετική επιθεώρηση ποιότητας',
        },
        typoDetectionOperators: {
            less: 'Λιγότερα',
            greater: 'Μεγαλύτερο',
        },
        autoAddTypes: {
            realTimeAdd: 'Προσθήκη σε πραγματικό χρόνο.',
            timingAdd: 'Χρονική προσθήκη',
        },
        messageTypes: {
            text: 'Μήνυμα κειμένου',
            markdown: 'Μήνυμα σήμανσης',
        },
        inServiceStatus: {
            activated: 'Ενεργοποιημένο',
            disabled: 'Απενεργοποιημένο',
            inactivated: 'Μη ενεργοποιημένο',
            resigned: 'Έξοδος από την επιχείρηση',
        },
        roles: {
            agent: 'Εργαζόμενος',
            customer: 'Πελάτη',
        },
        commentVisibleAuthority: {
            all: 'Ορατή σε όλους.',
            self: 'Μόνο στον εαυτό σου είναι ορατό.',
            designation: 'Καθορισμένο ορατό άτομο',
        },
        appealCheckingTask: {
            agent: 'Πράκτορα',
            flyingBookGroupChat: 'Συνομιλία ομάδας ιπτάμενων βιβλίων',
            finalAppeal: 'Τελική προσφυγή',
            largeModel: 'Μεγάλο μοντέλο',
            overdueReview: 'Επανεξέταση',
            questionnaire: 'Ερωτηματολόγο',
            eCommerceReview: 'Επισκόπηση ηλεκτρονικού εμπορίου',
            socialMediaComments: 'Σχόλια Κοινωνικών Μέσων',
            mixedType: 'Μεικτός τύπος',
            videoCall: 'Κλήση βίντεο',
            customModel: 'Προσαρμοσμένο μοντέλο',
            universalModel: 'Γενικό μοντέλο',
            enterpriseWeChatText: 'Επιχειρήσεις μικροκείμενο',
            generalQualityInspection: 'Γενική επιθεώρηση ποιότητας',
            processQualityInspection: 'Επιθεώρηση ποιότητας διαδικασίας',
            voiceCopy: 'Επαναφορά φωνής',
            beEqualTo: 'Ίση',
            notEqualTo: 'Δεν είναι ίσο',
            canAppeal: 'Μπορεί να έφεσε',
            noAppeal: 'Μη καταγγελίας',
        },
        wechat: {
            redEnvelopes: 'Κόκκινο φάκελο',
            text: 'Κείμενο',
            picture: 'Εικόνα',
            voice: 'Φωνή',
            voiceCall: 'Κλήση φωνής',
            video: 'Βίντεο',
            businessCard: 'Επαγγελματική κάρτα',
            position: 'Τοποθεσία',
            expression: 'Έκφραση',
            link: 'Δεσμός',
            applet: 'Μικρό πρόγραμμα',
            chatRecord: 'Εγγραφή συνομιλίας',
            mixedMessage: 'Μικτό μήνυμα',
            file: 'Αρχείο',
        },
        gong: {
            sessionActivity: 'Δραστηριότητα συνεδρίασης',
            conversationAction: 'Ενέργεια συνεδρίας',
            riskSemantics: 'Σημασιολογία κινδύνου',
            daysNotFollowedUp: 'Ημέρες που δεν ακολουθούνταν',
            waysideData: 'Στοιχεία παρακολούθησης των οδών',
            notStarted: 'Δεν ξεκίνησες',
            completed: 'Ολοκληρώθηκε',
            haveInHand: 'Σε εξέλιξη.',
            unpublished: 'Δεν δημοσιεύτηκε.',
            published: 'Δημοσίευση',
            knowledgePoints: 'Σημεία γνώσης',
            technologicalProcess: 'Διαδικασία',
            notMarked: 'Χωρίς επισήμανση',
            inAnnotation: 'Σε κάλεσμα',
            annotated: 'Ετικέτας',
        },
        qualityChecingTask: {
            appealCanceled: 'Η προσφυγή ακυρώθηκε.',
            complaintExpired: 'Η καταγγελία έληξε.',
            incomingCall: 'Εισερχόμενη κλήση.',
            exhale: 'Εκπνοή',
            incomingCallthirdParty: 'Εισερχόμενη κλήση (τρία)',
            incomingCallconsultation: 'Εισερχόμενη κλήση (Συμβουλευτική)',
            incomingCallforcedInsertion: 'Εισερχόμενη κλήση (ισχυρή)',
            incomingCallmonitoring: 'Εισερχόμενη κλήση (ακούγοντας)',
            incomingCalltransfer: 'Εισερχόμενη κλήση (μεταφορά)',
            incomingCallinterception: 'Εισερχόμενη κλήση (διακοπή)',
            incomingCalltransferToExternalLine: 'Εισερχόμενη κλήση (μεταφορά εξωτερικής γραμμής)',
            incomingCallthirdPartyExternalLine: 'Εισερχόμενη κλήση (τριπλή εξωτερική γραμμή)',
            incomingCallexternalLine: 'Εισερχόμενη κλήση (συμβουλευτική εξωτερική γραμμή)',
            outgoingCallthirdParty: 'Αποτελέσματα (τρίτης)',
            outgoingCalltransfer: 'Έξοδος (μεταφορά)',
            outgoingCallforcedInsertion: 'Αποτελέσματα (αναγκασμένο)',
            outgoingCallmonitoring: 'Αποτελέσματα (ακρόαση)',
            outgoingCallinterception: 'Εξερχόμενη κλήση (διακοπή)',
            outgoingCalltransferToExternalLine: 'Εξερχόμενη (μεταφορά εξωτερικής γραμμής)',
            outgoingCallthreePartyExternalLine: 'Εξερχόμενη κλήση (τρίτης εξωτερικής γραμμής)',
            customerServiceAnswer: 'Απάντηση εξυπηρέτησης πελατών',
            customerServiceMissed: 'Εξυπηρέτηση πελατών',
            customerAnswer: 'Απάντηση',
            customerMissed: 'Αποτυχία πελάτης',
            theTelephoneIsBusy: 'Τηλέφωνο απασχολημένο',
            phoneOffline: 'Τηλέφωνο εκτός σύνδεσηςComment',
            customerQuickHanging: 'Γρήγορη κρεμασμένη πελάτης',
            clientHangsUp: 'Ο πελάτης το κλείνει.',
            queueTimeout: 'Χρονικό όριο αναμονής',
            giveUpQueuing: 'Εγκατάλειψη ουράς',
            outsideLineAnswering: 'Εξωτερική απάντηση',
            externalLineIsNotConnected: 'Εξωτερική γραμμή που δεν συνδέεται',
            noQueueSelected: 'Δεν επιλέχθηκε αναμονή',
            notEvaluated: 'Δεν αξιολογήθηκε',
            noEvaluationRequired: 'Δεν χρειάζεται αξιολόγηση',
            queuingSucceeded: 'Επιτυχία ουράς',
            noCustomerServiceOnline: 'Καμία υπηρεσία πελατών σε απευθείας σύνδεση',
            customer: 'Πελάτη',
            customerService: 'Υπηρεσία πελατών',
            outsideLines: 'Έξω.',
        },
        sessionActivity: {
            single: 'Μέσος χρόνος μεμονωμένης κλήσης',
            all: 'Σύνολο κλήσεων',
            allTime: 'Συνολική διάρκεια κλήσεων',
        },
        sessionAction: {
            salesProportion: 'Σχέση ομιλίας πωλήσεων',
            salesLongest: 'Μέσος όρος δήλωση πωλήσεων',
            customerLongest: 'Μέση μακροχρόνια ομιλία πελάτης',
            discussNumber: 'Αριθμός διεξοδικών συζητήσεων',
            frequency: 'Συχνότητα ερωτήσεων',
        },
        monitorCriteria: {
            all: 'Πριν και μετά.',
            before: 'Πριν',
            after: 'Μετά.',
        },
        monitorTimeCycle: {
            day: 'Ημέρα',
            week: 'Εβδομάδα',
            month: 'Μήνας',
        },
        monitorGroupTestType: {
            ab: 'Σύγκριση των δύο ομάδων',
            a: 'Ομάδα Α',
            b: 'Ομάδα Β',
        },
        fields: {
            customerServiceDepartment: 'Τμήμα εξυπηρέτησης πελατών',
            belongToDepartment: 'Ανήκει στο τμήμα.',
            doesNotBelongToTheDepartment: 'Δεν ανήκει στο τμήμα',
            department: 'Υπηρεσία',
            customerTags: 'Ετικέτα πελατών',
            member: 'Μέλη',
            time: 'Χρόνο',
            cascade: 'Κασκέτας',
            anyMatch: 'Οποιαδήποτε ταιριάζει.',
            keyWord: 'Λέξεις-κλειδιά',
            keyEvents: 'Γεγονότα κλειδιά',
        },
        semanticIntelligence: {
            staff: 'Εργαζόμενος',
            customer: 'Πελάτη',
            employeesAndCustomers: 'Εργαζόμενοι και πελάτες',
            notStarted: 'Δεν ξεκίνησες',
            haveInHand: 'Σε εξέλιξη.',
            completed: 'Ολοκληρώθηκε',
            callRecording: 'Καταγραφή κλήσεων',
            enterpriseWeChatCall: 'Μικρολόγια επιχειρήσεων',
            enterpriseWeChatText: 'Επιχειρήσεις μικροκείμενο',
            discourseMiningForObjectionHandling: 'Ένσταση Χειρισμός Ολόγων',
            productSellingPointScriptsMining: 'Σημείο πώλησης προϊόντων εξόρυξης',
            conversationScenario: 'Σενάρια συνεδρίας',
            topicOfConversation: 'Θέμα:',
            keyEvents: 'Γεγονότα κλειδιά',
            customerLabel: 'Ετικέτα πελατών',
            includeAny: 'Περιέχει όλο',
            includeAll: 'Περιέχει όλο',
            and: 'Και,',
            or: 'Ή',
            question: 'Ερωτηματική ποινή',
            nonInterrogativeSentence: 'Μη ανακριτικής πρότασης',
        },
        coach: {
            comprehensiveScore: 'Πλήρης βαθμολογία',
            comprehensiveScoreCourseQuality05LearningEffect02InteractiveExperience: 'Πλήρης βαθμολογία = 0,3 * ποιότητα μαθήματος 0,5 * μάθηση αποτέλεσμα 0.2 * διαδραστική εμπειρία',
            courseQuality: 'Ποιότητα μαθημάτων',
            learningEffect: 'Μάθηση επίδραση',
            interactiveExperience: 'Διαδραστική εμπειρία',
            greaterThanOrEqual: 'Μεγαλύτερη ή ίση',
            lessThanOrEqual: 'Λιγότερο ή ίσο',
            equal: 'Ίση',
            smartSparring: 'Έξυπνο ρεζέρι',
            intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας',
            notPassed: 'Δεν έλαβαν',
            analogTelephone: 'Αναλογικό τηλέφωνο',
            enterScenarioInformation: 'Εισάγετε πληροφορίες σενάριου',
            generateDialogueFramework: 'Δημιουργία ενός πλαισίου διαλόγου',
            generatePromptLanguage: 'Δημιουργήθηκε άμεση',
            aIGeneratedDialogue: 'Δημιουργημένη διάλογο AI',
            system: 'Σύστημα',
            custom: 'Προσαρμοσμένο',
            flow: 'Διαδικασία',
            script: 'Λέξεις',
            express: 'Έκφραση',
            emotion: 'Συναίσθημα',
            rateAccordingToCourseConfiguration: 'Βαθμολογία ανά ρύθμιση πορείας',
            intelligentModelRating: 'Έξυπνο μοντέλο βαθμολογία',
            allData: 'Όλα τα δεδομένα',
            dataFromThisDepartment: 'Στοιχεία του τμήματος',
            multidepartmentalData: 'Δεδομένα πολλαπλών τομέας',
            underReview: 'Σε Αναθεώρηση',
            no: 'Οχι',
            yes: 'Μάλιστα.',
            automaticRating: 'Αυτόματη βαθμολογία',
            auditRating: 'Βαθμολογία ελέγχου',
            reRating: 'Επαναφορά αποτέλεσμας',
            inAppeal: 'Σε Παραπόνιο',
            reviewed: 'Επανεξέταση',
            notViewed: 'Μη προβολή',
            viewed: 'Προβολή',
            uncorrected: 'Δεν διορθώθηκε',
            corrected: 'Διορθώθηκε',
            practice: 'Άσκηση',
            examination: 'Εξέταση',
            other: 'Άλλα',
            notMeetingStandards: 'Δεν έως το πρότυπο',
            meetingStandards: 'Πρότυπο',
            excellent: 'Εξαιρετικά.',
            invalid: 'Αποτυχία',
            notStarted: 'Δεν ξεκίνησες',
            haveInHand: 'Σε εξέλιξη.',
            ended: 'Τέλος.',
            completed: 'Ολοκληρώθηκε',
            hangInTheAir: 'Μη ολοκληρωμένες',
            passed: 'Πέρασε',
            voiceConversation: 'Διάλογος φωνής',
            textDialogue: 'Διάλογο κειμένου',
            slidePresentation: 'Παρουσίαση σλάιντ',
            unpublished: 'Δεν δημοσιεύτηκε.',
            published: 'Δημοσίευση',
            narration: 'Αφηγητής',
            studentSpeaking: 'Δόκιμος.',
            robotTalk: 'Τα ρομπότ μιλάνε.',
            knowledgeBaseQA: 'Βάση γνώσεων Ε & Α',
            slide: 'Κύλιση',
            negativeEmotions: 'Αρνητικό συναίσθημα',
            emotionallyNormal: 'Κανονική διάθεση',
            incompleteScript: 'Ημιτελής ομιλίας',
            completeScript: 'Πλήρης ομιλίας',
            normalSpeechSpeed: 'ΝΟΡΜΑ',
            speakTooFast: 'Γρήγορα φωτιά',
            speakTooSlowly: 'ΠΑΡΑΡΤΗΜΑ',
            whole: 'Όλα',
            singlePage: 'Ενιαία σελίδα',
            qA: 'Μια ερώτηση και μία απάντηση',
            situationalDialogue: 'Διάλογο κατάστασης',
            misses: 'Αστόχηση',
            hit: 'Χτύπημα.',
            sequentialQA: 'Διαδοχική ερμηνεία & A',
            randomQA: 'Τυχαίες Ερωτήσεις',
            mastered: 'Βεβαίωση',
            notMastered: 'Χωρίς κυριότητα',
        },
        algorithm: {
            salesEmpowerment: 'Ενίσχυση των πωλήσεων',
            enterpriseWeChatVoice: 'Enterprise WeChat φωνή',
            enterpriseWeChatText: 'Enterprise WeChat κείμενο',
            waiting: 'Αναμονή',
            extracting: 'Για την εξαγωγή',
            success: 'Επιτυχία',
            fail: 'Αποτυχία',
            intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας',
            textDialogue: 'Διάλογο κειμένου',
            voiceCall: 'Κλήση φωνής',
            smartTags: 'Έξυπνη ετικέταName',
            satisfactionEvaluation: 'Αξιολόγηση ικανοποίησης',
            score: 'Αξιολόγηση',
            grade: 'Αξιολόγηση',
            customerServiceTeam: 'Ομάδα εξυπηρέτησης πελατών',
            conversationAnalysis: 'Ανάλυση συζήτησης',
        },
        operatorListGather: {
            falseClosing: 'Λάθος κλείσιμο',
            largeModelSemanticMatching: 'Μεγάλο μοντέλο σημασιολογικό ταίριασμα',
            system: 'Σύστημα',
            customerInformation: 'Πληροφορίες πελατών',
            audio: 'Ήχος',
            videoSound: 'Βίντεο ήχο',
            videoScreen: 'Οθόνη βίντεο',
            videoFile: 'Αρχείο βίντεο',
            voiceMessage: 'Μήνυμα φωνής',
            picture: 'Εικόνα',
            documentation: 'Τεκμηρίωση',
            workOrderInformation: 'Πληροφορίες παραγγελίας εργασίας',
            semanticMatching: 'Σημασιολογικό ταίριασμα',
            specifiedTime: 'Καθορισμένος ώρας',
            externalInterfaceDetection: 'Ανίχνευση εξωτερικού διεπαφής',
            robot: 'Ρομπότ',
            intelligentModel: 'Ευφυές μοντέλο',
            businessSummary: 'Περίληψη επιχειρήσεων',
            firstSentence: 'Πρώτη φράση',
            lastSentence: 'Τελευταία πρόταση',
            allTime: 'Όλο το χρόνο.',
            nonBusinessWorkingHours: 'Μη επαγγελματικές ώρες',
            businessWorkingHours: 'Ώρα εργασίας επιχειρήσεων',
        },
        callDialogueManage: {
            flyingBookGroupChat: 'Συνομιλία ομάδας ιπτάμενων βιβλίων',
            videoCall: 'Κλήση βίντεο',
            questionnaire: 'Ερωτηματολόγο',
            originalSoundManagement: 'Αρχική διαχείριση ήχου',
            eCommerceReview: 'Επισκόπηση ηλεκτρονικού εμπορίου',
            socialMediaComments: 'Σχόλια Κοινωνικών Μέσων',
        },
        user: {
            voiceRobotOutcall: 'Εξέλιξη ρομπότ φωνής',
            workOrder: 'Σειρά εργασίας',
        },
        dataPreprocess: {
            ecommerceSessionQualityInspection: 'Επιθεώρηση ποιότητας συνεδρίασης ηλεκτρονικού εμπορίου',
        },
        connectedByConversation: {
            workOrder: 'Σειρά εργασίας',
        },
    },
    pages: {
        auth: {
            welcome: '',
            copyRight: '',
            login: {
                name: 'Σύνδεση',
                email: 'Ηλεκτρονικό ταχυδρομείο',
                password: 'Κωδικός πρόσβασης',
                forgetPwd: 'Ξεχάσατε τον κωδικό πρόσβασης',
                emailCannotBeEmpty: 'Το γραμματοκιβώτιο δεν πρέπει να είναι άδειο.',
                passwordCannotByEmpty: 'Ο κωδικός πρόσβασης δεν πρέπει να είναι κενός.',
                mustChangeLogin: 'Λυπάμαι, ο κωδικός πρόσβασης πρέπει να επαναφέρεται, παρακαλώ επικοινωνήστε με τον διαχειριστή σας για να επαναφέρετε τον κωδικό πρόσβασης.',
                dismissionLogin: 'Συγγνώμη, άφησες τη δουλειά σου.',
                forbiddenLogin: 'Λυπάμαι, ο λογαριασμός σας είναι απενεργοποιημένος.',
                loginError: 'Η σύνδεση απέτυχε, λανθασμένο γραμματοκιβώτιο ή κωδικό πρόσβασης.',
                loginPrompt: 'Σύνδεση στο σύστημα',
                rememberMe: 'Να με θυμάσαι.',
            },
            logout: {
                logoutError: 'Η σύνδεση απέτυχε. Ελέγξτε τη σύνδεση του δικτύου σας ή δοκιμάστε ξανά αργότερα.',
            },
            resetPassword: {
                forgetPwd: 'Ξεχάσατε τον κωδικό πρόσβασης',
                inputEmailPrompt: 'Εισάγετε το email του λογαριασμού σας παρακάτω και θα σας στείλουμε ένα email και οδηγίες για την επαναφορά του κωδικού πρόσβασής σας.',
                sendEmailSuccess: 'Η επιστολή επιβεβαίωσης τροποποίησης κωδικού στάλθηκε με επιτυχία στο email που συμπληρώσατε, παρακαλώ ελέγξτε την εγκαίρως.',
                sendEmailFailed: 'Το γραμματοκιβώτιο απέτυχε. Ελέγξτε τη σύνδεση του δικτύου σας ή δοκιμάστε ξανά αργότερα.',
                setNewPassword: 'Ορισμός νέου κωδικού πρόσβασης σας',
                passwordCannotEmpty: 'Ο κωδικός πρόσβασης δεν πρέπει να είναι κενός',
                passwordFormWrong: 'Εσφαλμένη μορφή κωδικού πρόσβασης',
                confirmPasswordWrong: 'Οι δύο κωδικοί πρόσβασης που εισάγονται δεν είναι ίσοι.',
                passwordResetSuccess: 'Επιτυχία επαναφοράς κωδικού πρόσβασης.',
                passwordResetFailed: 'Αποτυχία επαναφοράς κωδικού πρόσβασης. Ελέγξτε τη σύνδεση του δικτύου σας ή δοκιμάστε ξανά αργότερα.',
                linkTimeover: 'Επαναφορά του συνδέσμου κωδικού πρόσβασης έληξε, παρακαλώ δοκιμάστε ξανά',
            },
            form: {
                title: 'Εμφάνιση μορφής CASE',
            },
        },
        public: {
            auth: {
                forgotPassword: {
                    email: 'Ηλεκτρονικό ταχυδρομείο',
                    emailFormatError: 'Σφάλμα μορφής γραμματοκιβωτίου, παρακαλώ εισάγετε ξανά!',
                    forgotPassword: 'Ξέχασες τον κωδικό σου;',
                    describe: 'Εισάγετε το email του λογαριασμού σας παρακάτω και θα σας στείλουμε ένα email και οδηγίες για την επαναφορά του κωδικού πρόσβασής σας.',
                    send: 'Αποστολής',
                    emailCannotBeEmpty: 'Το γραμματοκιβώτιο δεν μπορεί να είναι κενό',
                    resetPasswordExpire: 'Επαναφορά του συνδέσμου κωδικού πρόσβασης έληξε, παρακαλώ δοκιμάστε ξανά',
                },
                resetPassword: {
                    setPassword: 'Ορισμός νέου κωδικού πρόσβασης σας',
                    newPassword: 'Νέο κωδικό πρόσβασης',
                    repeatPassword: 'Αντίγραφο κωδικού πρόσβασης',
                    resetPassword: 'Επαναφορά κωδικού πρόσβασης',
                    passwordCannotBeEmpty: 'Ο νέος κωδικός πρόσβασης δεν μπορεί να είναι κενός.',
                    confirmPasswordCannotBeEmpty: 'Ο διπλός κωδικός πρόσβασης δεν μπορεί να είναι κενός.',
                    passwordsNotMatch: 'Δύο κωδικοί πρόσβασης δεν είναι συνεπείς!',
                    passwordFormWrong: 'Ο κωδικός δεν μπορεί να είναι στα κινέζικα, και ο αριθμός είναι 6-14!',
                    linkExpiration: 'Επαναφορά του συνδέσμου κωδικού πρόσβασης έληξε, παρακαλώ δοκιμάστε ξανά',
                },
            },
            errors: {
                haveNoPermissionWarningText: 'Δεν έχετε άδεια να προβάλετε αυτή τη σελίδα',
            },
        },
        downloadCenter: {
            name: 'Λήψη κέντρου',
            saveTime: '(30 ημέρες εξ ολοκλήρου)',
            headerTitle: 'Λήψη αρχείου',
            download: 'Λήψης',
            downloadPromp: 'Η εργασία λήψης έχει υποβληθεί, παρακαλώ πηγαίνετε.',
            viewProgress: 'Προβολή προόδου',
        },
        uploadCenter: {
            name: 'Κέντρο αποστολής',
        },
        tasks: {
            index: {
                name: 'Όνομα',
                remark: 'Περιγραφή',
                qualityCheckTasksTitle: 'Πάγκος εργασίας',
                informationCollection: 'Εργασίες συλλογής',
                qualityCheckTasks: 'Εργασία επιθεώρησης',
                wechatQaTasks: 'Ανάλυση',
                moduleName: 'Χρήση νέου προτύπουName',
                creatNewQualityCheckTask: 'Νέα εργασίας',
                generalInspectionList: 'Έκθεση γενικής επιθεώρησης ποιότητας',
                editQualityCheckTask: 'Επεξεργασία εργασιών επιθεώρησης',
                creatNewQualityCheckTaskError: 'Αποτυχία δημιουργίας νέας εργασίας επιθεώρησης ποιότητας.',
                editQualityCheckTaskError: 'Αποτυχία επεξεργασίας εργασίας επιθεώρησης ποιότητας.',
                type: 'Τύπος τύπου',
                singleScore: 'Μονό βαθμός',
                singleScoreNullError: 'Το ενιαίο βαθμό δεν μπορεί να είναι κενό',
                inspector: 'Επιθεωρητής ποιότητας',
                inspectDataSource: 'Πηγή δεδομένων',
                taskName: 'Όνομα εργασίας',
                inspectionType: 'Τύπος επιθεώρησης ποιότητας',
            },
            manage: {
                screeningCondition: 'Κατάσταση φίλτρου',
                template: {
                    condition: {
                        index: {
                            name: 'Κατάσταση',
                            existingConditions: 'Υφιστάμενες προϋποθέσεις',
                        },
                        detail: {
                            id: 'ID',
                            name: 'Όνομα κατάστασης',
                            remark: 'Περιγραφή',
                            checkRange: 'Εύρος ανίχνευσης',
                            operator: 'Αερομεταφορέας',
                            operatorLogic: 'Λογική λογική του χειριστή',
                        },
                    },
                    checkPointTest: {
                        title: 'Δοκιμή κανόνα',
                        running: 'Οι κανόνες στο τεστ, παρακαλώ αργότερα...',
                        clearSuccess: 'Ο προσομοίωσης διαλόγου αδειάστηκε με επιτυχία',
                        mock: 'Προσομοιωμένο διάλογο',
                        save: 'Αποθήκευση του επιλεγμένου διάλογου',
                        saveAll: 'Αποθήκευση όλων των συζητήσεων',
                        saveSuccess: 'Η συζήτηση αποθηκευμένη με επιτυχία',
                        close: 'Έξοδος',
                        delete: 'Διαγραφή επιλεγμένων',
                        clear: 'Κενό',
                        customer: 'Πελάτη',
                        agent: 'Υπηρεσία πελατών',
                        test: 'Δοκιμή',
                        request: 'Αφού ξεκαθαρίσει ο διάλογος προσομοίωσης, δεν μπορεί να ανακτηθεί. Επιβεβαιώστε να το καθαρίσετε;',
                        deletePopconfirmContent: 'Επιθυμείτε σίγουρα τη διαγραφή του επιλεγμένου διαλόγου;',
                    },
                    checkPoint: {
                        index: {
                            name: 'Ρυθμίσεις κανόνας',
                            wechatTitle: 'Ρύθμιση μοντέλου ανάλυσης',
                            existingCheckPoints: 'Υφιστάμενοι κανόνες επιθεώρησης ποιότητας',
                            currentCheckPointScore: 'Η τρέχουσα βαθμολογία κανόνας επιθεώρησης ποιότητας είναι η',
                            currentCheckPointScoreWechat: 'Η τρέχουσα βαθμολογία μοντέλο ανάλυσης είναι.',
                            currentCheckPointWeight: 'Το συνολικό βάρος του υφιστάμενου κανόνα επιθεώρησης ποιότητας είναι η',
                            weightTotalScoreAndItemScore: 'Συνολική βαθμολογία: 100, μονό βαθμολογία:',
                            template: 'Πρότυπο κανόνας επιθεώρησης ποιότητας',
                            import: 'Εισαγωγή κανόνας επιθεώρησης ποιότητας',
                            getTemplateError: 'Αποτυχία λήψης του προτύπου κανόνα επιθεώρησης ποιότητας.',
                            tabs: {
                                template: 'Πρότυπο',
                                demo: 'Δείγμα:',
                            },
                            customize: 'Κενό πρότυπο',
                            move: 'Σύρετε και ρίξτε την ταξινόμηση και την ταξινόμηση',
                            classification: 'Ταξινόμηση επιθεώρησης ποιότητας',
                            classificationWeChat: 'Υπόδειγμα ταξινόμησης',
                            first: 'Ταξινόμηση επιπέδου 1',
                            second: 'Δευτερεύουσα ταξινόμηση',
                            new: 'Νέος κανόνας επιθεώρησης ποιότητας',
                            weChatNew: 'Προσθήκη μοντέλου ανάλυσης',
                            createWeChat: 'Νέο μοντέλο ανάλυσης',
                            empty: 'Δεν υπάρχουν προς το παρόν κανόνες επιθεώρησης ποιότητας,',
                            wechatEmpty: 'Κανένα μοντέλο ανάλυσης,',
                            newSecond: 'Νέα δευτερεύουσα κατάταξη',
                            newFirst: 'Νέα ταξινόμηση πρώτου επιπέδου',
                            checkPoint: 'Κανόνες επιθεώρησης ποιότητας',
                            checkPointWeChat: 'Μοντέλο ανάλυσης',
                        },
                        detail: {
                            name: 'Όνομα',
                            remark: 'Περιγραφή',
                            type: 'Τύπος',
                            deduction: 'Μειώσεις',
                            rule: 'Κανόνες',
                            highlighted: 'Επισήμανση:',
                            gradeType: 'Μέθοδος βαθμολογίας',
                            interactiveCategory: 'Ταξινόμηση αλληλεπίδρασης',
                            predeterminedScore: 'Βαθμολογία',
                            weight: 'Βάρος',
                            na: 'N/A',
                            default: 'Προκαθορισμένο βαθμό',
                            preRule: 'Κανόνας προϋποθέσεων',
                            analysisHighlighted: 'Κανόνες ανάλυσης',
                            categorySelectPrompt: 'Παρακαλώ επιλέξτε μια κατηγορία',
                            checkHighlightArrayError: 'Ο κανόνας δεν ταιριάζει με την επισήμανση, παρακαλώ κάντε κλικ στο κουμπί ανάλυσης ξανά.',
                            foctorsHolder: 'Παρακαλώ επιλέξτε ένα στοιχείοName',
                            foctorsErrorNone: 'Ο κανόνας πολλαπλών στοιχείων είναι κενός, προσθέστε έναν τύπο πολλαπλών στοιχείων.',
                            naError: 'Αδύνατο να κλείσει το αντικείμενο όταν το προκαθορισμένο βαθμό είναι N/A',
                            templateNew: {
                                theLargeModelRulesHaveBeenIntegratedIntoTheIntelligentRulesAndTheSubsequentIterationWillNotBeContinuedForBetterExperienceItIsRecommendedToSwitchToTheIntelligentRules: 'Οι μεγάλοι κανόνες μοντέλου έχουν ενσωματωθεί στους ευφυείς κανόνες, και η επακόλουθη επανάληψη δεν θα συνεχιστεί. Για καλύτερη εμπειρία, συνιστάται η αλλαγή στους έξυπνους κανόνες.',
                                agent: 'Πράκτορα',
                                convertToLargeModelRules: 'Μετατροπή σε μεγάλους κανόνες μοντέλου',
                                bigModelRules: 'Μεγάλοι κανόνες μοντέλου',
                                language: 'Γλώσσα',
                                nAIsTheNotApplicableWhichSetsPreconditionsForTheQualityInspectionRuleIfTheConditionIsMetTheRuleIsNotApplicableIfTheConditionIsNotMetTheRuleIsNotDetectedDescriptionOfPreconditionsMeansandMeansorIndicatesNOTFillInTheExampleRR2R3: 'Δεν είναι η μη εφαρμόσιμη, η οποία θέτει προϋποθέσεις για τον κανόνα επιθεώρησης ποιότητας. Εάν η προϋπόθεση πληρούται, ο κανόνας δεν εφαρμόζεται. Εάν η προϋπόθεση δεν πληρούται, ο κανόνας δεν ανιχνεύεται·\nΠεριγραφή των προϋποθέσεων: Αναφέρεται η «ΟΧΙ», συμπληρώστε το παράδειγμα "(R1 | R2)& & R3"',
                                applicationMessageType: 'Τύπος μηνύματος εφαρμογής',
                                selectAll: 'Επιλογή όλων',
                                highlightTags: 'Ετικέτα επισήμανσης:',
                                ruleType: 'Τύπος κανόνας',
                                dataSource: 'Πηγή δεδομένων',
                                whole: 'Όλα',
                                enterpriseMicroConversation: 'Πολιτική συνόδου επιχειρήσεων',
                                enterpriseAndMicroCommunication: 'Μικρολόγια επιχειρήσεων',
                            },
                            components: {
                                flow: {
                                    flow: {
                                        determineNodes: 'Κόμβος απόφασης',
                                        dialogueNode: 'Κόμβος διαλόγου',
                                        editNodes: 'Επεξεργασία κόμβου',
                                    },
                                    nodeConfig: {
                                        smartRules: 'Έξυπνοι κανόνες',
                                        bigModelRules: 'Μεγάλοι κανόνες μοντέλου',
                                        nodeName: 'Όνομα κόμβου',
                                        nodeRules: 'Κανόνες κόμβου',
                                        scoringLogic: 'Λογική βαθμολογίας',
                                        score: 'Βαθμολογία:',
                                        rule: 'Κανόνες',
                                        multiBranchLogic: 'Λογική πολλαπλών υποκατάστημα',
                                        highlight: 'Επισήμανση:',
                                        submit: 'Υποβολή',
                                    },
                                    ruleList: {
                                        manualConfiguration: 'Χειροκίνητη ρύθμιση',
                                        dragAndDropConfiguration: 'Ρυθμίσεις σύρισης και πτώσης',
                                        branch: 'Κλάδος',
                                        branchName: 'Όνομα κλάδου:',
                                        addRules: 'Προσθήκη κανόνων',
                                    },
                                    sidebar: {
                                        node: 'Κόμβος',
                                    },
                                    hooks: {
                                        useControlButtons: {
                                            automaticOrganization: 'Αυτόματη φινίρισμα',
                                            canvasAdaptation: 'Προσαρμοστικό',
                                            copy: 'Αντιγραφή',
                                            delete: 'Διαγραφή',
                                        },
                                        useFlow: {
                                            determineThatTheChildNodesOfANodeCannotBeUsedAsConnectionTargets: 'Ο παιδικός κόμβος του κόμβου κρίσης δεν μπορεί να χρησιμοποιηθεί ως στόχος σύνδεσης.',
                                            theStartingNodeCannotBeUsedAsAConnectionTarget: 'Ο κόμβος έναρξης δεν μπορεί να είναι ένας στόχος σύνδεσης',
                                            startingNodeCannotConnectMultipleNodes: 'Ο κόμβος έναρξης δεν μπορεί να συνδέσει περισσότερο από ένα κόμβο',
                                            nodeCannotBeConnectedToItself: 'Ο κόμβος δεν μπορεί να συνδεθεί με τον εαυτό του.',
                                            startNode: 'Έναρξη κόμβος',
                                        },
                                    },
                                },
                                msgTypesSelect: {
                                    index: {
                                        cancelSelectAll: 'Ακύρωση επιλογής όλων',
                                        selectAll: 'Επιλογή όλων',
                                    },
                                },
                                customModelsSelect: {
                                    index: {
                                        whetherItMeetsTheRequirements: 'Συμμόρφωση',
                                        gradedEvaluation: 'Αξιολόγηση βαθμού',
                                    },
                                },
                            },
                        },
                        configuration: {
                            title: 'Κανόνες επιθεώρησης ποιότητας',
                            wechatTitle: 'Μοντέλο ανάλυσης',
                            neme: 'Όνομα',
                            errorMessage: 'Η διαγραφή απέτυχε με τουλάχιστον έναν όρο',
                            desc: 'Περιγραφή',
                            status: 'Κατάσταση',
                            yes: 'Αποτελεσματικό',
                            no: 'Μη έγκυρο',
                            namePlaceHolder: 'Παρακαλώ εισάγετε ένα όνομα ετικέτας',
                            desPlaceHolder: 'Παρακαλώ εισάγετε μια περιγραφή',
                            nameEmpty: 'Το όνομα δεν μπορεί να είναι κενό',
                            desEmpty: 'Η περιγραφή δεν μπορεί να είναι κενή',
                            type: 'Τύπος',
                            ruler: 'Έξυπνοι κανόνες',
                            machineLearning: 'Τρόπος μάθησης',
                            autoScore: 'Έξυπνο βαθμό (παλιά)',
                            manualScore: 'Χειροκίνητη βαθμολογία',
                            interaction: 'Ανίχνευση αλληλεπίδρασης (παλιά)',
                            typeTips: {
                                model: 'Ευφυές μοντέλο: Είναι ένα προκαθορισμένο σύστημα επιθεώρησης ποιότητας, που μπορεί να ελέγξει γρήγορα τα προβλήματα που υπάρχουν στην υπηρεσία χωρίς διαμόρφωση και συντήρηση. Αυτό το μοντέλο είναι πιο γενικό, εάν δεν πληρείτε τις επιχειρηματικές απαιτήσεις, παρακαλούμε να χρησιμοποιήσετε "ευφυείς κανόνες" ή "επιχειρηματικό σκορ".',
                                rule: 'Ευφυείς κανόνες: αυτόματη βαθμολογία βασισμένη στον κανόνα AI',
                                manual: 'Χειροκίνητη βαθμολογία: χειροκίνητη επιθεώρηση ποιότητας, χειροκίνητη βαθμολογία με το χέρι',
                            },
                            model: 'Υπόδειγμα:',
                            ruleType: {
                                words: 'Λέξεις',
                                interaction: 'Αλληλεπίδραση',
                                feature: 'Χαρακτηριστικά',
                                information: 'Πληροφορίες',
                            },
                            testingMode: {
                                all: 'Ανίχνευση όλων των λέξεων-κλειδιών.',
                                any: 'Ανίχνευση αυθαίρετων λέξεων-κλειδιών',
                            },
                            operatorTypesOfInteraction: {
                                question: 'Μια ερώτηση και μία απάντηση',
                                element: 'Απάντηση στοιχείων',
                                repet: 'Επαναπαραγωγή',
                                snatch: 'Λέξεις',
                                silent: 'Σιωπή',
                            },
                            role: 'Ρόλος ανίχνευσης:',
                            preposition: 'Προχρηματοδότης:',
                            range: 'Εύρος ανίχνευσης:',
                            from: 'Τομέα',
                            to: 'Ποινή στο Όχι.',
                            end: 'Ποινή',
                            hasOldSilentTip: 'Γεια σας, για να βελτιωθεί η ακρίβεια, Το "Ευφυής Κανόνες-Σιωπή-Σιωπή" αναβαθμίστηκε σε "Απάντηση Timeout". Συνιστάται η ενημέρωση των κανόνων χρήσης!',
                            changeToOld: 'Εναλλαγή στην Κληρονομιάς',
                            changeToNew: 'Εναλλαγή σε νέα έκδοση',
                            logic: {
                                logic: 'Λογική βαθμολογίας',
                                naTip: 'Δεν είναι η μη εφαρμόσιμη, η οποία θέτει προϋποθέσεις για τον κανόνα επιθεώρησης ποιότητας. Εάν πληρούνται οι προϋποθέσεις, ο κανόνας δεν εφαρμόζεται. Εάν δεν πληρούνται οι προϋποθέσεις, ο κανόνας δεν εντοπίζεται.',
                                score: 'Βαθμολογία:',
                                na: 'N/A：',
                                naDes: 'Αυτό το στοιχείο δεν εμπλέκεται στην επιτρεπόμενη ανίχνευση.',
                                preRule: 'Κανόνες προϋποθέσεως:',
                                notCatchPreRule: 'Όταν δεν πληρούνται οι προϋποθέσεις:',
                                naChecked: 'Στην αποτυχία:',
                                preRuleEmpty: 'Ο κανόνας προϋποθέσεως δεν μπορεί να είναι κενός',
                                operatorEmpty: 'Η απαραίτητη κατάσταση δεν μπορεί να είναι μηδενική στον χειριστή',
                                multipleEmpty: 'Η απαραίτητη κατάσταση δεν μπορεί να είναι κενή σε πολλαπλή λογική βαθμολογία',
                                average: 'Μέσος όρος βαθμολογίας εντός ομάδας',
                                addOrSubtract: 'Άμεσο συν ή μείον σημείο',
                                noChange: 'Χωρίς συν ή μείον πόντοι',
                                rule: 'Κανόνες:',
                                all: 'Ικανοποιεί όλους τους χειριστές',
                                any: 'Ικανοποιεί αυθαίρετο χειριστή',
                                customize: 'Προσαρμοσμένη λογική λειτουργίας',
                                multiple: 'Πολλαπλή βαθμολογία',
                                heightLight: 'Επισήμανση:',
                                machineLearningTip: 'Αυτή τη στιγμή, η λειτουργία αυτο-μάθησης είναι αποτελεσματική μόνο για την ομιλία της μονής. Για πολύπλοκο λόγο, παρακαλώ χρησιμοποιήστε έξυπνους κανόνες.',
                                strategy: 'Στρατηγική:',
                            },
                        },
                        component: {
                            approvalSubmittedSuccessfully: 'Η έγκριση υποβλήθηκε επιτυχώς.',
                        },
                        components: {
                            pageHeaderExtra: {
                                test: 'Δοκιμή',
                                formal: 'Τυπική',
                                submit: 'Υποβολή',
                            },
                            createModal: {
                                index: {
                                    pleaseEnterARuleDescription: 'Παρακαλώ εισάγετε μια περιγραφή κανόνων',
                                    ruleGeneratedSuccessfully: 'Ο κανόνας δημιουργήθηκε με επιτυχία',
                                    failedToGenerateRule: 'Αποτυχία δημιουργίας κανόνων:',
                                    aIGeneration: 'Παραγωγή AI',
                                    pleaseEnterTheRuleDescriptionTheContentIsGeneratedByAIForReferenceOnly: 'Παρακαλώ εισάγετε την περιγραφή του κανόνα. Το περιεχόμενο δημιουργείται από ΤΙ μόνο για αναφορά.',
                                    generateRules: 'Δημιουργία κανόνων',
                                    myRules: 'Οι κανόνες μου.',
                                },
                            },
                        },
                    },
                    automaticAdd: {
                        index: {
                            name: 'Αυτοματοποίηση διεργασίας',
                            screeningCondition: 'Κατάσταση φίλτρου',
                            aiScreeningCondition: 'Κατάσταση έξυπνου φίλτρου',
                            rule: 'Κανόνες',
                            automaticAddition: 'Προσθήκη αυτόματης',
                            automaticAdditionTip: 'Αυτόματη προσθήκη δεδομένων σε εργασίες σε πραγματικό χρόνο ή σε τακτά χρονικά διαστήματα για επιθεώρηση ποιότητας ΤΙ',
                            autoAdd: {
                                autoAddType: 'Μέθοδος αυτόματης προσθήκης',
                                addFrequency: 'Προσθήκη συχνότητας',
                                add: 'Προσθήκη',
                            },
                            automaticSamplingInspection: 'Αυτόματη επιθεώρηση δειγματοληψίας',
                            automaticSamplingInspectionTip: 'Αυτόματη εξαγωγή δεδομένων που απαιτούν χειροκίνητη επιθεώρηση ποιότητας, για παράδειγμα, να αποσπάσει το 10% των χθεσινών τυχαίων δεδομένων κάθε μέρα για χειροκίνητη δειγματοληψία.',
                            everyAgentCheckLimit: 'Μέγιστη κλήρωση ανά παράγοντας',
                            automaticAllocation: 'Αυτόματη κατανομή',
                            automaticAllocationTip: 'Κατανομή επιθεωρήσεων δειγματοληψίας: τα εξαγόμενα δεδομένα κατανέμονται αυτόματα στους επιθεωρητές ποιότητας. Για παράδειγμα, το 10% των χθεσινών τυχαίων δεδομένων εξάγονται καθημερινά για τη δειγματοληψία. και δύο επιθεωρητές ποιότητας κατατίθενται κατά μέσο όρο σε αυτό το καθήκον.',
                            automaticAllocationTip2: 'Κατανομή επανεξέτασης: τα δεδομένα προσφυγής κατανέμονται αυτόματα στον επιθεωρητή ποιότητας, για παράδειγμα, τα καθημερινά δεδομένα προσφυγής κατανέμονται εξίσου τυχαία στους δύο επιθεωρητές ποιότητας αυτού του καθήκοντος για την επανεξέταση.',
                            automaticPush: 'Αυτόματη ώθηση',
                            automaticPushTip: 'Γνωστοποίηση ενεργοποίησης: ειδοποίηση/συναγερμός κατά την επιθεώρηση ποιότητας, για παράδειγμα, όταν προκύπτει μοιραίο σφάλμα στην εξυπηρέτηση πελατών, αποστέλλεται μήνυμα κοινοποίησης στον μικρό όμιλο επιχείρησης.',
                            automaticPushTip2: 'Χρονική έκθεση: Στείλτε τα αποτελέσματα επιθεώρησης ποιότητας με τη μορφή ταχυδρομείου, για παράδειγμα, Στείλτε τα αποτελέσματα της ποιότητας επιθεώρησης της χθεσινής χειροκίνητης δειγματοληψίας στο γραμματοκιβώτιο του επόπτη πελατών στις 9:00 κάθε μέρα.',
                            automaticAssess: 'Αυτόματη αξιολόγηση',
                            automaticAssessTip: 'Τα χειροκίνητα αποτελέσματα δειγματοληψίας συγκρίνονται τακτικά με τα αποτελέσματα επιθεώρησης ποιότητας ΤΙ για την αξιολόγηση της ακρίβειας. Για παράδειγμα, το ποσοστό ακρίβειας των χθεσινών δεδομένων δειγματοληψίας αξιολογείται στις 8:00 κάθε μέρα.',
                            reexaminationComplaint: 'Επανεξέταση της καταγγελίας',
                            spoktReviewDetail: 'Ρύθμιση επιχειρήσεων',
                            spoktReviewDetailTip: 'Ρύθμιση λειτουργιών όπως λίστα επιθεώρησης ποιότητας, τυχαία λίστα επιθεώρησης, επιχείρηση καταγγελιών, λίστα αναθεώρησης και παρατηρήσεις',
                            qaDetailAction: 'Ρύθμιση επιθεώρησης ποιότητας',
                            spoktDetailAction: 'Διαμόρφωση δειγματοληψίας',
                            reviewDetailAction: 'Επανεξέταση των ρυθμίσεων',
                            appealAction: 'Ρύθμιση αίτησης',
                            remarkTemplate: 'Πρότυπο σημείωσης',
                            automaticArchiving: 'Αυτόματη αρχειοθήκη',
                            conditionalRules: 'Κανόνες κατάστασης',
                            qualityInspectionConditions: 'Όροι επιθεώρησης ποιότητας',
                            unopened: 'Δεν ανοίγει ακόμα.',
                            sampleInspectionDistributionModel: 'Κατανομή δειγματοληψίας',
                            reviewAllocationModel: 'Κατανομή επανεξέτασης',
                            distributionModelTitle: 'Πολιτική κατανομής:',
                            pushRules: 'Πίεση κανόνων',
                            push: 'Σπρώξτε.',
                            assessRules: 'Κανόνες αξιολόγησης',
                            on: 'on',
                            off: 'off',
                            updateStatusSuccess: 'Αλλαγή κατάστασης επιτυχής!',
                            updateStatusFailed: 'Αποτυχία αλλαγής κατάστασης, παρακαλώ προσπαθήστε ξανά αργότερα!',
                            sampleNumberOrPercent: 'Αριθμός δειγματοληψίας ή αναλογία',
                            inspectorList: 'Καθορισμένος επιθεωρητής ποιότητας',
                            numberOfSubmission: 'Αριθμός επιτρεπόμενων παρατηρήσεων',
                            rewivewDays: 'Ημέρα',
                            TimeOfSubmission: 'Ημερομηνία ισχύος υποβολής των παρατηρήσεων',
                            rewivewSecond: 'Χρόνια',
                            switchOn: 'Άνοιγμα:',
                            switchOff: 'Κλείσιμο',
                            notMatchAnyRule: 'Όταν δεν αντιστοιχούν κανόνες:',
                            appealOptionsList: {
                                hiddenInspector: 'Καταγγελία κρυφών πληροφοριών επιθεωρητή',
                                hiddenHit: 'Η σελίδα προσφυγής υποστηρίζει τονισμό και τοποθέτηση επιτυχιών.',
                            },
                            caseLibrary: 'Συγχρονισμός βιβλιοθήκης περίπτωσης',
                            caseLibrarySyncTip: 'Συγχρονίστε τις περιπτώσεις που προστέθηκαν από το σύστημα QA στο σύστημα εξυπηρέτησης πελατών',
                            addCase: 'Αύξηση συγχρονισμούς',
                            caseLibraryId: 'Βιβλιοθήκη περίπτωσης',
                            caseLibraryIdTip: 'Ομάδα βάσης περιπτώσεων του συστήματος QA',
                            udeskCaseLibraryIdTip: 'Ομάδα υποθέσεων του συστήματος εξυπηρέτησης πελατών',
                            syncHis: 'Περίπτωση συγχρονικής ιστορίας',
                            otherSettings: 'Άλλες ρυθμίσεις',
                            udeskCaseLibraryId: 'Ομάδα κεφαλαίων',
                            url: 'Πίεση URLName',
                            urlTip: 'Παρακαλώ εισάγετε μια διεύθυνση διασύνδεσης που ξεκινά με http:// ή https://',
                        },
                        templateNew: {
                            resultsView: 'Προβολή αποτελεσμάτων',
                            afterTheStartOfTheSupportConfigurationResultsAreAvailableAndTheTimingCanBeViewedInRealTimeOrAccordingToTheRegularRules: 'Μετά το άνοιγμα, μπορείτε να ρυθμίσετε το χρονοδιάγραμμα της ανακοίνωσης απόδοσης και προβολής, η οποία μπορείτε να δείτε σε πραγματικό χρόνο ή από τους κανόνες χρονικούς χρόνους.',
                            topicAnalysis: 'Θεματική ανάλυση',
                            identifyTheTopicInTheConversationAndCustomizeTheTopicDimensionAccordingToTheBusinessSituation: 'Προσδιορίστε το θέμα στη συζήτηση και να προσαρμόσετε τη διάσταση του θέματος σύμφωνα με την επιχειρηματική κατάσταση.',
                            detailDisplayConfiguration: 'Ρύθμιση οθόνης λεπτομερειών:',
                            silenceOver: 'Σιωπή',
                            displayAtSeconds: 'Εμφανίστηκαν δευτερόλεπτα',
                            secondaryReview: 'Δευτεροβάθμια επανεξέταση',
                            numberOfAppealsAllowedToBeSubmitted: 'Αριθμός των προσφυγών που επιτρέπεται να υποβληθούν αιτήσεις',
                            validityOfSubmissionOfAppeal: 'Ισχύς υποβολής προσφυγής',
                            validityOfAppealReview: 'Ισχύς της επανεξέτασης προσφυγής',
                            hours: 'Ώρες',
                            businessSummary: 'Περίληψη επιχειρήσεων',
                            eachCustomerServiceRepresentativeCanSelectALowerLimit: 'Κάτω όριο εκχύλισης ανά παραγόντος',
                            automaticallyGenerateBusinessSummariesFromLargeModelsAndCustomizeDimensionsBasedOnBusinessSituations: 'Η σύνοψη επιχειρήσεων δημιουργείται αυτόματα από το μεγάλο μοντέλο, και η διάσταση μπορεί να προσαρμοστεί σύμφωνα με την επιχειρηματική κατάσταση.',
                            onlyTheFirstLevelReviewerAllocationStrategy: 'Πρωτοβάθμιος κριτής μόνο στρατηγική αποστολής',
                            secondaryCompounding: 'Δευτερεύον σύνθετο:',
                            secondLevelReviewersOnlySupportAverageDistribution: 'Οι δευτερεύοντες αναθεωρητές υποστηρίζουν μόνο την ίση κατανομή',
                            secondLevelReviewer: 'Αναθεωρητής δεύτερου επιπέδου:',
                            samplingInspectionTarget: 'Στόχος επιθεώρησης δειγματοληψίας',
                            setTheTargetToBeCompletedByManualSamplingInspectionWhenTheTargetIsNotReachedOrExceededAPromptWillBeGivenForExampleEveryCustomerServiceShouldCompleteSamplingInspectionsEveryMonthWhenTheNumberIsLessThan80APromptWillBeGivenOnTheQualityInspectionAndSamplingInspectionPage: 'Ορισμός του στόχου που πρέπει να συμπληρωθεί με χειροκίνητη επιθεώρηση δειγματοληψίας, και δώστε αίτηση όταν ο στόχος δεν επιτευχθεί ή υπέρβαση. Για παράδειγμα, κάθε υπηρεσία πελατών θα πρέπει να ολοκληρώνει την επιθεώρηση δειγματοληψίας 100 αντικειμένων ανά μήνα, και όταν ο στόχος είναι μικρότερος από 80 αντικείμενα, η σελίδα επιθεώρησης ποιότητας και επιθεώρησης δειγματοληψίας παρέχει έμφαση.',
                        },
                        component: {
                            pleaseImproveTheSamplingDeadlineConfiguration: 'Παρακαλώ βελτιώστε τη διαμόρφωση προθεσμίας δειγματοληψίας!',
                            pleaseImproveTheAppealConfiguration: 'Παρακαλώ βελτιώστε τη διαμόρφωση έφεσης!',
                            displaySilentDuration: 'Εμφάνιση σιωπηλής διάρκειας',
                            playbarDisplayMood: 'Διάθεση εμφάνισης της γραμμής αναπαραγωγής',
                            playbarDisplaySmartLabel: 'Εμφάνιση της γραμμής αναπαραγωγής έξυπνης ετικέτας',
                            playbarDisplayHitRule: 'Κανόνας εμφάνισης γραμμής αναπαραγωγής',
                            verificationFailed: 'Η επαλήθευση απέτυχε',
                            pleaseAddASecondLevelQualityInspector: 'Παρακαλώ προσθέστε τον επιθεωρητή ποιότητας Βαθμού ΙΙ',
                        },
                        businessSummary: {
                            components: {
                                field: {
                                    index: {
                                        hintLanguage: 'Ζήτηση',
                                        fieldName: 'Όνομα πεδίου',
                                        fieldDescription: 'Περιγραφή πεδίου',
                                        generateContent: 'Δημιουργία περιεχομένου:',
                                        enabled: 'Ενεργοποιημένο',
                                        generationMethod: 'Μέθοδος παραγωγής',
                                        automaticGeneration: 'Δημιουργείται αυτόματα',
                                        manualTrigger: 'Χειροκίνητη ενεργοποίησης',
                                        filterCondition: 'Κατάσταση φίλτρου',
                                        return: 'Επιστροφή',
                                        preserve: 'Αποθήκευση',
                                    },
                                    components: {
                                        training: {
                                            index: {
                                                generateResults: 'Δημιουργία αποτελεσμάτων',
                                            },
                                        },
                                    },
                                },
                                contentScope: {
                                    index: {
                                        notQualified: 'Μη εξειδικευμένο',
                                        limitedScope: 'Περιορισμένο πεδίο εφαρμογής',
                                        add: 'Προσθήκη',
                                        thereIsCurrentlyNoDataAvailable: 'Χωρίς δεδομένα',
                                    },
                                },
                            },
                            index: {
                                fieldName: 'Όνομα πεδίου',
                                fieldDescription: 'Περιγραφή πεδίου',
                                nothing: 'Κανένα',
                                generationMethod: 'Μέθοδος παραγωγής',
                                generateManually: 'Δημιουργία χειροκίνητων',
                                automaticGeneration: 'Δημιουργείται αυτόματα',
                                generateContent: 'Δημιουργία περιεχομένου:',
                                notQualified: 'Μη εξειδικευμένο',
                                filterCondition: 'Κατάσταση φίλτρου',
                                enabled: 'Ενεργοποιημένο',
                                type: 'Τύπος',
                                system: 'Σύστημα',
                                custom: 'Προσαρμοσμένο',
                                operation: 'Λειτουργία',
                                edit: 'Επεξεργασία',
                                areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                                delete: 'Διαγραφή',
                                addField: 'Προσθήκη πεδίους',
                            },
                        },
                        autoAdd: {
                            index: {
                                addQuestionnaireDataAutomatically: 'Προσθήκη δεδομένων ερωτηματολογίου',
                                addVideoDataAutomatically: 'Προσθήκη δεδομένων βίντεο αυτόματα',
                                automaticallyAddTextData: 'Αυτόματη προσθήκη δεδομένων κειμένου:',
                                addVoiceDataAutomatically: 'Προσθήκη φωνητικών δεδομένων αυτόματα',
                                automaticallyAddWorkOrderData: 'Αυτόματη προσθήκη δεδομένων σειράς εργασίας',
                            },
                        },
                        topicAnalysis: {
                            components: {
                                field: {
                                    index: {
                                        topicName: 'Όνομα θεματικού',
                                        topicDescription: 'Θέμα περιγραφή',
                                        topicTag: 'Θέμα ετικέτας',
                                    },
                                },
                            },
                            index: {
                                addTopic: 'Προσθήκη θεματικού',
                                topicName: 'Όνομα θεματικού',
                                topicDescription: 'Θέμα περιγραφή',
                                topicTag: 'Θέμα ετικέτας',
                                pleaseEnterATopicName: 'Παρακαλώ εισάγετε ένα όνομα θέματου',
                            },
                        },
                        components: {
                            businessConfig: {
                                index: {
                                    moreThanTheValidityPeriodIsNotChecked: 'Περισσότερο από την περίοδο ισχύος δεν ελέγχεται',
                                    dontSetValidityPeriod: 'Μην ρυθμίσετε περίοδο ισχύος',
                                    setTheValidityPeriodOfRandomInspection: 'Ορισμός της περίοδος ισχύος της τυχαίας επιθεώρησης',
                                    setTheDeadlineForRandomInspection: 'Ορισμός της προθεσμίας για τυχαία επιθεώρησης',
                                    validityPeriodOfSamplingInspection: 'Περίοδος ισχύος της επιθεώρησης δειγματοληψίας',
                                    day: 'Ημέρα',
                                    samplingDeadline: 'Προθεσμία δειγματοληψίας',
                                    caseLibraryConfiguration: 'Ρυθμίσεις βιβλιοθήκης κεφαλαίων:',
                                    allowViewingTheCaseLibraryInTheAppealsSDK: 'Επιτρέπεται η προβολή της βιβλιοθήκης υπόθεσης στους προσφυγές SDK',
                                    finalConfiguration: 'Τελική ρύθμιση:',
                                    allowFinalReviewInQualityDetails: 'Επιτρέψτε την τελική αναθεώρηση σε λεπτομέρειες ποιότητας',
                                    aIQualityInspectionResultsCanBeAppealed: 'Τα αποτελέσματα επιθεώρησης ποιότητας τεχνητής τεχνολογίας',
                                    theResultsOfManualSamplingCanBeAppealed: 'Τα αποτελέσματα της χειροκίνητης δειγματοληψίας μπορούν να προσφύγουν.',
                                    setAppealDeadline: 'Καθορισμός προθεσμίας προσφυγής',
                                    complaintDeadline: 'Προθεσμία καταγγελίας',
                                    reviewDeadline: 'Προθεσμία επανεξέτασης',
                                    setAppealValidityPeriod: 'Καθορισμός περίοδος ισχύος της προσφυγής',
                                    refreshTheAppealValidityPeriodDuringRandomInspectionOrReinspection: 'Ανανέωση της περίοδος ισχύος της προσφυγής κατά την τυχαία επιθεώρηση ή επανεξέταση.',
                                    numberOfAppealsAllowedToBeSubmitted: 'Αριθμός των προσφυγών που επιτρέπεται να υποβληθούν αιτήσεις',
                                    second: 'Χρόνια',
                                },
                            },
                            autoAssign: {
                                index: {
                                    whenTheSecondlevelReviewAssignerIsEqualToTheFirstlevelReviewSubmiterTheSecondlevelReviewIsAutomaticallyCompleted: 'Όταν ο οριστής επανεξέτασης δεύτερου επιπέδου είναι ίσος με τον υποβάλλοντα αξιολόγησης πρώτου επιπέδου, η ανασκόπηση δεύτερου επιπέδου ολοκληρώνεται αυτόματα.',
                                    firstlevelReview: 'Επισκόπηση',
                                    triggerPolicy: 'Πολιτική ενεργοποίησης:',
                                    secondaryReviewOnlyWhenPassing: 'Δευτεροβάθμια επανεξέταση μόνο όταν περάσει',
                                    secondaryReviewOfAllResults: 'Δευτεροβάθμια επανεξέταση όλων των αποτελεσμάτων',
                                },
                            },
                            viewGrade: {
                                index: {
                                    number: '- Όχι.',
                                    pushTiming: 'Χρονισμός ώθησης ώθησης',
                                    realtimeViewing: 'Προβολή πραγματικού χρόνου',
                                    timingView: 'Προβολή χρόνου',
                                    addFrequency: 'Προσθήκη συχνότητας',
                                    timeRange: 'Εύρος χρόνου',
                                    pleaseSelect: 'Παρακαλώ επιλέξτε.',
                                    filterCriteria: 'Κριτήρια φίλτρου:',
                                },
                            },
                        },
                    },
                    roleConfig: {
                        index: {
                            name: 'Ρύθμιση ρόλων',
                            roleConfigTip: 'Χρησιμοποιείται για τη ρύθμιση κανόνων αναγνώρισης για την επεξεργασία διαχωρισμού ηχείων όταν τα εισαγόμενα δεδομένα κλήσης είναι μονό. Συμμόρφωση προς τους κανόνες για τον ρόλο αντιπροσώπους',
                            operator: 'Αερομεταφορέας',
                            operatorLogic: 'Λογική λογική του χειριστή',
                        },
                    },
                    manualAdd: {
                        index: {
                            name: 'Προσθήκη χειροκίνητα',
                            tip: 'Χρησιμοποιείται για το φιλτράρισμα δεδομένων προεπισκόπησης με το χέρι ρύθμιση των κριτηρίων και γρήγορη προσθήκη στην εργασία επιθεώρησης ποιότητας',
                            screeningCondition: 'Προσθήκη με κριτήρια φίλτρου',
                            aiScreeningCondition: 'Κατάσταση έξυπνου φίλτρου',
                            rule: 'Κανόνες',
                            createTime: 'Προσθήκη ώρας',
                            filterTitle: 'Περιεχόμενο φίλτρου',
                            filterRule: 'Κατάσταση φίλτρου',
                            startTime: 'Ώρα έναρξης',
                            endTime: 'Τέλος χρόνου',
                            records: 'Εισαγωγή αρχείων',
                            createUserName: 'Αερομεταφορέας',
                            successCount: 'Προστέθηκε με επιτυχία',
                            conditionRule: 'Κανόνες κατάστασης:',
                            preview: 'Προεπισκόπησης',
                            previewData: 'Προς το παρόν, υπάρχουν κριτήρια που ταιριάζουν τα {0} φίλτρα, έχουν προστεθεί εργασίες {1}, μπορούν να προστεθούν {2} εργασίες, και {3} εργασίες δεν μπορούν να προστεθούν.',
                            failCount: 'Αποτυχία προσθήκης',
                        },
                    },
                    basicInfo: {
                        index: {
                            title: 'Βασικές πληροφορίες',
                            name: 'Όνομα',
                            taskName: 'Όνομα εργασίας',
                            taskNamePlaceholder: 'Παρακαλώ εισάγετε ένα όνομα εργασίας',
                            requiredName: 'Το όνομα εργασίας δεν μπορεί να είναι κενό',
                            taskRemarkPlaceholder: 'Παρακαλώ εισάγετε μια περιγραφή εργασίας',
                            requiredRemark: 'Η περιγραφή εργασιών δεν μπορεί να είναι κενή',
                            remark: 'Περιγραφή',
                            taskRemark: 'Περιγραφή εργασίας',
                            source: 'Πηγή δεδομένων',
                            benchmarkScore: 'Βαθμολογία αναφοράς',
                            benchmarkScorePlaceholder: 'Παρακαλώ εισάγετε ένα βαθμό αναφοράς',
                            scoreLowerLimit: 'Ελάχιστη βαθμολογία',
                            scoreUpperLimit: 'Μέγιστο κάλυμμα βαθμολογίας',
                            inspectType: 'Τύπος επιθεώρησης ποιότητας',
                            nlpModel: 'Το μοντέλο NLP',
                            commonInspect: 'Τακτική επιθεώρηση ποιότητας',
                            associateInspect: 'Σχετική επιθεώρηση ποιότητας',
                            associateCycle: 'Περίοδος αντιστοιχίας',
                            associateRegulation: 'Κανόνας σύνδεσης',
                            judgeStrategy: 'Λογική εκτέλεσης',
                            rule: 'Κανόνες',
                            commonTip: 'Τακτική επιθεώρηση ποιότητας: εφαρμόζεται στην ενιαία επικοινωνία και στον διάλογο. Ο έλεγχος ποιότητας πραγματοποιείται στο περιεχόμενο της ενιαίας επικοινωνίας.',
                            associateTip: 'Συναφής επιθεώρηση ποιότητας: εφαρμόζεται σε πολλαπλές επικοινωνίες και συνομιλίες, σύνδεση του περιεχομένου των πολλαπλών επικοινωνιών για επιθεώρηση ποιότητας.',
                            cycleTip: 'Εάν υπάρχουν πολλαπλές σχετικές επικοινωνίες και διαλόγοι, τα δεδομένα κατά τη σχετική περίοδο θα εισαχθούν στο έργο επιθεώρησης ποιότητας.',
                            scoreLowerLimitPlaceholder: 'Παρακαλώ εισάγετε όριο βαθμολογίας',
                            scoreUpperLimitPlaceholder: 'Παρακαλώ εισάγετε το μέγιστο κάλυμμα βαθμολογίας',
                            call: 'Κλήση φωνής',
                            dialogue: 'Διάλογο κειμένου',
                            user: 'Επιθεωρητής ποιότητας',
                            wechatUser: 'Αερομεταφορέας',
                            noDesignated: 'Μη καθορίσει',
                            type: 'Τύπος τύπου',
                            singleScore: 'Μονό βαθμός',
                            conduct: 'Παρακαλώ συμπληρώστε πρώτα τις ακόλουθες πληροφορίες, στη συνέχεια κάντε κλικ Επόμενο',
                            conduct2: 'Παρακαλείσθε να συμπληρώσετε τη διαμόρφωση των κανόνων επιθεώρησης ποιότητας και των σημείων επιθεώρησης ποιότητας. Εάν έχετε ολοκληρώσει τις ρυθμίσεις, μπορείτε να κάνετε κλικ στον οδηγό Επόμενο ή εξόδου',
                            conduct3: 'Η βαθμολογία επιθεώρησης ποιότητας διαμορφώνεται σύμφωνα με το σημείο επιθεώρησης ποιότητας και την αξιολόγησή του. Μπορείτε να καθορίσετε διαφορετικά επίπεδα επιθεώρησης ποιότητας. Αν δεν χρειάζεστε βαθμολογία, μπορείτε να παραλείψετε αυτό το βήμα. Εάν έχετε ολοκληρώσει τη ρύθμιση, μπορείτε να κάνετε κλικ Next ή να βγείτε από τον οδηγό.',
                            conduct4: 'Μπορείτε να ρυθμίσετε τα χαρακτηριστικά δεδομένων που θα προστεθούν αυτόματα στην εργασία ανάλογα με τα χαρακτηριστικά δεδομένων που η εργασία πρέπει να ελέγξει στο αυτόματο θέση προσθήκης. Εάν δεν χρειάζεται να προσθέσετε αυτόματα δεδομένα προς το παρόν, μπορείτε να κάνετε κλικ στο Skip. Αν έχετε ολοκληρώσει τη ρύθμιση, μπορείτε να κάνετε κλικ στο Επόμενο.',
                            conduct5: 'Αν χρησιμοποιείτε μονό καταγραφή, παρακαλώ βεβαιωθείτε ότι θα ρυθμίσετε αυτό το αντικείμενο και πατήστε Επόμενο. Παρακαλώ χρησιμοποιήστε μόνο τη φωνή της εξυπηρέτησης πελατών για να βοηθήσετε το σύστημα να προσδιορίσει τα διαφορετικά κομμάτια μεταξύ της εξυπηρέτησης πελατών και του πελάτη. Αν χρησιμοποιείτε την εγγραφή δύο καναλιών ή έχετε ολοκληρώσει τη ρύθμιση, μπορείτε να κάνετε κλικ σε Skip',
                            conduct6: 'Μπορείτε να χρησιμοποιήσετε τη χειροκίνητη λειτουργία προσθήκης για να εισάγετε τα υπάρχοντα δεδομένα επικοινωνίας στο σύστημα για επιθεώρηση ποιότητας, ή έχετε υποβάλει μία χειροκίνητη προσθήκη, παρακαλώ κάντε κλικ στο Τέλος απευθείας',
                            helper: 'Προβολή τεκμηρίωσης βοήθειας',
                            quit: 'Έξοδος εκκίνησης',
                            next: 'Επόμενο βήμα',
                            complete: 'Ολοκληρώθηκε',
                            skip: 'Παράλειψη',
                            cancel: 'Ακύρωση',
                            delete: 'Διαγραφή',
                            save: 'Αποθήκευση',
                        },
                        template: {
                            language: 'Γλώσσα',
                            samplingInspector: 'Επιθεωρητής δειγματοληψίας',
                            sessionType: 'Τύπος συνεδρίας',
                        },
                    },
                },
                workbench: {
                    qualityCheckList: {
                        index: {
                            name: 'Επιθεώρηση εργασίας',
                            search: 'Φίλτρος',
                            export: 'Εξαγωγή',
                            condition: 'Κατάσταση',
                            logic: 'Λογική',
                            reQualityInspection: 'Επανεπιθεώρηση',
                            reQualityInspectionUnderWay: 'Επαναληψία επιθεώρησης...',
                            reQualityInspectionUnderWayTip: 'Η έξοδος από τη σελίδα μετά το κλείσιμο του παραθύρου δεν επηρεάζει την εργασία.',
                            reQualityInspectionDone: 'Ολοκληρώθηκε επανεπιθεώρησης',
                            reQualityInspectionDoneTip: 'Η επανεξέταση έχει ολοκληρωθεί με επιτυχία, παρακαλώ κάντε κλικ στο κουμπί επιβεβαίωσης.',
                            endReQualityInspection: 'Τερματισμός εργασίας',
                            alreadyDoneTip: 'Ολοκληρώθηκε',
                            totalTip: 'Σύνολο',
                            unit: 'Άρθρο',
                            endReInspectionSuccess: 'Τέλος εργασίας επανα- ποιότητας',
                            closeWindow: 'Κλείσιμο παραθύρου',
                            endReInspectionFailed: 'Αποτυχία εργασίας επανα- ποιότητας, παρακαλώ προσπαθήστε ξανά αργότερα!',
                        },
                        detail: {
                            name: 'Λεπτομέρειες επιθεώρησης ποιότητας',
                            reviewName: 'Στοιχεία αναθεώρησης',
                            spotCheckName: 'Στοιχεία δειγματοληψίας',
                            audioText: 'Ηχογραφημένο κείμενο',
                            callInfo: 'Πληροφορίες κλήσης',
                            satisfactionEvaluation: 'Αξιολόγηση ικανοποίησης:',
                            queueTime: 'Χρόνος που δαπανήθηκε στην ουρά:',
                            ringingTime: 'Χρόνος κλήσης:',
                            callTime: 'Γεγονότα κλήσης:',
                            hangUpIdentity: 'Τηλεφώνησε στο πάρτι.',
                            location: 'Σπίτι:',
                            source: 'Πηγή:',
                            agent: 'Υπηρεσία πελατών:',
                            deviceType: 'Τύπος συσκευής:',
                            callType: 'Τύπος κλήσης:',
                            phoneNumber: 'Αριθμός ανακοίνωσης:',
                            task: 'Καθήκοντα:',
                            commentsTip: 'Παρακαλώ εισάγετε σχόλια επιθεώρησης ποιότητας.',
                            lastPage: 'Προηγούμενη σελίδα:',
                            nextPage: 'Επόμενη σελίδα',
                            score: 'Βαθμός επιθεώρησης ποιότητας',
                            review: 'Αναθεώρηση',
                            file: 'Αρχειοθετήσεις',
                            changeList: 'Τροποποίηση εγγραφής',
                            fullMarks: 'Πλήρεις σημάνσεις',
                            most: 'Περισσότεροι',
                            saveReview: 'Αναθεώρηση υποβολής',
                            saveSpotCheck: 'Επιθεώρηση δειγματοληψίας και υποβολή',
                            point: 'Σημείο επιθεώρησης ποιότητας',
                            sampleAssignInspector: 'Ορισμός επιθεωρητή δειγματοληψίας',
                            reviewAssignInspector: 'Ανέθεση',
                            sampleStatus: 'Καθεστώς δειγματοληψίας',
                            read: 'Ανάγνωση:',
                            user: 'Χρήστης',
                            confirmer: 'Επιβεβαιωμένο άτομο',
                            voiceDownloadError: 'Η λήψη φωνής απέτυχε, παρακαλώ δοκιμάστε ξανά αργότερα!',
                            smartTags: 'Έξυπνη ετικέταName',
                            interactiveTip: 'Χρησιμοποιήστε την αναγνώριση αλληλεπίδρασης για να ανιχνεύσετε τη χρήση της εξυπηρέτησης πελατών FAQ',
                            interactiveIsEmptyTip: 'Δεν εντοπίστηκε περιεχόμενο διαδραστικής αναγνώρισης',
                            businessRecords: 'Επιχειρηματικά αρχεία',
                        },
                    },
                },
                reports: {
                    groupChatAnalysis: {
                        index: {
                            analysisOfEnterpriseWeChatGroupChat: 'Ανάλυση της ομάδας συνομιλίας Enterprise WeChat',
                        },
                    },
                },
            },
            cards: {
                health: 'Υγειονομική επιθεώρηση',
                accuracy: 'Ποσοστό έγκρισης ανακαλύψεων',
                sessionsTotal: 'Σύνολο συνόδων',
                enable: 'Ενεργοποίηση ενεργοποίησης',
                disable: 'Απενεργοποίηση',
                none: 'Οχι',
                call: 'Κλήση',
                dialogue: 'Διάλογος',
                taobao: 'Ηλεκτρονικό εμπόριο',
                wecom: 'Συνεδρία',
                ticket: 'Σειρά εργασίας',
            },
            component: {
                language: 'Γλώσσα',
                backup: '(Επιστροφή)',
                taskSaveAsSucceeded: 'Εργασία αποθηκευμένη ως επιτυχή',
                copyContent: 'Αντιγραφή περιεχομένου',
                essentialInformation: 'Βασικές πληροφορίες',
                ruleConfiguration: 'Ρυθμίσεις κανόνας',
                basicInformationQualityInspector: 'Βασικός επιθεωρητής Πληροφορίες-Ποιότητας',
                qualityInspectionRating: 'Αξιολόγηση επιθεώρησης ποιότητας',
                roleConfiguration: 'Ρύθμιση ρόλων',
                autoAddConfiguration: 'Αυτόματη προσθήκη ρυθμίσεων',
                autoPushConfiguration: 'Αυτόματη ρύθμιση ώθησης',
                automaticSamplingConfiguration: 'Αυτόματη διαμόρφωση δειγματοληψίας',
                automaticAllocationConfiguration: 'Αυτόματη ρύθμιση κατανομής',
                businessConfiguration: 'Ρύθμιση επιχειρήσεων',
                caseBaseConfiguration: 'Βιβλιοθήκη περίπτωσης',
            },
            template: {
                cancel: 'Ακύρωση',
                complete: 'Ολοκληρώθηκε',
                sort: 'Ταξινόμηση',
                ruleApproval: 'Έγκριση κανόνας',
                enterpriseMicroConversationAnalysisTask: 'Ανάλυση μικροσυνόδου επιχειρήσεων',
                enterpriseAndMicroVoiceAnalysisTask: 'Έργο ανάλυσης μικροφωνίας Enterprise',
                saveTaskAs: 'Αποθήκευση εργασίας',
            },
            approve: {
                checkPoint: {
                    index: {
                        ruleDetails: 'Λεπτομέρειες κανόνας',
                    },
                },
                components: {
                    autoApproveSwitch: {
                        modificationSucceeded: 'Επιτυχία τροποποίησης',
                        automaticApproval: 'Αυτόματη έγκριση',
                    },
                    pageHeaderExtra: {
                        modificationSucceeded: 'Επιτυχία τροποποίησης',
                        test: 'Δοκιμή',
                        formal: 'Τυπική',
                        adopt: 'Απ\' τον λόγο',
                    },
                    rejectButton: {
                        index: {
                            areYouSureToReject: 'Σίγουρα θα απορρίψεις.',
                            pleaseEnterTheRejectionReason: 'Παρακαλώ εισάγετε λόγο απόρριψης',
                            reject: 'Απορρίφθηκαν',
                        },
                    },
                    table: {
                        index: {
                            modificationSucceeded: 'Επιτυχία τροποποίησης',
                            taskName: 'Όνομα εργασίας',
                            dataSource: 'Πηγή δεδομένων',
                            qualityInspectionType: 'Τύπος επιθεώρησης ποιότητας',
                            state: 'Κατάσταση',
                            updateTime: 'Ώρα ενημέρωσης',
                            updatedBy: 'Ενημέρωση προσώπων',
                            approver: 'Έγκριση',
                            reasonForRejection: 'Λόγος απόρριψης',
                            operation: 'Λειτουργία',
                            details: 'Λεπτομέρειες',
                            adopt: 'Απ\' τον λόγο',
                            whole: 'Όλα',
                            approvalStatus: 'Κατάσταση έγκρισης',
                        },
                    },
                },
            },
        },
        dashboard: {
            title: 'Επισκόπηση',
            hi: 'Γεια.',
            standardEdition: 'Τυπική έκδοση',
            call: 'Ισοζύγιο φωνητικής ποιότητας επιθεώρησης',
            text: 'Περίοδος ισχύος της επιθεώρησης ποιότητας του κειμένου·',
            collectionTasks: 'Συλλογή καθηκόντων επιθεώρησης ποιότητας',
            noCollection: 'Καμία συλλογή καθηκόντων επιθεώρησης ποιότητας,',
            goToCollecte: 'Μετάβαση στη συλλογή',
            yesterdayOverView: 'Χθεσινές στατιστικές επιχειρήσεων',
            yesterdayAgent: 'Χθεσινή λίστα εξυπηρέτησης πελατών',
            yesterdayInspWork: 'Χθεσινή κατάσταση εργασίας του επιθεωρητή ποιότητας',
            operationalStatistics: {
                title: 'Στατιστικές επιχειρήσεων',
                qualityTesting: 'Επιθεώρηση ποιότητας',
                spotCheck: 'Τυχαία επιθεώρηση',
                appeal: 'Καταγγελία',
                chartTitles: {
                    qualityTestingTrend: 'Τάση όγκου επιθεώρησης',
                    qualityTestingAnalysis: 'Εργασία επιθεώρησης ποιότητας',
                    spotCheckTrend: 'Τάση δειγματοληψίας',
                    spotCheckAnalysis: 'Κατάσταση δειγματοληψίας',
                    appealTrend: 'Τάσεις καταγγελίας',
                    appealAnalysis: 'Το καθεστώς της εντολής προσφυγής',
                },
                titles: {
                    qualityDataTend: 'Διανομή δεδομένων επιθεώρησης ποιοτικού ελέγχου',
                    qualityCover: 'Κάλυψη επιθεώρησης ποιότητας',
                    qualityAverageTime: 'Μέσος όρος επιθεώρησης ποιότητας Χρόνος αναμονής',
                    qualityCoverTend: 'Τάση κάλυψης της ποιότητας επιθεώρησης',
                    handCover: 'Χειροκίνητη χειριστή',
                    checkCover: 'Δειγματοληψία κάλυψης',
                    resAverageTime: 'Μέσος χρόνος επεξεργασίας',
                    handTend: 'Τάση χειροκίνητης επεξεργασίας',
                    dataTend: 'Διανομή εργασιών δεδομένων',
                },
                qualityAverage: 'Μέση βαθμολογία επιθεώρησης ποιότητας',
                scoreTrend: 'Τάση βαθμολογίας επιθεώρησης ποιότητας',
                qualityAverageTime: 'Μέσος όρος επιθεώρησης ποιότητας Χρόνος αναμονής',
                callCoverage: 'Κάλυψη επιθεώρησης φωνητικής ποιότητας',
                textCoverage: 'Κάλυψη ποιότητας επιθεώρησης κειμένου κειμένου',
                checkCount: 'Όγκος δεδομένων δειγματοληψίας',
                siphonCount: 'Εξαγωγή όγκου στοιχείων',
                reviewCount: 'Επανεξέταση δεδομένων',
                appealCount: 'Όγκος στοιχείων καταγγελίας',
                checkRate: 'Ποσοστό τυχαίας επιθεώρησης',
                reviewRate: 'Ποσοστό της επανεξέτασης καταγγελίας',
                PieTitle: {
                    totalCount: 'Συνολικός αριθμός συνομιλίων',
                    totalCall: 'Αριθμός φωνητικών κλήσεων',
                    totalIm: 'Αριθμός συνομιλίων κειμένου:',
                    inspectionCall: 'Ποσότητα επιθεώρησης φωνητικής ποιότητας',
                    inspectionIm: 'Ποσότητα επιθεώρησης ποιότητας κειμένου',
                    checkCall: 'Ποσότητα δειγματοληψίας φωνητής',
                    unCheckCall: 'Μη δειγματοληψία φωνής',
                    checkIm: 'Ποσότητα δειγματοληψίας κειμένου',
                    unCheckIm: 'Χωρίς δειγματοληψία κείμενου',
                    reviewCall: 'Όγκος αναθεώρησης',
                    reviewIm: 'Ποσότητα επανεξέτασης κειμένου:',
                    unReviewCall: 'Μη ελεγχόμενη ποσότητα φωνής',
                    unReviewIm: 'Ποσό του κειμένου που δεν αναθεωρήθηκε',
                    unInspectionCall: 'Η ποσότητα φωνής δεν ελέγχθηκε',
                    unInspectionIm: 'Μη ελεγχόμενη ποσότητα κειμένου κειμένου',
                },
                check_rate: 'Δειγματοληψία κάλυψης',
                voice_check_rate: 'Κάλυψη φωνητικής δειγματοληψίας δειγματοληψίας',
                text_check_rate: 'Κάλυψη δειγματοληψίας κειμένου',
                sample_execute_time: 'Μέσος χρόνος επεξεργασίας δειγματοληψίας',
                review_execute_time: 'Μέσος χρόνος επεξεργασίας παράβασης',
            },
            analysisOverview: {
                tableTitle: {
                    conditions: 'Κανόνες επιθεώρησης ποιότητας Kanban',
                    agent: 'Κατάταξη εξυπηρέτησης πελατών',
                },
                tableTips: {
                    conditions: 'Η <div> ταξινομεί το συνολικό αριθμό συνομιλίων που παραβιάζουν και συμμορφώνονται με τους κανόνες επιθεώρησης ποιότητας. <Br />\nΕπιθεώρηση ποιότητας Είδος: όνομα του σημείου επιθεώρησης ποιότητας <br />\nΣυνολικός αριθμός παράνομων συνομιλιών: συνολικός αριθμός παράνομων συνομιλίων για αυτό το αντικείμενο επιθεώρησης ποιότητας <br />\nΠοσοστό παραβιάσεων: Ποσοστό παραβιάσεων = συνολικός αριθμός παραβιάσεων/συνολικός αριθμός παραβιάσεων',
                    agent: '<Divi> Ταξινόμηση της μέσης βαθμολογίας των αντιπροσώπων <br />\nΌνομα υπηρεσίας πελατών: το όνομα της εξυπηρέτησης πελατών <br />\nΟμάδα εξυπηρέτησης πελατών: η ομάδα εξυπηρέτησης πελατών όπου βρίσκεται η εξυπηρέτηση πελατών (η πληροφορία του οργανισμού στις πληροφορίες εξυπηρέτησης πελατών)<br />\nΣυνολικός αριθμός συνομιλιών σκορ: συνολικός αριθμός ποιότητας επιθεώρησης συνομιλίες της εξυπηρέτησης πελατών <br />\nΜέση βαθμολογία επιθεώρησης ποιότητας: η μέση βαθμολογία επιθεώρησης ποιότητας του πράκτορα (συνολική βαθμολογία/συνολικός αριθμός συνομιλιών) Μην ανησυχείς.',
                },
                tips: {
                    total: 'Συνολικός αριθμός εισαγωγών/συνομιλίων που αναλαμβάνονται στο έργο επιθεώρησης ποιότητας',
                    agentTotal: 'Ο συνολικός αριθμός των φορέων επιθεώρησης ποιότητας που εισήλθαν στην εργασία επιθεώρησης ποιότητας',
                    avg: 'Μέση βαθμολογία βαθμολογίας επιθεώρησης',
                    violation: 'Σύνολο του αριθμού των φορών όλων των αντικειμένων επιθεώρησης ποιότητας του διαλόγου πέραση πλήττονται και παραβιάζεται',
                    compliance: 'Συνοψίζεται ο αριθμός των φορών που πλήττονται τα στοιχεία επιθεώρησης ποιότητας στη διαδικασία επιθεώρησης ποιότητας μέσω διαλόγου',
                    check: 'Συνολικός αριθμός χειροκίνητων δειγματοληψίας',
                    appeal: 'Συνολικός αριθμός των καταγγελιών που υποβλήθηκαν σε συνολικό αριθμό συζητήσεων',
                    review: 'Συνολικός αριθμός αξιολογήσεων που υποβλήθηκαν σε συνολικό αριθμό συζητήσεων',
                },
                subTips: {
                    violation: 'Ποσοστό παραβίασης: συνολικός αριθμός παραβιάσεων/συνολικός αριθμός ειδών επιθεώρησης ποιότητας * 100%',
                    compliance: 'Ποσοστό συμμόρφωσης: συνολικός αριθμός χρόνου συμμόρφωσης/συνολικός αριθμός ειδών επιθεώρησης ποιότητας * 100%',
                    check: 'Κάλυψη δειγματοληψίας: συνολική χειροκίνητη δειγματοληψία/συνολική επιθεώρηση ποιότητας * 100%',
                    appeal: 'Ποσοστό προσφυγής: συνολικός αριθμός προσφυγών/συνολικός αριθμός επιθεωρήσεων ποιότητας * 100%',
                    review: 'Ποσοστό αναθεώρησης: συνολικός αριθμός αναθεωρήσεων/συνολικός αριθμός επιθεωρήσεων ποιότητας * 100%',
                },
            },
            components: {
                companyBackground: {
                    index: {
                        cancel: 'Ακύρωση',
                        pleaseEnterTheCompanyBusinessDescriptionUsedToImproveTheAccuracyOfLargeModelQualityInspectionItIsRecommendedToKeepWithinWords: 'Παρακαλούμε εισάγετε την επιχειρηματική περιγραφή, που χρησιμοποιείται για τη βελτίωση της ακρίβειας της μεγάλης ποιότητας επιθεώρησης μοντέλου, συνιστάται να κρατήσει μέσα σε 200 λέξεις.',
                        save: 'Αποθήκευση',
                    },
                },
            },
        },
        admin: {
            system: {
                index: {
                    name: 'Ρυθμίσεις συστήματος',
                    systemName: 'Όνομα συστήματος',
                    speakerRecognize: 'Ταυτοποίηση ηχείου',
                    massage: 'Ειδοποίηση μηνύματος',
                    evaluate: 'Τεχνητή γνωστική αξιολόγηση',
                    evaluateTip: 'Μετά το άνοιγμα, επιλέξτε γρήγορο έλεγχο στοιχεία ποιότητας επιθεώρησης και άμεση χειρωνακτική αξιολόγηση',
                    speakerRecognizeTip: 'Για να έχετε πρόσβαση σε μια κλήση τρίτων μέσω API, είναι απαραίτητο να προσδιοριστεί εάν το αριστερό κανάλι είναι εξυπηρέτηση πελατών ή πελάτης.',
                    speakerRecognizeTip2: 'Η καταγραφή ενός καναλιού ορίζει το ρόλο του πράκτορα μέσω αναγνώρισης κειμένου και διαμόρφωση ρόλου.',
                    enabledImSendStatusFilter: 'Φιλτράρισμα επιθεώρησης ποιότητας κειμένου',
                    enabledImSendStatusFilterTips: 'Το περιεχόμενο ανίχνευσης της ομιλίας του χειριστή στην επιθεώρηση ποιότητας δεν περιλαμβάνει μηνύματα στην κατάσταση του [Withtruwn], [Αποτυχία αποστολής] d] και [Μη αναγνωσμένο μηνύμα εκτός γραμμής]',
                    lang: 'Ρυθμίσεις γλώσσας συστήματος',
                    zh: 'Απλοποιημένα κινεζικά',
                    en: 'English',
                    tw: 'Παραδοσιακά κινέζικα',
                },
                template: {
                    maskChangeRecord: 'Αλλαγή αρχείου μάσκας',
                    singleMailQualityInspection: 'Επιθεώρηση ενιαίας αλληλογραφίας',
                    blockSMS: 'Μπλοκ SMS',
                    maskInternalRemarks: 'Εσωτερικές παρατηρήσεις μάσκας',
                    workOrderQualityInspectionMessageFiltering: 'Διάταξη εργασίας ποιότητας επιθεώρησης μηνύματος',
                    theMaskedDataIsOnlyDisplayedButDoesNotParticipateInIntelligentQualityInspection: 'Τα μασκοφόρα δεδομένα εμφανίζονται μόνο, αλλά δεν συμμετέχουν σε έξυπνη επιθεώρηση ποιότητας.',
                    multimodalQualityInspection: 'Επιθεώρηση πολυτροπικής ποιότητας',
                    useALargeMultimodalModelToCheckThePicturesAudioAndVideoInTheSession: 'Χρησιμοποιήστε ένα μεγάλο πολυτροπικό μοντέλο για να ελέγξετε τις εικόνες, το ήχο και το βίντεο στη συνεδρία.',
                    pictureRecognition: 'Αναγνώριση εικόνας',
                    largeModelLabelSaveFlowMode: 'Μεγάλο μοντέλο λειτουργία ροής εξοικονόμησης ετικέτας',
                    whenEnabledLargeModelMarkingIsPerformedOnlyForSmartTagsRelatedToSessionContent: 'Όταν ενεργοποιείται, η σήμανση μεγάλου μοντέλου εκτελείται μόνο για έξυπνες ετικέτες που σχετίζονται με το περιεχόμενο συνεδρίας',
                    largeModelQualityInspectionProvincialFlowMode: 'Μεγάλο μοντέλο επιθεώρησης επαρχιακής λειτουργίας',
                    afterEnabledLargeModelQualityInspectionIsPerformedOnlyForIntelligentModelRulesRelatedToSessionContent: 'Μετά την ενεργοποίηση, η επιθεώρηση μεγάλου μοντέλου ποιότητας πραγματοποιείται μόνο για έξυπνους κανόνες μοντέλου που σχετίζονται με το περιεχόμενο συνεδρίας.',
                    cambodian: 'Καμπότζη',
                    cantonese: 'Καντονέζικα',
                    korean: 'Κορεάτικα',
                    filipino: 'Φιλιππινέζικα',
                    largeModelSettings: 'Ρυθμίσεις μεγάλων μοντέλων',
                    forcedCustomerServiceOffline: 'Υπηρεσία εξαναγκασμένων πελατών offline υπηρεσίας',
                    afterOpeningWhenTheCustomerFailsToCompleteTheQualityTrainingTaskAccordingToTheTimeRequirementTheCustomerServiceWillBeForcedToGoOffline: 'Μετά το άνοιγμα, όταν ο πελάτης αποτυγχάνει να ολοκληρώσει την εργασία ποιότητας κατάρτισης σύμφωνα με την απαίτηση χρόνου, η εξυπηρέτηση πελατών θα αναγκαστεί να πάει εκτός σύνδεσης.',
                    indonesian: 'Ινδονησιακά',
                    vietnamese: 'Βιετναμέζικα',
                    portuguese: 'Πορτογαλική',
                    malay: 'Μαλαισία',
                    french: 'Γαλλικά',
                    spanish: 'Ισπανικά',
                    japanese: 'Ιαπωνικά',
                    thai: 'Ταϊλάνδης',
                    blockSystemSendingMessages: 'Μήνυμα αποστολής συστήματος μάσκας',
                    textDataDesensitization: 'Αποσυναισθητοποίηση δεδομένων',
                    whenTheSwitchIsTurnedOnTheDesensitizationFieldDropdownListWillBeDisplayedmultipleChoicesAreSupportedTheDesensitizationFieldsPersonNameMobileNumberAddress: 'Όταν ο διακόπτης είναι ενεργοποιημένος, εμφανίζεται η λίστα απευαισθητοπισμού πεδίου (υποστηρίζεται η πολλαπλή επιλογή). Τα πεδία απευαισθητοποίησης περιλαμβάνουν το όνομα του ατόμου, τον αριθμό κινητού τηλεφώνου και τη διεύθυνση.',
                    desensitizingField: 'Απευαισθητοποιημένο πεδίο',
                    name: 'Όνομα του προσώπου:',
                    cellphoneNumber: 'Αριθμός κινητού τηλεφώνου:',
                    address: 'Διεύθυνση',
                    dataCleaning: 'Καθαρισμός δεδομένων',
                    afterSettingTheConversationDataOfQCAndWeChatWillBeCleanedRegularlyAndCannotBeRecoveredPleaseBeCareful: 'Μετά τη θέση, η συνομιλία ποιότητας επιθεώρησης και τα δεδομένα της συνεδρίας WeChat θα καθαρίζονται τακτικά και δεν μπορούν να ανακτηθούν. Παρακαλώ χειρουργείτε προσεκτικά.',
                    newCleaningRules: 'Νέος κανόνας καθαρισμού',
                    qualityInspectionRuleApproval: 'Έγκριση των κανόνων επιθεώρησης ποιότητας',
                    afterOpeningTheModificationOfQualityInspectionRulesCanTakeEffectOnlyAfterBeingApproved: 'Μετά το άνοιγμα, η τροποποίηση του κανόνα επιθεώρησης ποιότητας πρέπει να εγκριθεί πριν αρχίσει να ισχύει.',
                    maskOfflineMessageUnread: 'Μήνυμα εκτός σύνδεσης μη αναγνωσμένα μηνύματα',
                    privacyNumberProtection: 'Προστασία αριθμού απορρήτου',
                    afterOpeningDesensitizeThecustomerPhoneFieldInTheCallWhichIsDisplayedAs1881: 'Μετά το άνοιγμα, απευαισθητοποιήστε το πεδίο "πελάτη τηλεφώνου" κατά τη διάρκεια της κλήσης και εμφάνισε το ως 1881 * * * * * * * * * * * *',
                    shieldingWithdrawn: 'Η μάσκα αποσύρθηκε.',
                    maskSendingFailed: 'Η αποστολή μάσκας απέτυχε',
                },
                component: {
                    conversation: 'Κλήση',
                    dialogue: 'Διάλογος',
                    weCom: 'Enterprise WeChat',
                    day: 'Ημέρα',
                    week: 'Εβδομάδα',
                    month: 'Μήνας',
                    year: 'Έτος',
                },
                components: {
                    dataDeleteConfigItem: {
                        scopeOfCleaning: 'Πεδίο εφαρμογής του καθαρισμού',
                        dataCleaningTimeSetting: 'Ρυθμίσεις χρόνου καθαρισμού δεδομένων',
                        afterCleanUpTheData: 'Μετά τον καθαρισμό των δεδομένων',
                        dataAfterComplaintCompletion: 'Δεδομένα μετά την παραγραφή',
                    },
                },
                coachSpeechRecognition: {
                    executionSuccessful: 'Επιτυχής εκτέλεση',
                    saveSuccessful: 'Αποθήκευση με επιτυχία',
                    speechRecognition: 'Αναγνώριση ομιλών',
                    reExecuteErrorCorrection: 'Διόρθωση σφαλμάτων επανεμβάσεις',
                    confirmExecution: 'Επιβεβαίωση εκτέλεσης',
                    voiceDetection: 'Ανίχνευση φωνής',
                    noiseDetectionPowerLevel: 'Ισχύς ανίχνευσης θορύβου Επίπεδο ≤',
                    pleaseEnterTheThreshold: 'Παρακαλώ εισάγετε ένα κατώτατο όριο',
                    volumeDetectionPowerLevel: 'Ισχύς ανίχνευσης όγκου Επίπεδο ≥',
                    reset: 'Επαναφοράς',
                    preserve: 'Αποθήκευση',
                },
                coachTemplate: {
                    french: 'Γαλλικά',
                    spanish: 'Ισπανικά',
                    japanese: 'Ιαπωνικά',
                    thai: 'Ταϊλάνδης',
                    loginPopupWindow: 'Παράθυρο αναδυόμενου σύνδεσης',
                    afterActivationAPopupPromptWillAppearWhenEnteringTheIntelligentAccompanimentSystem: 'Μετά το άνοιγμα, θα ζητηθεί ένα αναδυόμενο παράθυρο κατά την εισαγωγή του έξυπνου συστήματος sparring.',
                    title: 'Τίτλος',
                    text: 'Κείμενο',
                    checkBoxContent: 'Περιεχόμενο του πλαισίου ελέγχου',
                    informedConsentForm: 'Ενημερωμένη έντυπη συγκατάθεσης',
                    toHelpYouImproveYourCommunicationAndCommunicationSkillsAsWellAsTheApplicationOfProfessionalKnowledgeAllowingYouToPracticeAnytimeAnywhereAndReceiveRealtimeFeedbackWeWillCollectTheFollowingInformationFromYouThroughThisPlatform: 'Προκειμένου να σας βοηθήσει να βελτιώσετε τις δεξιότητες επικοινωνίας και ομιλίας και την εφαρμογή των επαγγελματικών γνώσεων, επιτρέποντας σας να εξασκηθείτε οποιαδήποτε στιγμή και οπουδήποτε και να λάβετε ανατροφοδότηση σε πραγματικό χρόνο, θα συλλέξουμε τις ακόλουθες πληροφορίες από εσάς μέσω αυτής της πλατφόρμας:',
                    iHaveFullyReadAndFullyUnderstoodThisInformedConsentFormAndSolemnlyDeclareThatIAgreeToProcessMySensitivePersonalInformationInAccordanceWithThePurposesAndMethodsStatedInThisInformedConsentForm: 'Έχω διαβάσει και κατανοήσει πλήρως αυτό το έντυπο ενημέρωσης συγκατάθεσης και συμφωνώ επίσημα να χειριστώ τις ευαίσθητες προσωπικές μου πληροφορίες σύμφωνα με την σκοπούς και τρόπος που αναφέρονται στο παρόν έντυπο ενημερωμένης συγκατάθεσης',
                },
                webPlugin: {
                    webPlugin: 'Πρόσθετο ιστού',
                    generateLink: 'Δημιουργία δεσμού',
                    link: 'Δεσμός',
                    pleaseEnterALink: 'Παρακαλώ εισάγετε έναν δεσμό',
                },
            },
            systemIntegration: {
                title: 'Ρυθμίσεις συστήματος',
                ccIntegrationTips: 'Ευφυής ποιότητας επιθεώρηση Docking Udesk Call Center Περιγραφή Έγγραφος',
                unauthorized: 'Μη εξουσιοδοτημένο',
                authorized: 'Επιτρεπόμενο',
                udeskDomain: 'Σύστημα εξυπηρέτησης πελατών',
                udeskToken: 'Κλειδί συστήματος πράκτορας',
                udeskAdminEmail: 'Λογαριασμός διαχειριστή συστήματος εξυπηρέτησης πελατών',
                password: 'Κωδικός πρόσβασης λογαριασμού διαχειριστή',
                applyAuth: 'Έγκριση',
                cancelAuth: 'Ακύρωση έγκρισης',
                reApplyAuth: 'Επανεάθεση',
                keyTips: 'Διαχείριση ιστορικού του συστήματος εξυπηρέτησης πελατών-ΕΠΑ',
            },
            customerField: {
                title: 'Πεδίο πελατών',
                table: {
                    propName: 'Όνομα πεδίου',
                    propDesc: 'Περιγραφή πεδίου',
                    valueType: 'Τύπος πεδίου',
                    propType: 'Μέθοδος δημιουργίας',
                    createTime: 'Χρόνος δημιουργίας',
                    canNotEdit: 'Τα πεδία συστήματος δεν υποστηρίζουν επεξεργασίας',
                },
                edit: 'Επεξεργασία πεδίους',
                new: 'Νέο πεδίο',
            },
            wechatDocking: {
                title: 'Επιχειρησιακή μικροποίηση',
                formLabels: {
                    companyId: 'Ταυτότητα επιχειρήσεων',
                    communicationKey: 'Κλειδί επικοινωνίας',
                    token: 'Token',
                    encodingAESKey: 'EncodingAESKey',
                    url: 'URL επαναφοράς γεγονότων',
                    applicationName: 'Όνομα εφαρμογής',
                    applicationId: 'ID εφαρμογής ιστού',
                    applicationSecret: 'Εφαρμογή του απόρρητου',
                },
                formTitle: {
                    initialForm: 'Αρχική ρύθμιση',
                    synchronizeForm: 'Συγχρονισμός βιβλίου διευθύνσεων',
                    settingForm: 'Ρυθμίσεις εφαρμογών',
                },
                qrCodeUrlTip: 'Παρακαλώ ζητήστε από τον διαχειριστή να σαρώσει τον παρακάτω δισδιάστατο κώδικα για να δεσμευθεί η εφαρμογή ανάπτυξης.',
            },
            taobao: {
                formLabels: {
                    name: 'Όνομα αποθήκευσης',
                    account: 'Αριθμός λογαριασμού',
                    password: 'Κωδικός πρόσβασης',
                    confirm: 'Επιβεβαίωση κωδικού πρόσβασης',
                    authorization: 'Έγκριση',
                    switchOn: 'Άνοιγμα:',
                    switchOff: 'Κλείσιμο',
                },
                tableLabels: {
                    name: 'Όνομα αποθήκευσης',
                    account: 'Αριθμός λογαριασμού',
                    authorization: 'Έγκριση',
                    updateUser: 'Πρόσφατα ενημερωμένο άτομο',
                    updateTime: 'Τελευταία ώρα ενημέρωσης',
                },
            },
            weifengDocking: {
                formLabels: {
                    secondaryDomain: 'Όνομα δευτερεύουσας χώρου Weifeng',
                    secretKeyTip: 'Το μυστικό κλειδί του ενοικιαστή λαμβάνεται στον τόπο προσάρτησης του συστήματος υπόβαθρο του συστήματος Weifeng.',
                },
            },
            user: {
                index: {
                    name: 'Διαχείριση εργαζομένων',
                    existingUsers: 'Υπάρχουν ήδη υπάλληλοι.',
                    deleteSuccess: 'Διαγραφή με επιτυχία',
                    deleteFailed: 'Η διαγραφή απέτυχε',
                },
                detail: {
                    accountPrompt: 'Παρακαλώ εισάγετε e- mail',
                    resetPassword: 'Επαναφορά κωδικού πρόσβασης',
                    passwordPrompt: 'Κωδικός πρόσβασης (6-14 συνδυασμός γραμμάτων και αριθμών)',
                    originPasswordPrompt: 'Παρακαλώ εισάγετε τον αρχικό κωδικό πρόσβασης',
                    resumePasswordPrompt: 'Παρακαλώ εισάγετε ξανά τον κωδικό πρόσβασης σας',
                    passwordFormWrong: 'Παρακαλώ εισάγετε ένα συνδυασμό από 6-14 γράμματα και αριθμούς!',
                    resumePasswordWrong: 'Δύο κωδικοί πρόσβασης δεν είναι συνεπείς!',
                    suppertImageType: 'Υποστήριξη jpg, gif, png, μέγιστο 500Kb',
                    namePrompt: 'Παρακαλώ εισάγετε ένα όνομα',
                    nickNamePrompt: 'Παρακαλώ εισάγετε ένα ψευδώνυμο',
                    telephonePrompt: 'Παρακαλώ εισάγετε αριθμό τηλεφώνους',
                    roleSelectedPrompt: 'Παρακαλώ επιλέξτε ένα ρόλο',
                    agentIdPrompt: 'Παρακαλώ εισάγετε τον αριθμό εργασίας',
                    disabled: 'Απενεργοποίηση',
                    enabled: 'Ενεργοποίηση ενεργοποίησης',
                    reloadBowerInfo: 'Αλλαγές πληροφοριών χρήστη, ανάγκη ανανέωσης του περιηγητή;',
                    saveUserError: 'Αποτυχία αποθήκευσης πληροφοριών χρήστη, παρακαλώ προσπαθήστε ξανά αργότερα.',
                    resetPasswordSuccess: 'Επιτυχής επαναφορά κωδικού πρόσβασης',
                    resetPasswordFailed: 'Η επαναφορά κωδικού πρόσβασης απέτυχε, παρακαλώ προσπαθήστε ξανά αργότερα.',
                },
            },
            userGroups: {
                index: {
                    name: 'Διαχείριση των εργαζομένων ομάδων',
                    existingUserGroups: 'Υφιστάμενη ομάδα εργαζομένων',
                },
            },
            role: {
                index: {
                    name: 'Διαχείριση ρόλων',
                    existingRoles: 'Υπάρχοντες Ρόλοι',
                },
                edit: {
                    editRole: 'Επεξεργασία ρόλου',
                    createRole: 'Δημιουργία ρόλου',
                    basicInfo: 'Βασικές πληροφορίες',
                    taskPermissions: 'Άδειες εργασίας',
                    existingTasks: 'Ήδη εργασίες',
                },
            },
            anomalousData: {
                title: 'Μη φυσιολογικά δεδομένα',
                list: {
                    selectHolder: 'Παρακαλώ επιλέξτε μια πηγή δεδομένων',
                    businessTime: 'Χρόνος επαγγελματίας',
                    businessId: 'Αναγνώριση επαγγελματικής κατάστασηςName',
                    export: 'Εξαγωγή',
                },
            },
            templateComponent: {
                list: {
                    title: 'Αγορά προτύπων',
                    name: 'Όνομα πρότυπου',
                    searchHolder: 'Παρακαλώ εισάγετε το περιεχόμενο για ερώτηση',
                    update: 'Ενημέρωση',
                    sort: 'Ταξινόμηση',
                    moduleType: 'Τύπος προτύπου',
                    moduleSourceType: 'Εφαρμοστέος τύπος',
                    fetchNum: 'Αριθμός αποκτηθέντων φορών',
                    newest: 'Πρόσφατα ενημέρωσης',
                    usedMost: 'Πάρτε τα περισσότερα.',
                    call: 'Κλήση',
                    dialogue: 'Διάλογος',
                    waiting: 'Προς επανεξέταση',
                    cancel: 'Ακύρωση δημοσίευσης',
                    success: 'Εγκρίθηκε και δημοσιεύθηκε.',
                    failed: 'Απόρριψη ελέγχου',
                    no: 'Μη αναβαθμίσιμο',
                    ok: 'Μπορεί να αναβαθμίσεις',
                    all: 'Όλα',
                    delete: 'Διαγραφή με επιτυχία',
                    downOk: 'Αφαίρεση',
                    withdraw: 'Πέτυχε η απόσυρση.',
                    updateOk: 'Επιτυχής αναβάθμιση',
                    get: 'Φύγε.',
                    width: 'Απόσυρση',
                    getOk: 'Επιτυχία απόκτησης',
                    orgName: 'Οργάνωση',
                    nowVersion: 'Τρέχουσα έκδοση',
                    lastedVersion: 'Τελευταία έκδοση',
                    appStatus: 'Κατάσταση εφαρμογής',
                    actions: 'Λειτουργία',
                    down: 'Από το ράφι.',
                    updateTop: 'Αναβάθμιση',
                    check: 'Προβολή',
                    deleteWhen: 'Επιβεβαίωση διαγραφής;',
                    yes: 'Μάλιστα.',
                    noo: 'Οχι',
                    deleteOk: 'Διαγραφή',
                    permissible: 'Επιτρεπόμενο',
                    noPermissible: 'Δεν επιτρέπεται',
                    openUp: 'Άνοιγμα:',
                    openDown: 'Μη ανοιχτός',
                    task: 'Εργασία επιθεώρησης',
                    point: 'Σημείο επιθεώρησης ποιότητας',
                    tag: 'Σημασιολογική ετικέτας',
                    muti: 'Πολλαπλά στοιχεία',
                    inter: 'Μια ερώτηση και μία απάντηση',
                    info: 'Φορέας πληροφορίας',
                    concept: 'Λέξεις έννοιας',
                    detail: 'Λεπτομέρειες ενότητας',
                    infomation: 'Βασικές πληροφορίες',
                    detailConfig: 'Λεπτομερείς ρυθμίσεις',
                    twoEdit: 'Δευτεροβάθμια επεξεργασίας',
                    mustUpdate: 'Αναβάθμιση τώρα',
                    descition: 'Περιγραφή πρότυπου',
                    descitionSize: 'Η περιγραφή προτύπου δεν μπορεί να υπερβαίνει τα 250 λέξεις',
                    stencilsDetail: 'Λεπτομέρειες πρότυπου',
                    updatedRecords: 'Ενημέρωση αρχείου',
                    version: 'Αριθμός έκδοσης',
                    updateDescription: 'Ενημέρωση περιγραφή',
                    myModule: 'Πρότυπο μου',
                    addModule: 'Νέο ενότηταName',
                    publishVersion: 'Έκδοση έκδοσης',
                    earliestVersion: 'Η πρώτη έκδοση',
                    edit: 'Επεξεργασία',
                    add: 'Νέο',
                    configNo: 'Οι λεπτομέρειες ρυθμίσεων ενότητας δεν μπορούν να είναι κενά',
                    updateNo: 'Η περιγραφή ενημέρωσης δεν μπορεί να είναι κενή',
                    editSuccess: 'Επιτυχία τροποποίησης',
                    saveSuccess: 'Αποθήκευση με επιτυχία',
                    newer: 'Ενημέρωση',
                    sumbit: 'Υποβολή',
                    cancelName: 'Ακύρωση',
                    nameRequired: 'Το όνομα ενότητας είναι ένα απαιτούμενο πεδίο',
                    nameSize: 'Το όνομα ενότητας δεν μπορεί να υπερβαίνει 16 χαρακτήρων',
                    publishStatus: 'Κατάσταση δημοσίευσης',
                    submitUpdate: 'Υποβολή ενημέρωσης',
                    updateVersion: 'Ενημέρωση έκδοσης',
                    updateExplain: 'Ενημέρωση περιγραφή',
                },
            },
            customDataSource: {
                amazonEcommerce: 'Ηλεκτρονικό εμπόριο του Αμαζονίου',
                youtubeVideo: 'Youtube βίντεο',
                amazon: {
                    component: {
                        queuing: 'Στη γραμμή',
                        notStarted: 'Δεν ξεκίνησες',
                        inProgress: 'Σε εξέλιξη.',
                        success: 'Επιτυχία',
                        failed: 'Αποτυχία',
                        successfullyCreated: 'Δημιουργήθηκε επιτυχώς.',
                        editedSuccessfully: 'Επεξεργάστηκε με επιτυχία',
                        operationSucceeded: 'Επιτυχία λειτουργίας',
                        deletedSuccessfully: 'Διαγραφή με επιτυχία',
                        link: 'Δεσμός',
                        grabState: 'Πάρτε κατάσταση κατάσταση κατάστασης',
                        updateTime: 'Ώρα ενημέρωσης',
                        grab: 'Άρπαξε.',
                        edit: 'Επεξεργασία',
                    },
                    template: {
                        amazonEcommerce: 'Ηλεκτρονικό εμπόριο του Αμαζονίου',
                        thisProduct: 'Αυτό το προϊόν',
                        competition: 'Ανταγωνισμός',
                        new: 'Νέο',
                        edit: 'Επεξεργασία',
                        link: 'Δεσμός',
                    },
                },
                youtube: {
                    template: {
                        youtubeVideo: 'Youtube βίντεο',
                        thisProduct: 'Αυτό το προϊόν',
                        competition: 'Ανταγωνισμός',
                        new: 'Νέο',
                        edit: 'Επεξεργασία',
                        link: 'Δεσμός',
                    },
                    component: {
                        queuing: 'Στη γραμμή',
                        notStarted: 'Δεν ξεκίνησες',
                        inProgress: 'Σε εξέλιξη.',
                        success: 'Επιτυχία',
                        failed: 'Αποτυχία',
                        successfullyCreated: 'Δημιουργήθηκε επιτυχώς.',
                        editedSuccessfully: 'Επεξεργάστηκε με επιτυχία',
                        operationSucceeded: 'Επιτυχία λειτουργίας',
                        deletedSuccessfully: 'Διαγραφή με επιτυχία',
                        youTubeVideoLink: 'Σύνδεσμος βίντεο στο YouTube',
                        grabState: 'Πάρτε κατάσταση κατάσταση κατάστασης',
                        updateTime: 'Ώρα ενημέρωσης',
                        grab: 'Άρπαξε.',
                        edit: 'Επεξεργασία',
                    },
                },
            },
        },
        demo: {
            title: 'Ευφυής επιθεώρηση ποιότητας',
            template: 'Επιλέξτε πρότυπο επιθεώρησης ποιότητας',
            radio: 'Επιλέξτε τη φόρμα εγγραφής',
            uploadAudio: 'Αποστολή εγγραφής',
            uploadAudioTip: 'Η αποστολή καταγραφής υποστηρίζει μόνο μορφές wav και mp3, και το μέγεθος δεν υπερβαίνει το 1G',
            uploadText: 'Αποστολή κειμένου:',
            uploadTextTip: 'Το ανεβασμένο κείμενο υποστηρίζει μόνο μορφές srt και txt, και το μέγεθος δεν υπερβαίνει τα 10M. Μετά την αποστολή του κειμένου, η ASR δεν θα χρησιμοποιηθεί πλέον για την ανάλυση του αρχείου καταγραφής.',
            uploadSuccess: 'Η εγγραφή αρχείου αποστολήθηκε με επιτυχία',
            uploadFailed: 'Αποτυχία αποστολής αρχείου εγγραφής',
            startQualityInspection: 'Έναρξη επιθεώρησης ποιότητας',
            qualityInspectionStarted: 'Επιθεώρηση ποιότητας εν εξελίξει',
            downloadText: 'Λήψη κειμένουComment',
            checking: 'Πρόοδος επιθεώρησης ποιότητας',
            checkingTip: 'Αναμένεται να πάρει λίγα λεπτά, παρακαλώ να είστε υπομονετικοί.',
            noCheckContent: 'Δεν έχει ακόμη αποτελέσματα επιθεώρησης ποιοτικού ελέγχου.',
            noTextDownload: 'Δεν μπορεί να κατεβάσει κείμενο επιθεώρησης ποιότητας!',
            pleaseCheckParams: 'Παρακαλώ ελέγξτε αν θα επιλέξετε το πρότυπο, τον τύπο φωνής και ανεβάστε το αρχείο εγγραφής',
            inspectionFailed: 'Η επιθεώρηση ποιότητας απέτυχε, παρακαλώ δοκιμάστε ξανά αργότερα!',
        },
        wechatQa: {
            baseInfo: {
                title: 'Βασικές πληροφορίες',
            },
            conversationSetting: {
                title: 'Ρυθμίσεις συνεδρίας',
                segmentationStrategy: 'Στρατηγική τεμαχία',
                rule: 'Στρατηγική',
                time: 'Χρόνος κοπής',
                daily: 'Κάθε μέρα.',
                passScore: 'Επιλέξιμο βαθμολογία',
                ruleLogic: 'Λογική εκτέλεσης',
            },
            message: {
                title: 'Πίεση γεγονότων',
                table: {
                    index: 'Αύξων αριθμός',
                    name: 'Όνομα',
                    type: 'Λειτουργία ώθησης',
                    desc: 'Περιγραφή',
                    status: 'Κατάσταση',
                },
                subTitle: 'Λίστα γεγονότων',
            },
            checkPoint: {
                title: 'Μοντέλο ανάλυσης',
                groups: 'Μοντέλο ομαδοποίησης',
                newClassification: 'Νέα ομάδας',
                editClassification: 'Επεξεργασία ομαδοποίησης',
                benchmarkScore: 'Βαθμολογία αναφοράς',
                pointCount: 'Κοινό μοντέλο ανάλυσης υπό την τρέχουσα κατάταξη',
                openPointCount: 'Αριθμός ενεργοποίησης είναι:',
                closedPointCount: 'Η απενεργοποιημένη ποσότητα είναι:',
                scoreLowerLimit: 'Ελάχιστη βαθμολογία',
                scoreUpperLimit: 'Μέγιστο κάλυμμα βαθμολογίας',
                classificationName: 'Όνομα ομάδας',
                classificationNamePlaceHolder: 'Παρακαλώ εισάγετε ένα όνομα ομάδας',
                classificationRemark: 'Περιγραφή ομάδας',
                classificationRemarkPlaceHolder: 'Παρακαλώ εισάγετε μια περιγραφή ομάδας',
            },
            chartRecord: {
                title: 'Συνεδρία WeChat Enterprise',
                table: {
                    id: 'ID συνεδρίας',
                    type: 'Τύπος συνεδρίας',
                    startTime: 'Ώρα έναρξης συνεδρίας',
                    endTime: 'Τελευταία ώρα τέλους συνεδρίας',
                    groupId: 'Ομάδα ID',
                    client: 'Πελάτη',
                    customer: 'Υπηρεσία πελατών',
                    averageScore: 'Μέση βαθμολογία επιθεώρησης ποιότητας',
                },
                detail: {
                    title: 'Λεπτομέρειες συνεδρίας WeChat Enterprise',
                    inspectionInfo: 'Πληροφορίες ανάλυσης',
                    chartInfo: 'Πληροφορίες συνεδρίας',
                    tasks: 'Ανάλυση',
                    avgScore: 'Μέσος βαθμός ανάλυσης',
                    qualified: 'Προσδιορισμένο',
                    unqualified: 'Μη επιλέξιμε',
                    taskTitle: 'Εφαρμοστέο πρότυπο ανάλυσης',
                    info: 'Ανάλυση πληροφοριών σε πραγματικό χρόνο σε πραγματικό χρόνο.',
                    today: 'Σημερινά νέα',
                    history: 'Ιστορικά μηνύματα',
                    components: {
                        filter: {
                            index: {
                                pleaseEnterACommentNickname: 'Παρακαλώ εισάγετε ένα σχόλιο',
                                pleaseEnterTheGroupChatName: 'Παρακαλώ εισάγετε ένα όνομα ομάδας συνομιλίας',
                            },
                        },
                    },
                    template: {
                        whole: 'Όλα',
                    },
                },
            },
            realTimeAnalysis: {
                title: 'Ανάλυση πραγματικού χρόνου',
                table: {
                    name: 'Όνομα σκηνής',
                    count: 'Αριθμός μοντέλων ανάλυσης',
                    baseScore: 'Βαθμολογία αναφοράς',
                    passScore: 'Προσδιορισμένη βαθμολογία',
                    maxScore: 'Μέγιστο κάλυμμα βαθμολογίας',
                    minScore: 'Ελάχιστη βαθμολογία',
                    status: 'Κατάσταση',
                    actions: 'Λειτουργία',
                },
                detail: {
                    title: 'Ανάλυση σεναρίων',
                    form: {
                        name: 'Όνομα σκηνής',
                        prevCondition: 'Συνθήκες ενεργοποίησης σεναρίου',
                        prevConditionToolTip: 'Εάν η κατάσταση είναι κενή, το σενάριο αναλύεται ως προκαθορισμένο',
                        prevConditionError: 'Οι συνθήκες ενεργοποίησης σενάριο δεν μπορούν να συμπίπτουν με το μοντέλο ανάλυσης.',
                        scoreInputPlaceholder: 'Εισάγετε βαθμό',
                        baseScore: 'Βαθμολογία αναφοράς',
                        status: 'Κατάσταση',
                        passScore: 'Προσδιορισμένη βαθμολογία',
                        maxScore: 'Μέγιστο όριο βαθμολογίας',
                        minScore: 'Κάτω όριο ελάχιστης βαθμολογίας',
                        analysisModel: 'Μοντέλο ανάλυσης',
                        message: 'Ειδοποίηση ενεργοποίησης',
                        pushType: 'Λειτουργία ώθησης',
                        createAnalysisModel: 'Προσθήκη μοντέλου',
                        scoreUpperLimitError: 'Το κατώτατο όριο της ελάχιστης βαθμολογίας δεν μπορεί να είναι μεγαλύτερο από το ανώτατο όριο της μέγιστης βαθμολογίας.',
                        table: {
                            name: 'Ονοματεπώνυμο',
                            rule: 'Κανόνες',
                            score: 'Βαθμολογία',
                        },
                        pushConfigSwitchTip1: 'Όταν εμφανιστεί η σκηνή',
                        pushConfigSwitchTip2: 'Ώρες και πάνω, ειδοποιήσεις',
                    },
                },
            },
            smartCustomerTag: {
                title: 'Έξυπνο επισήμανση πελατών',
                table: {
                    name: 'Όνομα κανόνας',
                    tags: 'Επιχειρησιακή ετικέτα μικρο πελάτης',
                    status: 'Ενεργοποιημένη κατάσταση',
                    createUser: 'Δημιουργός',
                    createTime: 'Χρόνος δημιουργίας',
                },
                detail: {
                    name: 'Όνομα κανόνας',
                    condition: 'Ορισμός κανόνων',
                    logic: 'Λογική',
                    status: 'Ενεργοποιημένη κατάσταση',
                    tags: 'Επιλογή ετικέτας',
                },
            },
            setting: {
                wechatQaCustomerLabel: {
                    template: {
                        numberOfCustomerTags: 'Ποσότητα',
                    },
                },
                messageFiltering: {
                    template: {
                        edit: 'Επεξεργασία',
                        messageContent: 'Περιεχόμενο μηνύματος',
                        messageTypeID: 'ID τύπου μηνύματος',
                        messageTypeDescription: 'Τύπος μηνύματος',
                        messageFiltering: 'Φίλτρα μηνυμάτων',
                        suitableForFilteringDataWithoutQualityInspection: 'Κατάλληλο για φιλτράρισμα δεδομένων χωρίς επιθεώρηση ποιότητας',
                        create: 'Δημιουργία δημιουργίας',
                        messageDescription: 'Περιγραφή μηνύματος',
                    },
                },
            },
            chartAudioRecord: {
                index: {
                    talkTime: 'Ώρα για ομιλία.',
                    sessionType: 'Τύπος συνεδρίας',
                    whole: 'Όλα',
                    staff: 'Εργαζόμενος',
                    customer: 'Πελάτη',
                    callKeywords: 'Λέξεις κλειδιά κλήσης',
                },
                detail: {
                    template: {
                        enterpriseMicroVoiceCallDetails: 'Λεπτομέρειες κλήσης επιχειρήσεων',
                    },
                },
            },
            wechatQaChartRecordEntry: {
                sessionArchiving: 'Αρχείο συνεδρίας',
                voiceCall: 'Κλήση φωνής',
                noMoreVoiceCalls: 'Τέρμα οι φωνητικές κλήσεις',
                enterpriseWechatVoiceCall: 'Enterprise WeChat φωνή κλήσης',
                enterpriseWechatConversationDetails: 'Λεπτομέρειες συνεδρίας WeChat Enterprise',
                previous: 'Προηγούμενο άρθρο:',
                next: 'Επόμενο άρθρο:',
            },
            dashboard: {
                template: {
                    enterpriseMicroConversationAnalysisTask: 'Ανάλυση μικροσυνόδου επιχειρήσεων',
                    enterpriseAndMicroVoiceAnalysisTask: 'Έργο ανάλυσης μικροφωνίας Enterprise',
                },
            },
            wechatQaTaskManagerEntry: {
                analysisOfEnterpriseWeChatGroupChat: 'Ανάλυση της ομάδας συνομιλίας Enterprise WeChat',
            },
            wechatQaSettingEntry: {
                messageFiltering: 'Φίλτρα μηνυμάτων',
            },
        },
        businessAnalysis: {
            keyword: 'Όνομα αναφοράς',
            createUser: 'Δημιουργός',
            createTime: 'Χρόνος δημιουργίας',
            updateTime: 'Ώρα ενημέρωσης',
        },
        semanticIntelligence: {
            agent: 'Πράκτορα',
            externalInterface: {
                detail: {
                    components: {
                        interfaceTest: {
                            index: {
                                testInterface: 'Διεπαφή δοκιμής',
                                testPassed: 'Η δοκιμή πέρασε',
                                testNotPassed: 'Η δοκιμή δεν πέρασε',
                                request: 'Αίτηση',
                                resultReturnedAfterParsing: 'Αποτέλεσμα επέστρεψε μετά την ανάλυση',
                                collapseAPIInteraction: 'Σύμπτυξη API αλληλεπίδρασης',
                                viewAPIInteractions: 'Προβολή αλληλεπιδράσεων API',
                            },
                        },
                        paramsList: {
                            components: {
                                valuePlain: {
                                    index: {
                                        pleaseEnterAPathExpression: 'Παρακαλώ εισάγετε μια έκφραση διαδρομής',
                                    },
                                },
                                valueSpecial1: {
                                    components: {
                                        randomFieldSelectList: {
                                            index: {
                                                pleaseSelect: 'Παρακαλώ επιλέξτε.',
                                                followthepathField: 'Πεδίο παρακολούθησης',
                                            },
                                        },
                                    },
                                    index: {
                                        informationEntity: 'Φορέας πληροφορίας',
                                        followthepathField: 'Πεδίο παρακολούθησης',
                                    },
                                },
                            },
                            index: {
                                pleaseEnterAParameterName: 'Παρακαλώ εισάγετε ένα όνομα παραμέτρου',
                                addInterfaceParameters: 'Προσθήκη παραμέτρων διεπαφής',
                            },
                        },
                    },
                    index: {
                        testNotPassed: 'Η δοκιμή δεν πέρασε',
                        saveSuccessful: 'Αποθήκευση με επιτυχία',
                        interfaceName: 'Όνομα διεπαφής',
                        pleaseEnterInterfaceName: 'Παρακαλώ εισάγετε όνομα διασύνδεσης',
                        interfaceDescription: 'Περιγραφή διεπαφής',
                        pleaseEnterInterfaceDescription: 'Παρακαλώ εισάγετε περιγραφή διεπαφής',
                        validity: 'Αποτελεσματικότητα',
                        pleaseSelectEffectivity: 'Παρακαλώ επιλέξτε αποτελεσματικότητα',
                        effective: 'Αποτελεσματικό',
                        invalid: 'Μη έγκυρο',
                        dataSource: 'Πηγή δεδομένων',
                        pleaseSelectADataSource: 'Παρακαλώ επιλέξτε μια πηγή δεδομένων',
                        requestMethod: 'Μέθοδος αίτησης',
                        pleaseSelectARequestMethod: 'Παρακαλώ επιλέξτε μια μέθοδο αιτήματος',
                        requestAddress: 'Διεύθυνση αίτησης',
                        pleaseEnterTheRequestAddress: 'Παρακαλώ εισάγετε τη διεύθυνση της αίτησης',
                        requestParameters: 'Παράμετροι αίτησης',
                        pleaseAddRequestParameters: 'Παρακαλώ προσθέστε παραμέτρους αίτησης',
                        returnParameter: 'Παράμετρος επιστροφής',
                        pleaseAddAReturnParameter: 'Παρακαλώ προσθέστε μια παράμετρος επιστροφής',
                        editExternalInterface: 'Επεξεργασία εξωτερικού διεπαφής',
                        newExternalInterface: 'Νέα εξωτερική διεπαφή',
                    },
                },
                index: {
                    operationSuccessful: 'Επιτυχία λειτουργίας',
                    name: 'Όνομα',
                    interfaceDescription: 'Περιγραφή διεπαφής',
                    dataSource: 'Πηγή δεδομένων',
                    requestMethod: 'Μέθοδος αίτησης',
                    requestAddress: 'Διεύθυνση αίτησης',
                    creationTime: 'Χρόνος δημιουργίας',
                    validity: 'Αποτελεσματικότητα',
                    externalInterface: 'Εξωτερική διεπαφή',
                    pleaseEnterAKeyword: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
                },
            },
            applicationMessageType: 'Τύπος μηνύματος εφαρμογής',
            intelligentModel: {
                components: {
                    promptArea: {
                        index: {
                            qualityInspectionRequirements: 'Απαιτήσεις επιθεώρησης ποιότητας',
                            outputSpecification: 'Προδιαγραφή εξόδου',
                            pleaseImproveTheConfiguration: 'Παρακαλώ τελειοποιήστε τη διαμόρφωσης',
                            generatePromptLanguage: 'Δημιουργήθηκε άμεση',
                        },
                        components: {
                            optimization: {
                                index: {
                                    failedToOptimizePrompt: 'Αποτυχία βελτιστοποίησης άμεσης',
                                    pleaseEnterACommand: 'Παρακαλώ εισάγετε μια εντολής',
                                    pleaseBecomeAPromptWord: 'Παρακαλώ γίνετε μια γρήγορη λέξη.',
                                    optimizationPrompt: 'Εικόνα βελτιστοποίησης',
                                    ifThePromptContainsVariablesTheVariablesNeedToBeReinsertedAfterThePromptIsOptimized: 'Αν η ερμηνεία περιέχει μεταβλητές, οι μεταβλητές πρέπει να επανεκχωρηθούν μετά τη βελτιστοποίηση της αίτησης.',
                                    cancel: 'Ακύρωση',
                                    application: 'Εφαρμογή',
                                    instruction: 'Οδηγία',
                                    generate: 'Δημιουργία δημιουργίας',
                                    promptWordGenerated: 'Δημιουργήθηκε η λέξη άμεσης',
                                },
                            },
                        },
                    },
                    typeSelect: {
                        index: {
                            whetherItMeetsTheRequirements: 'Συμμόρφωση',
                            gradedEvaluation: 'Αξιολόγηση βαθμού',
                        },
                    },
                    training: {
                        index: {
                            pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                            pleaseGeneratePrompt: 'Παρακαλώ δημιουργία άμεσων',
                            pleaseSelectADialogue: 'Παρακαλώ επιλέξτε ένα διάλογο',
                            training: 'Κατάρτιση',
                            dataType: 'Τύπος δεδομένων:',
                            voiceCall: 'Κλήση φωνής',
                            textDialogue: 'Διάλογο κειμένου',
                            generate: 'Δημιουργία δημιουργίας',
                            qualityInspectionResults: 'Αποτελέσματα επιθεώρησης ποιότητας:',
                            hit: 'Χτύπημα:',
                        },
                    },
                },
                detail: {
                    index: {
                        modelName: 'Ονοματεπώνυμο',
                        pleaseEnterTheModelNameForExampleIsThereASituationWhereCustomerServiceIsInactive: 'Παρακαλώ εισάγετε το όνομα του μοντέλου, για παράδειγμα, αν ο πράκτορας δεν έχει ενέργεια.',
                        modelDescription: 'Περιγραφή μοντέλου',
                        canYouProvideADetailedDescriptionOfTheContentYouNeedToTestForTheModelsUnderstandingSuchAsWhetherThereIsASituationWhereCustomerServiceIsInactiveThatIsCustomerServiceHasRespondedToCustomerInquiriesButTheCustomersQuestionsHaveNotBeenAddressedThroughoutOrTheResponseContentIsUnrelatedToTheCustomersResponse: 'Μπορείτε να περιγράψετε λεπτομερώς τι πρέπει να δοκιμάσετε, το οποίο είναι εύκολο για το μοντέλο να καταλάβει. Για παράδειγμα, αν η εξυπηρέτηση πελατών δεν έχει δράση, δηλαδή, η εξυπηρέτηση πελατών έχει απαντήσει στην ερώτηση του πελάτη, αλλά η ερώτηση του πελάτη δεν έχει αντιμετωπιστεί ή το περιεχόμενο της απάντησης δεν έχει καμία σχέση με την απάντηση του πελάτη.',
                        validity: 'Αποτελεσματικότητα',
                        effective: 'Αποτελεσματικό',
                        invalid: 'Μη έγκυρο',
                        type: 'Τύπος',
                        hintLanguage: 'Ζήτηση',
                        editIntelligentModel: 'Επεξεργασία Έξυπνου Μοντέλου',
                        createANewIntelligentModel: 'Νέο έξυπνο μοντέλο',
                    },
                },
                index: {
                    updateTime: 'Ώρα ενημέρωσης',
                    modelName: 'Ονοματεπώνυμο',
                    modelDescription: 'Περιγραφή μοντέλου',
                    type: 'Τύπος',
                    whetherItMeetsTheRequirements: 'Συμμόρφωση',
                    gradedEvaluation: 'Αξιολόγηση βαθμού',
                    validity: 'Αποτελεσματικότητα',
                    intelligentModel: 'Ευφυές μοντέλο',
                    applicableToSubjectiveQualityInspectionsuchAsWhetherTheQualityInspectionServiceAttitudeIsEnthusiasticWhetherTheServiceIsPatientEtc: 'Εφαρμόζεται στην υποκειμενική επιθεώρηση της ποιότητας (όπως εάν η στάση της υπηρεσίας επιθεώρησης ποιότητας είναι ενθουσιώδης και κατά πόσον υπηρεσία είναι ασθενής)',
                },
            },
            clusterAnalysis: 'Ανάλυση συστάδων',
            speechMining: 'Λέξεις Εξόρυξης',
            informationEntities: {
                detail: {
                    batchImportOfInformationEntitiesThroughTheAPIInterfaceIsSupportedEditingIsNotSupportedAfterSavingTheAPIName: 'Μπορείτε να εισάγετε φορείς πληροφοριών σε παρτίδες μέσω της διεπαφής API. Αφού αποθηκεύεται το όνομα API, δεν μπορεί να επεξεργαστεί.',
                    template: {
                        language: 'Γλώσσα',
                    },
                },
                component: {
                    language: 'Γλώσσα',
                    nothing: 'Κανένα',
                },
                template: {
                    language: 'Γλώσσα',
                },
            },
            knowledgeBase: {
                index: {
                    language: 'Γλώσσα',
                    classification: 'Ταξινόμηση',
                    import: 'Εισαγωγή',
                    importKnowledgeBase: 'Εισαγωγή βάσης γνώσης',
                    moveKnowledgePointsInBatch: 'Σημεία γνώσης',
                    moveTo: 'Μετακίνηση:',
                    pleaseSelectTheKnowledgePointsToBeMovedInBatch: 'Παρακαλώ επιλέξτε τα σημεία γνώσης που θα μετακινηθούν σε παρτίδες',
                },
                detail: {
                    index: {
                        language: 'Γλώσσα',
                        intrasentence: 'Εντός της πρότασης',
                        afterProblem: 'Μετά το πρόβλημα.',
                    },
                },
            },
            semanticTags: {
                component: {
                    numberOfReferences: 'Αριθμός αναφορών',
                    language: 'Γλώσσα',
                    nothing: 'Κανένα',
                },
                detail: {
                    template: {
                        largeModelAutomaticallyExpandsSimilarSentences: 'Μεγάλο μοντέλο επεκτείνει αυτόματα παρόμοιες προτάσεις.',
                        nLPAutoextendedSimilarSentences: 'Παρόμοιες προτάσεις NLP',
                        automaticExpansionOfSimilarSentences: 'Αυτόματη επέκταση παρόμοιων προτάσεων',
                        nLPExtendedSimilarSentences: 'Παρόμοιες προτάσεις NPP',
                        largeModelExtendedSimilarSentences: 'Μεγάλο μοντέλο επεκταμένες παρόμοιες προτάσεις',
                        oneclickOptimization: 'Βελτιστοποίηση ενός κλικ',
                        excludeRegularExpressionsSupportFillingInMultipleLinesWhenFillingInMultipleLinesTheLogicIsThatAnyHitCanBeEstablished: 'Εξαίρεση κανονικών εκφράσεων υποστήριξης συμπλήρωσης σε πολλαπλές γραμμές. Όταν συμπληρώνετε πολλαπλές γραμμές, η λογική είναι ότι κάθε επιτυχία μπορεί να καθιερωθεί.',
                        recallRegularTip: 'Ανακαλύψτε τακτική υποστήριξη για να συμπληρώσετε πολλαπλές γραμμές, συμπληρώστε πολλές γραμμές λογική χτύπησε οποιαδήποτε μπορεί να καθιερωθεί.',
                        language: 'Γλώσσα',
                    },
                    component: {
                        pleaseEnterAStandardSentence: 'Παρακαλώ εισάγετε μια τυπική πρόταση',
                    },
                },
                template: {
                    effectiveness: 'Αποτελεσματικότητα:',
                    pleaseSelectEffectivity: 'Παρακαλώ επιλέξτε αποτελεσματικότητα',
                    effective: 'Αποτελεσματικό',
                    invalid: 'Μη έγκυρο',
                    language: 'Γλώσσα',
                },
            },
            smartWordsLibrary: {
                template: {
                    ignoreWordsBlockWordsThatYouDontWantToPayAttentionToInWordCloudAnalysisToHelpAIThatAnalysisHotspotsAreInLineWithCurrentBusiness: 'Αγνόηση λέξεων: Μπλοκάρετε λέξεις στις οποίες δεν θέλετε να δώσετε προσοχή στην ανάλυση σύννεφου λέξης για να βοηθήσετε την τεχνητή τεχνολογία που αναλύει hotspots είναι σε γραμμή. e με τρέχουσες δραστηριότητες.',
                    typosWordSetUsedToOptimizeTheEffectOftyposDetectionForExampleIfrefundIsMistakenlySentAsrefundWidthCommonTyposAndCorrectWordsCanBeSetThroughThisFunctionAndItWillTakeEffectTheNextDayAfterSaving: 'Σετ λέξης τυπογραφίας: χρησιμοποιείται για τη βελτιστοποίηση του αποτελέσματος της "ανίχνευσης τύπου". Για παράδειγμα, εάν το "επιστροφή" αποστέλλεται λανθασμένα ως "επιστροφή πλάτος", οι κοινές τυπογραφίες και οι σωστές λέξεις μπορούν να ρυθμιστούν μέσω αυτής της λειτουργίας, και θα τεθεί σε ισχύ την επόμενη μέρα μετά την αποταμίευση.',
                    translationTerminologyUsedToOptimizeTheEffectOfTranslationWhenATermInTheIndustrySuchAsProductNameParameterNameEtcIsNotTranslatedCorrectlyTheTermAndItsCorrectTranslationCanBeAddedAsATranslationTerm: 'Μετάφραση ορολογία: χρησιμοποιείται για τη βελτιστοποίηση της επίδρασης της μετάφρασης. Όταν ένας όρος στον κλάδο, όπως ονομασία προϊόντος, ονομασία παραμέτρου κ.λπ., δεν μεταφράζεται σωστά, ο όρος και η σωστή μετάφρασή του μπορούν να προστεθούν ως όρος μετάφρασης.',
                    translationOfTerms: 'Μετάφραση Όρων',
                    hotWords: 'Καυτές λέξεις',
                    hotWordsUsedToImproveASRTranscriptionAccuracy: 'Ζεστές λέξεις: χρησιμοποιείται για τη βελτίωση της ακρίβειας ASR μεταγραφής',
                    sensitiveWords: 'Ευαίσθητες λέξεις',
                    sensitiveWordsSensitiveWordsCanBeConfiguredWithBusinessFocusWordsForPublicOpinionToDiscoverSensitiveWordClouds: 'Ευαίσθητες λέξεις: ευαίσθητες λέξεις μπορούν να διαμορφωθούν με επαγγελματικές λέξεις, χρησιμοποιούνται για την κοινή γνώμη ευαίσθητη λέξη cloud',
                },
                sensitiveWords: {
                    component: {
                        language: 'Γλώσσα',
                        newSensitiveWord: 'Νέα Ευαίσθητη Λόγο',
                        editSensitiveWords: 'Επεξεργασία ευαίσθητων λέξεων',
                        sensitiveWords: 'Ευαίσθητες λέξεις',
                    },
                    template: {
                        language: 'Γλώσσα',
                        sensitiveWords: 'Ευαίσθητες λέξεις',
                        sensitiveWordsCannotBeEmpty: 'Η ευαίσθητη λέξη δεν μπορεί να είναι κενή',
                        pleaseEnterSensitiveWordsSeparatedBy: 'Παρακαλώ εισάγετε μια ευαίσθητη λέξη, χωριστές πολλαπλές ευαίσθητες λέξεις \',\'',
                    },
                },
                hotWords: {
                    index: {
                        hotWordModel: 'Μοντέλο ζεστής λέξης',
                        aSRProject: 'Έργο ASR',
                        updateTime: 'Ώρα ενημέρωσης',
                        operation: 'Λειτουργία',
                        editBasicInformation: 'Επεξεργασία βασικών πληροφοριών',
                        managementHotWords: 'Ζεστές λέξεις διαχείρισης',
                        delete: 'Διαγραφή',
                        saveSuccessful: 'Αποθήκευση με επιτυχία',
                        newHotWordModel: 'Νέο μοντέλο καυτής λέξης',
                        editHotWordModel: 'Επεξεργασία μοντέλου ζεστής λέξης',
                        hotWordModelName: 'Όνομα μοντέλου θερμής λέξης',
                        pleaseEnterHotwordModelName: 'Παρακαλώ εισάγετε το όνομα του μοντέλου θερμοκρασίας',
                        pleaseSelectAnASRProject: 'Παρακαλώ επιλέξτε ένα έργο ASR',
                        areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                        deleteSuccessful: 'Διαγραφή με επιτυχία',
                        currentHotWords: 'Τρέχουσες καυτές λέξεις',
                        one: 'Ένας',
                        pleaseEnterAHotWordMultipleHotWordsAreSeparatedByCommasInChineseOrEnglishTheMaximumLengthIsCharacters: 'Παρακαλώ εισάγετε μια ζεστή λέξη. Πολλαπλές ζεστές λέξεις διαχωρίζονται με κόμματα στα κινέζικα ή στα αγγλικά. Το μέγιστο μήκος είναι 12 χαρακτήρες.',
                        submission: 'Υποβολή',
                    },
                },
                corpusData: {
                    component: {
                        language: 'Γλώσσα',
                    },
                    template: {
                        language: 'Γλώσσα',
                    },
                },
                professionalWords: {
                    component: {
                        language: 'Γλώσσα',
                    },
                    template: {
                        language: 'Γλώσσα',
                    },
                },
                smartWordsLibraryCommon: {
                    component: {
                        language: 'Γλώσσα',
                    },
                },
                smartWordsLibraryCommonList: {
                    template: {
                        aSRTrainingStatus: 'Κατάσταση κατάρτισης ASR κατάρτισης',
                    },
                },
                translationTerminology: {
                    components: {
                        list: {
                            index: {
                                pleaseEnterATermNameForTheLanguage: 'Παρακαλώ εισάγετε ένα όνομα όρου για τη γλώσσα',
                                addAdditionalLanguages: 'Προσθήκη πρόσθετων γλώσσες',
                            },
                        },
                    },
                    index: {
                        translationOfTerms: 'Μετάφραση Όρων',
                        language: 'Γλώσσα',
                        effectiveness: 'Αποτελεσματικότητα',
                        yes: 'Μάλιστα.',
                        no: 'Οχι',
                        edit: 'Επεξεργασία',
                        new: 'Νέο',
                        editTranslationTerms: 'Επεξεργασία μεταφραστικών όρων',
                        newTranslationTerm: 'Νέα όρος',
                        pleaseAddTermsInAtLeastTwoLanguages: 'Προσθέστε όρους σε δύο τουλάχιστον γλώσσες',
                    },
                },
            },
            clusteringAnalysis: {
                add: {
                    index: {
                        pleaseSelectAnApplicationScenario: 'Παρακαλώ επιλέξτε ένα σενάριο εφαρμογής',
                        keyWord: 'Λέξεις-κλειδιά',
                        pleaseEnterKeywords: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
                        keywordLengthWithinCharacters: 'Μήκος λέξεων κλειδιού μέσα σε 40 χαρακτήρων',
                        dataSources: 'Πηγή δεδομένων',
                        pleaseSelectADataSource: 'Παρακαλώ επιλέξτε πηγή δεδομένων',
                        theCurrentClusteringHasBeenCompletedReEditingWillGenerateANewClusteringDataAndWillNotOverwriteTheCompletedClusteringDataPleaseConfirm: 'Η τρέχουσα συστάδα έχει ολοκληρωθεί. Η επανεπεξεργασία θα δημιουργήσει ένα νέο κομμάτι δεδομένων συστάσεων και δεν θα αντικαταστήσει τα ολοκληρωμένα δεδομένα συστάδας. Επιβεβαιώστε παρακαλώ.',
                        savingSucceeded: 'Αποθήκευση με επιτυχία',
                        clusteringStart: 'Αρχίζει η ομαδοποίηση',
                        clustering: 'Συστάδες',
                        edit: 'Επεξεργασία',
                        newlyBuild: 'Νέο',
                        clusterName: 'Όνομα δέσμης',
                        pleaseEnterAName: 'Παρακαλώ εισάγετε ένα όνομα',
                        withinCharactersOfTheName: 'Μήκος ονόματος εντός 40 χαρακτήρων',
                        speaker: 'Ηχεία',
                        pleaseSelectASpeaker: 'Παρακαλώ επιλέξτε έναν ηχείο',
                        sessionDate: 'Ημερομηνία συνεδρίας',
                        pleaseEnterTheSessionDate: 'Παρακαλώ εισάγετε μια ημερομηνία συνεδρίας',
                        selectUpToMonthOfHistoricalSessionData: 'Επιλέξτε το μέγιστο 1 μήνα ιστορικών δεδομένων συνεδρίας',
                        automaticallyClusterDailyNewData: 'Αυτόματη συσσώρευση των καθημερινών νέων δεδομένων',
                        conversationChannel: 'Κανάλι συνομιλίας',
                        pleaseSelectAConversationChannel: 'Παρακαλώ επιλέξτε ένα κανάλι συνεδρίας',
                        applicationScenario: 'Σενάρια εφαρμογής',
                        clusteringRules: 'Κανόνες συστάδωσης',
                        incompleteClusteringRuleSettings: 'Η ρύθμιση κανόνων συστάδωσης δεν είναι πλήρης',
                        startClustering: 'Εκκίνηση συστάσεων',
                    },
                    components: {
                        conditionItem: {
                            pleaseSelectAQualityInspectionTask: 'Παρακαλώ επιλέξτε μια ποιότητα εργασίας',
                            beEqualTo: 'Ίση',
                        },
                    },
                },
                detail: {
                    index: {
                        theme: 'Θέμα:',
                        numberOfCorpora: 'Αριθμός σώματος',
                        corpusCoverage: 'Κάλυψη του σώματος',
                        clusterDetails: 'Λεπτομέρειες συστάδωσης',
                    },
                    ranking: {
                        hotWords: 'Καυτές λέξεις',
                        numberOfCorpora: 'Αριθμός σώματος',
                        speaker: 'Ηχεία',
                        sit: 'Κάθισε.',
                        passenger: 'Επισκέπτης',
                        hotSentence: 'Θερμή πρότασης',
                        corpusDetails: 'Λεπτομέρειες CorpusName',
                    },
                },
                index: {
                    delete: 'Διαγραφή',
                    deletionSucceeded: 'Διαγραφή με επιτυχία',
                    clusterName: 'Όνομα δέσμης',
                    speaker: 'Ηχεία',
                    creationTime: 'Χρόνος δημιουργίας',
                    state: 'Κατάσταση',
                    operation: 'Λειτουργία',
                    see: 'Προβολή',
                    edit: 'Επεξεργασία',
                    clusterAnalysis: 'Ανάλυση συστάδων',
                    newCluster: 'Νέος συστάδες',
                    clusteringStatus: 'Κατάσταση συστάδωσης',
                },
            },
            wordsMining: {
                dissent: {
                    components: {
                        pageLeftTable: {
                            enterKeywordsToSearchForObjections: 'Εισάγετε λέξεις-κλειδιά για αναζήτηση ένστασης',
                        },
                        pageRightTable: {
                            columnHeader: {
                                scriptLibrary: 'Βιβλιοθήκη ομιλίας',
                                recommendedScripts: 'Συνιστώ ομιλίας',
                                common: 'Σύνολο',
                                strip: 'Άρθρο',
                                scriptFavorites: 'Λέξεις αγαπημένες',
                            },
                            conditionPostfix: {
                                detectRoles: 'Ανίχνευση ρόλου',
                                detectionRange: 'Εύρος ανίχνευσης',
                                sentence: 'Ποινή',
                            },
                            customerFilter: {
                                scriptFiltering: 'Φίλτρα λόγους',
                                cancel: 'Ακύρωση',
                            },
                            index: {
                                viewDetails: 'Λεπτομέρειες προβολής',
                                areYouSureYouWantToDiscardYouCannotRestoreAfterDiscarding: 'Είσαι σίγουρος ότι θέλεις να το εγκαταλείψεις; Δεν μπορείς να το αποκαταστήσεις αφού το εγκαταλείψεις.',
                                abandonment: 'Απόρριψε',
                                deletionSucceeded: 'Διαγραφή με επιτυχία',
                                passenger: 'Επισκέπτης',
                                sit: 'Κάθισε.',
                                adopted: 'Εγκρίθηκε.',
                                determine: 'Προσδιορίστε την ένδειξη αυτών',
                                cancel: 'Ακύρωση',
                                adopt: 'Έγκριση',
                            },
                            pageRightFrom: {
                                savingSucceeded: 'Αποθήκευση με επιτυχία',
                                pleaseEnterTheScriptContent: 'Παρακαλώ εισάγετε το περιεχόμενο ομιλίας',
                                pleaseSelectAFavoriteGroup: 'Παρακαλώ επιλέξτε μια αγαπημένη ομαδοποίηση',
                            },
                        },
                    },
                    favorite: {
                        components: {
                            pageLeftTable: {
                                objectionHandlingScriptLibrary: 'Ένσταση Χειρισμός Βιβλιοθήκης Λόγων',
                            },
                            pageRightTable: {
                                index: {
                                    pleaseChooseToAdoptScript: 'Παρακαλώ επιλέξτε να υιοθετήσετε ομιλία.',
                                },
                            },
                        },
                    },
                },
                favoriteView: {
                    components: {
                        pageLeftTable: {
                            objectionHandlingScriptFavorites: 'Ένσταση Χειρισμός Λέξεις Αγαπητές',
                        },
                        pageRightTable: {
                            likeCancel: 'Όπως ακυρώθηκε.',
                            likeSuccessfully: 'Μου αρέσει η επιτυχία.',
                            adoptScripts: 'Να Υιοθετήσετε τον λόγο',
                            operation: 'Λειτουργία',
                            viewConversationDetails: 'Προβολή λεπτομερειών συνομιλίας',
                        },
                    },
                    sellingPoint: {
                        components: {
                            pageLeftTable: {
                                productSellingPointScriptLibrary: 'Βιβλιοθήκη πώλησης προϊόντων',
                            },
                            pageRightTable: {
                                keyPointsOfScript: 'Βασικά Σημεία Λόγου',
                            },
                        },
                    },
                },
                favorite: {
                    components: {
                        pageLeftTable: {
                            objectionHandlingScriptFavorites: 'Ένσταση Χειρισμός Λέξεις Αγαπητές',
                            newGroup: 'Νέα ομάδας',
                            editGroup: 'Επεξεργασία ομαδοποίησης',
                            addGroup: 'Προσθήκη ομαδοποίησης',
                            savingSucceeded: 'Αποθήκευση με επιτυχία',
                            groupName: 'Όνομα ομάδας',
                            pleaseEnterTheGroupName: 'Παρακαλώ εισάγετε ένα όνομα ομάδας',
                            groupNameWithinCharacters: 'Μήκος ονόματος ομάδας εντός 20 χαρακτήρων',
                            deletionSucceeded: 'Διαγραφή με επιτυχία',
                        },
                        pageRightTable: {
                            configDrawer: {
                                index: {
                                    scriptRecommendationSettings: 'Ρυθμίσεις του ομιλητή',
                                },
                                rightForm: {
                                    savingSucceeded: 'Αποθήκευση με επιτυχία',
                                    intelligentRecommendation: 'Ευφυής σύσταση',
                                    theAdoptedExcellentScriptsWillBeAutomaticallyDisplayedInTheConversationSidebarOfSimilarObjectionsAndEmployeesCanDirectlyViewTheRecommendedScriptsForLearningOnTheDetailedPageOfConversationReview: 'Οι υιοθετημένες εξαιρετικές ικανότητες ομιλίας θα εμφανιστούν αυτόματα στην πλευρά των συζητήσεων με παρόμοιες αντιρρήσεις, και οι εργαζόμενοι μπορούν να δουν απευθείας τις συνιστώμενες δεξιότητες ομιλίας για την εκμάθηση στη συνεδρία συνεχίστε τη σελίδα λεπτομέρειες.',
                                    objectionsIncludedByDefault: 'Ένσταση περιλαμβάνεται εξ προεπιλεγμένων',
                                    addRecommendationTriggerSemantics: 'Προσθήκη σημασιολογίας ενεργοποίησης',
                                    remindEmployeesToView: 'Υπενθυμίστε στους υπαλλήλους να δείτε.',
                                    shareWithMoreEmployees: 'Μοιραστείτε με περισσότερους υπαλλήλους.',
                                    allHands: 'Όλο το προσωπικό',
                                },
                                smartToolbar: {
                                    selectSemanticTag: 'Επιλογή σημασιολογικής ετικέτας',
                                },
                            },
                            index: {
                                doYouWantToExportAllDataRecordsUnderTheCurrentGroup: 'Εξαγωγή όλων των εγγραφών δεδομένων κάτω από την τρέχουσα ομάδα;',
                                newScript: 'Νέα λόγος',
                                editingScript: 'Επεξεργασία ομιλίας',
                                savingSucceeded: 'Αποθήκευση με επιτυχία',
                                objection: 'Ένσταση',
                                pleaseEnterAScriptObjection: 'Παρακαλώ εισάγετε μια ένσταση ομιλίας.',
                                speechTechnique: 'Λέξεις',
                                pleaseEnterTheScriptContent: 'Παρακαλώ εισάγετε το περιεχόμενο ομιλίας',
                                grouping: 'Ομαδοποίηση',
                                pleaseSelectAFavoriteGroup: 'Παρακαλώ επιλέξτε μια αγαπημένη ομαδοποίηση',
                                adoptScripts: 'Να Υιοθετήσετε τον λόγο',
                                passenger: 'Επισκέπτης',
                                sit: 'Κάθισε.',
                                numberOfViews: 'Αριθμός προβολών',
                                useful: 'Χρήσιμο',
                                operation: 'Λειτουργία',
                                edit: 'Επεξεργασία',
                                delete: 'Διαγραφή',
                                deletionSucceeded: 'Διαγραφή με επιτυχία',
                                scriptRecommendationSettings: 'Ρυθμίσεις του ομιλητή',
                            },
                        },
                    },
                },
                index: {
                    scriptLibrary: 'Βιβλιοθήκη ομιλίας',
                    scriptMining: 'Λέξεις Εξόρυξης',
                    objectionHandlingScripts: 'Χειρισμός ένστασης',
                    productSellingPointScripts: 'Σημεία πώλησης προϊόντων',
                },
                sellingPoint: {
                    index: {
                        newCluster: 'Νέος συστάδες',
                    },
                    components: {
                        callDetailModal: {
                            sessionDetails: 'Λεπτομέρειες συνεδρίας',
                            cancel: 'Ακύρωση',
                            determine: 'Προσδιορίστε την ένδειξη αυτών',
                            choice: 'Επιλογή',
                        },
                        pageCenterTable: {
                            scriptOverview: 'Επισκόπηση ομιλίας',
                        },
                        pageLeftTable: {
                            enterSearchKeywords: 'Εισάγετε λέξεις-κλειδιά αναζήτησης',
                            keyWord: 'Λέξεις-κλειδιά',
                        },
                        pageRightTable: {
                            index: {
                                viewDetails: 'Λεπτομέρειες προβολής',
                                scriptLibrary: 'Βιβλιοθήκη ομιλίας',
                                scriptRefinement: 'Διύλιση ομιλών',
                                adoptScript: 'Να Υιοθετήσετε τον λόγο',
                            },
                            tagsEdit: {
                                keyPointsOfScript: 'Βασικά Σημεία Λόγου',
                            },
                        },
                    },
                    favorite: {
                        components: {
                            pageLeftTable: {
                                productSellingPointScriptLibrary: 'Βιβλιοθήκη πώλησης προϊόντων',
                            },
                            pageRightTable: {
                                configDrawer: {
                                    rightForm: {
                                        defaultIncludedSellingPoints: 'Σημεία πώλησης',
                                    },
                                },
                                index: {
                                    keyWord: 'Λέξεις-κλειδιά',
                                    pleaseSelectAKeyword: 'Παρακαλώ επιλέξτε μια λέξη-κλειδίς',
                                    keyPointsOfScript: 'Βασικά Σημεία Λόγου',
                                    pleaseInputTheKeyPointsOfTheScript: 'Παρακαλώ εισάγετε τα βασικά σημεία ομιλίας.',
                                    viewDetails: 'Λεπτομέρειες προβολής',
                                    pleaseChooseToAdoptScript: 'Παρακαλώ επιλέξτε να υιοθετήσετε ομιλία.',
                                },
                            },
                        },
                    },
                },
            },
            conceptWord: {
                detail: {
                    template: {
                        language: 'Γλώσσα',
                        matchingLogic: 'Λογική ταυτοποίησης',
                        nLPMatching: 'Αγώνας NP',
                        strictlyMatchByWord: 'Αυστηρός ταίριασμα με λέξη.',
                    },
                },
                component: {
                    language: 'Γλώσσα',
                },
                template: {
                    language: 'Γλώσσα',
                },
            },
            applicationMessage: {
                index: {
                    messageTypeName: 'Όνομα τύπου μηνύματος',
                    messageTypeID: 'ID τύπου μηνύματος',
                    messageTypeDescription: 'Τύπος μηνύματος',
                    applicationMessageType: 'Τύπος μηνύματος εφαρμογής',
                    itIsApplicableToAccessDataFromDifferentChannelsForQualityInspectionWhichShouldBeClassifiedAccordingToChannelIdentification: 'Εφαρμόζεται στην πρόσβαση δεδομένων από διαφορετικά κανάλια για επιθεώρηση ποιότητας, τα οποία θα πρέπει να ταξινομούνται ανάλογα με την ταυτοποίηση των διαύλων.',
                },
                detail: {
                    index: {
                        messageTypeName: 'Όνομα τύπου μηνύματος',
                        pleaseEnterAMessageTypeName: 'Παρακαλώ εισάγετε ένα όνομα τύπου μηνύματος',
                        messageTypeDescription: 'Τύπος μηνύματος',
                        describeYourMessageTypeInDetail: 'Περιγράψτε λεπτομερώς τον τύπο του μηνύματος',
                        editMessageType: 'Επεξεργασία τύπου μηνύματος',
                        newMessageType: 'Τύπος νέου μηνύματος',
                    },
                },
            },
            aiAgent: {
                detail: {
                    components: {
                        paramsList: {
                            components: {
                                value: {
                                    components: {
                                        randomFieldSelectList: {
                                            index: {
                                                preprocessedField: 'Προεπεξεργασμένο πεδίο',
                                            },
                                        },
                                    },
                                    index: {
                                        preprocessedField: 'Προεπεξεργασμένο πεδίο',
                                        fixedValue: 'Σταθερή αξία',
                                        pleaseEnterTheField: 'Παρακαλώ εισάγετε το πεδίο',
                                    },
                                },
                            },
                            index: {
                                pleaseEnterKey: 'Παρακαλώ εισάγετε το κλειδί.',
                            },
                        },
                    },
                    index: {
                        pleasePerfectTheVariable: 'Παρακαλώ τελειοποιήστε τη μεταβλητή',
                        editAgent: 'Επεξεργασία πράκτορας',
                        newAgent: 'Νέος πράκτορας',
                        agentName: 'Όνομα πράκτορας',
                        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                        agentDescription: 'Περιγραφή παράγοντας',
                        effectiveness: 'Αποτελεσματικότητα',
                        source: 'Πηγή',
                        space: 'Χώρος',
                        agent: 'Πράκτορα',
                        aPIAddress: 'Διεύθυνση API',
                        userID: 'ID χρήστη',
                        type: 'Τύπος',
                        conversationMessages: 'Μήνυμα συνομιλίας',
                        variable: 'Μεταβλητή',
                    },
                },
                index: {
                    name: 'Όνομα',
                    description: 'Περιγραφή',
                    source: 'Πηγή',
                    statusUpdateSuccessful: 'Επιτυχής ενημέρωση κατάστασης',
                    agent: 'Πράκτορα',
                    pleaseEnterAKeyword: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
                },
            },
        },
        gong: {
            common: {
                pleaseSelectATemMember: 'Παρακαλώ επιλέξτε ένα μέλος της ομάδας',
                existingFilter: 'Υπάρχουν ήδη φίλτρα.',
                pleaseSelect: 'Παρακαλώ επιλέξτε.',
                filterCondition: 'Συνθήκες διήθησης',
                areYouSureToDeleteTheCurrentFilter: 'Επιθυμείτε σίγουρα τη διαγραφή του τρέχοντος φίλτρου;',
                sessionDate: 'Ημερομηνία συνεδρίας',
                staff: 'Εργαζόμενος',
                customer: 'Πελάτη',
                pleaseEnterCustomerName: 'Παρακαλώ εισάγετε το όνομα πελατών',
                keyWord: 'Λέξεις-κλειδιά',
                whole: 'Όλα',
                pleaseEnterSessionKeywords: 'Παρακαλώ εισάγετε λέξεις-κλειδιά συνεδρίας',
                sessionDuration: 'Διάρκεια συνεδρίας',
                sessionLabel: 'Σενάρια συνεδρίας',
                pleaseSelectASessionLabel: 'Παρακαλώ επιλέξτε ένα σενάριο συνεδρίας',
                commentTopic: 'Θέμα σχόλιο',
                pleaseSelectACommentTopic: 'Παρακαλώ επιλέξτε ένα θέμα σχολίου',
                areYouSureYouWantToOverwriteTheCurrentFilter: 'Είστε σίγουροι ότι επιθυμείτε την αντικατάσταση του τρέχοντος φίλτρου;',
                overlayFilter: 'Φίλτρο κάλυψης',
                NewFilter: 'Νέο φίλτρο',
                newFilter: 'Νέο φίλτρο',
                filterName: 'Όνομα φίλτρου',
                pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                allCall: 'Όλες οι κλήσεις',
                percentage: 'Ποσοστό',
                filterScreen: {
                    supportSearchingForMultipleKeywordsWithCommasinBothChineseAndEnglishSeparatingTheORRelationshipAndADashSeparatingTheAndRelationshipSuchAs: 'Μπορείτε να αναζητήσετε πολλαπλές λέξεις-κλειδιά. Χρησιμοποιήστε κόμματα (στα αγγλικά και κινέζικα) για να διαχωρίσετε OR και να σταματήσετε για να διαχωριστεί και OR. Για παράδειγμα:',
                    callRecordID: 'ID καταγραφής κλήσεων',
                    pleaseFillInTheCallRecordID: 'Παρακαλώ συμπληρώστε το αναγνωριστικό αρχείο κλήσεων',
                    minute: 'Πρακτικά',
                    second: 'Δευτερόλεπτα',
                    whole: 'Όλα',
                    callRecording: 'Καταγραφή κλήσεων',
                    enterpriseWechat: 'Enterprise WeChat',
                    conversationChannel: 'Κανάλι συνομιλίας',
                    pleaseSelectASessionChannel: 'Παρακαλώ επιλέξτε ένα κανάλι συνεδρίας',
                    learningStatus: 'Κατάσταση εκμάθησης',
                    pleaseSelectLearningStatus: 'Παρακαλώ επιλέξτε κατάσταση εκμάθησης',
                    notLearned: 'Δεν έμαθα',
                    learned: 'Μάθηση',
                    Minutes: 'Πρακτικά',
                    theFilterConditionIsEmptyNewFilterIsNotSupported: 'Η κατάσταση φίλτρου είναι κενή, το νέο φίλτρο δεν υποστηρίζεται!',
                    filterAddedSuccessfully: 'Το φίλτρο προστέθηκε με επιτυχία!',
                    failedToAddFilter: 'Αποτυχία προσθήκης φίλτρου!',
                    filterDeletedSuccessfully: 'Το φίλτρο διαγράφτηκε με επιτυχία!',
                    filterDeletionFailed: 'Αποτυχία διαγραφής φίλτρου!',
                    filterOverwriteSucceeded: 'Επιτυχής παράκαμψη φίλτρου!',
                    filterOverwriteFailed: 'Η παράκαμψη φίλτρου απέτυχε!',
                    theme: 'Θέμα:',
                    pleaseSelectATheme: 'Παρακαλώ επιλέξτε ένα θέμαName',
                    keyEvents: 'Γεγονότα κλειδιά',
                    pleaseSelectAKeyEvent: 'Παρακαλώ επιλέξτε ένα γεγονός κλειδιού',
                },
                filterItem: {
                    startRetesting: 'Έναρξη επανάληψης',
                    time: 'Χρόνο',
                    talkTime: 'Διάρκεια κλήσης',
                    keyEvents: 'Γεγονότα κλειδιά',
                    totalImplementationRateOfSupervisionItems: 'Συνολικό ποσοστό εκτέλεσης των στοιχείων εποπτείας',
                    sort: 'Ταξινόμηση:',
                    seeMore: 'Δείτε περισσότερα',
                },
                filterStatistics: {
                    conversation: 'Κλήση',
                    weChat: 'Βαϊξίνη',
                    quantity: 'Ποσότητα',
                },
            },
            caseBase: {
                index: {
                    copyTo: 'Αντιγραφή',
                    pleaseSelectTheLocationToMove: 'Παρακαλώ επιλέξτε μια τοποθεσία για μετακίνηση!',
                    folderCopiedSuccessfully: 'Ο φάκελος αντιγράφηκε με επιτυχία!',
                    cancelCollectionSuccessfully: 'Ακύρωση συλλογής με επιτυχία!',
                    collectionSucceeded: 'Επιτυχία συλλογής!',
                    starCaseBase: 'Βιβλιοθήκη περίπτωσης αστέρα',
                    move: 'Μετακίνηση',
                    rename: 'Μετονομασία',
                    delete: 'Διαγραφή',
                    folderMovedSuccessfully: 'Ο φάκελος μετακινήθηκε με επιτυχία!',
                    fileMovedSuccessfully: 'Το αρχείο μετακινήθηκε με επιτυχία!',
                    fileMoveFailed: 'Αποτυχία κίνησης αρχείου!',
                    folderAddedSuccessfully: 'Προσθήκη φακέλου με επιτυχία!',
                    folderRenameSucceeded: 'Ο φάκελος μετονομάστηκε με επιτυχία!',
                    fileRenameSucceeded: 'Το αρχείο μετονομάστηκε με επιτυχία!',
                    theFolderCannotBeRetrievedAfterDeletionAreYouSureToDeleteIt: 'Μετά τη διαγραφή του φακέλου, δεν θα μπορείτε να το ανακτήσετε. Σίγουρα θα το διαγράψεις;',
                    deleteSucceeded: 'Διαγραφή επιτυχώς!',
                    theFileCannotBeRetrievedAfterDeletionAreYouSureToDeleteIt: 'Μετά τη διαγραφή του αρχείου, δεν θα μπορείτε να το ανακτήσετε. Σίγουρα θα το διαγράψεις;',
                    share: 'Σύνολο',
                    folders: 'Φάκελος,',
                    calls: 'Κλήσης',
                    newFolder: 'Νέος φάκελος',
                    modifyFolder: 'Τροποποίηση φακέλου',
                    title: 'Τίτλος',
                    pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                    selectMoveLocation: 'Επιλέξτε τοποθεσία μετακίνησης',
                },
            },
            msgCenter: {
                index: {
                    learningReminder: 'Υπενθύμιση μάθησης',
                    subscriptionDynamics: 'Δυναμική συνδρομών',
                },
                subscription: {
                    index: {
                        theSessionYouSubscribedToID: 'Η συνεδρία στην οποία εγγραφήσατε (ID)',
                        thereAreDynamicUpdates: 'Υπάρχει μια δυναμική ενημέρωση',
                        newCommentsReplies: 'Προσθέστε σχόλια / Απαντήσεις',
                        strip: 'Άρθρο',
                        newHelp: 'Προσθήκη βοήθεια',
                        goAndWatch: 'Πήγαινε οι παρατηρητές.',
                    },
                },
                reply: {
                    index: {
                        respondedToMyComments: 'Απαντήστε τα σχόλιά μου',
                        replySucceeded: 'Απάντηση επιτυχής!',
                    },
                },
                answer: {
                    index: {
                        youMeInTheComments: '@ Με στα σχόλια.',
                        replySucceeded: 'Απάντηση επιτυχής!',
                    },
                },
                share: {
                    index: {
                        shareCallsForYou: 'Κλήση για να μοιραστείς',
                        shareCasesForYou: 'Να μοιραστούμε την υπόθεση.',
                    },
                },
                study: {
                    index: {
                        learned: 'Μάθηση',
                        ignored: 'Αγνόητα',
                        study: 'Μάθηση',
                        ignore: 'Αγνόηση',
                    },
                },
            },
            userManage: {
                list: {
                    importSuccessful: 'Επιτυχία εισαγωγής',
                    account: 'Αριθμός λογαριασμού',
                    password: 'Κωδικός πρόσβασης',
                    cover: 'Εξώφυλλα',
                    skip: 'Παράλειψη',
                    import: 'Εισαγωγή',
                    importEmployees: 'Εισαγωγές',
                    importPrompt: 'Εισαγωγή συμβουλών',
                    confirm: 'Προσδιορίστε την ένδειξη αυτών',
                    theDataContainsDuplicateAccountsOrNames: 'Διπλός λογαριασμός ή όνομα υπάρχει σε αυτή την καταχώριση δεδομένων',
                    allCoverage: 'Καλύψτε όλους.',
                    skipAll: 'Παράλειψη όλους',
                    headPortrait: 'Άβαταρ',
                    fullName: 'Όνομα',
                    nickname: 'Ψευδώνυμο',
                    excellentStaff: 'Εξαιρετικό προσωπικό',
                    yes: 'Μάλιστα.',
                    no: 'Οχι',
                    department: 'Υπηρεσία',
                    accountNumberemail: 'Αριθμός λογαριασμού (Email)',
                    telephone: 'Τηλέφωνο',
                    jobNumber: 'Αριθμός εργασίας',
                    role: 'Ρόλος',
                    pleaseEnterANameOrPhoneSearch: 'Παρακαλώ εισάγετε μια αναζήτηση ηλεκτρονικού ταχυδρομείου, ονόματος ή τηλεφώνους',
                    person: 'Άτομα)',
                    AddEmployee: 'Προσθήκη εργαζόμενου',
                },
                edit: {
                    jobNo: 'Αριθμός εργασίας',
                    udeskCustomerServiceSystemIdentity: 'Ταυτότητα συστήματος εξυπηρέτησης πελατών Udesk',
                    enterpriseWechatIdentity: 'Ταυτότητα WeChat Enterprise',
                    inputID: 'ID εισόδου',
                    newIdentityBinding: 'Νέα δέσμευση ταυτότητας',
                    identityBinding: 'Δέσμευση ταυτότητας',
                    avatarGreaterThan500kb: 'Avatar μεγαλύτερο από 500Kb',
                    uploadSuccessful: 'Αποστολή επιτυχή',
                    upload: 'Αποστολής',
                    supportJPGGIFAndPNGUpTo500kb: 'Υποστήριξη jpg, gif, png, μέγιστο 500Kb',
                    yes: 'Μάλιστα.',
                    no: 'Οχι',
                    accountNumber: 'Αριθμός λογαριασμού',
                    pleaseEnterTheAccountNumber: 'Παρακαλώ εισάγετε τον αριθμό λογαριασμού.',
                    initialPassword: 'Αρχικός κωδικός πρόσβασης',
                    pleaseInputAPassword: 'Παρακαλώ εισάγετε κωδικό πρόσβασης',
                    confirmPassword: 'Επιβεβαίωση κωδικού πρόσβασης',
                    thePasswordsEnteredTwiceAreDifferent: 'Ο κωδικός πρόσβασης που εισάγεται δύο φορές δεν είναι το ίδιο!',
                    headPortrait: 'Άβαταρ',
                    fullName: 'Όνομα',
                    pleaseEnterYourName: 'Παρακαλώ εισάγετε ένα όνομα',
                    nickname: 'Ψευδώνυμο',
                    department: 'Υπηρεσία',
                    excellentStaff: 'Εξαιρετικό προσωπικό',
                    sessionIdentity: 'Ταυτότητα συνεδρίας',
                    markTheSessionRecordAsBelongingToTheEmployee: 'Η ετικέτα συνεδρία ανήκει στον υπάλληλο',
                    telephone: 'Τηλέφωνο',
                    jobNumber: 'Αριθμός εργασίας',
                    role: 'Ρόλος',
                    pleaseSelectARole: 'Παρακαλώ επιλέξτε ένα ρόλο',
                    preservation: 'Αποθήκευση',
                    cancel: 'Ακύρωση',
                    addedSuccessfully: 'Προστέθηκε με επιτυχία!',
                    modificationSucceeded: 'Τροποποιήθηκε με επιτυχία!',
                    newEmployees: 'Νέος υπάλληλος',
                    editEmployee: 'Επεξεργασία υπαλλήλου',
                },
                detail: {
                    viewDetails: 'Λεπτομέρειες προβολής',
                    accountNumber: 'Αριθμός λογαριασμού',
                    headPortrait: 'Άβαταρ',
                    fullName: 'Όνομα',
                    nickname: 'Ψευδώνυμο',
                    department: 'Υπηρεσία',
                    excellentStaff: 'Εξαιρετικό προσωπικό',
                    yes: 'Μάλιστα.',
                    no: 'Οχι',
                    sessionIdentity: 'Ταυτότητα συνεδρίας',
                    markTheSessionRecordAsBelongingToTheEmployee: 'Η ετικέτα συνεδρία ανήκει στον υπάλληλο',
                    telephone: 'Τηλέφωνο',
                    jobNumber: 'Αριθμός εργασίας',
                    role: 'Ρόλος',
                },
            },
            roleManage: {
                list: {
                    menu: 'Μενού',
                    functionalCategory: 'Λειτουργικές κατηγορίες',
                    functionalSubclass: 'Υποκατηγορία συνάρτησης',
                    deletedSuccessfully: 'Διαγραφή με επιτυχία',
                    NewRole: 'Νέος Ρόλος',
                    role: 'Ρόλος',
                    dataPermissions: 'Άδειες δεδομένων:',
                    edit: 'Επεξεργασία',
                    areYouSureYouWantToDeleteTheRole: 'OK για τη διαγραφή ρόλου',
                    determine: 'Προσδιορίστε την ένδειξη αυτών',
                    cancel: 'Ακύρωση',
                    delete: 'Διαγραφή',
                    applicationPermission: 'Εφαρμογή δικαιωμάτων',
                },
                edit: {
                    youCanOnlySeeYourOwnSessionData: 'Μπορείτε να δείτε μόνο τα δικά σας δεδομένα συνεδρίας',
                    youCanViewTheSessionDataOfYourDepartmentAndSubordinateDepartments: 'Μπορείτε να δείτε τα δεδομένα συνεδρίας του τμήματος και των υφιστάμενων υπηρεσιών',
                    menu: 'Μενού',
                    functionalCategory: 'Λειτουργικές κατηγορίες',
                    functionalSubclass: 'Υποκατηγορία συνάρτησης',
                    successfullyAdded: 'Νέα Επιτυχία',
                    modifiedSuccessfully: 'Επιτυχία τροποποίησης',
                    edit: 'Επεξεργασία',
                    cancel: 'Ακύρωση',
                    confirm: 'Επιβεβαίωση',
                    roleName: 'Όνομα ρόλο',
                    pleaseEnterTheRoleName: 'Παρακαλώ εισάγετε ένα όνομα ρόλο',
                    dataAuthority: 'Άδειες δεδομένων',
                    youCanViewCompanyWideSessionData: 'Μπορείτε να προβάλετε δεδομένα συνεδρίας',
                    applicationPermission: 'Εφαρμογή δικαιωμάτων',
                },
            },
            callDetail: {
                index: {
                    conversationProcess: 'Διαδικασία συνεδρίας',
                    generateProcess: 'Διαδικασία παραγωγής',
                    addProcess: 'Προσθήκη διαδικασίας',
                    cancel: 'Ακύρωση',
                    complete: 'Ολοκληρώθηκε',
                    edit: 'Επεξεργασία',
                    theSettingWillBeSuccessfulLater: 'Ρυθμίστε την επιτυχία αργότερα!',
                    previous: 'Προηγούμενο άρθρο:',
                    next: 'Επόμενο άρθρο:',
                    debuggingMode: 'Λειτουργία αποσφαλμάτωσης',
                    afterActivationIfTheMessageMatchesTheRulesOfKeyEventsSupervisionItemsCustomerLabelsOrKnowledgePointRulesTheRuleNameThatTheMessageMatchesAndTheKnowledgePointNameOfTheKnowledgeBaseWillBeDisplayed: 'Αφού ενεργοποιηθεί το μήνυμα, αν ταιριάζει με τους κανόνες των βασικών γεγονότων, αντικείμενα παρακολούθησης, ετικέτες πελατών, ή σημεία γνώσης, εμφανίζονται το όνομα του κανόνα με τον οποίο ταιριάζει το μήνυμα και το όνομα σημείου γνώσης της βάσης γνώσεων.',
                    seeLater: 'Κοίτα αργότερα.',
                    determine: 'Προσδιορίστε την ένδειξη αυτών',
                    conversationalInsights: 'Στοιχεία συνεδρίασης',
                    customerInsight: 'Στοιχεία πελατών',
                    knowledgePointRecommendation: 'Σημείο γνώσης συστήνει',
                    comment: 'Παρατηρήσεις',
                    sessionQuality: 'Ποιότητα συνεδρίας',
                    setToListenLaterSuccessfully: 'Ρυθμίστε να ακούσετε την επιτυχία αργότερα!',
                    listenLater: 'Ακούστε αργότερα.',
                    seekCounselingSuccess: 'Αναζητήστε την επιτυχία του προπονητή!',
                    altogether: 'A',
                    appearsAt: 'Εμφανίστηκε.',
                    commentsPublishedSuccessfully: 'Τα σχόλια αναρτήθηκαν με επιτυχία',
                    callRecording: 'Καταγραφή κλήσεων',
                    addedSuccessfully: 'Προστέθηκε με επιτυχία',
                    shareWithColleagues: 'Μοιραστείτε με τους συναδέλφους',
                    shareWithCustomers: 'Μοιραστείτε με τους πελάτες',
                    resumptionDetails: 'Λεπτομέρειες της επαναπροσφοράς',
                    addToCaseBase: 'Προσθήκη στη βιβλιοθήκη περίπτωσης',
                    shareCases: 'Υποθέσεις',
                    seekCounseling: 'Αναζητήστε συμβουλή',
                    sessionRecord: 'Καταγραφή συνεδρίας',
                    businessRecord: 'Επιχειρηματικά αρχεία',
                    keywordSearch: 'Αναζήτηση λέξη-κλειδιά',
                    whole: 'Όλα',
                    pleaseEnterACommentEnterToNotifyOthersAndEnterToAddATopic: 'Παρακαλώ εισάγετε ένα σχόλιο',
                    subscriptionSession: 'Εγγραφή στη συνεδρία',
                    afterSubscribingYouWillBeNotifiedWhenThereAreNewHelpCommentsAndReplies: 'Μετά τη συνδρομή, όταν υπάρχουν νέα βοήθεια, σχόλια και απαντήσεις, θα λάβετε ειδοποιήσεις και υπενθυμίσεις.',
                },
            },
            coachTask: {
                index: {
                    employeeName: 'Όνομα υπαλλήλου',
                    customerName: 'Όνομα πελατών',
                    source: 'Πηγή',
                    viewSessionRecords: 'Προβολή εγγραφών συνεδριών',
                    coachingStatus: 'Κατάσταση προπονησης',
                    helpTime: 'Ώρα για βοήθεια.',
                    counselingTime: 'Χρόνος συμβουλής',
                    helpContent: 'Περιεχόμενο βοήθεια',
                    coachingOperation: 'Λειτουργία προπόνησης',
                    areYouSureYouWantToIgnoreIt: 'Είσαι σίγουρος ότι θέλεις να το αγνοήσεις;',
                    determine: 'Προσδιορίστε την ένδειξη αυτών',
                    cancel: 'Ακύρωση',
                    ignoreHelp: 'Αγνόηση βοήθειας',
                    coaching: 'Διεξάγει την προπονησία',
                    viewCoaching: 'Προβολή Coaching',
                    areYouSureToReturnToCounseling: 'Είσαι σίγουρος ότι θα επιστρέψεις στη σύμβουλο;',
                    returnToPendingCoaching: 'Συνεχίστε στη Συμβουλευτή',
                    tutor: 'Σύμβουλος',
                    helpSeekingStatus: 'Κατάσταση βοήθειας',
                    recentCoachingTime: 'Πρόσφατος Χρόνος συμβουλής',
                    operation: 'Λειτουργία',
                    ignoreSuccess: 'Αγνόηση επιτυχίας!',
                    recoverySucceeded: 'Η ανάκτηση επιτυχής!',
                    successfulCoaching: 'Επιτυχία διδασκαλίας!',
                    myMission: 'Η αποστολή μου',
                    selectCoachingStatus: 'Επιλογή κατάστασης προπονησης',
                    whole: 'Όλα',
                    iAskedForHelp: 'Ζήτησα βοήθεια.',
                    signOut: 'Έξοδος',
                    submit: 'Υποβολή',
                    helpPerson: 'Ζήτα βοήθεια.',
                    customer: 'Πελάτη',
                    toBeCoached: 'Για να γίνει καθοδήγηση',
                    counselingSuggestions: 'Συμβουλευτική συμβουλή',
                    pleaseEnterCoachingSuggestions: 'Παρακαλώ εισάγετε προτάσεις προπονησης',
                },
            },
            coachTaskCenter: {
                title: 'Κέντρο Αποστολής',
                list: {
                    taskName: 'Όνομα εργασίας',
                    lessonGroup: 'Ταξινόμηση μαθημάτων',
                    lessonName: 'Πορεία μαθημάτων',
                    taskType: 'Τύπος εργασίας',
                    taskStatus: 'Κατάσταση εργασίας',
                    taskExecutionInfo: 'Καθεστώς εφαρμογής',
                    totalCount: 'Αριθμός ατόμων προς εκτέλεση',
                    executeCount: 'Αριθμός εκτελεστών',
                    executeRate: 'Ποσοστό εφαρμογής',
                    completeCount: 'Αριθμός ολοκληρωθέντων',
                    completeRate: 'Ποσοστό ολοκλήρωσης',
                    commitCount: 'Αριθμός ατόμων που φτάνουν στο πρότυπο',
                    commitRate: 'Ποσοστό συμμόρφωσης',
                    excellentRate: 'Εξαιρετικό επιτόκιο',
                    taskTime: 'Ώρα εργασίας',
                    option: 'Λειτουργία',
                    edit: 'Επεξεργασία',
                    taskDetail: 'Δεδομένα εργασίας',
                    delete: 'Διαγραφή',
                    new: 'Νέα έκδοση',
                    taskTypeAll: 'Όλα',
                    taskTypePractice: 'Άσκηση',
                    taskTypeTest: 'Εξέταση',
                    taskStatusNotStarted: 'Δεν ξεκίνησες',
                    taskStatusRunning: 'Σε εξέλιξη.',
                    taskStatusEnd: 'Τέλος.',
                    taskStatusInvalid: 'Μη ισχύος',
                    unlimitedTime: 'Απεριόριστος χρόνος',
                    to: 'Στον',
                    deleteConfirm: 'Μετά τη διαγραφή, όλα τα αρχεία μάθησης κάτω από αυτή την εργασία θα καθαριστούν. Είσαι σίγουρος ότι θα τα διαγράψεις;',
                    deleteSuccess: 'Η εργασία διαγράφηκε με επιτυχία',
                },
                edit: {
                    addTask: 'Νέα εργασία δημοσίευσης',
                    editTask: 'Επεξεργασία εργασίας δημοσίευσης',
                    publishSuccess: 'Δημοσίευση με επιτυχία',
                    publishFailed: 'Η δημοσίευση απέτυχε',
                    updateSuccess: 'Επιτυχία ενημέρωσης',
                    updateFailed: 'Η ενημέρωση απέτυχε',
                    cannotBeNull: 'Δεν μπορεί να είναι κενό',
                    explain: 'Περιγραφή',
                    taskDescExtra: '(Αυτό θα εμφανιστεί στην είσοδο {0})',
                    taskTargetObj: 'Εκδόσεις αντικειμένων',
                    isEnable: 'Αποτελεσματικό καθεστώς',
                    dialogueMode: 'Λειτουργία διαλόγου',
                    voice: 'Φωνή',
                    text: 'Κείμενο',
                    userPortrait: 'Πορτραίτο χρήστη',
                    difficultyLevel: 'Δυσκολία',
                    limitDuration: 'Όριο διάρκειας',
                    tipLabel: 'Συμβουλές',
                    tipTooltip: 'Επιτρέψτε στους αντιπροσώπους να προβάλουν ομιλία αναφοράς',
                    limitTimes: 'Αριθμός εξετάσεων',
                    time: 'Χρόνο',
                    gradingStandart: 'Κριτήρια βαθμολογίας',
                    gradingStandartDescAffix: '(Η τρέχουσα διαδικασία συζήτησης είναι διαιρεμένη',
                    gradingStandartDescSuffix: 'Σημεία, δεξιότητα ομιλίας {0} πόντοι, διάθεση {1} πόντοι, ταχύτητα {2} πόντοι)',
                    completeStandart: 'Απαιτήσεις ολοκλήρωσης εργασιών',
                    byTimes: 'Με αριθμό φορών',
                    byScore: 'Κατά βαθμό',
                    completeByTimes: 'Αριθμός ασκήσεων',
                    times: 'Χρόνια',
                    score: 'Σημεία',
                    anyTimes: 'Οποιαδήποτε φορά μία φορά.',
                    getScore: 'Βαθμολογία',
                    offLimitDuration: 'Απεριόριστη διάρκειας',
                    onLimitDuration: 'Μήκος περιορισμένου χρόνου',
                    commitScore: 'Πρότυπο, σκορ.',
                    excellentScore: 'Εξαιρετικό πρότυπο, σκορ',
                    offLimitTime: 'Απεριόριστος χρόνος',
                    onLimitTime: 'Περιορισμένος χρόνος',
                },
            },
            homePage: {
                common: {
                    useMessage: {
                        hi: 'Γεια.',
                    },
                    callDynamic: {
                        today: 'Σήμερα',
                        yesterday: 'Χθες.',
                        sessions: 'Μια συνεδρία',
                    },
                    todoList: {
                        strip: 'Άρθρο',
                        theSessionIsAddedTolistenLater: 'Η συνεδρία ενώνεται με το "Ακούστε αργότερα"',
                        askYouForHelp: 'Να σου ζητήσω βοήθεια.',
                        iHopeToContactYouLater: 'Αναμένετε να επικοινωνήσετε αργότερα.',
                        lookingForwardToSendingTheInformationLater: 'Περιμένετε να στείλετε υλικό αργότερα αργότερα.',
                        dialogueRisk: 'Η συζήτηση έχει σημεία κινδύνου',
                        tutored: 'Προπονημένοι',
                        goToCounseling: 'Πήγαινε στη συμβουλή',
                        contacted: 'Επαφές',
                        hasBeenSent: 'Αποστολής',
                        areYouSureYouWantToIgnoreIt: 'Είσαι σίγουρος ότι θέλεις να το αγνοήσεις;',
                        determine: 'Προσδιορίστε την ένδειξη αυτών',
                        cancel: 'Ακύρωση',
                        ignore: 'Αγνόηση',
                        checked: 'Προβολή',
                    },
                    callListItem: {
                        strip: 'Άρθρο',
                        learned: 'Μάθηση',
                        keyEvents: 'Γεγονότα κλειδιά',
                        totalImplementationRateOfSupervisionItems: 'Συνολικό ποσοστό εκτέλεσης των στοιχείων εποπτείας',
                    },
                },
                index: {
                    operationSucceeded: 'Επιχείρηση επιτυχής!',
                    sessionDynamics: 'Δυναμική συνεδρίας',
                    my: 'Μου',
                    department: 'Υπηρεσία',
                    company: 'Εταιρεία',
                    toDoList: 'Προς υλοποίηση προς υλοποίηση',
                },
            },
            teamAnalysis: {
                index: {
                    effectiveCallVolumenumber: 'Πρακτικός όγκος κλήσης (μονάδα)',
                    bestPractices: 'Βέλτιστες πρακτικές',
                    averageDurationOfASingleCallminutes: 'Μέση διάρκεια μιας κλήσης (λεπτά)',
                    totalCallVolumePCs: 'Σύνολο κλήσεων (μονάδα)',
                    totalTalkTimehours: 'Συνολική διάρκεια κλήσης (ώρες)',
                    speakingPercentagepercentage: 'Ποσοστό ομιλίας (ποσοστό)',
                    maximumContinuousSpeakingTimeminutes: 'Μέγιστος συνεχής χρόνος ομιλίας (λεπτά)',
                    numberOfIndepthDiscussionsPCs: 'Αριθμός διεξοδικών συζητήσεων (μονάδα)',
                    maximumCustomerTalkminutes: 'Μέγιστη ομιλία πελάτη (λεπτά)',
                    questionFrequencyPCs: 'Συχνότητα ερωτήσεων (μονάδα)',
                    averageValue: 'Μέσος',
                    selectDate: 'Επιλογή ημερομηνίας',
                    personnel: 'Προσωπικό',
                    pleaseSelect: 'Παρακαλώ επιλέξτε.',
                    callRange: 'Εύρος κλήσης',
                    conversationActivity: 'Δραστηριότητα συνεδρίασης',
                    conversationAction: 'Ενέργεια συνεδρίας',
                    keyEvents: 'Γεγονότα κλειδιά',
                    callRecord: 'Καταγραφή κλήσεων',
                    filter: 'Φίλτρο:',
                    conversation: 'Κλήση',
                    minute: 'Πρακτικά',
                    sale: 'Εργαζόμενος',
                },
            },
            saleClientCenter: {
                detail: {
                    index: {
                        january: 'Ιανουάριος',
                        numberOfCalls: 'Αριθμός κλήσεων',
                        accountInformation: 'Πληροφορίες λογαριασμού',
                        month: 'Μήνας',
                        today: 'Σήμερα',
                        customerDetails: 'Στοιχεία πελατών',
                        searchKeywordsInCommunicationContent: 'Αναζήτηση λέξεων-κλειδιών στο περιεχόμενο επικοινωνίας',
                        allMembers: 'Όλα τα Μέλη',
                        reset: 'Επαναφοράς',
                        query: 'Ερώτηση',
                        allTrip: 'Εμφάνιση πλήρους ταξιδιούName',
                        contactOverview: 'Επισκόπηση επικοινωνίας',
                        lastContact: 'Τελευταία επαφή',
                        nextContact: 'Επόμενη επαφή',
                        previous: 'Προηγούμενο άρθρο:',
                        next: 'Επόμενο άρθρο:',
                        viewDetails: 'Λεπτομέρειες προβολής',
                        contactDynamics: 'Δυναμική επαφής',
                        lastYear: 'Πέρυσι',
                        lastCall: 'Τελευταία κλήση',
                        hotTopicsForDiscussion: 'Θερμό θέμα συζήτησης',
                        totalInTheLastYear: 'Τον τελευταίο χρόνο συνολικά.',
                        callTimes: 'Δευτερεύουσα κλήσης',
                    },
                },
                list: {
                    index: {
                        risk: 'Κίνδυνος',
                        have: 'Υπάρχουν.',
                        nothing: 'Κανένα',
                        channel: 'Κανάλ',
                        callRecording: 'Καταγραφή κλήσεων',
                        enterpriseWeChatConversation: 'Πολιτική συνόδου επιχειρήσεων',
                        enterpriseWeChatCall: 'Μικρολόγια επιχειρήσεων',
                        followUpSuggestions: 'Συστάσεις',
                        customer: 'Κέντρο Πελατών',
                        followUp: 'Συνέχεια',
                        personInCharge: 'Υπεύθυνο άτομο',
                        recentFollowup: 'Ακολούθησε πρόσφατα.',
                        lastContactTime: 'Τελευταία ώρα επαφής',
                        operation: 'Λειτουργία',
                        see: 'Προβολή',
                        exceed: 'Περισσότερα.',
                        noActivityForMoreThanDays: 'Ημέρες χωρίς δραστηριότητα',
                        lately: 'Πρόσφατα',
                        risksOccurredInTheLastDays: 'Σημασιολογία κινδύνου εμφανίζονται εντός ημερών.',
                        savedSuccessfully: 'Αποθήκευση με επιτυχία',
                        today: 'Σήμερα',
                        allDepartments: 'Όλα τα τμήματα',
                        allMembers: 'Όλα τα Μέλη',
                        customerName: 'Όνομα πελατών',
                        reset: 'Επαναφοράς',
                        query: 'Ερώτηση',
                        customers: 'Πελάτη',
                        showTheContactInformationBetweenEmployeesAndCustomersInWhichPinkBubblesAreCustomerMessagesAndBlueOnesAreEmployeeMessagesTheLargerTheProportionOfSpeechesTheLargerTheBubbles: 'Εμφάνιση της επαφής μεταξύ εργαζομένων και πελατών, στην οποία ροζ φυσαλίδες είναι μηνύματα πελατών και μπλε φυσαλίδες είναι μηνύματα εργαζομένων. Όσο μεγαλύτερο είναι το ποσοστό των ομιλιών, τόσο μεγαλύτερες είναι οι φυσαλίδες.',
                        riskAllocation: 'Ρύθμιση κινδύνου',
                        preservation: 'Αποθήκευση',
                        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                        noActivityForDays: 'Ημέρες χωρίς δραστηριότητα',
                        riskSemanticsWithinDays: 'Σημασιολογία κινδύνου εμφανίζονται εντός ημερών.',
                        addRiskSemantics: 'Προσθήκη σημασιολογίας κινδύνου',
                        semanticTags: 'Σημασιολογικές ετικέτες:',
                        standardSentence: 'Τυπική πρόταση:',
                    },
                    components: {
                        advancedFilter: {
                            components: {
                                list: {
                                    index: {
                                        addNewConditions: 'Προσθήκη νέας κατάστασης',
                                    },
                                },
                            },
                            index: {
                                meetAllOfTheFollowingConditions: 'Εκπληρώστε όλες τις ακόλουθες προϋποθέσεις',
                            },
                        },
                        advancedFilterButton: {
                            index: {
                                screen: 'Φίλτρος',
                                pleaseSelectFilteringCriteria: 'Παρακαλώ επιλέξτε κριτήρια φίλτρου',
                            },
                        },
                    },
                },
                components: {
                    businessStage: {
                        index: {
                            changeOpportunityStage: 'Αλλαγή ευκαιριών',
                            theCurrentStageIs: 'Το τρέχον στάδιο είναι Ζε',
                            ConfirmToChangeItTo: ', Επιβεβαιώστε την αλλαγή',
                            IsIt: '- Τι;',
                            StageCoStay: '] Στάδια συνολικής διαμονής',
                            day: 'Ημέρα',
                            start: 'Εκκίνηση',
                            end: 'Τέλος:',
                            orderInput: 'Χάνουμε την Τάξη.',
                            restart: 'Επανεκκίνηση',
                            pleaseConfigureTheSalesStageInformation: 'Παρακαλώ ρυθμίστε πληροφορίες πωλήσεων στάδιο',
                            reasonForDocumentInput: 'Λόγος για την απώλεια της παραγγελίας:',
                            completeOrderInput: 'Πλήρης χαμένος γιατρός',
                            pleaseSelectTheReason: 'Παρακαλώ επιλέξτε έναν λόγο',
                        },
                        modal: {
                            customerDynamics: {
                                theManagerSuggests: 'Η διοίκηση συνιστά:',
                            },
                            index: {
                                sessionDetails: 'Λεπτομέρειες συνεδρίας',
                                customerDynamics: 'Δυναμική πελατών',
                                riskPoint: 'Σημείο κινδύνου:',
                                followUpSuggestions: 'Συστάσεις',
                            },
                            sessionDetails: {
                                common: 'Σύνολο',
                                currentlyViewingThe: 'Αριθμός προβολής.',
                                sessions: 'Μια συνεδρία',
                            },
                        },
                    },
                    businessTitle: {
                        index: {
                            theCurrentStageHasStayed: 'Η τρέχουσα φάση έχει σταματήσει.',
                            day: 'Ημέρα',
                        },
                    },
                    business: {
                        index: {
                            reEnableOpportunity: 'Επανεργοποίηση ευκαιριών',
                        },
                    },
                    customerTag: {
                        index: {
                            label: 'Ετικέτας',
                        },
                    },
                    moreCustomer: {
                        index: {
                            essentialInformation: 'Βασικές πληροφορίες',
                            cancel: 'Ακύρωση',
                            confirm: 'Επιβεβαίωση',
                            customer: 'Πελάτη',
                            currentFollowupStage: 'Τρέχουσα φάση παρακολούθησης',
                            telephone: 'Τηλέφωνο',
                            followUpDays: 'Ημέρες παρακολούθησης',
                            day: 'Ημέρα',
                            remarks: 'Παρατηρήσεις',
                            channelPreference: 'Προτίμηση καναλιού',
                            hello: 'Γεια.',
                            customFields: 'Προσαρμοσμένα πεδία',
                            opportunityAmount: 'Ποσό ευκαιρίας',
                            focus: 'Ανησυχήσεις',
                            customerInformation: 'Πληροφορίες πελατών',
                            viewMoreCustomerInformation: 'Δείτε περισσότερες πληροφορίες πελατών',
                        },
                    },
                    table: {
                        components: {
                            row: {
                                row0: {
                                    keyEvents: 'Βασικά γεγονότα:',
                                },
                                row1: {
                                    customerDynamics: 'Δυναμική πελατών',
                                    common: 'Σύνολο',
                                    barDynamic: 'Δυναμικό',
                                },
                                row2: {
                                    riskPoint: 'Σημείο κινδύνου:',
                                    common: 'Σύνολο',
                                    risks: 'Άρθρο Κίνδυνος',
                                },
                                row3: {
                                    followUpSuggestions: 'Συστάσεις',
                                    intelligentRecommendation: 'Ευφυής σύσταση',
                                    strip: 'Άρθρο',
                                    managersSuggestATotalOf: 'Ο διευθυντής προτείνει ένα σύνολο.',
                                    recommendedByManagers: 'Διευθυντής',
                                    creationTime: 'Χρόνος δημιουργίας',
                                    administratorSuggestions: 'Συμβουλές του διαχειριστή',
                                    suggestionsForNewManagers: 'Συμβουλές νέου διαχειριστή',
                                },
                            },
                        },
                        index: {
                            typeTime: 'Τύπος/Ώρας',
                        },
                    },
                    userInfo: {
                        index: {
                            personInCharge: 'Υπεύθυνο άτομο',
                            recentFollower: 'Ακολούθησε πρόσφατα.',
                            startTime: 'Πρώτη φορά πρόσβασης',
                            followUpDays: 'Ημέρες παρακολούθησης',
                            day: 'Ημέρα',
                            remarks: 'Παρατηρήσεις',
                        },
                    },
                },
            },
            studyAnalysis: {
                index: {
                    teamMembers: 'Μέλη της ομάδας',
                    membersLearnTheTotalNumberOfOtherPeoplesConversationsdeDuplicationLookingUpTheDetailsOfTheConversationAndClickingTheRecordingAndPlayingIsRegardedAsLearningOnce: 'Ο συνολικός αριθμός των συνεδριών που έχουν μάθει τα μέλη από άλλα (αποδεκατισμός). Κοιτάζοντας τις λεπτομέρειες συνεδρίας και κάνοντας κλικ στην εγγραφή για να παίξει θεωρείται ως μάθηση μια φορά.',
                    totalNumberOfStudies: 'Συνολικός αριθμός μάθησης',
                    theTotalNumberOfCommentsAndRepliesFromMembersToOtherPeoplesSessionsdeDuplication: 'Ο συνολικός αριθμός των παρατηρήσεων και απαντήσεων που ξεκίνησαν τα μέλη στις συνεδρίες άλλων ατόμων (απόφευκτα)',
                    totalNumberOfInteractions: 'Συνολικός αριθμός αλληλεπιδράσεων',
                    learnTheSumOfConversationCallDuration: 'Άθροισμα της διάρκειας κλήσης συνεδρίας',
                    lengthOfStudy: 'Διάρκεια μάθησης',
                    totalNumberOfMembersWhoInitiatedTheConversationToOthers: 'Ο συνολικός αριθμός των αιτήσεων για βοήθεια από τα μέλη στις συνεδρίες άλλων ανθρώπων (αποδεκατισμός)',
                    totalNumberOfRequests: 'Συνολικός αριθμός αιτήσεων βοήθειας',
                    totalNumberOfMembersCounselingOthersForHelpdeDuplication: 'Συνολικός αριθμός των μελών που παρέχουν συμβουλές για βοήθεια από άλλους (αποδεκατίσματα)',
                    totalCounseling: 'Συνολικός αριθμός εκπαιδευτικών',
                    totalNumberOfMemberSessionsToOthersAddedToTheCaseBasedeDuplication: 'Ο συνολικός αριθμός των συνεδριών των μελών προς άλλα που προστέθηκαν στη βιβλιοθήκη περίπτωσης (αποδεκατισμός)',
                    addCase: 'Προσθήκη περίπτωση',
                    totalNumberOfSubscriptionsMadeByMembersToOtherPeoplesSessionsdeDuplication: 'Συνολικός αριθμός συνδρομών μελών σε συνεδρίες άλλων ατόμων (απόφευκτα)',
                    subscribe: 'Συνδρομής',
                    totalNumberOfSessionsCommunicatedByMembers: 'Συνολικός αριθμός συνόδων που ανακοινώνονται από τα μέλη',
                    totalSessions: 'Σύνολο συνόδων',
                    theTotalNumberdeDuplicationOfAMembersOwnSessionItIsDeemedToBeAReplayIfTheMemberHasCheckedTheSessionDetailsAndClickedTheRecordingAndPlayback: 'Ο συνολικός αριθμός των μελών που επαναλαμβάνουν τις συνεδρίες τους (αποδεκατισμός), αναζητώντας τις λεπτομέρειες της συνεδρίας και κάνοντας κλικ στην εγγραφή για να αναπαραχθεί είναι σε σχέση με την εγγραφή. σαν επανάληψη μια φορά.',
                    totalNumberOfDoubleDisk: 'Συνολικός αριθμός redisks',
                    totalNumberOfDuplicateDiskTotalNumberOfSessions: 'Συνολικός αριθμός ρυθμίσεων/συνολικός αριθμός συνεδριών * 100%',
                    proportionOfDoubleDisk: 'Η αναλογία του διπλού δίσκους',
                    summationOfConversationCallDurationOfDuplicateDisk: 'Σύνοψη της συνεδρίας διάρκεια κλήσεως του εναλλασσόμενου δίσκου',
                    resumptionDuration: 'Διάρκεια ανακοίνωσης',
                    totalNumberOfRequestsForHelpFromMembersForTheirOwnSessionsdeDuplication: 'Ο συνολικός αριθμός των μελών που ξεκίνησαν βοήθεια για τη δική τους συνεδρίαση (αποδεκατισμός)',
                    theTotalNumberOfCommentsincludingRepliesReceivedByOthersInAMembersSession: 'Ο συνολικός αριθμός παρατηρήσεων (συμπεριλαμβανομένων των απαντήσεων) που έλαβε η συνεδρίαση του μέλους',
                    theTotalNumberOfSessionsOfMembersAddedToTheCaseBaseByOthersdeDuplication: 'Συνολικός αριθμός συνεδριών μελών που προστέθηκαν στη βιβλιοθήκη υποθέσεων από άλλους',
                    theTotalNumberOfMemberSessionsSubscribedByOthersdeDuplication: 'Συνολικός αριθμός συνεδριών μελών που εγγράφονται από άλλους (απόφευκτα)',
                    askForHelpInTheLastMonth: 'Τον περασμένο μήνα για βοήθεια.',
                    lastTimeForHelp: 'Τελευταία φορά να ζητήσω βοήθεια.',
                    operation: 'Λειτουργία',
                    viewAllSessionsInTheLastMonth: 'Προβολή όλων των συνεδριών του τελευταίου μήνας',
                    allDepartments: 'Όλα τα τμήματα',
                    reset: 'Επαναφοράς',
                    query: 'Ερώτηση',
                    altogether: 'A',
                    secondSession: 'Δευτερεύουσα συνεδρία',
                },
            },
            checkPointTest: {
                components: {
                    testSelectComponent: {
                        currentTestItems: 'Τρέχον έργο δοκιμής:',
                        supervisionItem: 'Είδη εποπτείας',
                        keyEvents: 'Γεγονότα κλειδιά',
                    },
                },
                index: {
                    pleaseCheckTheMonitoringItemsOrKeyEventsToBeTestedAndEnsureThatThereAreCallsInTheSimulatedDialogue: 'Παρακαλώ ελέγξτε τα στοιχεία παρακολούθησης ή τα βασικά γεγονότα που θέλετε να δοκιμάσετε και βεβαιωθείτε ότι υπάρχει περιεχόμενο ομιλίας στην προσομοιωμένη συνομιλία',
                },
            },
            executionAnalysis: {
                index: {
                    executiveForceAnalysis: 'Ανάλυση εκτέλεσης',
                },
            },
            konwledgeBase: {
                detail: {
                    components: {
                        richTextList: {
                            process: 'Διαδικασία 1',
                            technologicalProcess: 'Διαδικασία',
                            newProcess: 'Νέα διαδικασία',
                        },
                    },
                    index: {
                        upload: 'Αποστολής',
                        preservation: 'Αποθήκευση',
                        newlyBuild: 'Νέο',
                        cancel: 'Ακύρωση',
                        name: 'Όνομα',
                        describe: 'Περιγραφή',
                        type: 'Τύπος',
                        classification: 'Ταξινόμηση',
                        content: 'Περιεχόμενο',
                        enclosure: 'Προσάρτηση',
                        knowledgePointAssociation: 'Σύνδεση σημείων γνώσης',
                        open: 'Άνοιγμα:',
                        close: 'Κλείσιμο',
                        operator: 'Αερομεταφορέας',
                        logic: 'Λογική',
                        see: 'Προβολή',
                        edit: 'Επεξεργασία',
                    },
                },
                index: {
                    name: 'Όνομα',
                    describe: 'Περιγραφή',
                    createdBy: 'Δημιουργός',
                    type: 'Τύπος',
                    lastUpdated: 'Τελευταία ώρα ενημέρωσης',
                    numberOfReferences: 'Αριθμός αναφορών',
                    operation: 'Λειτουργία',
                    see: 'Προβολή',
                    edit: 'Επεξεργασία',
                    delete: 'Διαγραφή',
                    categoryDeletedSuccessfully: 'Κατηγορία διαγράφηκε με επιτυχία',
                    classificationOfKnowledgePoints: 'Ταξινόμηση των σημείων γνώσης',
                    newlyBuild: 'Νέο',
                    knowledgeBase: 'Βάση γνώσης',
                    knowledgePoints: 'Σημεία γνώσης',
                    technologicalProcess: 'Διαδικασία',
                    keyword: 'Λέξη κλειδιά',
                    batchExport: 'Εξαγωγή παρτίδας',
                    batchDelete: 'Διαγραφή παρτίδας',
                    importProcess: 'Διαδικασία εισαγωγής',
                    importKnowledgePoints: 'Εισαγωγή σημείων γνώσης',
                    ifTheKnowledgePointDoesNotExistInTheKnowledgeBaseAddTheKnowledgePointDirectlyIfItExistsSkipAndDoNotUpdate: 'Εάν το σημείο γνώσης δεν υπάρχει στη βάση γνώσεων, προσθέστε το σημείο γνώσης απευθείας. παραλείψτε το και μην το ενημερώσετε.',
                    editKnowledgePointClassification: 'Επεξεργασία ταξινόμησης σημείων γνώσης',
                    newKnowledgePointClassification: 'Ταξινόμηση νέων σημείων γνώσης',
                    categoryEditingSucceeded: 'Επιτυχία επεξεργασίας κατηγορίας',
                    newClassificationSucceeded: 'Νέα κατηγορία με επιτυχία',
                    classificationName: 'Όνομα κατηγορίας',
                },
            },
            monitoringReport: {
                index: {
                    executiveSupervision: 'Εποπτεία εκτελεστικών δυνάμεων',
                },
            },
            topicCallout: {
                index: {
                    whole: 'Όλα',
                    date: 'Ημερομηνία',
                    dimensionStatus: 'Κατάσταση κλήσης',
                    callRecordID: 'ID καταγραφής κλήσεων',
                    callRecordIDMustBeNumeric: 'Το ID καταγραφής κλήσεων πρέπει να είναι ένας αριθμός',
                    strip: 'Άρθρο',
                    topicAnnotation: 'Θέμα κλήσης',
                    annotated: 'Ετικέτας',
                    stripNotMarked: 'Ράβδος, μη επισήμανσης',
                    barInDimension: 'Ράβδοι, σε κάλεσμα',
                    customer: 'Πελάτη',
                    sale: 'Πωλήσεις',
                    common: 'Σύνολο',
                    sessions: 'Συνεδρίες',
                    currentTopic: 'Τρέχον θέμα:',
                    staff: 'Εργαζόμενος',
                    topicOfConversation: 'Θέμα:',
                    theOperationIsSuccessfulAndTheDimensionHasBeenReset: 'Επιτυχία λειτουργίας, επαναφορά κλήσης',
                    afterResetAllTheAnnotationRecordsOfThisCommunicationSessionWillBeClearedPleaseConfirm: 'Μετά την επαναφορά, όλα τα αρχεία ετικέτας αυτής της συνεδρίας θα εκκαθαριστούν. Επιβεβαιώστε παρακαλώ.',
                    resetAll: 'Επαναφορά όλων',
                    pleaseSelectTheTopicToBeMarked: 'Παρακαλώ επιλέξτε ένα θέμα για την ετικέτα της ετικέτας',
                    pleaseTickTheSentenceToBeMarked: 'Παρακαλώ ελέγξτε την πρόταση που θα σημειωθεί.',
                    theOperationIsSuccessfulAndTheAnnotationHasTakenEffect: 'Η λειτουργία πέτυχε, η ετικέτα άρχισε να ισχύει.',
                    theScopeOfThisAnnotationIncludesMessagesOfOtherTopicsClickOKToCoverThem: 'Το πεδίο εφαρμογής αυτής της σημείωσης περιλαμβάνει μηνύματα από άλλα θέματα. Κάντε κλικ στο OK για να τα αντικαταστήσετε.',
                    confirmDimensions: 'Επιβεβαίωση κλήσης',
                    talkTime: 'Ώρα για ομιλία.',
                    callID: 'Κλήση ID',
                },
            },
            topicList: {
                index: {
                    callID: 'Κωδικός κλήσης',
                    latestMarkedTime: 'Τελευταία ώρα σημείωσης',
                    topicOfConversation: 'Θέμα:',
                    numberOfSentences: 'Αριθμός προτάσεων',
                    sentence: 'Ποινή',
                    operation: 'Λειτουργία',
                    see: 'Προβολή',
                    delete: 'Διαγραφή',
                    edit: 'Επεξεργασία',
                    newSubTopic: 'Νέο υποθέματο',
                    move: 'Μετακίνηση',
                    whole: 'Όλα',
                    topicDeletedSuccessfully: 'Το θέμα διαγράφηκε με επιτυχία',
                    newlyBuild: 'Νέο',
                    topicList: 'Κατάλογος θεματικών ειδών',
                    callIDMustBeNumeric: 'Ταυτότητα κλήσης πρέπει να είναι ένας αριθμός',
                    leadInTopic: 'Εισαγωγή Θέματος',
                    whenTheCategoryNameIsRepeatedTheOriginalTopicCategoryWillNotBeOverwrittenThisItemWillBeSkippedDirectlyAndWillNotBeImported: 'Εάν η ονομασία της κατηγορίας είναι διπλή, η αρχική κατηγορία θεμάτων δεν θα αντικατασταθεί, και το αντικείμενο θα παραλείψει και δεν θα εισαχθεί.',
                    mobileClassification: 'Κινητή ταξινόμηση',
                    editTopic: 'Επεξεργασία Θέματος',
                    newTopic: 'Νέο θέμα',
                    topicName: 'Όνομα θεματικού',
                },
            },
            groupTest: {
                detail: {
                    template: {
                        modificationSucceeded: 'Επιτυχία τροποποίησης',
                        createdSuccessfully: 'Δημιουργήθηκε επιτυχώς.',
                        modificationFailed: 'Η τροποποίηση απέτυχε',
                        creationFailed: 'Αποτυχία δημιουργίας',
                        monitoringName: 'Όνομα παρακολούθησης',
                        upToCharacters: 'Μέγιστο ποσό 40 χαρακτήρων',
                        pleaseEnterAName: 'Παρακαλώ εισάγετε ένα όνομα',
                        monitoringIndicators: 'Δείκτης παρακολούθησης',
                        sessionActivity: 'Δραστηριότητα συνεδρίασης',
                        conversationAction: 'Ενέργεια συνεδρίας',
                        keyEvents: 'Γεγονότα κλειδιά',
                        supervisionItems: 'Είδη εποπτείας',
                        monitoringMembers: 'Μέλη παρακολούθησης',
                        groupReceivingGuidanceTrainingOrManagementIntervention: 'Ομάδες που λαμβάνουν καθοδήγηση, εκπαίδευση ή παρεμβάσεις διαχείρισης',
                        groupA: 'Ομάδα Α',
                        pleaseSelectGroupAData: 'Παρακαλώ επιλέξτε δεδομένα της ομάδας Α',
                        thereAreDuplicateUsersInGroupB: 'Διπλή χρήσης στην ομάδα Β',
                        groupARemarks: 'Παρατηρήσεις',
                        controlGroupGroupComparedWithGroupA: 'Ομάδα ελέγχου, σε σύγκριση με την ομάδα Α',
                        groupB: 'Ομάδα Β',
                        pleaseSelectGroupBData: 'Παρακαλώ επιλέξτε δεδομένα της ομάδας Β',
                        thereAreDuplicateUsersInGroupA: 'Υπάρχουν διπλοί χρήστες στην ομάδα Α',
                        groupBRemarks: 'Παρατηρήσεις της ομάδας Β',
                        monitoringPeriod: 'Κύκλος παρακολούθησης',
                        startNode: 'Έναρξη κόμβος',
                        monitoringScope: 'Εύρος παρακολούθησης',
                        pleaseSelectMonitoringConditions: 'Παρακαλώ επιλέξτε συνθήκες παρακολούθησης',
                        pleaseEnterANumber: 'Παρακαλώ εισάγετε έναν αριθμό',
                        pleaseSelectATimePeriod: 'Παρακαλώ επιλέξτε μια χρονική περίοδος',
                        preservation: 'Αποθήκευση',
                        cancel: 'Ακύρωση',
                    },
                },
                list: {
                    template: {
                        deletionSucceeded: 'Διαγραφή με επιτυχία',
                        notStarted: 'Δεν ξεκίνησες',
                        haveInHand: 'Σε εξέλιξη.',
                        closed: 'Τέλος.',
                        newGroupTest: 'Νέα δοκιμή ομάδας',
                    },
                },
            },
            businessConfiguration: {
                salesStage1: 'Φάση πωλήσεων',
                communicationStrategy1: 'Στρατηγική επικοινωνίας',
                riskAllocation: 'Ρύθμιση κινδύνου',
                businessConfiguration: 'Ρύθμιση επιχειρήσεων',
                communicationStrategy: {
                    detail: {
                        components: {
                            pushRichText: {
                                index: {
                                    objectionHandlingScript: 'Χειρισμός ένστασης',
                                    productSellingPointScript: 'Σημεία πώλησης προϊόντων',
                                    caseGrouping: 'Ομάδα υποθέσεων',
                                    pleaseSelectExcellentCases: 'Παρακαλώ επιλέξτε μια καλή υπόθεση.',
                                    pleaseSelectKnowledgePoints: 'Παρακαλώ επιλέξτε ένα σημείο γνώσης',
                                    associativeLinks: 'Σχετικοί δεσμοί',
                                    jumpTo: 'Πήδα.',
                                    jumpType: 'Τύπος άλμας',
                                    knowledgePoints: 'Σημεία γνώσης',
                                    excellentCases: 'Εξαιρετική περίπτωση',
                                    excellentScript: 'Εξαιρετικός ομιλίας',
                                    pleaseSelectASingleKnowledgePoint: 'Παρακαλώ επιλέξτε ένα μόνο σημείο γνώσης',
                                },
                            },
                        },
                        index: {
                            name: 'Όνομα',
                            pushText: 'Πίεση κειμένου',
                            enableStatus: 'Ενεργοποιημένη κατάσταση',
                            triggerRules: 'Κανόνας ενεργοποίησης',
                            communicationStrategy: 'Στρατηγική επικοινωνίας',
                        },
                    },
                    list: {
                        index: {
                            communicationStrategyGrouping: 'Ομάδα στρατηγικής επικοινωνίας',
                            name: 'Όνομα',
                            pushText: 'Πίεση κειμένου',
                            effectiveness: 'Αποτελεσματικότητα',
                            openSuccessfully: 'Άνοιγμα με επιτυχία',
                            closeSuccessfully: 'Κλείσιμο με επιτυχία',
                            operationFailed: 'Η λειτουργία απέτυχε',
                            operation: 'Λειτουργία',
                            edit: 'Επεξεργασία',
                            delete: 'Διαγραφή',
                            newlyBuild: 'Νέο',
                            communicationStrategy: 'Στρατηγική επικοινωνίας',
                            editGroup: 'Επεξεργασία ομαδοποίησης',
                            groupName: 'Όνομα ομάδας',
                        },
                    },
                },
                riskStatement: {
                    detail: {
                        components: {
                            riskSettingRule: {
                                index: {
                                    allSessions: 'Όλες οι συνεδρίες',
                                    recentDays: 'Πρόσφατες ημέρες',
                                    recentSessions: 'Πρόσφατες συνεδρίες',
                                    scopeOfApplication: 'Πεδίο εφαρμογής:',
                                    day: 'Ημέρα',
                                    through: 'Πέραση',
                                },
                            },
                        },
                        index: {
                            describe: 'Περιγραφή',
                            applicableCustomers: 'Εφαρμόζεται για τους πελάτες',
                            enableStatus: 'Ενεργοποιημένη κατάσταση',
                            triggerRules: 'Κανόνας ενεργοποίησης',
                            riskRules: 'Κανόνες κινδύνου',
                        },
                    },
                    list: {
                        index: {
                            riskAllocation: 'Ρύθμιση κινδύνου',
                            keyWord: 'Λέξεις-κλειδιά',
                            newRiskRule: 'Νέος κανόνας κινδύνου',
                            riskRuleName: 'Ονοματεπώνυμο κανόνα κινδύνου',
                            describe: 'Περιγραφή',
                            state: 'Κατάσταση',
                            openSuccessfully: 'Άνοιγμα με επιτυχία',
                            closeSuccessfully: 'Κλείσιμο με επιτυχία',
                            operationFailed: 'Η λειτουργία απέτυχε',
                            operation: 'Λειτουργία',
                            edit: 'Επεξεργασία',
                            delete: 'Διαγραφή',
                            deletionSucceeded: 'Διαγραφή με επιτυχία',
                        },
                    },
                },
                salesStage: {
                    detail: {
                        components: {
                            alias: {
                                orderInput: 'Χάνουμε την Τάξη.',
                            },
                            endReasonList: {
                                addEndReason: 'Προσθήκη λόγου τέλης',
                                enterEndReason: 'Εισάγετε λόγο τέλη',
                            },
                            stageList: {
                                keyEvents: 'Γεγονότα κλειδιά',
                                waysideData: 'Στοιχεία παρακολούθησης των οδών',
                                includeAny: 'Περιέχει όλο',
                                includeAll: 'Περιέχει όλο',
                                pleaseEnterTheStageName: 'Παρακαλώ εισάγετε όνομα φάσης',
                                setStageRules: 'Ορισμός κανόνων σταδίου',
                                stageName: 'Όνομα φάσης',
                                operator: 'Αερομεταφορέας',
                                logic: 'Λογική',
                            },
                        },
                        index: {
                            theInputFormatOfTheTimeTypeFieldIs: 'Μορφή εισόδου τύπου πεδίου χρόνου: 2022-12-31 00:00:000',
                            requestFailedPleaseTryAgainLater: 'Η αίτηση απέτυχε, παρακαλώ προσπαθήστε ξανά αργότερα.',
                            salesStage: 'Φάση πωλήσεων',
                            essentialInformation: 'Βασικές πληροφορίες',
                            name: 'Όνομα',
                            applicableDepartments: 'Εφαρμοζόμενη υπηρεσία',
                            applicableToOthers: 'Εφαρμόζεται σε άλλα',
                            manualChangePhase: 'Χειροκίνητη αλλαγή φάσης',
                            enableStatus: 'Ενεργοποιημένη κατάσταση',
                            describe: 'Περιγραφή',
                            opportunityStageSettings: 'Ρυθμίσεις φάσης ευκαιρίας',
                            stageSettings: 'Ρυθμίσεις φάσης',
                            aliasSettings: 'Ρυθμίσεις ονόματος',
                            closeOpportunity: 'Τέλος Ευκαιρίας',
                            newSuccessfully: 'Νέα Επιτυχία',
                            newFailed: 'Νέα απέτυχε',
                            savingSucceeded: 'Αποθήκευση με επιτυχία',
                            saveFailed: 'Αποτυχία αποθήκευσης',
                        },
                    },
                    list: {
                        index: {
                            salesStage: 'Φάση πωλήσεων',
                            keyWord: 'Λέξεις-κλειδιά',
                            newSalesStage: 'Νέο στάδιο πωλήσεων',
                            salesStageName: 'Ονοματεπώνυμο στάδιο πωλήσεων',
                            describe: 'Περιγραφή',
                            state: 'Κατάσταση',
                            openSuccessfully: 'Άνοιγμα με επιτυχία',
                            closeSuccessfully: 'Κλείσιμο με επιτυχία',
                            operationFailed: 'Η λειτουργία απέτυχε',
                            operation: 'Λειτουργία',
                            edit: 'Επεξεργασία',
                            delete: 'Διαγραφή',
                            deletionSucceeded: 'Διαγραφή με επιτυχία',
                        },
                    },
                },
                largeModelGeneration: {
                    index: {
                        largeModelGeneration: 'Παραγωγή μεγάλου μοντέλου',
                        conversationInsights: 'Στοιχεία συνεδρίασης',
                    },
                    sessionsInsight: {
                        components: {
                            autoGenerate: {
                                index: {
                                    automaticGeneration: 'Δημιουργείται αυτόματα',
                                },
                            },
                            hooks: {
                                conversationSummary: 'Περίληψη συνεδρίας',
                                conversationProcess: 'Διαδικασία συνεδρίας',
                                opportunityPoints: 'Σημείο ευκαιρίας',
                            },
                            prompt: {
                                index: {
                                    edit: 'Επεξεργασία',
                                    restoreDefault: 'Επαναφορά προκαθορισμένου',
                                    cancel: 'Ακύρωση',
                                    confirm: 'Επιβεβαίωση',
                                },
                            },
                        },
                        index: {
                            saveSuccessful: 'Αποθήκευση με επιτυχία',
                            hintLanguage: 'Ζήτηση',
                            preserve: 'Αποθήκευση',
                            cancel: 'Ακύρωση',
                        },
                    },
                },
            },
            salesBusinessConfigurationEntry: {
                largeModelGeneration: 'Παραγωγή μεγάλου μοντέλου',
                salesStage: 'Φάση πωλήσεων',
                communicationStrategy: 'Στρατηγική επικοινωνίας',
                riskAllocation: 'Ρύθμιση κινδύνου',
                businessConfiguration: 'Ρύθμιση επιχειρήσεων',
            },
            salesLearningCenter: {
                knowledgeBase: 'Βάση γνώσης',
                speechCorpus: 'Βιβλιοθήκη ομιλίας',
                learningCenter: 'Κέντρο εκπαίδευσης',
            },
            customerFields: {
                components: {
                    baseFields: {
                        index: {
                            customerInformation: 'Πληροφορίες πελατών',
                        },
                    },
                },
                index: {
                    otherInformation: 'Άλλες πληροφορίες',
                },
            },
        },
        intelligentAnalysis: {
            ruleTemplate: {
                components: {
                    importButton: {
                        index: {
                            import: 'Εισαγωγή',
                        },
                    },
                },
                hooks: {
                    index: {
                        questionnaire: 'Ερωτηματολόγο',
                        eCommerceReview: 'Επισκόπηση ηλεκτρονικού εμπορίου',
                        socialMediaComments: 'Σχόλια Κοινωνικών Μέσων',
                        mixing: 'Ανάμειξη',
                        videoCall: 'Κλήση βίντεο',
                        all: 'Όλα',
                        intelligentModel: 'Ευφυές μοντέλο',
                        smartRules: 'Έξυπνοι κανόνες',
                        manualScoring: 'Χειροκίνητη βαθμολογία',
                        enable: 'Ενεργοποίηση ενεργοποίησης',
                        notEnabled: 'Μη ενεργοποιημένο',
                        voiceCall: 'Κλήση φωνής',
                        textDialogue: 'Διάλογο κειμένου',
                        ecommerceTextSession: 'Συνεδρία κειμένου ηλεκτρονικού εμπορίου',
                        workOrder: 'Σειρά εργασίας',
                    },
                },
                index: {
                    language: 'Γλώσσα',
                    mixing: 'Ανάμειξη',
                    videoCall: 'Κλήση βίντεο',
                    ruleName: 'Όνομα κανόνας',
                    ruleType: 'Τύπος κανόνας',
                    pleaseSelect: 'Παρακαλώ επιλέξτε.',
                    ruleStatus: 'Κατάσταση κανόνας',
                    dataSourceType: 'Τύπος πηγής δεδομένων',
                    voiceCall: 'Κλήση φωνής',
                    textDialogue: 'Διάλογο κειμένου',
                    ecommerceTextSession: 'Συνεδρία κειμένου ηλεκτρονικού εμπορίου',
                    workOrder: 'Σειρά εργασίας',
                    status: 'Κατάσταση',
                    operation: 'Λειτουργία',
                    edit: 'Επεξεργασία',
                    ruleTemplate: 'Πρότυπο κανόνων',
                },
            },
            analysisReportTitle: 'Έκθεση ανάλυσης',
            ruleTest: 'Δοκιμή κανόνα',
            intelligentTags: {
                publicOpinionLabel: 'Σήμανση της κοινής γνώμης',
                businessLabel: 'Επιχειρηματική ετικέτα:',
                userLabel: 'Ετικέτα χρήστη',
                productLabel: 'Ετικέτα προϊόντων',
                labelDisplayQuantity: 'Ποσότητα εμφάνισης ετικετών',
                unlimited: 'Απεριόριστο',
                ignoringTagLibraries: 'Παράβλεψη βιβλιοθήκης ετικέτας',
                automaticallyGenerateLabels: 'Δημιουργία ετικέτων αυτόματα',
                afterActivationLabelsAreAutomaticallyGeneratedForTheSessionBasedOnTheLargeModelAndTheGeneratedLabelsAreClassifiedAsunclassifiedByDefault: 'Μετά την ενεργοποίηση της συνεδρίας, οι ετικέτες δημιουργούνται αυτόματα με βάση το μεγάλο μοντέλο, και οι ετικέτες που δημιουργούνται είναι ταξινομημένες κάτω από την προεπιλεγμένη κατηγορία.',
                defaultValidity: 'Προκαθορισμένη αποτελεσματικότητα',
                supervisionItem: 'Είδη εποπτείας',
                customerLabel: 'Ετικέτα πελατών',
                newSupervisionItemRule: 'Κανόνας νέου ειδών εποπτείας',
                editSupervisionItemRule: 'Επεξεργασία εποπτευόμενων αντικειμένων κανόνας',
                newCustomerLabel: 'Νέα ετικέτα πελατών',
                editCustomerLabel: 'Επεξεργασία ετικέτες πελατών',
                newSessionLabel: 'Νέα ετικέτα συνεδρίας',
                editSessionLabel: 'Επεξεργασία ετικέτας συνεδρίας',
                newKeyEvent: 'Νέο γεγονός κλειδιού',
                editKeyEvents: 'Επεξεργασία γεγονότος κλειδιού',
                detail: {
                    template: {
                        type: 'Τύπος',
                        rules: 'Κανόνες',
                        language: 'Γλώσσα',
                        pleaseSelectLanguage: 'Παρακαλώ επιλέξτε μια γλώσσα',
                        nameIsARequiredField: 'Το όνομα είναι ένα απαιτούμενο πεδίο',
                    },
                    formItemComponent: {
                        ifTheDialogDoesNotMeetTheFollowingOperatorConditionsTheLargeModelIsUsedToDetermineIfTheDialogDoesNotMeetTheFollowingOperatorConditions: 'Εάν ο διάλογος δεν πληροί τις ακόλουθες προϋποθέσεις του χειριστή, το μεγάλο μοντέλο χρησιμοποιείται για να προσδιορίσει εάν ο διάλογος δεν πληροί τις ακόλουθες προϋποθέσεις χειριστή.',
                        largeModelExtensionLabel: 'Μεγάλες ετικέτες επέκτασης μοντέλου',
                        sessionRecordID: 'ID εγγραφής συνεδρίας',
                        sessionTime: 'Ώρα συνεδρίας',
                        smartTags: 'Έξυπνη ετικέταName',
                        viewDetails: 'Λεπτομέρειες προβολής',
                        afterDeletionTheDataRecordedInThisSessionWillBeClearedAreYouSureYouWantToDeleteIt: 'Μετά τη διαγραφή, τα δεδομένα αυτής της συνεδρίας θα εκκαθαριστούν. Σίγουρα θα το διαγράψεις;',
                        tagData: 'Δεδομένα ετικέτας',
                        batchDeletion: 'Διαγραφή παρτίδας',
                    },
                    component: {
                        pleaseSelectAtLeastOneModel: 'Παρακαλώ επιλέξτε τουλάχιστον ένα μοντέλο',
                        userLabel: 'Ετικέτα χρήστη',
                        productLabel: 'Ετικέτα προϊόντων',
                        publicOpinionLabel: 'Σήμανση της κοινής γνώμης',
                    },
                },
                template: {
                    labelExtraction: 'Εξαγωγή ετικετών',
                    presetLabelGroup: 'Ομάδα προκαταρκτικής ετικέτας',
                    customLabelGroup: 'Προσαρμοσμένη ομάδα ετικέτας',
                    generateLabelsAutomatically: 'Δημιουργία ετικέτων αυτόματα',
                    recordingTime: 'Χρόνος εγγραφής',
                    youCanSelectUpToOneMonthDaysOfRecordsInTheLastYear: 'Μπορείτε να επιλέξετε έως ένα μήνα (31 ημέρες) εγγραφών το τελευταίο έτος.',
                    advancedFiltering: 'Προχωρημένη φιλτράριση',
                    dataType: 'Τύπος δεδομένων',
                    filterCriteria: 'Κατάσταση φίλτρου',
                    edit: 'Επεξεργασία',
                    createANewSubcategory: 'Νέα υποκατηγορία',
                    delete: 'Διαγραφή',
                    nameLengthCannotExceed: 'Το μήκος του ονόματος δεν μπορεί να υπερβαίνει το 40.',
                },
                component: {
                    firstCreationMethod: 'Πρώτη Μέθοδος Δημιουργίας',
                    createManually: 'Δημιουργία χειροκίνητα',
                    largeModelCreation: 'Μεγάλο μοντέλο δημιουργίας',
                    language: 'Γλώσσα',
                    modelExpansion: 'Επέκταση μοντέλου',
                    enable: 'Ενεργοποίηση ενεργοποίησης',
                    notEnabled: 'Μη ενεργοποιημένο',
                    standardScreening: 'Τυπικό φίλτρο',
                    advancedFiltering: 'Προχωρημένη φιλτράριση',
                },
                components: {
                    autoGenerateTagsModal: {
                        afterOpeningTagsAreAutomaticallyGeneratedForSessionsBasedOnLargeModelsTheGeneratedTagsAreClassifiedUnderLargeModelTagsByDefault: 'Μετά το άνοιγμα, οι ετικέτες δημιουργούνται αυτόματα για συνεδρίες με βάση μεγάλα μοντέλα. Οι ετικέτες που δημιουργούνται κατατάσσονται στο "Μεγάλες Ετικέτες Μοντέλο" από προεπιλογή.',
                        labelingRequirements: 'Απαιτήσεις επισήμανσης',
                        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                        tagIgnored: 'Η ετικέτα αγνοήθηκε.',
                        pleaseEnterTheLabelToBeIgnoredAndEnterTheCarToBeAddedAutomatically: 'Παρακαλώ εισάγετε την ετικέτα που θα αγνοηθεί και εισάγετε το αυτοκίνητο που θα προστεθεί αυτόματα.',
                        batchFilterLabel: 'Ετικέτα φίλτρου παρτίδας',
                    },
                    tagExtractModal: {
                        taskType: 'Τύπος εργασίας',
                        immediateExecution: 'Άμεση εκτέλεση',
                        timingExecution: 'Εκτέλεση χρονομέτρησης',
                        executionFrequency: 'Συχνότητα εκτέλεσης',
                        pleaseSelectAnExecutionFrequency: 'Παρακαλώ επιλέξτε μια συχνότητα εκτέλεσης',
                        timeFrameCannotExceedDays: 'Το χρονικό πλαίσιο δεν μπορεί να υπερβαίνει τις 30 ημέρες',
                        scheduledTaskInEffect: 'Προγραμματισμένη εργασία',
                        pleaseStartUsingAfterDataProcessingIsComplete: 'Παρακαλώ αρχίστε τη χρήση μετά την ολοκλήρωση της επεξεργασίας δεδομένων',
                        endTask: 'Τέλος εργασίας',
                        viewTasks: 'Προβολή εργασιών',
                        voiceCall: 'Κλήση φωνής',
                        textDialogue: 'Διάλογο κειμένου',
                        workOrder: 'Σειρά εργασίας',
                        formValidationFailed: 'Η επικύρωση της φόρμας απέτυχε:',
                        labelExtraction: 'Εξαγωγή ετικετών',
                        dataSource: 'Πηγή δεδομένων',
                        pleaseSelectADataSource: 'Παρακαλώ επιλέξτε μια πηγή δεδομένων',
                        dataTimeRange: 'Εύρος χρόνου δεδομένων',
                        pleaseSelectATimeRange: 'Παρακαλώ επιλέξτε ένα χρονικό εύρος',
                        selectUpToDaysOfData: 'Επιλέξτε έως και 30 ημέρες δεδομένων',
                        extractionQuantityUpperLimit: 'Ποσότητα εξαγωγής',
                        pleaseEnterTheMaximumExtractionQuantity: 'Παρακαλώ εισάγετε τη μέγιστη ποσότητα εξαγωγής',
                        addToClassification: 'Προσθήκη στην ταξινόμηση',
                        pleaseSelectALabelClassification: 'Παρακαλώ επιλέξτε μια ταξινόμηση ετικέτας',
                        extractionRequirements: 'Απαιτήσεις εξαγωγής',
                        pleaseEnterExtractionRequirementsoptional: 'Παρακαλώ εισάγετε απαιτήσεις εξαγωγής (προαιρετικά)',
                        submittedSuccessfullyStartCreatingTags: 'Υποβολή με επιτυχία, έναρξη δημιουργίας ετικετών',
                        checkLater: 'Ελέγξτε αργότερα.',
                    },
                    timeRange: {
                        index: {
                            today: 'Σήμερα',
                            yesterday: 'Χθες το βράδυ.',
                            theDayBeforeYesterday: 'Προχθές μέρα.',
                            thisWeek: 'Αυτή την εβδομάδα.',
                            lastWeek: 'Την περασμένη εβδομάδα.',
                            thisMonth: 'Αυτό το μήνα',
                            lastMonth: 'Τον περασμένο μήνα.',
                        },
                    },
                },
            },
            businessAnalysis: {
                detail: {
                    businessAnalysisFiter: {
                        component: {
                            keyWord: 'Λέξεις-κλειδιά',
                            sessionLabel: 'Ετικέτα συνεδρίας',
                            keyEvents: 'Γεγονότα κλειδιά',
                            matchAny: 'Ταίριασμα οποιασδήποτες',
                            matchAll: 'Ταίριασμα όλων',
                            beEqualTo: 'Ίση',
                            includeAll: 'Περιέχει όλο',
                            includeAny: 'Περιέχει όλο',
                            advancedConditions: 'Προχωρημένες συνθήκες',
                            smartTag: 'Έξυπνη ετικέταName',
                            smartTagI: 'Έξυπνη ετικέτα ένας',
                            smartTagII: 'Έξυπνη ετικέτα II',
                        },
                        template: {
                            pleaseSelectSmartTag: 'Παρακαλώ επιλέξτε μια έξυπνη ετικέτα.',
                            pleaseSelectASessionLabel: 'Παρακαλώ επιλέξτε μια ετικέτα συνεδρίας',
                            pleaseSelectAKeyEvent: 'Παρακαλώ επιλέξτε ένα γεγονός κλειδιού',
                            pleaseSelectAdvancedCondition: 'Παρακαλώ επιλέξτε προηγμένα κριτήρια',
                            newAdvancedFilter: 'Νέο προηγμένο φίλτρο',
                            moveUp: 'Μετακίνηση πάνω',
                            moveDown: 'Μετακίνηση προς τα κάτι',
                            moveLeft: 'Μετακίνηση αριστερά',
                            shiftRight: 'Μετακίνηση δεξιά',
                        },
                    },
                    component: {
                        businessAnalysispng: 'Επιχειρηματική ανάλυση.png.',
                        savedSuccessfully: 'Αποθήκευση με επιτυχία',
                    },
                    template: {
                        ecommerceSessionQualityInspection: 'Επιθεώρηση ποιότητας συνεδρίασης ηλεκτρονικού εμπορίου',
                        questionnaire: 'Ερωτηματολόγο',
                    },
                },
            },
            supervision: {
                detail: {
                    index: {
                        permanentlyValid: 'Μόνιμα αποτελεσματικό',
                        permanentlyInvalid: 'Μόνιμα μη έγκυρο',
                        customValidity: 'Περίοδος τελωνειακής ισχύς',
                        termOfValidity: 'Περίοδος ισχύος',
                        name: 'Όνομα',
                        explain: 'Περιγραφή',
                        state: 'Κατάσταση',
                        classification: 'Ταξινόμηση',
                        smartRecommendation: 'Ευφυής σύσταση',
                        preconditions: 'Προϋποθέση',
                        SetPreconditionsForThisSupervisionItem: '1. Ορίστε προϋποθέσεις για αυτό το στοιχείο εποπτείας:',
                        whenThePreconditionsAreMetItIsThesupervisionItemToBeImplementedAndThenTheSupervisionItemShallBeTested: 'Όταν πληρούνται οι προϋποθέσεις, θεωρείται "το στοιχείο εποπτείας που θα εφαρμοστεί", και το στοιχείο εποπτείας θα δοκιμαστεί·',
                        ifThePreconditionsAreNotMetTheSupervisionItemWillNotBeDetected: 'Εάν δεν πληρούνται οι προϋποθέσεις, το στοιχείο εποπτείας δεν θα εντοπιστεί·',
                        NoPreconditionsAreSetThatIsAllSessionsAreDetectedByDefault: '2. Μην ορίσετε προϋποθέσεις, δηλαδή, όλες οι συνεδρίες ανιχνεύονται εξ ορισμού.',
                        have: 'Υπάρχουν.',
                        nothing: 'Κανένα',
                        preconditionRule: 'Κανόνας προϋποθέσεων',
                        preconditionLogic: 'Λογική προϋπόθεσης',
                    },
                    recommendation: {
                        caseGrouping: 'Ομάδα υποθέσεων',
                        whenEmployeesFailToPerformWellTheyCanIntelligentlyRecommendExcellentScriptsAndExcellentCases: 'Όταν οι εργαζόμενοι δεν παίζουν στη θέση τους, μπορούν να προτείνουν έξυπνα εξαιρετικές ικανότητες ομιλίας και εξαιρετικές περιπτώσεις.',
                        smartRecommendation: 'Ευφυής σύσταση',
                        open: 'Άνοιγμα:',
                        close: 'Κλείσιμο',
                        whenThisSupervisionItem: 'Όταν αυτό το στοιχείο εποπτείας',
                        implement: 'Εκτέλεση',
                        unexecuted: 'Δεν εκτελέστηκε',
                        when: 'Πότε:',
                        recommendedKnowledgePoints: 'Συνιστά σημεία γνώσης',
                        caseRecommendation: 'Συνιστάται η υπόθεση.',
                    },
                },
                index: {
                    determine: 'Προσδιορίστε την ένδειξη αυτών',
                    sort: 'Ταξινόμηση',
                    sortSucceeded: 'Ταξινόμηση με επιτυχία',
                    supervisionItemClassification: 'Ταξινόμηση των στοιχείων εποπτείας',
                    pressEnterToCreateANew: 'Πίεση Εισαγωγή Νέου',
                    nameCannotBeEmpty: 'Το όνομα δεν μπορεί να είναι κενό',
                    newlyBuild: 'Νέο',
                    name: 'Όνομα',
                    explain: 'Περιγραφή',
                    validStatus: 'Έγκυρο κατάσταση',
                    permanentlyValid: 'Μόνιμα αποτελεσματικό',
                    permanentlyInvalid: 'Μόνιμα μη έγκυρο',
                    operation: 'Λειτουργία',
                    edit: 'Επεξεργασία',
                    batchDelete: 'Διαγραφή παρτίδας',
                    newSupervisionItem: 'Νέο αντικείμενο εποπτείας',
                    keyWord: 'Λέξεις-κλειδιά',
                    delete: 'Διαγραφή',
                    deleteSucceeded: 'Διαγραφή με επιτυχία',
                },
            },
            analysisReport: {
                components: {
                    list: {
                        index: {
                            theDataCannotBeRecoveredAfterDeletionAreYouSureYouWantToDeleteIt: 'Τα δεδομένα δεν μπορούν να επαναφέρονται μετά τη διαγραφή. Είστε σίγουροι ότι θέλετε να το διαγράψετε;',
                        },
                    },
                    businessAnalysisFiter: {
                        component: {
                            smartTag: 'Έξυπνη ετικέταName',
                            beEqualTo: 'Ίση',
                            includeAll: 'Περιέχει όλο',
                            includeAny: 'Περιέχει όλο',
                            matchAny: 'Ταίριασμα οποιασδήποτες',
                            matchAll: 'Ταίριασμα όλων',
                            smartTagI: 'Έξυπνη ετικέτα ένας',
                            smartTagII: 'Έξυπνη ετικέτα II',
                        },
                        template: {
                            pleaseSelectASmartTag: 'Παρακαλώ επιλέξτε μια έξυπνη ετικέτα.',
                            pleaseSelectAdvancedConditions: 'Παρακαλώ επιλέξτε προηγμένα κριτήρια',
                            newAdvancedFilter: 'Νέο προηγμένο φίλτρο',
                            rename: 'Μετονομασία',
                            moveUp: 'Μετακίνηση πάνω',
                            moveDown: 'Μετακίνηση προς τα κάτι',
                            shiftLeft: 'Μετακίνηση αριστερά',
                            shiftRight: 'Μετακίνηση δεξιά',
                        },
                    },
                },
                template: {
                    businessTrendAnalysis: 'Ανάλυση των επιχειρήσεων τάσης',
                    percentableSituation: 'Ποσοστό',
                    delete: 'Διαγραφή',
                    labelFiltering: 'Φίλτρο ετικέτας:',
                    satisfyAny: 'Συναντήστε αυθαίρετα',
                    meetAll: 'Γνωρίστε όλοι.',
                    theNumberOfConversationsOfSecondaryCategoryLabelsPrimaryCategoryAndASessionMayContainMultipleLabels: 'Αριθμός συζητήσεων δευτερογενούς ταξινόμησης ≥ πρωτογενής ταξινόμηση, μια συνεδρία μπορεί να περιέχει πολλαπλές ετικέτες',
                    calculationLogicOfMonthOnMonthChangeconversationVolumeOfTheSelectedTimePeriodConversationVolumeOfTheImmediatelyPrecedingTimePeriodconversationVolumeOfTheLastTimePeriod: 'Λογική για τον υπολογισμό της αλλαγής δακτυλίου: (όγκος διαλόγου στο επιλεγμένο χρονικό διάστημα-διάλογο κατά την αμέσως προηγούμενη χρονική περίοδο) Όγκος διαλόγου κατά την προηγούμενη χρονική περίοδο.',
                    proportionOfPrimaryClassification: 'Ποσοστό ταξινόμησης πρώτου επιπέδου',
                    saveAs: 'Αποθήκευση',
                    cover: 'Εξώφυλλα',
                    preservation: 'Αποθήκευση',
                    qualityInspectionTask: 'Καθήκοντα ανάλυσης:',
                    query: 'Ερώτηση',
                    changeFromMonthToMonth: 'Αλλαγή δαχτυλιδιού',
                    tagRanking: 'Κατάταξη ετικέτας',
                    proportion: 'Ποσοστό',
                },
                component: {
                    ecommerceTextSession: 'Συνεδρία κειμένου ηλεκτρονικού εμπορίου',
                    questionnaire: 'Ερωτηματολόγο',
                    noSubordinateClassificationExists: 'Δεν υπάρχει υφιστάμενη ταξινόμηση',
                    categoryName: 'Όνομα κατηγορίας',
                    numberOfConversations: 'Αριθμός συζητήσεων',
                    operation: 'Λειτουργία',
                    businessAnalysispng: 'Επιχειρηματική ανάλυση.png.',
                    savingSucceeded: 'Αποθήκευση με επιτυχία',
                    deletionSucceeded: 'Διαγραφή με επιτυχία',
                    sequence: 'Αλληλουχία',
                    firstLevelClassification: 'Ταξινόμηση επιπέδου 1',
                    ringRatioChange: 'Αλλαγή δαχτυλιδιού',
                    classClassification: 'Ταξινόμηση επίπεδο {0}',
                },
            },
            intelligentExtractors: {
                components: {
                    pageLeftTable: {
                        areYouSureToDeleteTheDocumentAndItsExtractedContent: 'Επιβεβαιώστε τη διαγραφή του εγγράφου και του περιεχομένου του;',
                        addKnowledgeBase: 'Προσθήκη βάσης γνώσης',
                        uploadDocument: 'Αποστολή εγγράφου',
                        supportsWordPDFPowerPointExcelAndTxtFormatFiles: 'Υποστήριξη αρχείων, pdf, ppt, excel, σχήμα txt',
                        taskName: 'Όνομα εργασίας',
                        extractConversationDate: 'Εξαγωγή ημερομηνία συζήτησης',
                        pleaseSelectAConversationDate: 'Παρακαλώ επιλέξτε μια ημερομηνία συνομιλίας',
                        dataSource: 'Πηγή δεδομένων',
                        dataType: 'Τύπος δεδομένων',
                    },
                    pageRightTable: {
                        index: {
                            exportSuccessful: 'Εξαγωγή',
                            problem: 'Ερώτηση',
                            answer: 'Απάντηση',
                            addToKnowledgeBase: 'Προσθήκη στη βάση γνώσης',
                            pleaseConfirmWhetherToDeleteIt: 'Παρακαλώ καθορίστε αν θα διαγραφεί η διαγραφή',
                        },
                        pageRightFrom: {
                            addToKnowledgeBase: 'Προσθήκη στη βάση γνώσης',
                            selectClassification: 'Επιλογή κατηγορίας',
                            pleaseSelectAKnowledgeBaseClassification: 'Παρακαλώ επιλέξτε ταξινόμηση βάσης γνώσης',
                        },
                    },
                },
                index: {
                    intelligentExtraction: 'Ευφυής εξαγωγή',
                    documentExtraction: 'Εξαγωγή εγγράφου',
                    dialogueExtraction: 'Εξαγωγή διαλόγου',
                },
            },
            ignoreLabel: {
                index: {
                    operationSuccessful: 'Επιτυχία λειτουργίας',
                    labelIgnored: 'Η ετικέτα αγνοήθηκε.',
                    add: 'Προσθήκη',
                    areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                    batchFilterLabels: 'Ετικέτα φίλτρου παρτίδας',
                },
            },
            dataPreprocess: {
                component: {
                    language: 'Γλώσσα',
                },
                detail: {
                    template: {
                        language: 'Γλώσσα',
                    },
                },
            },
            intelligentCollection: {
                index: {
                    language: 'Γλώσσα',
                },
                detail: {
                    index: {
                        language: 'Γλώσσα',
                        pleaseSelectLanguage: 'Παρακαλώ επιλέξτε μια γλώσσα',
                    },
                },
            },
            customerPortrait: {
                template: {
                    ticketCount: 'Αριθμός εντολών εργασίας:',
                    numberOfVideoCalls: 'Αριθμός κλήσεων βίντεο:',
                    questionnaire: 'Ερωτηματολόγο',
                },
            },
            sentimentAnalysis: {
                index: {
                    publicOpinionAnalysis: 'Ανάλυση της κοινής γνώμης',
                },
            },
        },
        logoSite: {
            index: {
                intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας',
                savedSuccessfully: 'Αποθήκευση με επιτυχία',
                logoSettings: 'Ρυθμίσεις λογισμικού',
                default: 'Προκαθορισμένο',
                custom: 'Προσαρμοσμένο',
                title: 'Τίτλος',
                theTitleOfTheSystemDisplayShouldBeWithinWords: 'Το όνομα τίτλου που εμφανίζεται από το σύστημα συνιστάται να είναι εντός 6 χαρακτήρων.',
                logoImageUpload: 'Αποστολή εικόνας λογισμικού',
                pleaseSelectAPictureWithASizeOfNoMoreThankb: 'Παρακαλώ επιλέξτε μια εικόνα με μέγεθος που δεν υπερβαίνει τα 2048kb',
                inOrderToEnsureTheBrowsingEffectOfLogoUploadPicturesSuggestions: 'Προκειμένου να εξασφαλιστεί το λογότυπο περιήγησης, προτείνεται να ανεβάσετε εικόνες:',
                Size5050Pixels: '1. Μέγεθος: 50 * 50 εικονοστοιχεία?',
                FormatPicturesWithTransparentBackgroundPNGOrJPGLogoGraphicsInWhite: '2. Μορφή: εικόνα με διαφανές φόντο, png ή jpg, γραφικό λογότυπο με τη χρήση λευκών',
                browserLabelIcon: 'Εικονίδιο καρτέλας',
                toEnsureTheBrowsingEffectOfTagsUploadPicturesSuggestions: 'Προκειμένου να εξασφαλιστεί η επίδραση της περιήγησης ετικέτας, συνιστάται να ανεβάζετε εικόνες:',
                Size3232Pixels: '1. Μέγεθος: 32*32 εικονοστοιχεία;',
                FormatPictureWithTransparentBackgroundPNGOrJpg: '2. Μορφή: εικόνα με διαφανές φόντο, png ή jpg',
            },
        },
        sdkTest: {
            index: {
                qualityInspectionInProgressPleaseCheckLater: 'Επιθεώρηση ποιότητας σε εξέλιξη, παρακαλώ περιμένετε...',
            },
            componentIndex: {
                atThatTimeInChinasRealEstateReachedACriticalMomentForItsSurvivalALargeNumberOfHousesWereLeftUnattendedAndThePeopleWereUnwillingToBuyThemHangzhouOnceFellBelow8000AndSomeDevelopersFailedToShipAtThatTimeShenzhenWasStillAbout2w3wConsolidationAndTheHousesInTheFirstTierCitiesWereAlsoInDanger: 'Το 2015, η ακίνητη περιουσία της χώρας μου έφτασε σε μια κρίσιμη στιγμή επιβίωσης. Ένας μεγάλος αριθμός σπιτιών ήταν αφύλακτος και οι άνθρωποι δεν ήταν διατεθειμένοι να τα αγοράσουν. Ο Hangzhou κάποτε έπεσε κάτω από 8000, και κάποιοι προγραμματιστές έσπασαν την αγορά στο πλοίο. Shenzhen ήταν ακόμη εδραίωση περίπου 2w-3w την εποχή εκείνη, και τα σπίτια σε πρώτη βαθμίδα πόλεις ήταν επίσης σε κίνδυνο.',
                xiaoAn: 'Ανν.',
                storestoreStoreloadTheseMemoryBarriersAreCalledJSRMemoryBarriersTheyAreImplementedAtTheJVMLevelThereAreTwoWaysToImplementThemAtTheBottomOfTheOperatingSystemLockBus2MemoryBarrierMetaLanguageSuchAsSfancewriteBarrierMfencefullScreenBarrierAndIfencereadBarrierTheBottomLayerOfTheHotspotsVirtualMachineUsesAnAssemblyStatementLockADDLLockIsAnEmptyOperationThatIsLockBusThisIsBecauseSomeOperatingSystemsDoNotSupportMemoryBarrierMetaLanguage: 'Το Storestore storeload αυτά τα εμπόδια μνήμης ονομάζονται jsr εμπόδια μνήμης, τα οποία βρίσκονται στο επίπεδο JVM. Υπάρχουν δύο εφαρμογές στο κάτω μέρος του λειτουργικού συστήματος: η μία είναι να κλειδώσει το λεωφορείο, και η άλλη είναι ο πρωτόγονος φραγμός μνήμης, όπως sfance (εφράγμα εγγραφής) mfence (πλήρης φράγμα) ifence (ανάγνωστο εμπόδιο). Το κάτω στρώμα του hotspots εικονικό μηχάνημα χρησιμοποιεί μια δήλωση συναρμολόγησης: lock addl,block μια κενή λειτουργία, Το οποίο είναι το λεωφορείο κλειδαριών. Αυτό γίνεται επειδή ορισμένα λειτουργικά συστήματα δεν υποστηρίζουν τα πρωτόγονα εμπόδια μνήμης.',
                xiaobei: 'Σιαομπέι',
                TryToMarinateTheMeatForSeveralTimesTheDishesFriedAfterAddingTheIngredientsAndWineAreLikeRottenMeatWithASourSmellSinceThenNoCookingWineHasBeenAddedToTheBacon: '1. Προσπαθήστε να μαρινάρετε το κρέας αρκετές φορές και ανακατεύετε τα λαχανικά αφού προσθέσετε κρασί. Το κρέας είναι τρελό και μυρίζει ξινό! Από εδώ και πέρα, όχι άλλο κρασί μαγειρικής για μπέικον.',
                xiaodong: 'Χιάτοντονγκ.',
                xiaoxi: 'Σιάο Χι',
                TryToMarinateTheMeatForSeveralTimesTheDishesFriedAfterAddingTheWineAreLikeRottenMeatWithASourSmellSinceThenNoCookingWineHasBeenAddedToTheBacon: '3. Προσπαθήστε να μαρινάρετε το κρέας αρκετές φορές, και τα λαχανικά τηγανητά αφού προσθέσετε κρασί είναι σαν χαλασμένο κρέας, με ξινή μυρωδιά! Από εδώ και πέρα, όχι άλλο κρασί μαγειρικής για μπέικον.',
            },
        },
        home: {
            index: {
                flyingBookConversation: 'Ιπτάμενος βιβλίο συζήτησης',
                templateManagement: 'Διαχείριση προτύπων',
                evaluationOverview: 'Επισκόπηση αξιολόγησης',
                evaluationRecord: 'Αρχείο αξιολόγησης',
                curriculumEvaluation: 'Αξιολόγηση προγράμματος σπουδών',
                videoCallManagement: 'Διαχείριση κλήσεων βίντεο',
                planManagement: 'Διαχείριση σχεδίου',
                dataIntegration: 'Ενσωμάτωση δεδομένων',
                questionnaireManagement: 'Διαχείριση ερωτηματολογίου',
                originalSoundManagement: 'Αρχική διαχείριση ήχου',
                productManagement: 'Διαχείριση προϊόντων',
                productDetails: 'Λεπτομέρειες προϊόντος',
                qualityAccompanyList: 'Συνοδευτικός κατάλογος ποιότητας',
                ecommerceReviewManagement: 'Διαχείριση επανεξέτασης ηλεκτρονικού εμπορίου',
                socialMediaReviewManagement: 'Διαχείριση Social Media Αναθεώρησης',
                customDataSource: 'Προσαρμοσμένη πηγή δεδομένων',
                qualityInspectionResults: 'Αποτελέσματα επιθεώρησης ποιότητας',
                accountManagement: 'Διαχείριση λογαριασμού',
                employeeProfile: 'Εργαζόμενοι Πορτραίτου',
                intelligentAnalysis: 'Ευφυής ανάλυση',
                customKanban: 'Προσαρμοσμένο Kanban',
                dataScreening: 'Επισκόπηση δεδομένων',
                learningRecord: 'Εκμάθηση εγγραφής',
                dataAnalysis: 'Ανάλυση δεδομένων',
                scoringManagement: 'Διαχείριση βαθμολογίας',
                businessConfiguration: 'Ρύθμιση επιχειρήσεων',
                manualReview: 'Χειροκίνητη ανασκόπηση',
                taskList: 'Λίστα εργασιών',
                videoAnalysis: 'Ανάλυση βίντεο',
                overview: 'Επισκόπηση',
                personalSignage: 'Προσωπικό Κάνμπαν.',
                learningCenter: 'Κέντρο εκπαίδευσης',
                wrongQuestionSet: 'Λάθος σύνολο προβλήματος',
                abilityImprovement: 'Δυναμικότητα αναβάθμισης για την αναβάθμιση',
                close: 'Κλείσιμο',
                switchingSystemApplications: 'Εναλλαγή εφαρμογών συστήματος',
                moveTheMouseHereToCallUpTheApplicationSwitchingMenuClickTheMenuItemToJumpToDifferentApplications: 'Μετακινήστε το ποντίκι εδώ για να καλέσετε το μενού εναλλαγής της εφαρμογής, και κάντε κλικ στο στοιχείο μενού για να πηδήξετε σε διαφορετικές εφαρμογές.',
                teamAnalysis: 'Ανάλυση ομάδας',
                semanticIntelligence: 'Σημασιολογική νοημοσύνη',
                permissionManagement: 'Διαχείριση άδειας',
                dataConnection: 'Προσάρτηση δεδομένων',
                courseManagement: 'Διαχείριση μαθημάτων',
                labelManagement: 'Διαχείριση ετικέτας',
                curriculum: 'Κέντρο μαθημάτων',
                courseConfiguration: 'Ρύθμιση πορείας',
                task: 'Η αποστολή μου',
                historicalLearningData: 'Ιστορία',
                taskCenter: 'Διαχείριση εργασιών',
                knowledgeBase: 'Βάση γνώσης',
                ecommerceSessionManagement: 'Διαχείριση συνεδριών ηλεκτρονικής εμπορίας',
            },
            components: {
                subAppEntries: {
                    applicationSwitching: 'Εναλλαγή εφαρμογής',
                    descriptionOfIntelligentQualityInspectionSystem: 'Περιγραφή του ευφυούς συστήματος επιθεώρησης ποιότητας',
                },
            },
        },
        eCommerceManage: {
            template: {
                ecommerceSessionFilter: 'Φίλτρο συνεδρίας ηλεκτρονικού εμπορίου',
                allEcommerceSessions: 'Όλες οι συνεδρίες',
                ecommerceSessionManagement: 'Διαχείριση συνεδριών ηλεκτρονικής εμπορίας',
            },
        },
        analysisEnable: {
            bestPractices: 'Βέλτιστες πρακτικές',
            behaviorAnalysis: 'Ανάλυση συμπεριφοράς',
            teamAnalysis: 'Ανάλυση ομάδας',
            executiveSupervision: 'Εποπτεία εκτελεστικών δυνάμεων',
            executiveForceAnalysis: 'Ανάλυση εκτέλεσης',
        },
        appealCheckingTask: {
            sdk: {
                index: {
                    interfaceRequestExceptionPleaseTryAgainLater: 'Παρακαλώ δοκιμάστε ξανά αργότερα.',
                    currentDataCannotBeAppealed: 'Τα τρέχοντα στοιχεία δεν μπορούν να προσφύγουν.',
                    beforeCanAppeal: 'Πριν μπορέσει να έφεσε',
                    time: 'Χρόνο',
                    uniqueRecordID: 'Μοναδικό ID εγγραφής',
                    videoSessionID: 'ID συνεδρίας βίντεο',
                    intelligentInspectionTime: 'Έξυπνος χρόνος επιθεώρησης ποιότητας',
                    manualInspectionTime: 'Χρόνος χειροκίνητης επιθεώρησης ποιότητας',
                    grade: 'Αξιολόγηση:',
                    startTime: 'Ώρα έναρξης',
                    workOrderNo: 'Αριθμός παραγγελίας εργασίας',
                    customerServiceHasReadNotRead: 'Ανάγνωση/μη αναγνωσμένη πράκτορα',
                    canYouAppeal: 'Αν πρέπει να ασκηθεί προσφυγή',
                },
                components: {
                    viewTabs: {
                        index: {
                            caseLibrary: 'Βιβλιοθήκη περίπτωσης',
                        },
                    },
                    caseLibView: {
                        index: {
                            caseLibrary: 'Βιβλιοθήκη κεφαλαίων',
                        },
                    },
                    qaResultView: {
                        index: {
                            reviewDetailsNotObtained: 'Αποτυχία ανάκτησης των λεπτομερειών αναθεώρησης.',
                            customerService: 'Υπηρεσία πελατών',
                            review: 'Ανασκόπηση',
                        },
                    },
                },
            },
        },
        clientCenter: {
            wechatClientManage: {
                template: {
                    enterpriseAndMicroNotes: 'Παρατηρήσεις μικρών επιχειρήσεων',
                    addFriendTime: 'Προσθήκη ώρας φιλόδοξης',
                },
            },
            template: {
                ecommerceCustomers: 'Πελάτες ηλεκτρονικού εμπορίου',
            },
        },
        qualityInspectionList: {
            detail: {
                component: {
                    finalSubmission: 'Τελική υποβολή',
                    operationSucceeded: 'Επιτυχία λειτουργίας',
                    operationFailed: 'Η λειτουργία απέτυχε',
                    startPerformingReQualityInspection: 'Έναρξη επανεπιθεώρησης',
                    callID: 'Κωδικός κλήσης',
                },
                template: {
                    newFeaturesClickThequickSpotCheckButtonAndAfterTheSubmissionIsSuccessfulItWillAutomaticallyJumpToTheNextPage: 'Νέα χαρακτηριστικά! Κάντε κλικ στο κουμπί Γρήγορης δειγματοληψίας ελέγχου θα πηδήξει αυτόματα στην επόμενη σελίδα μετά την επιτυχή υποβολή ~ ~ ~ ~',
                },
                components: {
                    finalReview: {
                        index: {
                            confirmedFinal: 'Επιβεβαιώθηκε τελικό;',
                            afterTheFinalReviewOnlyTheFinalReviewAndFilingOperationsAreSupported: 'Μετά την τελική επανεξέταση, υποστηρίζονται μόνο οι τελικές πράξεις επανεξέτασης και αρχειοθέτησης.',
                            finalAppeal: 'Τελική προσφυγή',
                        },
                    },
                },
            },
            template: {
                sort: 'Ταξινόμηση',
                deleteRecord: 'Διαγραφή εγγραφής',
                areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                confirm: 'Προσδιορίστε την ένδειξη αυτών',
                reIdentification: 'Επαναγνωμόνιση',
                rerecognitionWillConsumeTranscriptionTimePleaseOperateWithCaution: 'Η επαναληπτική ταυτοποίηση θα καταναλώσει το χρόνο μεταφοράς, παρακαλώ να λειτουργεί με προσοχή.',
                determine: 'Προσδιορίστε την ένδειξη αυτών',
                executionSuccessful: 'Επιτυχής εκτέλεση',
            },
            component: {
                pleaseSelectData: 'Παρακαλώ επιλέξτε δεδομένα',
                operationSuccessful: 'Επιτυχία λειτουργίας',
                startPerformingReQualityInspection: 'Έναρξη επανεπιθεώρησης',
            },
        },
        recordUpload: {
            template: {
                workOrderUpload: 'Αποστολή παραγγελίας εργασίας',
                uploadFileName: 'Αποστολή όνομα αρχείου',
                analysisTask: 'Ανάλυση',
                analyzeProgress: 'Ανάλυση της προόδου',
                analysisSucceeded: 'Ανάλυση επιτυχίας',
                analysisFailed: 'Η ανάλυση απέτυχε',
                localDataUpload: 'Αποστολή τοπικών δεδομένων',
                recordingUpload: 'Αποστολή εγγραφής ήχου',
                textUpload: 'Αποστολή κειμένου:',
                uploadTime: 'Χρόνος αποστολής',
                taskName: 'Όνομα εργασίας',
                operator: 'Αερομεταφορέας',
                qualityInspectionProgress: 'Πρόοδος επιθεώρησης ποιότητας',
                whole: 'Όλα',
                haveInHand: 'Σε εξέλιξη.',
                completed: 'Ολοκληρώθηκε',
                exportAllCompletedDataRecordsUnderTheCurrentFilterCondition: 'Εξαγωγή όλων των ολοκληρωμένων εγγραφών δεδομένων με τα τρέχοντα κριτήρια φίλτρου;',
                upload: 'Αποστολής',
            },
            detail: {
                info: {
                    template: {
                        uploadTicketFieldData: 'Αποστολή στοιχείων πεδίου εισιτηρίου',
                        workOrderFieldTemplateDownload: 'Πρότυπο πεδίου παραγγελίας εργασίας',
                        uploadWorkOrderMailData: 'Αποστολή δεδομένων ταχυδρομείων εντολής εργασίας',
                        emailTemplateDownload: 'Λήψη προτύπου email',
                        fillInTheName: 'Συμπλήρωση ονομασίας',
                        fillInTheNameSuchAsTheTypesetpurposeOfTheImportedData: 'Εισάγετε το όνομα, όπως ο τύπος/συλλογή/ο σκοπός των εισαγόμενων δεδομένων.',
                        default: 'Προκαθορισμένο',
                        jDCOM: 'Τζινγκντονγκ.',
                        dataType: 'Τύπος δεδομένων',
                        selectAnalysisTask: 'Επιλογή εργασίας ανάλυσης',
                        uploadFiles: 'Αποστολή αρχείου',
                        DownloadExcelTemplateAndFillInAccordingToTheFormat: '1. Κατεβάστε το excel πρότυπο και συμπληρώστε το σύμφωνα με τη μορφή:',
                        template: 'Πρότυπο',
                        SupportUpTo10000PiecesOfData: '2. Μέγιστη υποστήριξη 10000 τεμάχια δεδομένων',
                        supportTheUploadOfDialogDataExportedByJDLogFileWithAMaximumFileSizeOfM: 'Υποστήριξη Jingdong εξαγόμενων στοιχείων διαλόγου αποστολή, .txt αρχείο, μέγιστο μέγεθος υποστήριξης 100M',
                        alongTheWayDataTemplate: 'Πρότυπο δεδομένων παρακολούθησης',
                    },
                },
                result: {
                    template: {
                        workOrderQualityInspection: 'Επιθεώρηση ποιότητας παραγγελίας',
                        workOrderQualityInspectionCompleted: 'Επιθεώρηση ποιότητας παραγγελίας',
                        textUnderInspection: 'Παρακαλώ περιμένετε υπομονετικά κατά την επιθεώρηση ποιότητας κειμένου.',
                        textQualityInspectionCompleted: 'Επιθεώρηση ποιότητας κειμένου ολοκληρώθηκε',
                    },
                },
                template: {
                    startAnalysis: 'Έναρξη ανάλυσης',
                    pleaseUploadTheFile: 'Παρακαλώ αποστολή του αρχείου',
                    localDataUpload: 'Αποστολή τοπικών δεδομένων',
                },
            },
        },
        reviewList: {
            detail: {
                template: {
                    newFeaturesClickThereviewAndSubmitButtonAndThePageWillAutomaticallyJumpToTheNextPageAfterTheSubmissionIsSuccessful: 'Νέα χαρακτηριστικά! Κάντε κλικ στο κουμπί "Review Υποβολή", αφού η υποβολή είναι επιτυχής, θα άλμα αυτόματα στην επόμενη σελίδα ~ ~ ~~',
                },
            },
            template: {
                sort: 'Ταξινόμηση',
            },
        },
        role: {
            detail: {
                taskPermissions: {
                    template: {
                        qualityInspectionTaskPermission: 'Άδεια επιθεώρησης ποιότητας εργασίας',
                        edit: 'Επεξεργασία',
                        iParticipated: 'Είμαι ανακατεμένος.',
                    },
                },
                dataPermissions: {
                    template: {
                        thisRoleCanSeeDataUnderTheSelectedDepartment: 'Αυτός ο ρόλος μπορεί να δει τα δεδομένα κάτω από την επιλεγμένη υπηρεσία',
                        dataPermissions: 'Άδειες δεδομένων',
                        selectDepartment: 'Επιλογή τμήματος',
                        edit: 'Επεξεργασία',
                    },
                },
            },
        },
        spotCheckList: {
            detail: {
                component: {
                    startPerformingReQualityInspection: 'Έναρξη επανεπιθεώρησης',
                    callID: 'Κωδικός κλήσης',
                },
                template: {
                    newFeaturesClickThesampleInspectionSubmissionAndquickSampleInspectionButtonsAfterTheSubmissionIsSuccessfulItWillAutomaticallyJumpToTheNextPage: 'Νέα χαρακτηριστικά! Κάντε κλικ δειγματοληψία υποβολής και τα κουμπιά γρήγορης δειγματοληψίας θα άλμα αυτόματα στην επόμενη σελίδα μετά από επιτυχή υποβολή',
                },
            },
            template: {
                sort: 'Ταξινόμηση',
            },
        },
        templateTest: {
            semanticTags: {
                template: {
                    rule: 'Κανόνες',
                },
            },
        },
        ticketManage: {
            detail: {
                template: {
                    workOrderManagement: 'Διαχείριση εντολών εργασίας',
                    workOrderDetails: 'Λεπτομέρειες εντολής εργασίας',
                },
            },
            template: {
                workOrderFilter: 'Φίλτρο παραγγελίας εργασίας',
                allWorkOrders: 'Όλες οι εντολές εργασίας',
                workOrderManagement: 'Διαχείριση εντολών εργασίας',
            },
        },
        trainingCenter: {
            topicAnnotation: 'Θέμα κλήσης',
            topicList: 'Κατάλογος θεματικών ειδών',
            clusteringAnnotation: {
                components: {
                    filter: {
                        index: {
                            roleType: 'Τύπος ρόλου',
                            keyWord: 'Λέξεις-κλειδιά',
                            pleaseEnterKeywordSearch: 'Παρακαλώ εισάγετε αναζήτηση λέξεων κλειδιών',
                            query: 'Ερώτηση',
                        },
                    },
                },
            },
            similarQuestionRecommend: {
                index: {
                    thisFunctionHasNotBeenOpenedYetPleaseContactTheSystemAdministratorIfNecessary: 'Αυτή η λειτουργία δεν έχει ανοιχτεί ακόμα. Παρακαλώ επικοινωνήστε με τον διαχειριστή του συστήματος εάν είναι απαραίτητο.',
                    pleaseSelectAQuestion: 'Παρακαλώ επιλέξτε μια ερώτηση!',
                    recommendedSimilarSentencesLargeModel: 'Συνιστά παρόμοιες προτάσεις (μεγάλο μοντέλο)',
                    selectAll: 'Επιλογή όλων',
                    add: 'Προσθήκη',
                    changeBatch: 'Τροποποίηση μιας παρτίδας',
                },
            },
            fastTraining: {
                components: {
                    sentenceTypeTag: {
                        index: {
                            createManually: 'Δημιουργία χειροκίνητα',
                            largeModelExpansion: 'Μεγάλο μοντέλο επέκτασης',
                            nLPAutomaticExpansion: 'Αυτόματη επέκταση NLP',
                        },
                    },
                },
            },
        },
        adminEntry: {
            qualityInspectionLanguageSettings: 'Ρυθμίσεις γλώσσας επιθεώρησης ποιότητας',
            businessWorkingHours: 'Ώρα εργασίας επιχειρήσεων',
            localDataUpload: 'Αποστολή τοπικών δεδομένων',
            assembleMenuListAccordingToCurrentUserPermissions: 'Συναρμολογήστε τη λίστα μενού σύμφωνα με τα τρέχοντα προνόμια χρήστη',
            sessionSettings: 'Ρυθμίσεις συνεδρίας',
            logoSettings: 'Ρυθμίσεις λογισμικού',
        },
        login: {
            template: {
                welcomeBackPleaseEnterYourDetails: 'Καλώς ήρθες πίσω! Παρακαλώ εισάγετε τα στοιχεία σας',
                mailbox: 'Ηλεκτρονικό ταχυδρομείο',
                password: 'Κωδικός πρόσβασης',
                signIn: 'Σύνδεση',
            },
            components: {
                layout: {
                    theCurrentIPDoesNotAllowLogin: 'Η τρέχουσα IP δεν επιτρέπει τη σύνδεση',
                    welcomeToLogin: 'Καλωσήρθατε στη σύνδεση',
                    pursuingExcellenceAndLeadingChange: 'Η επιδίωξη της αριστείας, οδηγώντας την αλλαγή',
                    intelligentPlatform: 'Ευφυής πλατφόρμας',
                },
                virtualLogin: {
                    index: {
                        pleaseSelect: 'Παρακαλώ επιλέξτε.',
                    },
                },
            },
            oauth: {
                illegalCall: 'Παράνομος κλήσης',
                welcomeBackClickTheButtonBelowToJumpToTheIdentityAuthenticationPlatform: 'Καλώς ήρθες πίσω! Κάντε κλικ στο παρακάτω κουμπί για να πηδήξετε στην πλατφόρμα ταυτοποίησης',
                loggingIn: 'Σύνδεση...',
                unifiedIdentityAuthenticationLogin: 'Ενοποιημένη ταυτότητα σύνδεση ταυτότητας',
            },
            component: {
                unableToLogIn: 'Αδύνατη η σύνδεση!',
                unableToLand: 'Αδύνατον να προσγειωθεί!',
                theAccountDoesNotHaveTheCorrectPhoneInformationAndCannotObtainTheVerificationCodePleaseContactTheAdministratorToFillInTheCorrectPhoneInformationAndTryAgain: 'Ο λογαριασμός δεν διαθέτει τις σωστές πληροφορίες του τηλεφώνου και δεν μπορεί να λάβει τον κωδικό επαλήθευσης. Παρακαλώ επικοινωνήστε με τον διαχειριστή για να συμπληρώσετε τις σωστές πληροφορίες του τηλεφώνου και προσπαθήστε ξανά.',
            },
        },
        checkPointTest: {
            index: {
                simulatedWorkOrder: 'Προσομοιωμένη σειρά εργασίας',
                ruleTestSomeRulesCannotBeTestedUsingRulesSuchAsVoiceSpeedVolumeAndOnTheRoadData: 'Δοκιμή κανόνων: Ορισμένοι κανόνες δεν μπορούν να δοκιμαστούν χρησιμοποιώντας κανόνες, όπως ταχύτητα ομιλίας και όγκος, δεδομένα κατά μήκος της διαδρομής, κλπ.',
            },
        },
        appEntry: {
            components: {
                subSystemEntryCard: {
                    learnMore: 'Μάθε περισσότερα',
                    enteringTheSystem: 'Εισάγετε το σύστημα',
                },
            },
            index: {
                cancel: 'Ακύρωση',
                enteringTheSystem: 'Εισάγετε το σύστημα',
                close: 'Κλείσιμο',
                enterSystemApplication: 'Εισάγετε την εφαρμογή συστήματος',
                clickEnterSystemToJumpToTheEnabledSystemApplication: 'Κάντε κλικ στο "Enter System" για να πηδήξετε σε μια εφαρμογή συστήματος ενεργοποιημένο',
            },
        },
        permissionManagement: {
            employeeManagement: 'Διαχείριση εργαζομένων',
            roleManagement: 'Διαχείριση ρόλων',
            permissionManagement: 'Διαχείριση άδειας',
        },
        generalSetting: {
            docking: {
                components: {
                    ruleList: {
                        beEqualTo: 'Ίση',
                        contain: 'Περιέχει',
                        doesNotContain: 'Δεν περιέχει',
                        applicationSystem: 'Σύστημα εφαρμογής',
                        intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας/ανευφυής ανάλυση συνεδρίας',
                        salesEmpowerment: 'Ενίσχυση των πωλήσεων',
                        dataSourceType: 'Τύπος πηγής δεδομένων',
                        filterCriteria: 'Κατάσταση φίλτρου',
                    },
                },
                index: {
                    dataConnection: 'Προσάρτηση δεδομένων',
                    savingSucceeded: 'Αποθήκευση με επιτυχία',
                    dataIsolation: 'Απομόνωση δεδομένων',
                    afterOpeningYouCanSetTheDataRangeOfEachApplicationSystemAccessCallAndEnterpriseWeChatSessionIfTheSwitchIsNotTurnedOnAllSystemsAreConnectedToFullData: 'Μετά το άνοιγμα, μπορείτε να ορίσετε το εύρος δεδομένων κάθε κλήσης πρόσβασης του συστήματος εφαρμογής και την επιχείρηση WeChat συνεδρία. Εάν ο διακόπτης δεν είναι ενεργοποιημένος, όλα τα συστήματα συνδέονται με τα πλήρη δεδομένα.',
                    accessRules: 'Κανόνες πρόσβασης',
                    preservation: 'Αποθήκευση',
                },
            },
            permissionManagement: {
                role: {
                    index: {
                        applyName: 'Όνομα εφαρμογής',
                        accessRights: 'Πρόσβαση',
                        inAppPermissionSettings: 'Ρυθμίσεις αδειών εντός της εφαρμογής',
                        setUp: 'Ρύθμιση',
                        applicationAccess: 'Πρόσβαση σε εφαρμογή',
                        newRole: 'Νέος Ρόλος',
                    },
                },
            },
        },
        wechatNotificationAnalysis: {
            conversationalAnalysis: {
                index: {
                    sessionDetails: 'Λεπτομέρειες συνεδρίας',
                },
            },
            messageNotification: {
                index: {
                    sessionDetails: 'Λεπτομέρειες συνεδρίας',
                    caseDetails: 'Λεπτομέρειες περίπτωσης',
                },
            },
        },
        coach: {
            courseManagement: {
                baseInfo: {
                    index: {
                        save: 'Αποθήκευση',
                        cancel: 'Ακύρωση',
                        visibleEmployees: 'Οορατοί εργαζόμενοι',
                        newCourse: 'Νέα μαθήματα',
                        editCourse: 'Επεξεργασία πορείας',
                        courseName: 'Όνομα πορείας',
                        courseIntroduction: 'Εισαγωγή μαθημάτων',
                        courseType: 'Τύπος πορείας',
                        courseClassification: 'Ταξινόμηση μαθημάτων',
                        courseCover: 'Κάλυμμα πορείας',
                        learningContent: 'Περιεχόμενο μάθησης',
                        uploadLearningMaterials: 'Αποστολή μαθησιακών υλικών',
                    },
                },
                flow: {
                    components: {
                        configDrawer: {
                            test: 'Δοκιμή',
                            preservation: 'Αποθήκευση',
                            cancel: 'Ακύρωση',
                            editNodeName: 'Επεξεργασία ονόματος κόμβου',
                            determine: 'Προσδιορίστε την ένδειξη αυτών',
                            individual: 'Ένας',
                            of: ', Σύνολο',
                            branch: 'Σημεία',
                        },
                        configDrawerComponents: {
                            pPTParsing: 'Ανάλυση PPT σε...',
                            uploadSuccessful: 'Αποστολή επιτυχή',
                            uploadAttachments: 'Αποστολή συνημμένου',
                            pPTParsingPleaseWait: 'PPT ανάλυση, παρακαλώ περιμένετε.',
                        },
                        customerPortraitConfigDrawer: {
                            cancel: 'Ακύρωση',
                            afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisPortrait: 'Δεν μπορεί να αποκατασταθεί μετά τη διαγραφή. Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το πορτραίτο;',
                            delete: 'Διαγραφή',
                            determine: 'Προσδιορίστε την ένδειξη αυτών',
                            customerPortrait: 'Πορτραίτο πελατών',
                            bindSelectedCharacterPortrait: 'Σύνδεση του επιλεγμένου πορτρέτου',
                            customerProfileDetails: 'Λεπτομέρειες προφίλ πελατών',
                            createANewCustomerProfile: 'Νέο προφίλ πελατών',
                        },
                        flow: {
                            sidebar: {
                                node: 'Κόμβος',
                            },
                            useControlButtons: {
                                cancellingPleaseWait: 'Ξεκίνα, παρακαλώ αργότερα...',
                                redoInProgressPleaseWait: 'Επαναλαμβάνω, παρακαλώ αργότερα.',
                                automaticOrganization: 'Αυτόματη φινίρισμα',
                                canvasAdaptation: 'Προσαρμοστικό',
                                delete: 'Διαγραφή',
                            },
                            useFlow: {
                                nodeCannotBeConnectedToItself: 'Ο κόμβος δεν μπορεί να συνδεθεί με τον εαυτό του.',
                            },
                        },
                        globalConfigDrawer: {
                            cancel: 'Ακύρωση',
                            determine: 'Προσδιορίστε την ένδειξη αυτών',
                            globalConfiguration: 'Καθολική ρύθμιση',
                            sessionDetection: 'Ανίχνευση συνεδρίας',
                            reciprocalRule: 'Κανόνες αλληλεπίδρασης',
                            robotVoice: 'Ήχος ρομπότ',
                        },
                        interactionRuleForm: {
                            studentNodeTimeoutWithoutAnsweringSetting: 'Χρονικό διάστημα μη απαντημένων ρυθμίσεων',
                            maximumAllowedSilenceTimeForStudentsNotAnswerings: 'Μέγιστη επιτρεπόμενη σιωπηλή ώρα (s)',
                            promptScriptForFailureToAnswerOverTime: 'Ζήτηση χρονικού όρου',
                            addScript: 'Προσθήκη λέξεων',
                        },
                        robotTimbreForm: {
                            aixianatural: 'Αΐσα (Φύση)',
                            zhishaChat: 'Ζίσα (συνομιλία)',
                            zhiqiangentle: 'Ζικιαν (Πολυ)',
                            zhimiEmotion: 'Γνωρίζετε το ρύζι (συναίσθημα)',
                            aiShuoNatural: 'Aishuo (Φύση)',
                            zhishuoChat: 'Ζίσουο (συνομιλία)',
                            aiHaoAffinity: 'Αι Χάο',
                            zhixiangEmotion: 'Zhixiang (Emotion)',
                            robotVoice: 'Ήχος ρομπότ',
                            schoolboy: 'Αγόρια.',
                            girlStudent: 'Κορίτσια',
                            volume: 'Τόμος',
                            tone: 'Τόνος',
                            speechSpeed: 'Ταχύτητα λόγου',
                            test: 'Δοκιμή',
                            helloIAmAnIntelligentTrainingCoachAndLookForwardToCommunicatingWithYou: 'Γεια σας, είμαι ένας έξυπνος προπονητής και ανυπομονώ να επικοινωνήσω μαζί σας.',
                        },
                        sessionDetectionForm: {
                            expressionDetection: 'Ανίχνευση έκφρασης',
                            excessiveDetectionOfModalParticles: 'Υπερβολική ανίχνευση λέξης μορφής',
                            theNumberOfRepetitionsIs: 'Ο αριθμός των επαναλήψεων',
                            minus: 'Χρόνος, μείον.',
                            appear: 'Εμφάνιση',
                            subtract: 'Χρόνια, μείον.',
                            branch: 'Σημεία',
                            addRules: 'Προσθήκη κανόνων',
                            includingNegativeAngryComplaining: '(Συμπεριλαμβανομένου αρνητικού, θυμωμένου, παραπονιού)',
                            scorePointsDisplay: 'Εμφάνιση σημείων βαθμολογίας',
                            reminderOfSpeakingTooFasttooSlow: 'Ταχύτητα πολύ γρήγορη/ πολύ αργή υπενθύμιση',
                            scriptViolationReminder: 'Υπενθύμιση παραβίασης λόγου',
                            emotionalReminder: 'Συναισθηματική Υπενθύμιση',
                            speechSpeedDetection: 'Ανίχνευση ταχύτητας ομιλίας',
                            normalSpeechSpeedScore: 'ΚΑΝΟΝΙΚΟ ΠΕΔΙΟ ΕΦΑΡΜΟΓΗΣ',
                            speakTooFast: 'Γρήγορα φωτιά',
                            everyMinuteGreaterThan: 'Ανά λεπτό μεγαλύτερο',
                            aWordAppears: 'Εμφανίσου.',
                            speakTooSlowly: 'ΠΑΡΑΡΤΗΜΑ',
                            lessThanPerMinute: 'Λιγότερο από το λεπτό',
                            ignoreLessThan: 'Αγνόηση λιγότερα',
                            aSentenceOfWords: 'Η πρόταση της λέξης',
                            emotionalDetection: 'Ανίχνευση συναισθημάτων',
                            emotionalNormalScore: 'Κανονική βαθμολογία διάθεσης',
                            negativeEmotions: 'Αρνητικό συναίσθημα',
                            illegalWordDetection: 'Παράνομη ανίχνευση λέξεων',
                            scriptViolationConfiguration: 'Ρύθμιση παραβίασης ομιλίας',
                            realTimePromptOnTheFrontEnd: 'Πρότυπο σε πραγματικό χρόνο.',
                        },
                        const: {
                            nodeConfigs: {
                                knowledgeNode: {
                                    knowledgeBaseQA: 'Βάση γνώσεων Ε & Α',
                                    qAMethod: 'Μέθοδος ερωτήσεων και απάντησης',
                                    numberOfQuestionsAndAnswers: 'Αριθμός Ερωτήσεων και Απαντήσεις',
                                    scoringRules: 'Κανόνες βαθμολογίας',
                                    ifAnyQuestionAndAnswerIsCorrect: 'Οποιαδήποτε ερώτηση και απάντηση είναι σωστή.',
                                    branch: 'Σημεία',
                                    successfullySaved: 'Αποθήκευση με επιτυχία',
                                },
                                pptNode: {
                                    verificationPassed: 'Επαλήθευση',
                                    upload: 'Αποστολής',
                                    supportPptPdfFormatFiles: 'Υποστήριξη αρχείων ppt και pdf μορφής',
                                    uploadSlide: 'Αποστολή σλάιντ',
                                    assessmentMethod: 'Μέθοδος αξιολόγησης',
                                    associateSlide: 'Συνδεθείτε σλάιντ',
                                    standardScript: 'Πρότυπο λόγος',
                                    successfullySaved: 'Αποθήκευση με επιτυχία',
                                },
                                robotNode: {
                                    robotScript: 'Λόγος ρομπότ',
                                    randomScript: 'Τυχαία ομιλία',
                                    chooseAScriptWithSimilarSemanticsAndTheRobotWillRandomlySayOneSentence: 'Επιλέξτε λέξεις με παρόμοια σημασιολογικά, και το ρομπότ θα πει τυχαία μία από τις προτάσεις.',
                                    customerPortrait: 'Πορτραίτο πελατών',
                                    whenTheCustomersPortraitIsConsistentTheRobotSaysThisScript: 'Όταν το πορτραίτο του πελάτη είναι συνεπές, το ρομπότ μιλάει αυτό το λέει αυτό.',
                                    setAsDefaultScript: 'Ορισμός ως προκαθορισμένου',
                                    yes: 'Μάλιστα.',
                                    no: 'Οχι',
                                    useThisScriptWhenTheRobotMissesAnyUserTags: 'Αυτό λέγεται όταν το ρομπότ χάνει οποιαδήποτε ετικέτα χρήστη.',
                                    successfullySaved: 'Αποθήκευση με επιτυχία',
                                    thisBranchNodeAlreadyHasADefaultScriptDoYouWantToReplaceTheDefaultScriptWithTheCurrentScript: 'Αυτός ο κόμβος υποκατάστημα έχει ήδη μια προκαθορισμένη ομιλία. Επιθυμείτε την αντικατάσταση της προκαθορισμένης ομιλίας με την τρέχουσα ομιλία;',
                                },
                                startNode: {
                                    paragon: 'Φωνητικός',
                                    successfullySaved: 'Αποθήκευση με επιτυχία',
                                },
                                userNode: {
                                    verificationPassed: 'Επαλήθευση',
                                    standardScript: 'Πρότυπο λόγος',
                                    successfullySaved: 'Αποθήκευση με επιτυχία',
                                },
                                aiGenDialogueNode: {
                                    pleaseImproveTheConfiguration: 'Παρακαλώ τελειοποιήστε τη διαμόρφωσης',
                                },
                                aiGenPromptNode: {
                                    pleaseEnterAConversationExample: 'Παρακαλώ εισάγετε μια συνομιλία δείγματος',
                                    dialogueExample: 'Παράδειγμα συζήτησης',
                                    generateConversationExamples: 'Παράδειγμα διαλόγου δημιουργίας',
                                    mattersNeedingAttention: 'Προφυλάξεις',
                                    pleaseEnterThePromptLanguage: 'Παρακαλώ εισάγετε μια ερώτηση',
                                },
                                aiGenSceneNode: {
                                    dialogueScenario: 'Σκηνή διαλόγου',
                                    simulateCharacter: 'Εξομοιωμένος χαρακτήρας',
                                    accompanyingTrainees: 'Συνοδευτικό αντικείμενο',
                                    selectFromTemplateLibrary: 'Επιλέξτε από τη βιβλιοθήκη πρότυπου',
                                    templateLibrary: 'Βιβλιοθήκη προτύπων',
                                    role: 'Ρόλος',
                                    scene: 'Σκηνή',
                                },
                            },
                        },
                        pPTTestDrawer: {
                            slideTestWindow: 'Παράθυρο ελέγχου διαφάνειας',
                            clearContent: 'Καθαρισμός περιεχομένο',
                            close: 'Κλείσιμο',
                        },
                        aiGenFlowDrawer: {
                            index: {
                                aIGenerationProcessScript: 'Διαδικασία δημιουργίας AI',
                                scriptStyle: 'Στυλ ομιλίας',
                                theMostConversationRounds: 'Οι περισσότεροι γύροι διαλόγου',
                                copyConversation: 'Διάλογος αντιγραφής',
                                application: 'Εφαρμογή',
                                regenerate: 'Αναζωογόνο',
                                startGenerating: 'Έναρξη δημιουργίας',
                                pleaseGenerateAProcess: 'Παρακαλώ δημιουργία διαδικασίας',
                                copySuccessful: 'Επιτυχία αντιγραφής',
                            },
                        },
                        aiGenPPTDrawer: {
                            components: {
                                tipInput: {
                                    index: {
                                        salesRepresentative: 'Εκπρόσωπος πωλήσεων',
                                        customerServicePersonnel: 'Προσωπικό εξυπηρέτησης πελατών',
                                        storeCounter: 'Αποθήκευση μετρητής',
                                    },
                                },
                            },
                            index: {
                                generateFullTextSpeechScript: 'Δημιουργία δεξιοτήτων ομιλίας στο πλήρες κείμενο',
                                speaker: 'Ηχεία',
                                scriptStyle: 'Στυλ ομιλίας',
                                copyConversation: 'Διάλογος αντιγραφής',
                                application: 'Εφαρμογή',
                                regenerate: 'Αναζωογόνο',
                                startGenerating: 'Έναρξη δημιουργίας',
                                pleaseGenerateAProcess: 'Παρακαλώ δημιουργία διαδικασίας',
                                operationSuccessful: 'Επιτυχία λειτουργίας',
                                copySuccessful: 'Επιτυχία αντιγραφής',
                            },
                        },
                        aiTextArea: {
                            index: {
                                scriptPolishing: 'Γερμανικό λόγο',
                            },
                        },
                        aiWordsTextArea: {
                            theScriptCannotBeEmpty: 'Οι λέξεις δεν μπορούν να είναι άδειες!',
                            copySuccessful: 'Επιτυχία αντιγραφής',
                            cancel: 'Ακύρωση',
                            copy: 'Αντιγραφή',
                            replaceTheOriginalText: 'Αντικατάσταση πρωτοτύπων',
                            aiGeneration: 'Παραγωγή ενίσχυσης',
                            aiPolishing: 'Στιλ',
                            currentStyle: 'Τρέχον στύλ',
                            rigorous: 'Αυστηρός',
                            mild: 'Απαλά.',
                            lively: 'Ζωντανή',
                            simplicity: 'Απλό',
                            pleaseEnterTheSpeakerRole: 'Παρακαλώ εισάγετε έναν ρόλο ομιλητή',
                            startGenerating: 'Έναρξη δημιουργίας',
                        },
                        auditionTextArea: {
                            theScriptCannotBeEmpty: 'Οι λέξεις δεν μπορούν να είναι άδειες!',
                            copySuccessful: 'Επιτυχία αντιγραφής',
                            aiRewrite: 'Επαναγραφή AiName',
                            cancel: 'Ακύρωση',
                            copy: 'Αντιγραφή',
                            replaceTheOriginalText: 'Αντικατάσταση πρωτοτύπων',
                            currentStyle: 'Τρέχον στύλ',
                            rigorous: 'Αυστηρός',
                            mild: 'Απαλά.',
                            lively: 'Ζωντανή',
                            simplicity: 'Απλό',
                            pleaseEnterTheSpeakerRole: 'Παρακαλώ εισάγετε έναν ρόλο ομιλητή',
                            startGenerating: 'Έναρξη δημιουργίας',
                        },
                    },
                    index: {
                        verificationPassed: 'Επαλήθευση',
                        ruleValidation: 'Επαλήθευση κανόνας',
                        aIGeneration: 'Παραγωγή AI',
                        generateFullTextSpeechScript: 'Δημιουργία δεξιοτήτων ομιλίας στο πλήρες κείμενο',
                        editCourse: 'Επεξεργασία πορείας',
                        importConversation: 'Εισαγωγή συζήτησης',
                        uploadExcelToCompleteDialogueImport: 'Αποστολή πλήρης διάλογος εισαγωγής ExcelComment',
                        editBasicInformation: 'Επεξεργασία βασικών πληροφοριών',
                        test: 'Δοκιμή',
                        release: 'Δημοσίευση:',
                    },
                },
            },
            customerTagsManagement: {
                components: {
                    addTag: {
                        index: {
                            newLabel: 'Νέα ετικέταName',
                        },
                    },
                    tag: {
                        index: {
                            afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisLabel: 'Δεν μπορεί να ανακτηθεί μετά τη διαγραφή. Επιθυμείτε σίγουρα τη διαγραφή αυτής της ετικέτας;',
                            delete: 'Διαγραφή',
                            cancel: 'Ακύρωση',
                        },
                    },
                },
                index: {
                    labelManagement: 'Διαχείριση ετικέτας',
                    newGroup: 'Νέα ομάδας',
                    edit: 'Επεξεργασία',
                    afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisLabelGroup: 'Δεν μπορεί να ανακτηθεί μετά τη διαγραφή. Επιθυμείτε σίγουρα τη διαγραφή αυτής της ομάδας ετικέτας;',
                    delete: 'Διαγραφή',
                    cancel: 'Ακύρωση',
                    editGroup: 'Επεξεργασία ομαδοποίησης',
                    labelGroupName: 'Όνομα ομάδας ετικέτας',
                },
            },
            learningCenter: {
                components: {
                    camera: {
                        index: {
                            cameraDisabled: 'Απενεργοποιημένη φωτογραφική μηχανή',
                            noCameraDevicesFound: 'Δεν βρέθηκε η συσκευή φωτογραφικής λήψης',
                        },
                    },
                    cue: {
                        index: {
                            regenerate: 'Αναζωογόνο',
                            generate: 'Δημιουργία δημιουργίας',
                            referenceScript: 'Ομιλία αναφοράς',
                            mattersNeedingAttention: 'Προφυλάξεις',
                            examFrequency: 'Αριθμός εξετάσεων',
                            section: 'Τομέα',
                            timestotal: 'Ώρες/Σύνολο',
                            second: 'Χρόνια',
                            requirementsForPassingTheExam: 'Απαιτήσεις για την περάτωση των εξετάσεων',
                            examScore: 'Βαθμολογία δοκιμής ≥',
                            branch: 'Σημεία',
                        },
                    },
                    customerInfo: {
                        index: {
                            thereIsCurrentlyNoPortraitAvailable: 'Κανένα πορτραίτο.',
                            customerBackground: 'Ιστορικό Πελάτη',
                            customerLabel: 'Ετικέτα πελατών',
                        },
                    },
                    flow: {
                        index: {
                            processReminder: 'Ζήτηση διεργασίας (',
                            score: 'Βαθμολογία',
                            TotalScore: '/Συνολικός σκορ',
                        },
                    },
                    index: {
                        taskSource: 'Πηγή εργασίας',
                        taskName: 'Όνομα εργασίας',
                        taskStatus: 'Κατάσταση εργασίας',
                        whole: 'Όλα',
                        completionStatus: 'Κατάσταση ολοκλήρωσης',
                        courseClassification: 'Ταξινόμηση μαθημάτων',
                        practiceMode: 'Λειτουργία εξάσκησης',
                        examMode: 'Λειτουργία εξέτασης',
                        practiceTime: 'Χρόνος άσκησης',
                    },
                    ppt: {
                        index: {
                            nextPage: 'Επόμενη σελίδα',
                            tips: 'Ζήτηση',
                            continueWithCurrentPage: 'Συνέχιση τρέχουσας σελίδας',
                            goToTheNextPage: 'Μετάβαση στην επόμενη σελίδα',
                            afterEnteringTheNextPageYouWillNotBeAbleToReturnToThePreviousPagePleaseConfirmThatTheExplanationOnTheCurrentPageIsCompleteBeforeJumpingToTheNextPage: 'Αφού εισάγετε την επόμενη σελίδα, δεν θα μπορείτε να επιστρέψετε στην προηγούμενη σελίδα. Παρακαλώ επιβεβαιώστε ότι η επεξήγηση της τρέχουσας σελίδας είναι ολοκληρωμένη πριν από το άλμα.',
                            clickingOnTheNextPageWillNoLongerCauseThisPromptToPopUp: 'Κάντε κλικ στην επόμενη σελίδα δεν θα εμφανιστεί αυτή η ερώτηση',
                        },
                        list: {
                            index: {
                                slide: 'Κύλιση',
                            },
                        },
                    },
                    record: {
                        index: {
                            unableToRecord: 'Αδυναμία εγγραφής:',
                            creatingARecorderService: 'Δημιουργία υπηρεσίας εγγραφής',
                            turnOffTheRecorderService: 'Απενεργοποίηση υπηρεσιών εγγραφής',
                            theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'Ο τρέχων πελάτης είναι ήδη συνδεδεμένος με τον εξυπηρετητή ASR Websocket.',
                            afterProcessingTheLastFrameRestoreTheState: 'Μετά την επεξεργασία του τελευταίου πλαισίου, επαναφέρετε την κατάσταση',
                            aSRConnectionClosed: 'Σύνδεση ASR έκλεισε...',
                            recordingPausedAndHasBeenProcessedButThereIsStillDataInTheCache: 'Η εγγραφή έχει παύσει και έχει επεξεργαστεί, αλλά υπάρχουν ακόμα δεδομένα στη μνήμη μνήμης',
                            foundASRChannelClosedRecreateWebsocketLink: 'Βρέθηκε κανάλι ASR κλειστό, αναδημιουργία σύνδεσμου',
                            foundThatTheASRChannelIsNotOpenRecreateTheWebsocketLink: 'Βρέθηκε ότι το κανάλι ASR δεν είναι ανοικτό, αναδημιουργήστε το σύνδεσμο Websocket',
                        },
                        ppt: {
                            hook: {
                                index: {
                                    serverError: 'Σφάλμα εξυπηρετητή',
                                },
                            },
                        },
                        text: {
                            index: {
                                pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                                sendOut: 'Αποστολής',
                                startPracticing: 'Εκκίνηση εξάσκησης',
                                startTheExam: 'Ξεκίνα τις εξετάσεις.',
                            },
                        },
                        util: {
                            recorded: 'Καταγράφημα',
                            BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: 'Το 16-bit pcm SendFrameSize πρέπει να είναι ένα ακέραιο πολλαπλάσιο του 2',
                            pCMSamplingRateShouldNotOccur: 'Το ρυθμό δειγματοληψίας pcm δεν θα πρέπει να εμφανιστείν',
                            andTheRequiredSamplingRate: 'Και το απαιτούμενο ποσοστό δειγματοληψίας',
                            atypism: 'Ασυνεπή',
                            errorsThatShouldNotOccur: 'Σφάλματα που δεν θα πρέπει να συμβούν:',
                            spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span στυλ = "color:> Τα δεδομένα που είναι εκτός τάξης μπορούν να απορριφθούν αν οι απαιτήσεις δεν είναι υψηλές. Βοήθεια!',
                            flower: 'Λουλούδια',
                            TransferStopped: ': Η μεταφορά σταμάτησε.',
                        },
                        video: {
                            index: {
                                camera: 'Κάμερα',
                            },
                        },
                        voice: {
                            hook: {
                                bat: {
                                    index: {
                                        theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'Ο τρέχων πελάτης είναι ήδη συνδεδεμένος με τον εξυπηρετητή ASR Websocket.',
                                        aSRConnectionClosed: 'Σύνδεση ASR έκλεισε...',
                                        foundASRChannelClosedRecreateWebsocketLink: 'Βρέθηκε κανάλι ASR κλειστό, αναδημιουργία σύνδεσμου',
                                        unableToRecord: 'Αδυναμία εγγραφής:',
                                        aSRChannelClosedReopened: 'Το κανάλι ASR έκλεισε, άνοιξε ξανά.',
                                        theASRChannelWasNotCreatedStartingNow: 'Δεν δημιουργήθηκε κανάλι ASR, ξεκινήστε τη δημιουργία τώρα',
                                        useEffectCallbackToClearTheASRChannel: 'Χρήση Επηρεάστε κλήση για να καθαρίσετε το κανάλι ASR.',
                                        creatingARecorderService: 'Δημιουργία υπηρεσίας εγγραφής',
                                        turnOffTheRecorderService: 'Απενεργοποίηση υπηρεσιών εγγραφής',
                                    },
                                    util: {
                                        recorded: 'Καταγράφημα',
                                        BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: 'Το 16-bit pcm SendFrameSize πρέπει να είναι ένα ακέραιο πολλαπλάσιο του 2',
                                        pCMSamplingRateShouldNotOccur: 'Το ρυθμό δειγματοληψίας pcm δεν θα πρέπει να εμφανιστείν',
                                        andTheRequiredSamplingRate: 'Και το απαιτούμενο ποσοστό δειγματοληψίας',
                                        atypism: 'Ασυνεπή',
                                        errorsThatShouldNotOccur: 'Σφάλματα που δεν θα πρέπει να συμβούν:',
                                        spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span στυλ = "color:> Τα δεδομένα που είναι εκτός τάξης μπορούν να απορριφθούν αν οι απαιτήσεις δεν είναι υψηλές. Βοήθεια!',
                                        flower: 'Λουλούδια',
                                        TransferStopped: ': Η μεταφορά σταμάτησε.',
                                    },
                                },
                                index: {
                                    failInSend: 'Αποτυχία αποστολής',
                                },
                            },
                            index: {
                                startRecording: 'Έναρξη εγγραφής',
                                endRecording: 'Τέλος εγγραφής',
                                startPracticing: 'Εκκίνηση εξάσκησης',
                                startTheExam: 'Ξεκίνα τις εξετάσεις.',
                            },
                        },
                    },
                    taskMessageModal: {
                        index: {
                            theRemainingNumberOfTimesForTheCurrentExamIs: '(Ο τρέχων αριθμός των εξετάσεων που απομένουν είναι',
                            totalScriptScore: 'Σύνολο βαθμολογίας ομιλίας:',
                            totalEmotionalScore: 'Συνολική συναισθηματική βαθμολογία:',
                            totalScoreOfExpression: 'Συνολικός βαθμός έκφρασης:',
                            theCurrentTaskRatingResultNeedsToBeManuallyReviewedAfterTheReviewIsCompletedYouWillBeNotifiedOfTheFinalScorePleaseBePatientAndWait: 'Τα τρέχοντα αποτελέσματα βαθμολογίας εργασίας πρέπει να επανεξεταστούν χειροκίνητα. Αφού ολοκληρωθεί η αναθεώρηση, θα ενημερωθείτε για τα τελικά αποτελέσματα. Παρακαλώ περιμένετε υπομονετικά.',
                            areYouSureToSubmit: 'Επιβεβαίωση;',
                            theExerciseHasEndedAreYouSureToSubmit: 'Η άσκηση τελείωσε, είστε σίγουροι ότι θέλετε να την υποβάλετε;',
                            theExamHasEndedAreYouSureToSubmit: 'Η εξέταση τελείωσε, είσαι σίγουρος ότι θέλεις να την υποβάλεις;',
                            completed: 'Ολοκληρώθηκε',
                            page: 'Σελίδας',
                            pageCount: 'Σύνολο σελίδων',
                            topic: 'Θέμα:',
                            totalNumberOfQuestions: 'Συνολικός αριθμός ερωτήσεων',
                            totalScore: 'Συνολική βαθμολογία',
                            branch: 'Σημεία',
                            accumulatedCompletionProgress: 'Σωρευτική πρόοδος ολοκλήρωσης',
                            accumulatedPracticeDuration: 'Σωρευτική πρακτική Διάρκεια Διάρκειας',
                            lastPauseExerciseResults: 'Τελευταία αποτελέσματα εκτός ώρας',
                            exerciseInstructions: 'Οδηγίες άσκησης',
                            examInstructions: 'Περιγραφή εξετάσεων',
                            halfwayPausePracticeResults: 'Αποτελέσματα της μισής παύσης',
                            tips: 'Ζήτηση',
                            afterExitingThisExerciseWillNotBeCountedTowardsTheGradeAreYouSureToExit: 'Μετά την παραίτηση, αυτή η άσκηση δεν θα συμπεριληφθεί στο σκορ. Είστε σίγουροι ότι θέλετε να παραιτηθείτε;',
                            exitIsNotAllowedMidwayThroughTheExamAreYouSureToSubmit: 'Η παραίτηση δεν επιτρέπεται στη μέση των εξετάσεων. Επιβεβαίωση;',
                            pleaseOperateWithCaution: 'Times, παρακαλώ λειτουργήστε προσεκτικά)',
                            restart: 'Επανεκκίνηση',
                            returnToLearning: 'Επιστροφή στη Μάθηση',
                            continuePracticing: 'Συνέχιση της εξάσκησης',
                            continuingTheExam: 'Συνέχιση εξετάσεων',
                            return: 'Επιστροφή',
                            notSubmittedTemporarily: 'Δεν υποβλήθηκε',
                            iGotIt: 'Το ξέρω.',
                            confirmExit: 'Επιβεβαίωση εξόδου',
                            confirmSubmission: 'Επιβεβαίωση υποβολής',
                            signOut: 'Έξοδος',
                        },
                    },
                    taskSubmitButton: {
                        index: {
                            suspend: 'Παύση',
                            submit: 'Υποβολή',
                            remainingTimeOfThisQuestion: 'Λαμένος χρόνος',
                            SecondsLeftUntilTheEndTime: '10 δευτερόλεπτα μέχρι το τέλος του χρόνου',
                            remainingTime: 'Λαμένος χρόνος',
                        },
                    },
                    util: {
                        noUserVoiceContentDetectedPleaseTryAgain: 'Το περιεχόμενο φωνής χρήστη δεν ανιχνεύθηκε, παρακαλώ δοκιμάστε ξανά',
                    },
                    wave: {
                        index: {
                            continueRecording: 'Συνέχιση καταγραφής',
                            submit: 'Υποβολή',
                            endRecording: 'Τέλος εγγραφής',
                            suspendRecording: 'Παύση καταγραφής',
                            startPracticing: 'Εκκίνηση εξάσκησης',
                            startTheExam: 'Ξεκίνα τις εξετάσεις.',
                        },
                    },
                    deviceModal: {
                        index: {
                            dialogueMode: 'Λειτουργία διαλόγου',
                            excessiveNoisePleaseSwitchToAQuietEnvironment: 'Πάρα πολύ θόρυβο, παρακαλώ γυρίστε σε ήσυχο περιβάλλον.',
                            normalNoiseDetection: 'Η ανίχνευση θορύβου είναι φυσιολογική.',
                            theVolumeIsTooLowPleaseIncreaseTheVolume: 'Ο όγκος είναι πολύ χαμηλός, παρακαλώ αυξήστε τον όγκο',
                            volumeDetectionIsNormal: 'Κανονική ανίχνευση έντασης',
                            noiseDetection: 'Ανίχνευση θορύβου',
                            pleaseRemainQuietAndRecordAsAmbientSound: 'Παρακαλώ κρατήστε ήσυχη και καταγράφετε ήχο 3s.',
                            endRecording: 'Τέλος εγγραφής',
                            startRecording: 'Έναρξη εγγραφής',
                            volumeDetection: 'Ανίχνευση όγκου',
                            pleaseReadNowPerformVolumeTestAtNormalVolume: 'Παρακαλώ διαβάστε το "δοκιμή όγκου τώρα" σε κανονικό όγκο"',
                            playLastDetectedAudio: 'Αναπαραγωγή τελευταίας ανίχνευσης',
                            pleaseReadTheRequirementsCarefullyBeforeStarting: 'Παρακαλούμε διαβάστε προσεκτικά τις απαιτήσεις πριν αρχίσετε.',
                            return: 'Επιστροφή',
                            iGotIt: 'Το ξέρω.',
                            timeLimitForSingleQuestionAnswering: 'Προθεσμία απάντησης',
                            totalTimeLimit: 'Συνολικό όριο χρόνου',
                            unlimitedTime: 'Απεριόριστος χρόνος',
                            stillNeedToCompleteTheTaskInTotal: 'Η συνολική εργασία πρέπει να ολοκληρωθεί',
                            practice: 'Άσκηση',
                            second: 'Χρόνια',
                            taskScore: 'Ένα σκορ εργασία',
                            branch: 'Σημεία',
                            or: 'Ή',
                            examScore: 'Βαθμολογία δοκιμής ≥',
                            remainingExamTimes: 'Αριθμός εξετάσεων',
                            totalScore: 'Συνολική βαθμολογία',
                            Script: '(Μιλάκερ)',
                            scoreEmotion: 'Συναίσθημα',
                            fractionExpression: 'Υπο-έκφραση',
                            points: 'Βαθμοί)',
                            standardScore: 'Τυπική βαθμολογία',
                            excellentScore: 'Εξαιρετικό βαθμό',
                            exerciseInstructions: 'Οδηγίες άσκησης',
                            forASmoothAnswerPleaseCompleteTheEquipmentInspectionFirst: 'Για να απαντήσετε ομαλά στην ερώτηση, ολοκληρώστε πρώτα τη δοκιμή εξοπλισμού:',
                            camera: 'Κάμερα',
                            beingAbleToSeeOneselfInTheVideoMeansThatTheCameraIsFunctioningProperly: 'Το να είσαι σε θέση να δεις τον εαυτό σου στο βίντεο σημαίνει ότι η κάμερα είναι φυσιολογική.',
                            microphone: 'Μικρόφωνο',
                            pleaseSpeakIntoTheMicrophoneSeeingTheWaveformPatternIndicatesThatTheMicrophoneIsFunctioningProperly: 'Παρακαλώ μιλήστε στο μικρόφωνο, δείτε το μοτίβο κυματομορφών σημαίνει ότι το μικρόφωνο είναι φυσιολογικό είναι το μικρόφωνο.',
                        },
                    },
                },
                course: {
                    components: {
                        folderTree: {
                            modal: {
                                index: {
                                    empty: 'Κενό',
                                    copyTo: 'Αντιγραφή',
                                    classification: 'Ταξινόμηση',
                                    rename: 'Μετονομασία',
                                    newlyBuild: 'Νέο',
                                    categoryParent: 'Ανώτερη κατάταξη',
                                    moveTo: 'Μετακίνηση',
                                    name: 'Όνομα',
                                },
                            },
                            util: {
                                rename: 'Μετονομασία',
                                moveTo: 'Μετακίνηση',
                                copyTo: 'Αντιγραφή',
                                delete: 'Διαγραφή',
                                courseClassification: 'Ταξινόμηση μαθημάτων',
                                newlyBuild: 'Νέο',
                            },
                        },
                        evaluateDrawer: {
                            index: {
                                curriculumEvaluation: 'Αξιολόγηση προγράμματος σπουδών',
                                cancel: 'Ακύρωση',
                                submission: 'Υποβολή',
                                courseQuality: 'Ποιότητα μαθημάτων',
                                higherValuesIndicateBetterCourseQuality: 'Υψηλότερες τιμές δείχνουν καλύτερη ποιότητα μαθημάτων',
                                learningEffect: 'Μάθηση επίδραση',
                                theHigherTheValueTheBetterTheLearningEffect: 'Όσο υψηλότερη είναι η αξία, τόσο καλύτερη είναι η μάθηση.',
                                interactiveExperience: 'Διαδραστική εμπειρία',
                                theHigherTheValueTheBetterTheInteractiveExperienceOfTheCourse: 'Όσο υψηλότερη είναι η αξία, τόσο καλύτερη η διαδραστική εμπειρία του μαθήματος.',
                                suggestedFeedback: 'Προτεινόμενη ανάδραση',
                                pleaseEnterAnEvaluationProposalForThisCourse: 'Παρακαλούμε εισάγετε μια πρόταση αξιολόγησης για αυτό το μάθημα',
                            },
                        },
                    },
                    edit: {
                        index: {
                            curriculum: 'Πρόγραμμα σπουδών',
                        },
                    },
                    index: {
                        courseLabel: 'Ετικέτα πορείας',
                        comments: 'Παρατηρήσεις',
                        submissionOfEvaluation: 'Υποβολή αξιολόγησης:',
                        evaluationOfSuccess: 'Αξιολόγηση της επιτυχίας',
                        learn: 'Μάθηση',
                        practice: 'Εξάσκηση',
                        examination: 'Δοκιμή',
                        curriculum: 'Πρόγραμμα σπουδών',
                        courseIntroduction: 'Εισαγωγή μαθημάτων:',
                        createdOn: 'Χρόνος δημιουργίας:',
                        published: 'Δημοσίευση',
                        tasks: 'Καθήκοντα',
                        unpublishedTasks: 'Μη δημοσίευση',
                        task: 'Καθήκοντα',
                        operation: 'Λειτουργία',
                        learningMaterials: 'Υλικά εκμάθησης',
                        goPractice: 'Πήγαινε στην εξάσκηση',
                        publishTask: 'Δημοσίευση εργασιών',
                        taskData: 'Δεδομένα εργασίας',
                        edit: 'Επεξεργασία',
                        copy: 'Αντιγραφή',
                        successfullyCopied: 'Επιτυχία αντιγραφής',
                        delete: 'Διαγραφή',
                        afterDeletionAllTaskDataUnderThisCourseWillBeClearedAreYouSureToDeleteTheCourse: 'Μετά τη διαγραφή, όλα τα δεδομένα εργασίας σε αυτό το μάθημα θα εκκαθαριστούν. Σίγουρα θα διαγράψετε το μάθημα;',
                        courseName: 'Όνομα πορείας',
                        creationTime: 'Χρόνος δημιουργίας',
                        releaseStatus: 'Κατάσταση δημοσίευσης',
                        whole: 'Όλα',
                    },
                },
                nodeConfigTest: {
                    components: {
                        input: {
                            noSoundDetected: 'Δεν ανιχνεύθηκε ήχος',
                            voice: 'Φωνή',
                            text: 'Κείμενο',
                            referenceScript: 'Ομιλία αναφοράς:',
                            clickOnTheRightSideToStartRecording: 'Κάντε κλικ στο δεξί για να ξεκινήσετε την εγγραφή',
                            sendOut: 'Αποστολής',
                        },
                        hooks: {
                            input: {
                                theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'Ο τρέχων πελάτης είναι ήδη συνδεδεμένος με τον εξυπηρετητή ASR Websocket.',
                                afterProcessingTheLastFrameRestoreTheState: 'Μετά την επεξεργασία του τελευταίου πλαισίου, επαναφέρετε την κατάσταση',
                                aSRConnectionClosed: 'Σύνδεση ASR έκλεισε...',
                                recordingPausedAndHasBeenProcessedButThereIsStillDataInTheCache: 'Η εγγραφή έχει παύσει και έχει επεξεργαστεί, αλλά υπάρχουν ακόμα δεδομένα στη μνήμη μνήμης',
                                foundASRChannelClosedRecreateWebsocketLink: 'Βρέθηκε κανάλι ASR κλειστό, αναδημιουργία σύνδεσμου',
                                foundThatTheASRChannelIsNotOpenRecreateTheWebsocketLink: 'Βρέθηκε ότι το κανάλι ASR δεν είναι ανοικτό, αναδημιουργήστε το σύνδεσμο Websocket',
                                unableToRecord: 'Αδυναμία εγγραφής:',
                                creatingARecorderService: 'Δημιουργία υπηρεσίας εγγραφής',
                                turnOffTheRecorderService: 'Απενεργοποίηση υπηρεσιών εγγραφής',
                            },
                            util: {
                                recorded: 'Καταγράφημα',
                                BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: 'Το 16-bit pcm SendFrameSize πρέπει να είναι ένα ακέραιο πολλαπλάσιο του 2',
                                pCMSamplingRateShouldNotOccur: 'Το ρυθμό δειγματοληψίας pcm δεν θα πρέπει να εμφανιστείν',
                                andTheRequiredSamplingRate: 'Και το απαιτούμενο ποσοστό δειγματοληψίας',
                                atypism: 'Ασυνεπή',
                                errorsThatShouldNotOccur: 'Σφάλματα που δεν θα πρέπει να συμβούν:',
                                spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span στυλ = "color:> Τα δεδομένα που είναι εκτός τάξης μπορούν να απορριφθούν αν οι απαιτήσεις δεν είναι υψηλές. Βοήθεια!',
                                flower: 'Λουλούδια',
                                TransferStopped: ': Η μεταφορά σταμάτησε.',
                            },
                        },
                        finishTest: {
                            index: {
                                endTest: 'Τέλος δοκιμής',
                                testResult: 'Αποτελέσματα δοκιμής',
                                returnToCanvas: 'Επιστροφή στο καμβάς',
                                retest: 'Επανεκκίνηση δοκιμής',
                            },
                        },
                    },
                    index: {
                        testFromCurrentNode: 'Δοκιμή από τον τρέχον κόμβο',
                        listening: 'Ραδιόφωνο...',
                        canvasTesting: 'Δοκιμή καμβάς',
                        endOfProcess: 'Τέλος της διεργασίας',
                        restart: 'Επανεκκίνηση',
                        start: 'Εκκίνηση',
                    },
                },
                record: {
                    detail: {
                        components: {
                            openButton: {
                                index: {
                                    collapseAnalysis: 'Ανάλυση κατάρρευσης',
                                    expandParsing: 'Ανάπτυξη ανάλυσης',
                                },
                            },
                            overView: {
                                index: {
                                    tooManyModalParticles: 'Πάρα πολλές λέξεις',
                                    second: 'Χρόνια',
                                    ratingOverview: 'Επισκόπηση βαθμολογίας',
                                    totalScore: 'Συνολική βαθμολογία',
                                    section: 'Τομέα',
                                    name: 'Όνομα',
                                    of: '(Σύνολο)',
                                    people: 'Άτομα)',
                                    scriptScore: 'Βαθμολογία ομιλίας',
                                    common: 'Σύνολο',
                                    keyPoints: 'Ένα βασικό σημείο,',
                                    notReached: 'Δεν επετεύχθη,',
                                    have: 'Υπάρχουν.',
                                    violationOfRegulations: 'Παραβάσεις',
                                    emotionalScore: 'Βαθμολογία συναισθημάτων',
                                    appear: 'Εμφάνιση',
                                    secondaryNegativeEmotions: 'Δευτερεύοντα αρνητικά συναισθήματα',
                                    expressionScore: 'Βαθμολογία έκφρασης',
                                    speakTooFast: 'Γρήγορα φωτιά',
                                    times: 'Φορές,',
                                    speakTooSlowly: 'ΠΑΡΑΡΤΗΜΑ',
                                    average: 'Μέσος',
                                    wordminute: 'Λέξη/ λεπτό',
                                },
                            },
                            score: {
                                index: {
                                    studentNodeName: 'Όνομα κόμβου μαθητής',
                                    keyPointName: 'Όνομα βασικού σημείου',
                                    slideNodeName: 'Όνομα κόμβου',
                                    dialogue: 'Διάλογος',
                                    mainPoints: 'Βασικά σημεία',
                                    slide: 'Κύλιση',
                                    detectionResult: 'Αποτελέσματα δοκιμής',
                                    satisfy: 'Συνάντηση με τη Ρωσία.',
                                    dissatisfaction: 'Μη ικανοποιημένο',
                                    score: 'Βαθμολογία',
                                    script: 'Λέξεις',
                                    semantics: 'Σημασιολογικό',
                                    scriptViolation: 'Παραβίαση λόγου',
                                    emotion: 'Συναίσθημα',
                                    expression: 'Έκφραση',
                                },
                            },
                            taskTitle: {
                                index: {
                                    branch: 'Σημεία',
                                },
                            },
                            comprehensiveEvaluation: {
                                const: {
                                    thisTime: 'Αυτή τη φορά.',
                                    lastTime: 'Τελευταία φορά.',
                                    comprehensiveEvaluation: 'Συνολική αξιολόγηση',
                                },
                                index: {
                                    spanStylemarginLeftpxStandardScriptAccumulation: '<Span στυλ = "margin-αριστερά: 8px>· Τυποποιημένος ομιλητικός συναρμολογημένος',
                                    theTotalNumberOfWordsHitByTheStudentAfterReading: 'Μια λέξη, ο αριθμός των λέξεων που χτύπησε ο μαθητής.',
                                    aWordspan: 'Λέξη βάση>',
                                    timesspanbrspanStylemarginLeftpxSpeakTooSlowly: 'Χρόνια',
                                    timesspan: 'Βοήθεια!',
                                    tooManyModalParticles: '<Span στυλ = "margin-αριστερά: 8px>· πάρα πολλές λέξεις',
                                    complete: 'Πλήρες περιεχόμενο',
                                    keyHit: 'Χτύπημα βασικών σημείων',
                                    languageNorm: 'Προδιαγραφή γλωσσών',
                                    fluentExpression: 'Ομαλή έκφραση',
                                    emotionallyPositive: 'Συναισθηματικά θετικός',
                                    radarChart: 'Διάγραμμα ραντάρ',
                                    spanStylemarginLeftpxNumberOfCompleteProcesses: '<Span στυλ = "margin-αριστερά: 8px>· Αριθμός πλήρους ροών',
                                    spanStylemarginLeftpxNumberOfHitPoints: '<Span στυλ = "margin-αριστερά: 8px>· Χτυπήστε βασικά σημεία',
                                    spanStylemarginLeftpxYes: '<Span στυλ = "margin-αριστερά: 8px>· Ναι.',
                                    dealingWithIllegalWordsspan: 'Παραβίαση της λέξης caspan>',
                                    spanStylemarginLeftpxSpeakTooFast: '<Span στυλ = "margin-αριστερά: 8px>· Ραφήστε πολύ γρήγορα',
                                    spanbrspanStylemarginLeftpxTooManyModalParticles: 'Στυλ / Ξεφάνιση = "margin-αριστερά: 8px" πάρα πολλές λέξεις',
                                    spanStylemarginLeftpxNegativeEmotions: '<Span στυλ = "margin-αριστερά: 8pxFF· Αρνητικά συναισθήματα',
                                },
                            },
                            scoreRecord: {
                                index: {
                                    scoringRecords: 'Εγγραφή βαθμολογίας',
                                    firstRating: 'Αξιολόγηση πρώτης φοράς',
                                    totalScore: 'Συνολική βαθμολογία',
                                    changeTo: 'Αλλαγή',
                                },
                            },
                            aiGenScore: {
                                index: {
                                    communicationStage: 'Φάση επικοινωνίας',
                                    communicationObjectives: 'Στόχοι επικοινωνίας',
                                    scoringCriteria: 'Κριτήρια βαθμολογίας',
                                    suggestionsForImprovement: 'Συστάσεις προώθησης',
                                },
                            },
                            onceMore: {
                                index: {
                                    remainingTimes: 'Υπόλοιπο:',
                                    second: 'Χρόνια',
                                    doItAgain: 'Άλλη μια φορά.',
                                },
                            },
                            audio: {
                                index: {
                                    theBrowserDoesNotSupportAudioPlayback: 'Ο περιηγητής δεν υποστηρίζει την αναπαραγωγή ήχου.',
                                },
                            },
                            evaluationSuggestion: {
                                index: {
                                    scriptCommentsAndSuggestions: 'Σχόλια και Προτάσεις για τον Λόγο',
                                    regenerate: 'Αναζωογόνο',
                                    generate: 'Δημιουργία δημιουργίας',
                                    generationFailed: 'Η κατασκευή απέτυχε',
                                },
                            },
                            resultModal: {
                                index: {
                                    return: 'Επιστροφή',
                                    viewDetails: 'Λεπτομέρειες προβολής',
                                },
                            },
                        },
                        index: {
                            reRatingSuccessful: 'Επαναφορά επιτυχίας αποτέλεσμας',
                            reRatingFailed: 'Η επαναχρησιμοποίηση απέτυχε',
                            downloadRecording: 'Λήψη εγγραφής',
                            downloadText: 'Λήψη κειμένου:',
                            download: 'Λήψης',
                            reRating: 'Επαναφορά αποτέλεσμας',
                            submitARatingAppeal: 'Υποβολή βαθμολόγησης',
                            reviewSubmission: 'Αναθεώρηση υποβολής',
                            saveChanges: 'Αποθήκευση τροποποιήσεων',
                            previousSentence: 'Προηγούμενη πρόταση',
                            nextSentence: 'Επόμενη πρόταση',
                            score: 'Αξιολόγηση',
                            scoringSituation: 'Βαθμολογία',
                            dialogueAnalysis: 'Ανάλυση διαλόγου',
                        },
                    },
                    index: {
                        ratingAppealInProgress: 'Αποτελέσματα βαθμολογίας',
                        operation: 'Λειτουργία',
                        wrongQuestionSet: 'Λάθος σύνολο προβλήματος',
                        ratingUpdate: 'Ενημέρωση αξιολόγησης',
                        viewDetails: 'Λεπτομέρειες προβολής',
                        curriculum: 'Πρόγραμμα σπουδών',
                        taskName: 'Όνομα εργασίας',
                        taskType: 'Τύπος εργασίας',
                        score: 'Βαθμολογία',
                        scoringResults: 'Αποτελέσματα βαθμολογίας',
                        time: 'Χρόνο',
                        courseClassification: 'Ταξινόμηση μαθημάτων',
                        whole: 'Όλα',
                        learningTime: 'Χρόνος μάθησης',
                        historicalLearningData: 'Ιστορικά δεδομένα μάθησης',
                    },
                },
                task: {
                    exercise: {
                        index: {
                            intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας',
                            practicePause: 'Παύση εξάσκησης',
                            lastProgress: 'Τελευταία πρόοδος',
                            continuePracticing: 'Συνέχιση της εξάσκησης',
                            practice: 'Άσκηση',
                            startPracticing: 'Εκκίνηση εξάσκησης',
                            historicalData: 'Ιστορικά δεδομένα',
                            courseIntroduction: 'Εισαγωγή μαθημάτων:',
                            exerciseDifficulty: 'Δυσκολία άσκησης:',
                            practiceCompletionRequirements: 'Απαιτήσεις ολοκλήρωσης άσκησης:',
                            practiceFrequency: 'Αριθμός ασκήσεων ≥',
                            second: 'Χρόνια',
                            anyScore: 'Οποιαδήποτε βαθμολογία ≥',
                            branch: 'Σημεία',
                            or: 'Ή',
                            taskList: 'Λίστα εργασιών',
                            practiceTime: 'Χρόνος άσκησης:',
                            to: 'Στον',
                            unlimitedTime: 'Απεριόριστος χρόνος',
                            completionStatus: 'Κατάσταση ολοκλήρωσης',
                            numberOfExercises: 'Αριθμός ασκήσεων',
                            maximumScore: 'Υψηλότερο βαθμό',
                            operation: 'Λειτουργία',
                            enteringLearning: 'Εισάγετε μάθηση',
                            historicalLearningData: 'Ιστορικά δεδομένα μάθησης',
                            wrongQuestionSet: 'Λάθος σύνολο προβλήματος',
                        },
                    },
                    index: {
                        practiceTasks: 'Εργασία',
                        examTasks: 'Εργασίες εξέτασης',
                        task: 'Καθήκοντα',
                    },
                    learn: {
                        index: {
                            courseName: 'Όνομα πορείας',
                            courseIntroduction: 'Εισαγωγή μαθημάτων',
                            learningContent: 'Περιεχόμενο μάθησης',
                            downloadLearningMaterials: 'Λήψη υλικών εκπαίδευσης',
                            startPracticing: 'Εκκίνηση εξάσκησης',
                        },
                    },
                    test: {
                        index: {
                            taskList: 'Λίστα εργασιών',
                            courseIntroduction: 'Εισαγωγή μαθημάτων:',
                            examDifficulty: 'Δυσκολία των εξετάσεων:',
                            requirementsForPassingTheExam: 'Απαιτήσεις για την περαιτέρω εξέταση:',
                            examScore: 'Βαθμολογία δοκιμής ≥',
                            branch: 'Σημεία',
                            examTime: 'Χρόνος εξέτασης:',
                            to: 'Στον',
                            unlimitedTime: 'Απεριόριστος χρόνος',
                            completionStatus: 'Κατάσταση ολοκλήρωσης',
                            completionTimes: 'Αριθμός ολοκλήρωσης',
                            maximumScore: 'Υψηλότερο βαθμό',
                            operation: 'Λειτουργία',
                            immediateExam: 'Άμεση εξέταση:',
                            history: 'Ιστορία',
                        },
                    },
                },
                wrongQuestionSet: {
                    exercise: {
                        components: {
                            cue: {
                                index: {
                                    referenceScript: 'Ομιλία αναφοράς',
                                },
                            },
                            flow: {
                                index: {
                                    wrongQuestionItem: 'Λάθος αντικείμενο',
                                    score: 'Βαθμολογία',
                                    TotalScore: '/Συνολικός σκορ',
                                },
                            },
                            record: {
                                ppt: {
                                    hook: {
                                        index: {
                                            serverError: 'Σφάλμα εξυπηρετητή',
                                        },
                                    },
                                    index: {
                                        startRecording: 'Έναρξη εγγραφής',
                                        endRecording: 'Τέλος εγγραφής',
                                        startPracticing: 'Εκκίνηση εξάσκησης',
                                    },
                                },
                                text: {
                                    index: {
                                        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                                        sendOut: 'Αποστολής',
                                        startPracticing: 'Εκκίνηση εξάσκησης',
                                    },
                                },
                                voice: {
                                    index: {
                                        startRecording: 'Έναρξη εγγραφής',
                                        endRecording: 'Τέλος εγγραφής',
                                        startPracticing: 'Εκκίνηση εξάσκησης',
                                    },
                                    hook: {
                                        index: {
                                            failInSend: 'Αποτυχία αποστολής',
                                        },
                                    },
                                },
                            },
                            taskMessageModal: {
                                index: {
                                    scoreForThisPracticeOfIncorrectQuestions: 'Αποτέλεσμα αυτής της λάθος άσκησης',
                                    tips: 'Ζήτηση',
                                    areYouSureToEnd: 'Επιβεβαιώστε το τέλος;',
                                    practiceAgainWithoutMasteringTheWrongQuestions: 'Εξασκήστε ξανά και μην ελέγχετε τις λάθος ερωτήσεις.',
                                    continue: 'Συνέχεια',
                                    returnToTheSetOfIncorrectQuestions: 'Επιστροφή σε λάθος ερώτησης',
                                    end: 'Τέλος:',
                                    wrongQuestionItem: 'Λάθος αντικείμενο',
                                    numberOfExercisesThisTime: 'Ο αριθμός αυτής της άσκησης',
                                    masteringTheSituation: 'Κατανοήστε την κατάσταση.',
                                    mastered: 'Βεβαίωση',
                                    notMastered: 'Χωρίς κυριότητα',
                                },
                            },
                            taskSubmitButton: {
                                index: {
                                    practiceThisQuestionAgain: 'Άσκησε ξανά αυτή την ερώτηση.',
                                    nextQuestion: 'Επόμενη ερώτηση.',
                                },
                            },
                        },
                        ppt: {
                            index: {
                                mispracticeExercises: 'Λάθος Άσκηση',
                                endExercise: 'Τέλος άσκησης',
                            },
                        },
                        text: {
                            index: {
                                mispracticeExercises: 'Λάθος Άσκηση',
                                endExercise: 'Τέλος άσκησης',
                            },
                        },
                        voice: {
                            index: {
                                mispracticeExercises: 'Λάθος Άσκηση',
                                endExercise: 'Τέλος άσκησης',
                            },
                        },
                    },
                    list: {
                        components: {
                            checkScript: {
                                index: {
                                    checkScript: 'Προβολή ομιλίας',
                                    section: 'Τομέα',
                                    secondaryDiscourseTechnique: 'Δευτερεύουσα ομιλίας',
                                },
                            },
                            tableItem: {
                                count: {
                                    second: 'Χρόνια',
                                },
                                scoreRuleList: {
                                    noRelevantInformationFound: 'Δεν βρέθηκαν σχετικές πληροφορίες',
                                    recallWords: 'Ανάκληση λέξης',
                                    branch: 'Σημεία',
                                    answerIncorrectly: 'Λάθος απάντηση',
                                    second: 'Χρόνια',
                                    wrongAnswerRate: 'Λανθασμένο ποσοστό απάντησης',
                                },
                                standardScript: {
                                    standardScript: 'Πρότυπο λόγος',
                                    myScript: 'Τα λόγια μου.',
                                },
                                status: {
                                    mastered: 'Βεβαίωση',
                                    notMastered: 'Χωρίς κυριότητα',
                                },
                                index: {
                                    totalNumberOfQuestionsAnswered: 'Συνολικός αριθμός απαντήσεων',
                                    numberOfTimesIncorrectQuestionsHaveBeenPracticed: 'Αριθμός φορών λανθασμένα ερωτήματα',
                                },
                            },
                        },
                        index: {
                            wrongQuestionList: 'Κατάλογος λανθασμένων ερωτήσεων',
                            wrongQuestionSet: 'Λάθος σύνολο προβλήματος',
                            mispracticeExercises: 'Λάθος Άσκηση',
                            taskName: 'Όνομα εργασίας',
                            staff: 'Εργαζόμενος',
                            masteringTheSituation: 'Κατανοήστε την κατάσταση.',
                            whole: 'Όλα',
                        },
                    },
                },
            },
            taskCenter: {
                components: {
                    completeStandart: {
                        index: {
                            practiceFrequency: 'Αριθμός ασκήσεων ≥',
                            second: 'Χρόνια',
                            or: 'Ή',
                            excellentScoreAtAnyOneTime: 'Οποιαδήποτε βαθμολογία άριστη (≥)',
                            points: 'Βαθμοί)',
                            examScore: 'Βαθμολογία δοκιμής ≥',
                            branch: 'Σημεία',
                        },
                    },
                    manualReviewConfig: {
                        index: {
                            randomAverageDistribution: 'Τυχαία μέση κατανομή',
                            assignToDesignatedPersonnel: 'Αναθέστε σε Καθορισμένα Πρόσωπα',
                        },
                    },
                    examTimesInput: {
                        index: {
                            successfullyIncreasedTheNumberOfExams: 'Επιτυχία στην αύξηση του αριθμού των εξετάσεων',
                            failedToIncreaseTheNumberOfExams: 'Αύξηση του αριθμού των αστοχιών δοκιμής',
                            increaseTheNumberOfExams: 'Αύξηση του αριθμού των εξετάσεων',
                            selectObjects: 'Επιλογή αντικειμένου',
                        },
                    },
                    executionFilter: {
                        index: {
                            participationRate: 'Ποσοστό συμμετοχής',
                        },
                    },
                    intelligentReview: {
                        index: {
                            overallReview: 'Συνολική επανεξέταση',
                            pleaseEnterTheReviewCriterianotMandatory: 'Παρακαλώ εισάγετε κριτήρια σχολίου (δεν απαιτείται)',
                            commentaryOnSingleSentenceRhetoric: 'Παρατηρήσεις σχετικά με την ενιαία φράση',
                            realTimeReview: 'Αξιολογήσεις σε πραγματικό χρόνο.',
                        },
                    },
                },
                detail: {
                    resultAnalysis: {
                        averageScoreOfTheExam: 'Μέση βαθμολογία δοκιμής',
                        averageExamDurationmin: 'Μέση διάρκεια εξέτασης (min)',
                        accumulatedPracticeDurationmin: 'Σωρευτική διάρκεια πρακτικής (ελάχιστο)',
                        accumulatedPracticeTimes: 'Σωρευτικός αριθμός ασκήσεων',
                        totalScore: 'Συνολική βαθμολογία',
                        average: 'Μέσος',
                        total: 'Σύνολο',
                        keyHitCount: 'Βασικά σημεία χτύπησης',
                        practiceAverageScore: 'Μέσος βαθμολογία',
                        averagePracticeDurationmin: 'Μέση διάρκεια άσκησης (min)',
                        topOfTheHighestScore: 'Η υψηλότερη βαθμολογία Top3',
                        branch: 'Σημεία',
                        errorProneItemTop: 'Αντικείμενα στο σφάλμα Top5',
                        hitRate: 'Ποσοστό αποτυχίας',
                        hitRateOfKeyPointsInScript: 'Ομιλία βασικά σημεία Hit Rate',
                        averageScriptScore: 'Μέσος βαθμός ομιλίας',
                        sortByProcess: 'Ταξινόμηση κατά διαδικασία',
                        sortByScore: 'Ταξινόμηση κατά βαθμό',
                        averageScoreOfThisPagetotalScoreOfThisPage: 'Μέση βαθμολογία αυτής της σελίδας / συνολική βαθμολογία αυτής της σελίδας',
                        averageScoreOfThisItemtotalScoreOfThisItem: 'Η μέση βαθμολογία του αντικειμένου αυτού',
                        details: 'Λεπτομέρειες',
                        viewRules: 'Κανόνες προβολής',
                        standardScript: 'Πρότυπο λόγος',
                    },
                    scoreDetailList: {
                        section: 'Τομέα',
                        second: 'Χρόνια',
                        practice: 'Άσκηση',
                        examination: 'Εξέταση',
                        notMeetingStandards: 'Δεν έως το πρότυπο',
                        meetingStandards: 'Πρότυπο',
                        excellent: 'Εξαιρετικά.',
                        frequency: 'Αριθμός φορών',
                        fraction: 'Κλάσματα',
                        result: 'Αποτελέσματα',
                        operation: 'Λειτουργία',
                        viewDetails: 'Λεπτομέρειες προβολής',
                    },
                    index: {
                        common: 'Σύνολο',
                        people: 'Άνθρωποι.',
                        staff: 'Εργαζόμενος',
                        notMeetingStandards: 'Δεν έως το πρότυπο',
                        meetingStandards: 'Πρότυπο',
                        excellent: 'Εξαιρετικά.',
                        notStarted: 'Δεν ξεκίνησες',
                        haveInHand: 'Σε εξέλιξη.',
                        completed: 'Ολοκληρώθηκε',
                        passed: 'Πέρασε',
                        hangInTheAir: 'Μη ολοκληρωμένες',
                        failed: 'Δεν έλαβαν',
                        unlimitedTime: 'Απεριόριστος χρόνος',
                        to: 'Στον',
                        maximumScoringCriteria: 'Υψηλότερα κριτήρια βαθμολογίας',
                        completionStatus: 'Κατάσταση ολοκλήρωσης',
                        employeeName: 'Όνομα υπαλλήλου',
                        frequency: 'Αριθμός φορών',
                        practice: 'Άσκηση',
                        examination: 'Εξέταση',
                        average: 'Μέσος',
                        speechCraftAvgScore: 'Μέσος βαθμός ομιλίας',
                        emotionAvgScore: 'Μέση συναισθηματική βαθμολογία',
                        speedAvgScore: 'Express μέσο βαθμός',
                        flowAvgScore: 'Μέση βαθμολογία διαδικασίας',
                        practiceCostTime: 'Σωρευτική διάρκεια',
                        participateCommitRate: 'Ποσοστό συμμόρφωσης',
                        participateExcellentRate: 'Εξαιρετικό επιτόκιο',
                        duration: 'Διάρκειας',
                        score: 'Βαθμολογία',
                        scoringResults: 'Αποτελέσματα βαθμολογίας',
                        flowScore: 'Βαθμολογία διεργασίας',
                        craftScore: 'Βαθμολογία ομιλίας',
                        emotionScore: 'Βαθμολογία συναισθημάτων',
                        speedScore: 'Βαθμολογία έκφρασης',
                        contentIntegrity: 'Ακεραιότητα περιεχομένο',
                        pointHitRate: 'Βασικά σημεία αποτυχίας',
                        emotionNegativeRate: 'Αρνητική αναλογία συναισθημάτων',
                        paraPhaSiaRate: 'Ποσοστό ασυνήθιστης ταχύτητας ομιλίας',
                        toneOvermuchRate: 'Υπερβολικό ποσοστό των λέξεων',
                        maximumScore: 'Υψηλότερο βαθμό',
                        highestScoreResult: 'Αποτελέσματα υψηλότερων βαθμών',
                        state: 'Κατάσταση',
                        averageDurationmin: 'Μέση διάρκεια (ελάχιστα)',
                        lately: 'Πρόσφατα',
                        time: 'Χρόνο',
                        operation: 'Λειτουργία',
                        viewDetails: 'Λεπτομέρειες προβολής',
                        wrongQuestionSet: 'Λάθος σύνολο προβλήματος',
                        taskName: 'Όνομα εργασίας',
                        completeRequirements: 'Πλήρεις απαιτήσεις',
                        publishTo: 'Εκδόσεις αντικειμένων',
                        taskTime: 'Ώρα εργασίας',
                        fractionalComposition: 'Σύνθεση κλάσματος',
                        totalScore: 'Συνολική βαθμολογία',
                        branch: 'Σημεία',
                        Script: '(Μιλάκερ)',
                        scoreEmotion: 'Συναίσθημα',
                        fractionExpression: 'Υπο-έκφραση',
                        points: 'Βαθμοί)',
                        implementationRate: 'Ποσοστό συμμετοχής',
                        numberOfExecutors: 'Αριθμός συμμετεχόντων',
                        numberOfPeopleNotExecuted: 'Αριθμός μη συμμετεχόντων',
                        completionRate: 'Ποσοστό ολοκλήρωσης',
                        numberOfCompletedPersonnel: 'Αριθμός ολοκληρωθέντων',
                        numberOfUnfinishedPersonnel: 'Αριθμός μη ολοκληρωμένων',
                        complianceRate: 'Ποσοστό συμμόρφωσης',
                        numberOfQualifiedPersonnel: 'Αριθμός ατόμων που φτάνουν στο πρότυπο',
                        numberOfNonCompliantIndividuals: 'Αριθμός ατόμων που δεν πληρούν το πρότυπο',
                        excellentRate: 'Εξαιρετικό επιτόκιο',
                        participateCompleteRate: 'Ποσοστό ολοκλήρωσης της συμμετοχής',
                        numberOfOutstandingIndividuals: 'Εξαιρετικοί αριθμοί',
                        numberOfNonOutstandingIndividuals: 'Μη-άριστος αριθμός',
                        export: 'Εξαγωγή',
                        taskData: 'Δεδομένα εργασίας',
                        resultAnalysis: 'Ανάλυση των αποτελεσμάτων',
                        scoreDetails: 'Λεπτομέρειες βαθμολογίας.',
                        dataOverview: 'Επισκόπηση δεδομένων',
                        taskDetail: 'Λεπτομέρειες εργασίας',
                        scriptAnalysis: 'Ανάλυση ομιλίας',
                        flowAnalysis: 'Ανάλυση διαδικασίας',
                        expressionAnalysis: 'Ανάλυση έκφρασης',
                        emotionAnalysis: 'Ανάλυση συναισθημάτων ανάλυσης',
                        byTime: 'Προβολή διάστασης ώρας',
                        byNumber: 'Προβολή διάστασης μοιρών',
                        personData: 'Στατιστικές ανά προσωπικό',
                        numberData: 'Λεπτομέρεια κατά εγγραφή',
                        count: 'Με αριθμό φορών',
                        person: 'Κατά τον αριθμό των ατόμων',
                        reachTimes: 'Αναγνώσεις',
                        outOfReachTimes: 'Μη επιτυχημένοι καιροί',
                        seeOutOfReach: 'Κάντε κλικ για την προβολή μη επιτευχθέντας',
                        accumulative: 'Σωρευτικός',
                        script: 'Λέξεις',
                        times: 'Χρόνια',
                        sentence: 'Ποινή',
                        expressionAverage: 'Μέση βαθμολογία έκφρασης',
                        modalAnalysis: 'Ανάλυση των λέξεων',
                        total: 'Σύνολο',
                        muchModalAnalysis: 'Πάρα πολλές λέξεις',
                        normal: 'Κανονικός',
                        speedAnalysis: 'Ανάλυση ταχύτητας ομιλίας',
                        speedDistribution: 'Κατανομή λογισμού',
                        speakingSpeed: 'Ταχύτητα ομιλίας',
                        normalSpeak: 'Κανονική ταχύτητα ομιλίας',
                        tooFastSpeak: 'Γρήγορη ταχύτητα',
                        tooSlowlySpeak: 'Αργή ταχύτητα',
                        violationWord: 'Παραβίαση των λέξεων',
                        violationWordAnalysis: 'Ανάλυση των Λέξεων Παραβίασης',
                        noData: 'Οχι',
                        emotionalScore: 'Βαθμολογία συναισθημάτων',
                        emotionalDistribution: 'Κατανομή του συναισθήματος',
                        negativeEmotion: 'Αρνητικό συναίσθημα',
                        normalEmotion: 'Φυσιολογικό συναίσθημα',
                        getDetail: 'Λεπτομέρειες προβολής',
                        barPattern: 'Προβολή γραμμών',
                        timeDimension: 'Προβολή χρονικού πλάτους',
                        timesDimension: 'Προβολή διάστασης μοιρών',
                    },
                    components: {
                        dataOverview: {
                            hook: {
                                useSummary: {
                                    score: 'Βαθμολογία',
                                    speechScore: 'Βαθμολογία ομιλίας',
                                    emotionScore: 'Βαθμολογία συναισθημάτων',
                                    expressionScore: 'Βαθμολογία έκφρασης',
                                    processScore: 'Βαθμολογία διεργασίας',
                                    averageScore: 'Μέσος',
                                    averageScoreOfScript: 'Μέσος βαθμός ομιλίας',
                                    averageEmotionalScore: 'Μέση συναισθηματική βαθμολογία',
                                    expressionAverageScore: 'Express μέσο βαθμός',
                                    processAverageScore: 'Μέση βαθμολογία διαδικασίας',
                                    accumulatedDuration: 'Σωρευτική διάρκεια',
                                    accumulatedTimes: 'Σωρευτικές εποχές',
                                    participationComplianceRate: 'Ποσοστό συμμετοχής',
                                    participationRateForAchievingExcellence: 'Ποσοστό συμμετοχής',
                                    branch: 'Σημεία',
                                    numberOfPeople: 'Αριθμός ατόμων',
                                    averageScoreOfExpression: 'Μέση βαθμολογία έκφρασης',
                                    people: 'Άνθρωποι.',
                                },
                            },
                        },
                        emotionAnalysis: {
                            components: {
                                simplePieChart: {
                                    index: {
                                        negativeEmotions: 'Αρνητικό συναίσθημα',
                                    },
                                },
                            },
                        },
                        scriptAnalysis: {
                            hook: {
                                useSummary: {
                                    averageScoreOfScript: 'Μέσος βαθμός ομιλίας',
                                    branch: 'Σημεία',
                                },
                                useSummaryDetail: {
                                    keyHitRate: 'Βασικά σημεία αποτυχίας',
                                },
                            },
                        },
                    },
                },
                edit: {
                    index: {
                        intelligentReview: 'Έξυπνες κριτικές',
                        pleaseImproveTheConfiguration: 'Παρακαλώ τελειοποιήστε τη διαμόρφωσης',
                        examResults: 'Αποτελέσματα εξετάσεων',
                        showTheResultsAfterEachExam: 'Εμφάνιση των αποτελεσμάτων μετά από κάθε εξέταση.',
                        showTheResultsAfterTheLastExam: 'Δείξτε τα αποτελέσματα μετά την τελευταία εξέταση.',
                        doNotDisplayResults: 'Μην εμφανίζετε αποτελέσματα',
                        resultDisplay: 'Αποτελέσματα εμφανίζονται τα αποτελέσματα',
                        score: 'Βαθμολογία',
                        scoringResults: 'Αποτελέσματα βαθμολογίας',
                        allowViewingScoreDetails: 'Επίτρεψε την προβολή λεπτομερειών βαθμολογίας',
                        viewCanvasConfiguration: 'Προβολή ρύθμισης καμβάς',
                        synchronizationFailedProcessNodeHasChanged: 'Αποτυχία συγχρονισμού, ο κόμβος διεργασίας έχει δημιουργήσει αλλαγές',
                        successfullySynchronizedPleaseClickOnpublishToUpdateTheCourse: 'Η συγχρονισμός είναι επιτυχής, παρακαλώ κάντε κλικ στο Publish για να ενημερώσετε το μάθημα',
                        retrievedTheLatestCanvasConfiguration: 'Η πιο πρόσφατη διαμόρφωση καμβά τραβήχτηκε.',
                        synchronizeCanvasConfiguration: 'Συγχρονισμός ρύθμισης καμβάς',
                        scoringMethod: 'Μέθοδος βαθμολογίας',
                        pointsProcessPointsScript1PointsEmotion2PointsSpeakingSpeed3Points: 'Σημεία, ροή {0} πόντοι, ικανότητα ομιλίας {1} πόντοι, συναίσθημα {2}, ταχύτητα {3} πόντοι)',
                        excellentStandardsNeedToBeHigherThanStandardStandards: 'Τα εξαιρετικά πρότυπα πρέπει να είναι υψηλότερα από το πρότυπο',
                        theScoringCriteriaNeedToBeGreaterThanAndLessThanOrEqualTo100: 'Τα κριτήρια βαθμολογίας πρέπει να είναι μεγαλύτερα από 0% και μικρότερα ή ίσα με 100.',
                        theScoringCriteriaNeedToBeGreaterThanPointsAndLessThanOrEqualTo0Points: 'Τα κριτήρια βαθμολογίας πρέπει να είναι μεγαλύτερα από 0 βαθμούς και μικρότερα ή ίσα με {0} βαθμούς.',
                        doRatingsRequireManualReview: 'Αν η βαθμολογία χρειάζεται χειροκίνητη αναθεώρηση',
                        allocationStrategy: 'Πολιτική κατανομής',
                        pleaseSelectTheAssignedPersonnel: 'Παρακαλώ επιλέξτε ένα άτομο που έχει ανατεθεί.',
                        pleaseSelectADesignatedPerson: 'Παρακαλώ επιλέξτε ένα καθορισμένο άτομο',
                        timeLimitForSingleQuestionAnswering: 'Προθεσμία απάντησης',
                    },
                    autoAddOrganizationList: {
                        publishToNewlyAddedEmployeesByDefault: 'Δημοσίευση σε πρόσφατα προστιθέμενους υπαλλήλους εξ προκαθορισμένου',
                    },
                },
                list: {
                    index: {
                        reRatingMeansMatchingWillBeDoneAccordingToTheScoringRulesOfTheLatestCanvasThereIsManuallyReviewedScoringDataForTheCurrentTaskDoYouWantToOverwriteTheScores: 'Η επαναλαμβανόμενη βαθμολογία δείχνει ότι η βαθμολογία θα ταιριάζει σύμφωνα με τους κανόνες βαθμολογίας του τελευταίου καμβά. Η τρέχουσα εργασία έχει επανεξεταστεί χειροκίνητα δεδομένα βαθμολογίας. Θέλετε να αντικαταστήσετε το σκορ;',
                        notCovered: 'Μη καλυπτόμενα',
                        cover: 'Εξώφυλλα',
                        participationSituation: 'Συμμετοχή',
                        numberOfParticipants: 'Αριθμός συμμετεχόντων',
                        sumOfTheNumberOfPracticeSubjectsSelectedForThisTask: 'Σύνολο του αριθμού των επιλεγμένων αντικειμένων άσκησης για αυτήν την εργασία.',
                        sumOfTheNumberOfParticipantsInTheTask: 'Συνοψίζεται ο αριθμός των ατόμων που συμμετείχαν στην εργασία.',
                        numberOfCompletedPersonnel: 'Αριθμός ολοκληρωθέντων',
                        sumOfTheNumberOfPeopleWhoMeetTheTaskCompletionRequirements: 'Συνοψίστε τον αριθμό των ατόμων που πληρούν τις απαιτήσεις ολοκλήρωσης της εργασίας',
                        numberOfQualifiedPersonnel: 'Αριθμός ατόμων που φτάνουν στο πρότυπο',
                        sumUpTheNumberOfPeopleWhoMeetTheTaskScoreRequirements: 'Συνοψίστε τον αριθμό των ατόμων που πληρούν το σκορ εργασίας',
                        excellentPersonnel: 'Εξαιρετικοί αριθμοί',
                        sumUpTheNumberOfPeopleWithExcellentTaskScores: 'Συνοψίστε τον αριθμό των ατόμων που ανταποκρίνονται στην εργασία με εξαιρετική σκορ',
                        participationRate: 'Ποσοστό συμμετοχής',
                        numberOfParticipantsNumberOfParticipants: 'Αριθμός συμμετεχόντων/αριθμός συμμετεχόντων',
                        numberOfCompletedNumberOfParticipants: 'Αριθμός ολοκληρωμένων/Αριθμός συμμετοχής',
                        numberOfPeopleWhoMeetTheStandardsnumberOfPeopleWhoShouldParticipate: 'Αριθμός προσόντων/Αριθμός συμμετεχόντων',
                        excellentNumbernumberOfParticipants: 'Ανεξόφλητος αριθμός/αριθμός συμμετεχόντων',
                        participationCompletionRate: 'Ποσοστό ολοκλήρωσης της συμμετοχής',
                        numberOfCompletedParticipated: 'Αριθμός ολοκληρωμένων/Συμμετοχών',
                        participationComplianceRate: 'Ποσοστό συμμετοχής',
                        numberOfQualifiedPersonnelnumberOfParticipants: 'Αριθμός προσχώρησης/Συμμετοχής',
                        participationRateForAchievingExcellence: 'Ποσοστό συμμετοχής',
                        accumulatedDuration: 'Σωρευτική διάρκεια',
                        sumOfTheDurationOfStudentParticipationInTheTask: 'Συμμετοχή στη διάρκεια εργασίας και άθροιση',
                        averageDuration: 'Μέση διάρκειας',
                        sumOfStudentParticipationTimeInTaskstotalNumberOfParticipationTimes: 'Συνολική διάρκεια των συμμετεχόντων/συνολικός αριθμός συμμετεχόντων',
                        accumulatedTimes: 'Σωρευτικοί χρόνοι',
                        sumOfTheNumberOfTimesStudentsParticipateInTasks: 'Συνοψίζεται ο αριθμός των συμμετεχόντων στο έργο',
                        averageScore: 'Μέσος',
                        theAverageScoreOfThePersonnelParticipatingInThisTask: 'Μέση βαθμολογία του προσωπικού που συμμετέχει στην εργασία.',
                        maximumScore: 'Υψηλότερο βαθμό',
                        theHighestScoreForThePersonnelInvolvedInThisTask: 'Η υψηλότερη βαθμολογία του προσωπικού που συμμετέχει στην εργασία.',
                        averageScoreOfScript: 'Μέσος βαθμός ομιλίας',
                        sumOfTraineeScriptScorestotalParticipationTimes: 'Στοιχεία λόγου φοιτητών / Συνολική ώρα συμμετοχής',
                        totalScoreOfScript: 'Συνολική βαθμολογία ομιλίας',
                        theTotalScoreOfTheScriptSetUnderThisTask: 'Συνολικός βαθμός ομιλίας που ορίστηκε σε αυτήν την εργασία.',
                        processAverageScore: 'Μέση βαθμολογία διαδικασίας',
                        sumOfStudentProcessScoresTotalParticipationTimes: 'Σύνολο αποτελεσμάτων φοιτητικής διαδικασίας / συνολικός αριθμός δεσμεύσεων',
                        totalProcessScore: 'Συνολική βαθμολογία διεργασίας',
                        theTotalScoreOfTheProcessesSetUnderThisTask: 'Συνολική βαθμολογία της διαδικασίας που ορίζεται στο πλαίσιο αυτής της εργασίας',
                        averageEmotionalScore: 'Μέση συναισθηματική βαθμολογία',
                        sumOfStudentEmotionalScoresTotalParticipationTimes: 'Άθροισμα των συναισθημάτων εκπαιδευόμενου/συνολικός αριθμός συμμετεχόντων',
                        totalEmotionalScore: 'Συνολική συναισθηματική βαθμολογία',
                        theTotalScoreOfEmotionsSetUnderThisTask: 'Συνολική συναισθηματική βαθμολογία',
                        averageScoreOfExpression: 'Μέση βαθμολογία έκφρασης',
                        sumOfStudentExpressionScorestotalParticipationTimes: 'Άθροισμα βαθμολογίας έκφρασης εκπαιδευτικού/συνολικός αριθμός συμμετεχόντων',
                        totalScoreOfExpression: 'Συνολική βαθμολογία έκφρασης',
                        theTotalScoreOfExpressionsSetUnderThisTask: 'Συνολικό βαθμό έκφρασης που τέθηκε σε αυτήν την εργασίαName',
                        startExecutingReScoringYouCanJumpToTheTaskCenterToViewProgress: 'Αρχίστε να εκτελέσετε επαναβάθμιση, μπορείτε να πηδήξετε στο κέντρο εργασιών για να δείτε την πρόοδο.',
                        reRating: 'Επαναφορά αποτέλεσμας',
                        reRatingMeansThatMatchingWillBeDoneAccordingToTheLatestScoringRulesOnTheCanvasWhichWillOverwriteTheCurrentScoringResults: 'Η επαναλαμβανόμενη βαθμολογία δείχνει ότι η βαθμολογία θα ταιριάζει σύμφωνα με τους κανόνες βαθμολογίας του τελευταίου καμβά και η τρέχουσα βαθμολογία θα αντικατασταθεί. ..',
                        releaseTime: 'Ώρα απελευθέρωσης',
                    },
                },
                audit: {
                    components: {
                        pageLeftTable: {
                            reviewed: 'Επανεξέταση',
                            pendingReview: 'Προς επανεξέταση',
                            enterKeywordSearch: 'Εισάγετε λέξεις-κλειδιά για αναζήτηση.',
                        },
                        pageRightTable: {
                            index: {
                                employeeName: 'Όνομα υπαλλήλου',
                                systemRating: 'Βαθμολογία συστήματος',
                                scoringResults: 'Αποτελέσματα βαθμολογίας',
                                duration: 'Διάρκειας',
                                time: 'Χρόνο',
                                state: 'Κατάσταση',
                                whetherToModifyTheRating: 'Σωστή βαθμολογία',
                                finalScore: 'Τελικός βαθμολογίος',
                                reviewedBy: 'Αξιολογητής',
                                operation: 'Λειτουργία',
                                viewScoreDetails: 'Προβολή λεπτομερειών βαθμολογίας',
                                viewStatus: 'Προβολή κατάστασης',
                                whole: 'Όλα',
                                correctionStatus: 'Κατάσταση διόρθωσης',
                                completeReview: 'Πλήρης επανεξέτασης',
                                tips: 'Ζήτηση',
                                theFinalScoreOfTheStudentIsBasedOnTheCurrentFinalReviewResultPleaseConfirm: 'Τα τελικά αποτελέσματα των εκπαιδευόμενων υπόκεινται στα τρέχοντα αποτελέσματα της τελικής επανεξέτασης. Επιβεβαιώστε παρακαλώ.',
                            },
                        },
                    },
                    index: {
                        manualReview: 'Χειροκίνητη ανασκόπηση',
                    },
                },
                review: {
                    index: {
                        employeeName: 'Όνομα υπαλλήλου',
                        score: 'Βαθμολογία',
                        scoringResults: 'Αποτελέσματα βαθμολογίας',
                        duration: 'Διάρκειας',
                        taskName: 'Όνομα εργασίας',
                        numberOfAppealScripts: 'Αριθμός Αντιμετών',
                        appealTime: 'Χρόνος προσφυγής',
                        processStatus: 'Κατάσταση διεργασίας',
                        scoreAfterReview: 'Αποτέλεσμα μετά την ανασκόπηση',
                        reviewedBy: 'Αξιολογητής',
                        operation: 'Λειτουργία',
                        viewScoreStatus: 'Βαθμολογία προβολής',
                        whole: 'Όλα',
                        manualReview: 'Χειροκίνητη ανασκόπηση',
                    },
                },
                qalist: {
                    index: {
                        participatingEmployees: 'Συμμετέχοντες εργαζόμενοι',
                        traineeNickname: 'Εκπαιδευτικό ψευδώνυμο',
                        whetherToParticipate: 'Αν θα συμμετάσχει',
                        participateInTask: 'Συμμετοχή στο έργο',
                        notInvolved: 'Δεν εμπλέκονται.',
                        participation: 'Συμμετοχή',
                        finish: 'Τελείωση',
                        whetherTheRequirementsForTaskCompletionAreMet: 'Αν πληρούνται οι απαιτήσεις για την ολοκλήρωση της εργασίας',
                        unfinished: 'Μη ολοκληρωμένες',
                        complete: 'Ολοκληρώθηκε',
                        whetherItIsUpToStandard: 'Αν είναι αρμόδια για το πρότυπο',
                        whetherTheScoreRequirementsOfTheTaskAchievementCriteriaAreMet: 'Εάν πληρούνται οι απαιτήσεις βαθμολογίας των κριτηρίων επίτευξης εργασίας',
                        notUpToStandard: 'Δεν έως το πρότυπο',
                        standard: 'Πρότυπο',
                        whetherItIsExcellent: 'Εάν είναι εξαιρετικό',
                        whetherTheTaskMeetsTheRequirementsForAchievingExcellentScores: 'Αν η εργασία πληροί τις απαιτήσεις για την επίτευξη εξαιρετικών βαθμολογιών',
                        notExcellent: 'Όχι τέλεια.',
                        excellent: 'Εξαιρετικά.',
                        qualityAccompanyList: 'Συνοδευτικός κατάλογος ποιότητας',
                    },
                },
            },
            dashboard: {
                components: {
                    adminDataCards: {
                        exerciseTaskData: 'Άσκηση δεδομένων εργασίας',
                        implementationRate: 'Ποσοστό εφαρμογής',
                        numberOfExecutors: 'Αριθμός εκτέλεσης',
                        numberOfPeopleNotExecuted: 'Αριθμός μη εκτεθειμένου',
                        completionRate: 'Ποσοστό ολοκλήρωσης',
                        numberOfCompletedPersonnel: 'Αριθμός ολοκληρωθέντων',
                        numberOfUnfinishedPersonnel: 'Αριθμός μη ολοκληρωμένων',
                        complianceRate: 'Ποσοστό συμμόρφωσης',
                        numberOfQualifiedPersonnel: 'Αριθμός ατόμων που φτάνουν στο πρότυπο',
                        numberOfNonCompliantIndividuals: 'Αριθμός ατόμων που δεν πληρούν το πρότυπο',
                        excellentRate: 'Εξαιρετικό επιτόκιο',
                        numberOfOutstandingIndividuals: 'Εξαιρετικοί αριθμοί',
                        numberOfNonOutstandingIndividuals: 'Μη-άριστος αριθμός',
                        examTaskData: 'Δεδομένα εξετάσεων',
                        published: 'Δημοσίευση',
                        courses: 'Μαθήματος',
                        courseData: 'Δεδομένα πορείας',
                        practiceTasks: 'Εργασία',
                        examTasks: 'Εργασίες εξέτασης',
                    },
                    practiceSummary: {
                        practiceSummary: 'Περίληψη εξάσκησης',
                        numberOfPracticeTasks: 'Αριθμός καθηκόντων πρακτικών',
                        numberOfExercises: 'Αριθμός ασκήσεων',
                        accumulatedPracticeDuration: 'Σωρευτική πρακτική Διάρκεια Διάρκειας',
                        complianceRate: 'Ποσοστό συμμόρφωσης',
                        excellentRate: 'Εξαιρετικό επιτόκιο',
                        ranking: 'Κατάταξη',
                    },
                    rankingList: {
                        numberOfExercises: 'Αριθμός ασκήσεων',
                        exerciseDuration: 'Διάρκεια άσκησης',
                        complianceRate: 'Ποσοστό συμμόρφωσης',
                        excellentRate: 'Εξαιρετικό επιτόκιο',
                        diligenceChart: 'Κατάλογος επιμέλειας',
                        excellentList: 'Εξαιρετικός λίστας',
                        ranking: 'Κατάταξη',
                        fullName: 'Όνομα',
                        i: 'Εγώ...',
                    },
                    taskCard: {
                        end: 'Προθεσμία:',
                        noDeadline: 'Χωρίς προθεσμία',
                        second: 'Χρόνια',
                        branch: 'Σημεία',
                    },
                    taskProgress: {
                        thereAreCurrentlyNoTasksAvailable: 'Χωρίς εργασίες',
                        completed: 'Ολοκληρώθηκε',
                    },
                    filter: {
                        employeeDepartment: 'Υπηρεσία εργαζομένων',
                    },
                    exportButton: {
                        index: {
                            exportSuccessfulPleaseGoToTheTaskCenterToView: 'Η εξαγωγή είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
                            export: 'Εξαγωγή',
                        },
                    },
                    filterConfig: {
                        dropdown: {
                            custom: 'Προσαρμοσμένο',
                        },
                        modal: {
                            updateSuccessful: 'Επιτυχία ενημέρωσης',
                            successfullySaved: 'Αποθήκευση με επιτυχία',
                            setAsACommonReport: 'Καθορισμός σε κοινές εκθέσεις',
                            updateCurrentReport: 'Ενημέρωση τρέχουσας αναφοράς',
                        },
                    },
                    employeeDataCards: {
                        components: {
                            abilityGrowthTrend: {
                                utils: {
                                    averageScore: 'Μέσος',
                                    averageScoreOfScript: 'Μέσος βαθμός ομιλίας',
                                    averageEmotionalScore: 'Μέση συναισθηματική βαθμολογία',
                                    expressionAverageScore: 'Express μέσο βαθμός',
                                    processAverageScore: 'Μέση βαθμολογία διαδικασίας',
                                    branch: 'Σημεία',
                                },
                            },
                            comprehensiveEvaluation: {
                                const: {
                                    data: 'Δεδομένα',
                                },
                            },
                            doneStatus: {
                                index: {
                                    practice: 'Άσκηση',
                                    examination: 'Εξέταση',
                                    executed: 'Εκτέλεση',
                                    unexecuted: 'Δεν εκτελέστηκε',
                                    accumulatedExamDuration: 'Σωρευτική διάρκεια δοκιμής',
                                    examFrequency: 'Αριθμός εξετάσεων',
                                },
                            },
                            filter: {
                                index: {
                                    practice: 'Άσκηση',
                                    examination: 'Εξέταση',
                                    pleaseCompleteTheRequiredFields: 'Παρακαλώ συμπληρώστε τα απαιτούμενα στοιχεία',
                                    staff: 'Εργαζόμενος',
                                    taskType: 'Τύπος εργασίας',
                                    pleaseSelect: 'Παρακαλώ επιλέξτε.',
                                    taskName: 'Όνομα εργασίας',
                                },
                            },
                        },
                        index: {
                            completionStatus: 'Καθεστώς ολοκλήρωσης',
                            comprehensiveEvaluation: 'Συνολική αξιολόγηση',
                            abilityGrowthTrend: 'Τάση αύξησης της ικανότητας',
                            errorProneAnalysis: 'Ανάλυση σημείου',
                        },
                    },
                },
                hook: {
                    useSummary: {
                        activePopulation: 'Ενεργός αριθμός',
                        accumulatedPracticeDuration: 'Σωρευτική πρακτική Διάρκεια Διάρκειας',
                        averagePracticeDuration: 'Μέσος χρόνος Άσκησης',
                        people: 'Άνθρωποι.',
                        numberOfPracticeTasks: 'Αριθμός καθηκόντων πρακτικών',
                        numberOfExercises: 'Αριθμός ασκήσεων',
                        exerciseDuration: 'Διάρκεια άσκησης',
                        second: 'Χρόνια',
                        avgScore: 'Μέσος',
                        speechCraftAvgScore: 'Μέσος βαθμός ομιλίας',
                        emotionAvgScore: 'Μέση συναισθηματική βαθμολογία',
                        speedAvgScore: 'Express μέσο βαθμός',
                        flowAvgScore: 'Μέση βαθμολογία διαδικασίας',
                        practiceCostTime: 'Σωρευτική διάρκεια',
                        totalPracticeTimes: 'Σωρευτικές εποχές',
                        participateCommitRate: 'Ποσοστό συμμετοχής',
                        participateExcellentRate: 'Ποσοστό συμμετοχής',
                    },
                },
                index: {
                    employeeProfile: 'Εργαζόμενοι Πορτραίτου',
                    overview: 'Επισκόπηση',
                    personalSignage: 'Προσωπικό Κάνμπαν.',
                    ongoingExercises: 'Η άσκηση σε εξέλιξη',
                    ongoingExams: 'Εξέταση σε εξέλιξη.',
                    practiceTaskProgress: 'Πρόοδος άσκησης εργασίας',
                    examTaskProgress: 'Πρόοδος εργασίας',
                },
            },
            businessConfiguration: {
                scoreManagement: {
                    dimensionIndex: {
                        index: {
                            pleaseSelectAConceptWord: 'Παρακαλώ επιλέξτε μια λέξη έννοιας',
                            sessionDetectionSettings: 'Ρυθμίσεις ανίχνευσης συνεδρίας',
                            successfullySaved: 'Αποθήκευση με επιτυχία',
                            abnormalSpeechSpeed: 'Μη φυσιολογική ταχύτητα ομιλίας',
                            supportCustomSpeechSpeedDetectionStandardsAndTheResultsWillBeJudgedAsNormalTooFastOrTooSlowWhenThereIsAnAbnormalSpeechSpeedtooFasttooSlowPointsWillBeDeductedAccordingToTheScoringRules: 'Υποστηρίζεται το πρότυπο ανίχνευσης ταχύτητας ομιλίας που καθορίζεται από τον χρήστη. Το αποτέλεσμα θα είναι η κανονική ταχύτητα ομιλίας, πολύ γρήγορη ταχύτητα ομιλίας, και πολύ αργή ταχύτητα ομιλίας. Όταν η ομιλία είναι μη φυσιολογική (υπερβολικά γρήγορη/υπερβολικά αργή), η βαθμολογία θα μειωθεί σύμφωνα με τους κανόνες βαθμολογίας.',
                            speechSpeedTooFastGreaterThanEveryMinute: 'Ταχύτητα πολύ γρήγορα: περισσότερο από ένα λεπτό',
                            oneWordSpeakingTooSlowlyLessThanPerMinute: 'Λέξη, πολύ αργή: λιγότερο από το λεπτό',
                            charactersIgnoringLessThan: 'Λέξεις, αγνοείτε λιγότερα',
                            aSentenceOfWords: 'Η πρόταση της λέξης',
                            excessiveModalParticles: 'Πάρα πολλές λέξεις',
                            supportCustomModalParticlesAndSetRulesForExcessiveModalParticlesWhenThereAreTooManyModalParticlesPointsWillBeDeductedAccordingToTheScoringRules: 'Υποστηρίξτε λέξεις προσαρμοσμένο τόνο, και θέστε τους κανόνες των πάρα πολλών λέξεων τόνου. Όταν υπάρχουν πάρα πολλές λέξεις του τρόπου, η βαθμολογία θα μειωθεί σύμφωνα με τους κανόνες βαθμολογίας.',
                            theNumberOfRepetitionsIs: 'Ο αριθμός των επαναλήψεων',
                            inTheSecondTenseItIsDeterminedThatThereAreTooManyModalParticles: 'Τη δεύτερη φορά, καθορίζεται ότι υπάρχουν πάρα πολλά σωματίδια.',
                            definitionOfSensitiveViolations: 'Ορισμός ευαίσθητων παραβίασης',
                            supportCustomWordLibrariesToDetectThePresenceOfIllegalWordsInASentenceWhenIllegalWordsAppearPointsWillBeDeductedAccordingToTheScoringRules: 'Μπορείτε να προσαρμόσετε το λεξικό παράνομων λέξεων για να εντοπίσετε αν μια παράνομη λέξη εμφανίζεται σε μια πρόταση. Όταν υπάρχει μια παράνομη λέξη, το σκορ θα μειωθεί σύμφωνα με τους κανόνες βαθμολογίας.',
                            violationWords: 'Λέξεις παραβίασης:',
                            emotionalDetection: 'Ανίχνευση συναισθημάτων',
                            accordingToTheSystemEmotionModelDialogueTechniqueEmotionDetectionWillBeConductedAndTheResultsWillBeJudgedAsNormalEmotionsAndNegativeEmotionsincludingNegativeAngryAndComplainingWhenNegativeEmotionsOccurPointsWillBeDeductedAccordingToTheScoringRules: 'Σύμφωνα με το μοντέλο συναισθημάτων του συστήματος, η δοκιμασία συναισθημάτων θα κριθεί ως φυσιολογικό συναίσθημα και αρνητικό συναίσθημα (συμπεριλαμβανομένου αρνητικού, οργισμού και παραπονούμενου). Όταν υπάρχει αρνητικό συναίσθημα, η βαθμολογία θα μειωθεί σύμφωνα με τους κανόνες βαθμολογίας.',
                            preserve: 'Αποθήκευση',
                        },
                    },
                    scoreDimension: {
                        index: {
                            ratingDimension: 'Διάσταση αξιολόγησης',
                            ratingPoints: 'Βαθμοί βαθμολογίας',
                            explain: 'Περιγραφή',
                            type: 'Τύπος',
                        },
                    },
                    scoreModel: {
                        components: {
                            comprehensiveEvaluation: {
                                const: {
                                    randomData: 'Τυχαία δεδομένα',
                                },
                                index: {
                                    spanStylemarginLeftpxStandardScriptAccumulation: '<Span στυλ = "margin-αριστερά: 8px>· Τυποποιημένος ομιλητικός συναρμολογημένος',
                                    theTotalNumberOfWordsHitByTheStudentAfterReading: 'Μια λέξη, ο αριθμός των λέξεων που χτύπησε ο μαθητής.',
                                    aWordspan: 'Λέξη βάση>',
                                    timesspanbrspanStylemarginLeftpxSpeakTooSlowly: 'Χρόνια',
                                    timesspan: 'Βοήθεια!',
                                    tooManyModalParticles: '<Span στυλ = "margin-αριστερά: 8px>· πάρα πολλές λέξεις',
                                },
                            },
                        },
                        detail: {
                            components: {
                                model: {
                                    group: {
                                        theScoreIs: 'Το σκορ είναι.',
                                    },
                                    item: {
                                        violationOnceReduced: '1 παραβίαση μείον.',
                                        abnormalSpeechSpeedincludingTooFastOrTooSlowDecrease: 'Ανώμαλη ταχύτητα (συμπεριλαμβανομένης της πολύ γρήγορης ταχύτητας και πολύ αργής ταχύτητας) 1 μείωση',
                                        excessiveNumberOfModalParticlesReducedOnce: 'Πάρα πολλές μορφές λέξεις 1 μείου',
                                        oneNegativeDecreaseInEmotions: 'Αρνητικό συναίσθημα μείον 1.',
                                        branch: 'Σημεία',
                                    },
                                    wrap: {
                                        name: 'Όνομα',
                                        preserve: 'Αποθήκευση',
                                    },
                                },
                            },
                            index: {
                                complete: 'Πλήρες περιεχόμενο',
                                keyHit: 'Χτύπημα βασικών σημείων',
                                accurateFollowupReading: 'Ακριβής ανάγνωση',
                                languageNorm: 'Προδιαγραφή γλωσσών',
                                speechSpeed: 'Ταχύτητα λόγου',
                                modalParticles: 'Μορφή λέξης',
                                emotionallyPositive: 'Συναισθηματικά θετικός',
                                scoringModel: 'Μοντέλο βαθμολογίας',
                                successfullyModified: 'Επιτυχία τροποποίησης',
                                newSuccessfullyCreated: 'Νέα Επιτυχία',
                            },
                        },
                        index: {
                            scoringModel: 'Μοντέλο βαθμολογίας',
                            newModel: 'Νέο μοντέλο',
                            model: 'Υπόδειγμα:',
                            type: 'Τύπος',
                            operation: 'Λειτουργία',
                            preview: 'Προεπισκόπησης',
                            edit: 'Επεξεργασία',
                        },
                    },
                    index: {
                        scoringModel: 'Μοντέλο βαθμολογίας',
                        ratingDimension: 'Διάσταση αξιολόγησης',
                        sessionDetectionSettings: 'Ρυθμίσεις ανίχνευσης συνεδρίας',
                    },
                },
            },
            dataAnalysis: {
                learningRecord: {
                    components: {
                        keyPointHit: {
                            index: {
                                pleaseSelect: 'Παρακαλώ επιλέξτε.',
                                hit: 'Χτύπημα.',
                                misses: 'Αστόχηση',
                            },
                        },
                    },
                    index: {
                        duration: 'Διάρκειας',
                        processScore: 'Βαθμολογία διεργασίας',
                        branch: 'Σημεία',
                        contentCompleteness: 'Ακεραιότητα περιεχομένο',
                        scriptScore: 'Βαθμολογία ομιλίας',
                        keyHitRate: 'Βασικά σημεία αποτυχίας',
                        emotionalScore: 'Βαθμολογία συναισθημάτων',
                        negativeProportionOfEmotions: 'Αρνητική αναλογία συναισθημάτων',
                        expressionScore: 'Βαθμολογία έκφρασης',
                        theProportionOfAbnormalSpeechSpeed: 'Ποσοστό ασυνήθιστης ταχύτητας ομιλίας',
                        excessiveProportionOfModalParticles: 'Υπερβολικό ποσοστό των λέξεων',
                        learningRecordData: 'Μάθηση στοιχείων εγγραφής στοιχείων',
                        staff: 'Εργαζόμενος',
                        curriculum: 'Πρόγραμμα σπουδών',
                        mainPoints: 'Βασικά σημεία',
                    },
                },
                customKanban: {
                    components: {
                        chart: {
                            components: {
                                header: {
                                    components: {
                                        chartToggle: {
                                            hooks: {
                                                form: 'Πίνακας',
                                                lineChart: 'Διάγραμμα γραμμής',
                                                barChart: 'Ιστόγραμμα',
                                                pieChart: 'Διάγραμμα πίτας',
                                            },
                                            index: {
                                                switchingTypes: 'Τύπος εναλλαγής',
                                            },
                                        },
                                    },
                                    index: {
                                        saveSuccessful: 'Αποθήκευση με επιτυχία',
                                        editChart: 'Επεξεργασία γραφής',
                                        chartName: 'Όνομα διαγράμματος',
                                        deleteSuccessful: 'Διαγραφή με επιτυχία',
                                        refresh: 'Ανανέωση',
                                        export: 'Εξαγωγή',
                                        areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                                        delete: 'Διαγραφή',
                                        viewFilteringCriteria: 'Προβολή κριτηρίων φίλτρου',
                                    },
                                },
                            },
                            index: {
                                exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'Η εξαγωγή είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
                            },
                        },
                        header: {
                            index: {
                                saveSuccessful: 'Αποθήκευση με επιτυχία',
                                deleteSuccessful: 'Διαγραφή με επιτυχία',
                                editReport: 'Επεξεργασία αναφοράς',
                                reportName: 'Όνομα αναφοράς',
                                refresh: 'Ανανέωση',
                                areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                                delete: 'Διαγραφή',
                                exportToExcel: 'Εξαγωγή Excel',
                                exportSnapshot: 'Εξαγωγή στιγμιότυπου',
                                export: 'Εξαγωγή',
                                authority: 'Άδειες',
                                permissionSettings: 'Ρυθμίσεις αδειών',
                                reportVisiblePermissions: 'Αναφορά ορατών δικαιωμάτων',
                                visibleToEveryone: 'Ορατή σε όλους.',
                                onlyVisibleToOneself: 'Μόνο στον εαυτό σου είναι ορατό.',
                                designatedPersonnelVisible: 'Προσδιορισμένο άτομο ορατό',
                                pleaseSelect: 'Παρακαλώ επιλέξτε.',
                                reportDataPermissions: 'Άδεια αναφοράς δεδομένων',
                                restrictedByUserPermissions: 'Περιορίζεται από άδειες χρήστη',
                                visiblePeopleAreTheSame: 'Οι ορατοί άνθρωποι είναι ίδιοι.',
                            },
                        },
                        titleFooter: {
                            index: {
                                addReport: 'Νέα έκθεση:',
                                reportName: 'Όνομα αναφοράς',
                            },
                        },
                    },
                    index: {
                        exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'Η εξαγωγή είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
                        dataQueryInProgress: 'Ερώτηση δεδομένων σε...',
                        customKanban: 'Προσαρμοσμένο Kanban',
                    },
                },
                intelligentAnalysis: {
                    components: {
                        header: {
                            hooks: {
                                form: 'Πίνακας',
                                lineChart: 'Διάγραμμα γραμμής',
                                barChart: 'Ιστόγραμμα',
                                pieChart: 'Διάγραμμα πίτας',
                            },
                            index: {
                                successfullyAdded: 'Προστέθηκε με επιτυχία',
                                viewSQL: 'Προβολή SQL',
                                export: 'Εξαγωγή',
                                addToReport: 'Προσθήκη στην έκθεση',
                            },
                        },
                        refer: {
                            hooks: {
                                data: 'Δεδομένα',
                                interrogativeSentence: 'Ερωτήσεις',
                                historicalQuery: 'Ιστορικό ερώτημα',
                            },
                            index: {
                                copySuccessful: 'Επιτυχία αντιγραφής',
                                copy: 'Αντιγραφή',
                            },
                        },
                        search: {
                            components: {
                                latitudeModal: {
                                    components: {
                                        selector: {
                                            const: {
                                                notMeetingStandards: 'Δεν έως το πρότυπο',
                                                meetingStandards: 'Πρότυπο',
                                                excellent: 'Εξαιρετικά.',
                                                notStartedYet: 'Δεν ξεκίνησες',
                                                inProgress: 'Σε εξέλιξη.',
                                                completed: 'Ολοκληρώθηκε',
                                                incomplete: 'Μη ολοκληρωμένες',
                                            },
                                        },
                                    },
                                    const: {
                                        taskName: 'Όνομα εργασίας',
                                        department: 'Υπηρεσία',
                                        studentName: 'Όνομα μαθητής',
                                        scoringResults: 'Αποτελέσματα βαθμολογίας',
                                        taskCompletionStatus: 'Κατάσταση συμπλήρωσης εργασίας',
                                    },
                                    index: {
                                        pleaseSelectADimension: 'Παρακαλώ επιλέξτε μια διάσταση',
                                    },
                                },
                            },
                            index: {
                                enterToOpenThePopupBoxForDimensionSelection: 'Εισάγετε @ για να ανοίξετε το κουτί σφαίρας για την επιλογή διάστασης',
                                pleaseEnterAQueryStatementToDirectlyQuery: 'Παρακαλώ εισάγετε τη δήλωση ερωτήματος για απευθείας ερώτηση.',
                                query: 'Ερώτηση',
                            },
                        },
                    },
                    index: {
                        exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'Η εξαγωγή είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
                        dataQueryInProgress: 'Ερώτηση δεδομένων σε...',
                    },
                },
            },
            templateManage: {
                dialogueManage: {
                    edit: {
                        enterTheAppropriateSceneDescriptionAccordingToYourSparringPurposeForExampleIfACustomerWantsToBuySeriousIllnessInsuranceForHisFamilyTheSalespersonIntroducesTheInsuranceProductsAndProtectionToHimByPhoneYouCanProvideSpecificEventsThatMayOccurInTheSceneInTheDescriptionTheMoreDetailedTheSceneDescriptionTheMoreAccurateTheDialogueProcessOrFrameworkWillBeAndTheBetterTheEffectWillBe: 'Εισάγετε την κατάλληλη περιγραφή σκηνής σύμφωνα με τον σκοπό σας. Για παράδειγμα, εάν ένας πελάτης θέλει να αγοράσει σοβαρή ασφάλεια για την οικογένειά του, ο πωλητής εισάγει τα ασφαλιστικά προϊόντα και προστασία σε αυτόν μέσω τηλεφώνου. Μπορείτε να παρέχετε συγκεκριμένα γεγονότα που μπορεί να συμβούν στη σκηνή της περιγραφής. Όσο πιο λεπτομερής η περιγραφή της σκηνής, τόσο πιο ακριβής θα είναι η διαδικασία ή το πλαίσιο και τόσο καλύτερο θα είναι το αποτέλεσμα.',
                        enterTheAppropriateSceneDescriptionAccordingToYourSparringPurposeForExampleACustomerWantsToBuySeriousIllnessInsuranceForHisFamilyAndTheSalespersonIntroducesTheInsuranceProductsAndInsuranceToHimByPhoneYouCanProvideSpecificEventsThatMayOccurInTheSceneInTheDescriptionTheMoreDetailedTheSceneDescriptionTheMoreAccurateTheDialogueProcessOrFrameworkWillBeAndTheBetterTheEffectWillBe: 'Εισάγετε την κατάλληλη περιγραφή σκηνής σύμφωνα με τον σκοπό σας.\nΓια παράδειγμα, ένας πελάτης θέλει να αγοράσει σοβαρή ασφάλεια για την οικογένειά του, και ο πωλητής παρουσιάζει τα ασφαλιστικά προϊόντα και την ασφάλιση σε αυτόν μέσω τηλεφώνου.\nΜπορείτε να παρέχετε συγκεκριμένα γεγονότα που μπορεί να συμβούν στη σκηνή της περιγραφής. Όσο πιο λεπτομερής η περιγραφή της σκηνής, τόσο πιο ακριβής θα είναι η διαδικασία ή το πλαίσιο και τόσο καλύτερο θα είναι το αποτέλεσμα.',
                        editSceneSuccessfully: 'Επεξεργασία σκηνής με επιτυχία',
                        sceneCreatedSuccessfully: 'Η σκηνή δημιουργήθηκε με επιτυχία',
                        sceneName: 'Όνομα σκηνής',
                        pleaseEnterASceneName: 'Παρακαλώ εισάγετε ένα όνομα σκηνής',
                        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                        scenarioDescription: 'Περιγραφή σεναρίου',
                        pleaseEnterASceneDescription: 'Παρακαλώ εισάγετε μια περιγραφή σκηνής',
                        pleaseEnterASceneDescriptionForTheSceneAndThePurposeOfTheSceneEntryForExampleCustomersWantToHandlePersonnelNeedsBusinessEnterPersonnelInformationPhoneNumberAndOrderProductsAndImprovementsTheMoreDetailedTheSceneDescriptionTheMoreCharacteristicTheDialogueProcessWillBeTheBetterTheEffectWillBe: 'Παρακαλώ εισάγετε μια περιγραφή σκηνής για τη σκηνή και τον σκοπό της είσοδος σκηνής.\nΓια παράδειγμα: οι πελάτες θέλουν να χειριστούν τις ανάγκες του προσωπικού, να εισάγουν τον αριθμό πληροφοριών του προσωπικού και να παραγγείλουν προϊόντα και βελτιώσεις.\nΌσο πιο λεπτομερής η περιγραφή της σκηνής, τόσο πιο χαρακτηριστική θα είναι η διαδικασία του διαλόγου, τόσο καλύτερο θα είναι το αποτέλεσμα.',
                        panelObjectStudent: 'Αντικείμενο πίνακα (Φοιτητής)',
                        pleaseEnterAPanelObject: 'Παρακαλώ εισάγετε ένα αντικείμενο πίνακας',
                        proposedRolesRobots: 'Προτεινόμενοι Ρόλοι (Ρομπότ)',
                        pleaseSelectASuggestedRole: 'Παρακαλώ επιλέξτε έναν προτεινόμενο ρόλο',
                        pleaseEnterARoleName: 'Παρακαλώ εισάγετε ένα όνομα ρόλο',
                        remarks: 'Παρατηρήσεις',
                        cancel: 'Ακύρωση',
                        save: 'Αποθήκευση',
                    },
                    list: {
                        name: 'Όνομα',
                        accompanyingTrainingObjectCadet: 'Συνοδευτικό αντικείμενο εκπαίδευσης (Cadet)',
                        proposedRolesRobots: 'Προτεινόμενοι Ρόλοι (Ρομπότ)',
                        creationTime: 'Χρόνος δημιουργίας',
                        remarks: 'Παρατηρήσεις',
                        enabledStatus: 'Ενεργοποιημένη κατάσταση',
                        operation: 'Λειτουργία',
                        edit: 'Επεξεργασία',
                        delete: 'Διαγραφή',
                        failedToGetList: 'Αποτυχία λήψης λίστας',
                        statusUpdateSuccessful: 'Επιτυχής ενημέρωση κατάστασης',
                        statusUpdateFailed: 'Η ενημέρωση κατάστασης απέτυχε',
                        areYouSureYouWantToDelete: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                        confirm: 'Επιβεβαίωση',
                        cancel: 'Ακύρωση',
                        deletedSuccessfully: 'Διαγραφή με επιτυχία',
                        deleteFailed: 'Η διαγραφή απέτυχε',
                        sceneName: 'Όνομα σκηνής',
                        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                        pleaseEnterThePartnerstudent: 'Παρακαλώ εισάγετε τον συνεργάτη (φοιτητή)',
                        pleaseEnterARoleName: 'Παρακαλώ εισάγετε ένα όνομα ρόλο',
                        pleaseEnterComments: 'Παρακαλώ εισάγετε σχόλια',
                        startDate: 'Ημερομηνία έναρξης',
                        endDate: 'Ημερομηνία λήξης',
                        reset: 'Επαναφοράς',
                        filter: 'Φίλτρος',
                        new: 'Νέο',
                    },
                },
                roleManage: {
                    edit: {
                        aishaNature: 'Αΐσα (Φύση)',
                        zhishachat: 'Ζίσα (συνομιλία)',
                        zhiqianGentle: 'Ζικιαν (Πολυ)',
                        knowRiceemotion: 'Γνωρίζετε το ρύζι (συναίσθημα)',
                        aishuoNature: 'Aishuo (Φύση)',
                        zhishuochat: 'Ζίσουο (συνομιλία)',
                        aiHaoAffinity: 'Αι Χάο',
                        zhixiangEmotion: 'Zhixiang (Emotion)',
                        enterTheCorrespondingDescriptionAccordingToYourPartnersTargetRoleSuchAsTAsPersonalityCharacteristicsCommunicationStylePositionAndWorkUnitPainPointsWhatProductsAreCurrentlyUsedWhatEnvironmentAreCurrentlyInPlaceAndWhatPossibleObjectionsAreThereEtcTheClearerTheDescriptionProvidedTheMoreAccurateAndSpecificTheRoleWillBeBuilt: 'Εισάγετε την αντίστοιχη περιγραφή σύμφωνα με τον στόχο ρόλο του συνεργάτη σας, όπως τα χαρακτηριστικά προσωπικότητας του ΤΑ, στυλ επικοινωνίας, θέση και μονάδα εργασίας, πόνους, τι προϊόντα είναι αυτή τη στιγμή Χρησιμοποιούνται, ποιο περιβάλλον υπάρχουν σήμερα, και ποιες πιθανές αντιρρήσεις υπάρχουν, κλπ. Όσο πιο σαφής η περιγραφή που παρέχεται, τόσο πιο ακριβής και συγκεκριμένος ρόλος θα είναι ο ρόλος Χτισμένο',
                        editingRoleSuccessfully: 'Επιτυχής επεξεργασία ρόλου',
                        roleCreatedSuccessfully: 'Ο ρόλος δημιουργήθηκε με επιτυχία',
                        failedToGetSceneDetails: 'Αποτυχία λήψης λεπτομερειών σκηνής',
                        createType: 'Δημιουργία τύπου',
                        accurateCreation: 'Ακριβής δημιουργία',
                        roleName: 'Όνομα ρόλο',
                        pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                        gender: 'Φύλο',
                        male: 'Άνδρες',
                        female: 'Θήλεις',
                        timbre: 'Πίνακας 2',
                        freeDescription: 'Ελεύθερη περιγραφή',
                        dialogueSimilarToYourPositionAndRoleSceneIncludingYourCharacterCommunicationStyleCoordinationAndWorkUnitFeelingsWhatProductsAreCurrentlyUsedWhatEnvironmentAreYouInAndWhatExternalCharacteristicsAreYouHavingWhatYouWantToReflectInTheDiscussionWhatYouWantToAchieveInTheDiscussionWhatIsTheSceneInTheContentAndTheCharacteristics: 'Διάλογος παρόμοιος με τη θέση και τον ρόλο σας, συμπεριλαμβανομένου του χαρακτήρα σας, του στυλ επικοινωνίας, του συντονισμού και της μονάδας εργασίας, τα συναισθήματα, Ποια προϊόντα χρησιμοποιούνται σήμερα, σε ποιο περιβάλλον βρίσκεστε και ποια εξωτερικά χαρακτηριστικά έχετε. Τι θέλετε να αντανακλάτε στη συζήτηση, τι θέλετε να πετύχετε στη συζήτηση, ποια είναι η σκηνή στο περιεχόμενο, και τα χαρακτηριστικά',
                        roleTags: 'Ετικέτες ρόλου',
                        remarks: 'Παρατηρήσεις',
                        cancel: 'Ακύρωση',
                        save: 'Αποθήκευση',
                        create: 'Δημιουργία δημιουργίας',
                    },
                    list: {
                        aishaNature: 'Αΐσα (Φύση)',
                        zhishachat: 'Ζίσα (συνομιλία)',
                        zhiqianGentle: 'Ζικιαν (Πολυ)',
                        knowRiceemotion: 'Γνωρίζετε το ρύζι (συναίσθημα)',
                        aishuoNature: 'Aishuo (Φύση)',
                        zhishuochat: 'Ζίσουο (συνομιλία)',
                        aiHaoAffinity: 'Αι Χάο',
                        zhixiangEmotion: 'Zhixiang (Emotion)',
                        roleName: 'Όνομα ρόλο',
                        roleGender: 'Ρόλο Φύλο',
                        male: 'Άνδρες',
                        female: 'Θήλεις',
                        creationTime: 'Χρόνος δημιουργίας',
                        backgroundDescription: 'Περιγραφή φόντου',
                        timbreConfiguration: 'Ρύθμιση ρυθμίσεων',
                        remarks: 'Παρατηρήσεις',
                        status: 'Κατάσταση',
                        operation: 'Λειτουργία',
                        edit: 'Επεξεργασία',
                        delete: 'Διαγραφή',
                        failedToGetList: 'Αποτυχία λήψης λίστας',
                        updateStatusSuccessfully: 'Κατάσταση ενημέρωσης',
                        areYouSureYouWantToDelete: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                        cancel: 'Ακύρωση',
                        deletedSuccessfully: 'Διαγραφή με επιτυχία',
                        pleaseEnterARoleName: 'Παρακαλώ εισάγετε ένα όνομα ρόλο',
                        gender: 'Φύλο',
                        pleaseSelect: 'Παρακαλώ επιλέξτε.',
                        pleaseEnterComments: 'Παρακαλώ εισάγετε σχόλια',
                        reset: 'Επαναφοράς',
                        filter: 'Φίλτρος',
                        new: 'Νέο',
                    },
                },
                index: {
                    newRole: 'Νέος Ρόλος',
                    editRole: 'Επεξεργασία ρόλου',
                    newScene: 'Νέα σκηνή',
                    editScene: 'Επεξεργασία σκηνής',
                    templateManagement: 'Διαχείριση προτύπων',
                    roleManagement: 'Διαχείριση ρόλων',
                    sceneManagement: 'Διαχείριση σκηνής',
                },
            },
            courseEvaluation: {
                components: {
                    scoreRangeSelect: {
                        index: {
                            pleaseSelect: 'Παρακαλώ επιλέξτε.',
                            comprehensiveScore: 'Πλήρης βαθμολογία',
                            courseQuality: 'Ποιότητα μαθημάτων',
                            learningEffect: 'Μάθηση επίδραση',
                            interactiveExperience: 'Διαδραστική εμπειρία',
                            greater: 'Μεγαλύτερο',
                            equal: 'Ίση',
                            less: 'Λιγότερα',
                            pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                        },
                    },
                },
                overview: {
                    components: {
                        scoreTable: {
                            rankings: 'Κατάταξη',
                            courseName: 'Όνομα πορείας',
                            evaluationQuantity: 'Ποσότητα αξιολόγησης',
                            practicePasses: 'Πέρασμα εξάσκησης',
                        },
                        statisticsCards: {
                            numberOfPublishingTasks: 'Αριθμός εργασιών δημοσίευσης',
                            harvestEvaluationNumber: 'Αριθμός αξιολόγησης συγκομιδής',
                            practicePasses: 'Πέρασμα εξάσκησης',
                            examinations: 'Εξετάσεις',
                        },
                        trendChart: {
                            comprehensiveScore: 'Πλήρης βαθμολογία',
                            totalQuantityOfEvaluation: 'Συνολική ποσότητα αξιολόγησης',
                            addedComprehensiveEvaluationScore: 'Προστέθηκε ολοκληρωμένη βαθμολογία αξιολόγησης',
                            quantityOfNewEvaluation: 'Ποσότητα νέας αξιολόγησης',
                            score: 'Βαθμολογία',
                        },
                    },
                    index: {
                        failedToLoadDataPleaseTryAgain: 'Αποτυχία φόρτωσης δεδομένων, παρακαλώ προσπαθήστε ξανά',
                        evaluationOverview: 'Επισκόπηση αξιολόγησης',
                        courseStatistics: 'Στατιστικές μαθημάτων',
                        averageCourseScore: 'Μέση βαθμολογία μαθημάτων',
                        evaluationTrendChart: 'Εξέλιξη της αξιολόγησης',
                    },
                },
                records: {
                    index: {
                        deletedSuccessfully: 'Διαγραφή με επιτυχία',
                        courseName: 'Όνομα πορείας',
                        courseType: 'Τύπος πορείας',
                        evaluationTime: 'Χρόνος αξιολόγησης',
                        evaluators: 'Αξιολογητές',
                        operation: 'Λειτουργία',
                        viewDetails: 'Λεπτομέρειες προβολής',
                        editCourse: 'Επεξεργασία πορείας',
                        confirmDelete: 'Επιβεβαίωση διαγραφής',
                        areYouSureYouWantToDeleteThisEvaluationRecord: 'Επιθυμείτε σίγουρα τη διαγραφή αυτής της εγγραφής αξιολόγησης;',
                        delete: 'Διαγραφή',
                        evaluationRecord: 'Αρχείο αξιολόγησης',
                        course: 'Πρόγραμμα σπουδών',
                        pleaseSelect: 'Παρακαλώ επιλέξτε.',
                        score: 'Βαθμολογία',
                        textFeedback: 'Ανατροφοδότηση κειμένου',
                        all: 'Όλα',
                        yes: 'Μάλιστα.',
                        no: 'Οχι',
                        reset: 'Επαναφοράς',
                        determine: 'Προσδιορίστε την ένδειξη αυτών',
                    },
                },
            },
        },
        conversationAnalysis: {
            videoAnalysis: {
                detail: {
                    components: {
                        dialogue: {
                            index: {
                                keywordSearch: 'Αναζήτηση λέξη-κλειδιά',
                                previous: 'Προηγούμενο',
                                next: 'Επόμενο',
                                theObjectThatTriggersTheScrollingEventIs: 'Το αντικείμενο που ενεργοποιεί το γεγονός κύλισης',
                                userScrolling: 'Κύλιση χρήστη',
                            },
                        },
                        summary: {
                            index: {
                                reminder: 'Υπενθύμιση:',
                                edit: 'Επεξεργασία',
                                name: 'Όνομα',
                                hintLanguage: 'Ζήτηση',
                            },
                        },
                        viewpoint: {
                            index: {
                                viewpointExtraction: 'Εξαγωγή σημείου άποψης',
                            },
                        },
                        outline: {
                            index: {
                                numberOfKeywords: 'Αριθμός λέξεων-κλειών',
                                speaker: 'Ηχεία',
                                speechDuration: 'Διάρκεια ομιλίας',
                                proportionOfSpeaking: 'Αναλογία ομιλίας',
                                maximumSpeechDuration: 'Μέγιστο μήκος ομιλίας',
                                numberOfQuestions: 'Αριθμός ερωτήσεων',
                                averageSpeechSpeed: 'Μέση ταχύτητα',
                                conversationalActions: 'Ενέργεια συνεδρίας',
                                contentSummary: 'Περίληψη περιεχομένων',
                                generateSummary: 'Δημιουργία περίληψης',
                                keywordCloud: 'Λέξεις-κλειδιά λέξη cloud',
                            },
                        },
                    },
                    index: {
                        outline: 'Περίληψη',
                        viewpoint: 'Σημείο προβολής',
                        contentSummary: 'Περίληψη περιεχομένων',
                        viewpointExtraction: 'Εξαγωγή σημείου άποψης',
                        summaryOfKeyPoints: 'Περίληψη των βασικών σημειών',
                        videoAnalysis: 'Ανάλυση βίντεο',
                    },
                },
                list: {
                    index: {
                        delete: 'Διαγραφή',
                        uploadSuccessful: 'Αποστολή επιτυχή',
                        videoList: 'Λίστα βίντεο',
                        uploadVideo: 'Αποστολή βίντεο',
                        videoName: 'Όνομα βίντεο',
                        uploadTime: 'Χρόνος αποστολής',
                        endTime: 'Τέλος χρόνου',
                        analyzeProgress: 'Ανάλυση της προόδου',
                        haveInHand: 'Σε εξέλιξη.',
                        completed: 'Ολοκληρώθηκε',
                        fail: 'Αποτυχία',
                        toBegin: 'Ξεκινάμε.',
                        operation: 'Λειτουργία',
                        see: 'Προβολή',
                    },
                },
            },
            productManage: {
                components: {
                    acousticData: {
                        components: {
                            template: {
                                index: {
                                    operationSuccessful: 'Επιτυχία λειτουργίας',
                                    operator: 'Αερομεταφορέας',
                                    rules: 'Κανόνες',
                                    preserve: 'Αποθήκευση',
                                    cancel: 'Ακύρωση',
                                },
                            },
                        },
                        index: {
                            questionnaire: 'Ερωτηματολόγο',
                            voiceCall: 'Κλήση φωνής',
                            textDialogue: 'Διάλογο κειμένου',
                            workOrder: 'Σειρά εργασίας',
                            videoCall: 'Κλήση βίντεο',
                            enterpriseMicroData: 'Δεδομένα μικρών επιχειρήσεων',
                            socialMediaComments: 'Σχόλια Κοινωνικών Μέσων',
                            applicationComments: 'Σχόλια εφαρμογής',
                            associatesAcousticData: 'Συνδέει ακουστικά δεδομένα',
                        },
                    },
                    baseInfo: {
                        index: {
                            saveSuccessful: 'Αποθήκευση με επιτυχία',
                            basicInformation: 'Βασικές πληροφορίες',
                            productName: 'Όνομα προϊόντος',
                            productDescription: 'Περιγραφή προϊόντος',
                            productPicture: 'Εικόνα προϊόντος',
                            preserve: 'Αποθήκευση',
                            nextStep: 'Επόμενο βήμα',
                        },
                    },
                    subProduct: {
                        components: {
                            unrelatedProducts: {
                                index: {
                                    pleaseSelectProductData: 'Παρακαλώ επιλέξτε δεδομένα προϊόντων',
                                },
                            },
                        },
                        index: {
                            associateSubproducts: 'Συνδετικά υποπροϊόντα',
                            associationSuccess: 'Η σύνδεση',
                            operationSuccessful: 'Επιτυχία λειτουργίας',
                            productPicture: 'Εικόνα προϊόντος',
                            productID: 'Κωδικός ID προϊόντος',
                            productTitle: 'Τίτλος προϊόντος',
                            ecommercePlatform: 'Πλατφόρμα ηλεκτρονικού εμπορίου',
                            price: 'Τιμή',
                            sales: 'Πωλήσεις',
                            numberOfComments: 'Αριθμός σχολιών',
                            areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                            remove: 'Αφαίρεση',
                            productManagement: 'Διαχείριση προϊόντων',
                            productData: 'Στοιχεία προϊόντος:',
                        },
                    },
                },
                detail: {
                    index: {
                        productManagement: 'Διαχείριση προϊόντων',
                        basicInformation: 'Βασικές πληροφορίες',
                        associateSubproducts: 'Συνδετικά υποπροϊόντα',
                        associatesAcousticData: 'Συνδέει ακουστικά δεδομένα',
                        newProduct: 'Νέο προϊόν',
                    },
                },
                list: {
                    components: {
                        checkReportButton: {
                            index: {
                                productStatistics: 'Στατιστικές προϊόντων',
                                productInsights: 'Στοιχεία προϊόντων',
                                userInsights: 'Στοιχεία χρήστη',
                                viewReport: 'Προβολή αναφοράς',
                            },
                        },
                    },
                    index: {
                        pleaseEnterAKeyword: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
                        productPicture: 'Εικόνα προϊόντος',
                        productName: 'Όνομα προϊόντος',
                        productDescription: 'Περιγραφή προϊόντος',
                        creationTime: 'Χρόνος δημιουργίας',
                        updateTime: 'Ώρα ενημέρωσης',
                        ecommercePlatform: 'Πλατφόρμα ηλεκτρονικού εμπορίου',
                        numberOfSubproducts: 'Αριθμός υποπροϊόντων',
                        edit: 'Επεξεργασία',
                        areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                        delete: 'Διαγραφή',
                        productManagement: 'Διαχείριση προϊόντων',
                        newProduct: 'Νέο προϊόν',
                    },
                },
            },
            productDetail: {
                list: {
                    index: {
                        ecommercePlatform: 'Πλατφόρμα ηλεκτρονικού εμπορίου',
                        productTitle: 'Τίτλος προϊόντος',
                        productPicture: 'Εικόνα προϊόντος',
                        productID: 'Κωδικός ID προϊόντος',
                        price: 'Τιμή',
                        sales: 'Πωλήσεις',
                        numberOfComments: 'Αριθμός σχολιών',
                        associationStatus: 'Κατάσταση σύνδεσης',
                        associated: 'Σχετικά',
                        notAssociated: 'Δεν συνδέεται',
                        associatedMainProduct: 'Συνδεδεμένο κύριο προϊόν',
                        viewDetails: 'Λεπτομέρειες προβολής',
                        productDetails: 'Λεπτομέρειες προϊόντος',
                    },
                },
            },
            dashboard: {
                index: {
                    recentDataTrendStatistics: 'Στατιστικές πρόσφατης τάσης των δεδομένων',
                    nearlyDays: 'Σχεδόν 7 ημέρες',
                },
                components: {
                    balanceCard: {
                        index: {
                            millionHours: 'Εκατομμύρια ώρες.',
                            hours: 'Ώρες',
                        },
                    },
                },
            },
            dataIntegration: {
                dataIntegration: 'Ενσωμάτωση δεδομένων',
            },
            planManage: {
                automaticTriggerMessage: {
                    index: {
                        saveSuccessful: 'Αποθήκευση με επιτυχία',
                        autoTriggerMessage: 'Μήνυμα αυτόματης ενεργοποίησης',
                        automaticPush: 'Αυτόματη ώθηση',
                        newPush: 'Νέα ώθηση',
                        push: 'Σπρώξτε.',
                        preserve: 'Αποθήκευση',
                    },
                },
                index: {
                    autoTriggerMessage: 'Μήνυμα αυτόματης ενεργοποίησης',
                    planManagement: 'Διαχείριση σχεδίου',
                },
            },
        },
        businessWorkingHours: {
            components: {
                businessWorkingHoursSetting: {
                    index: {
                        addWorkingHours: 'Προσθήκη χρόνου εργασίας',
                    },
                },
            },
            index: {
                businessWorkingHours: 'Ώρα εργασίας επιχειρήσεων',
                newlyBuild: 'Νέο',
                name: 'Όνομα',
                describe: 'Περιγραφή',
                operation: 'Λειτουργία',
                edit: 'Επεξεργασία',
                delete: 'Διαγραφή',
                editBusinessWorkingHours: 'Επεξεργασία επαγγελματικών ώρων',
                newBusinessWorkingHours: 'Νέες επιχειρηματικές ώρες',
                workingHours: 'Χρόνος εργασίας',
            },
        },
        algorithmSemanticIntelligence: {
            intelligentExtraction: 'Ευφυής εξαγωγή',
        },
        taskCenter: {
            downloadList: {
                component: {
                    areYouSureYouWantToCancelAfterCancellationItCannotBeRestoredAgain: 'Σίγουρα θέλεις να το ακυρώσεις; Ακύρωση δεν θα είναι δυνατή',
                },
            },
            taskList: {
                template: {
                    plannedAnalysisQuantity: 'Προγραμματισμένη ποσότητα ανάλυσης',
                    actualAnalysisQuantity: 'Ποσότητα',
                    numberOfTokensConsumed: 'Αριθμός καταναλωμένων μάρκες',
                },
            },
        },
        accountManagement: {
            securitySetting: 'Ρυθμίσεις ασφαλείας',
            accountManagement: 'Διαχείριση λογαριασμού',
        },
        securitySettings: {
            components: {
                iPInput: {
                    index: {
                        to: 'Στον',
                        switchToIPAddressMode: 'Εναλλαγή στη λειτουργία διεύθυνσης IP',
                        switchToIPSegmentMode: 'Εναλλαγή σε λειτουργία τμήματος IP',
                    },
                },
                verificationConfig: {
                    index: {
                        afterTheTwostepVerificationIsTurnedOnEmployeesWhosePhoneNumbersAreNotFilledInAndWhosePhoneNumbersAreIncorrectlyFilledInWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToModifyTheNormalPhoneNumberForTheEmployeesAccount: 'Μετά την ενεργοποίηση της επαλήθευσης δύο σταδίων, οι υπάλληλοι των οποίων οι αριθμοί τηλεφώνου δεν συμπληρώνονται και οι αριθμοί τηλεφώνου των οποίων είναι εσφαλμένα συμπληρωμένοι δεν θα μπορούν να συνδεθούν στους αριθμούς Σύστημα. Σε περίπτωση μη συνδεθείτε, παρακαλούμε επικοινωνήστε με τον διαχειριστή για να τροποποιήσετε τον κανονικό αριθμό τηλεφώνου του λογαριασμού του εργαζόμενου.',
                        afterTheTwostepVerificationIsEnabledTheEmployeeAccountWhoseMobilePhoneNumberIsNotFilledInOrWhoseMobilePhoneNumberIsIncorrectlyFilledInWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToModifyTheNormalPhoneNumberForTheEmployeeAccount: 'Μετά την ενεργοποίηση της επαλήθευσης δύο σταδίων, ο λογαριασμός του οποίου ο αριθμός κινητού τηλεφώνου δεν συμπληρώνεται ή του οποίου ο αριθμός κινητού τηλεφώνου είναι εσφαλμένα συμπληρωμένος δεν θα είναι σε θέση. Συνδεθείτε στο σύστημα. Σε περίπτωση μη συνδεθείτε, παρακαλούμε επικοινωνήστε με τον διαχειριστή για να τροποποιήσετε τον κανονικό αριθμό τηλεφώνου για τον λογαριασμό των εργαζομένων.',
                        afterTheTwostepVerificationIsTurnedOnEmployeesWhoDoNotFillInTheMobilePhoneNumberOrFillInTheWrongMobilePhoneNumberWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToCorrectTheNormalPhoneNumberForTheEmployeeAccount: 'Μετά την ενεργοποίηση της επαλήθευσης δύο σταδίων, οι εργαζόμενοι που δεν συμπληρώνουν τον αριθμό κινητού τηλεφώνου ή δεν συμπληρώνουν λάθος αριθμό κινητού τηλεφώνου δεν θα μπορούν να συνδεθούν στο σύστημα. Σε περίπτωση μη συνδεθείτε, παρακαλούμε επικοινωνήστε με τον διαχειριστή για να διορθώσετε τον κανονικό αριθμό τηλεφώνου για τον λογαριασμό των εργαζομένων.',
                        login: 'Σύνδεση',
                        attention: 'Προσοχή.',
                        saveSuccessful: 'Αποθήκευση με επιτυχία',
                        twostepVerification: 'Επαλήθευση δύο σταδίων',
                        landing: 'Προσγείωση',
                        preserve: 'Αποθήκευση',
                    },
                },
            },
            index: {
                employeeLoginIPAddressRestrictions: 'Εργαζόμενος Σύνδεση IP Περιορισμοί Διεύθυνσης',
                limitTheIPRangeThatEmployeesCanLogInToLoginIsNotAllowedIfTheIPRangeIsExceededOnlyValidForWebsitesMobileAppsAreNotRestrictedAndAdministratorsAreNotRestricted: 'Περιορίστε το εύρος IP που μπορούν να συνδεθούν οι εργαζόμενοι. Δεν επιτρέπεται η σύνδεση αν η διεύθυνση IP υπερβαίνει το εύρος. Ισχύει μόνο για ιστοσελίδες, οι εφαρμογές κινητών δεν περιορίζονται και οι διαχειριστές δεν περιορίζονται.',
                iPRangeAllowedForLogin: 'Επιτρέπεται εύρος IP για σύνδεση',
                saveSuccessful: 'Αποθήκευση με επιτυχία',
                pleaseImproveTheConfiguration: 'Παρακαλώ τελειοποιήστε τη διαμόρφωσης',
                securitySetting: 'Ρυθμίσεις ασφαλείας',
                employeeLoginIPRestrictions: 'Εργαζόμενος Σύνδεση IP Περιορισμοί',
                restrictTheIPRangeThatEmployeesCanLogInToAndProhibitLoggingInBeyondTheRangeOnlyEffectiveForWebsitesMobileAppsAreNotRestrictedAndAdministratorsAreNotRestricted: 'Περιορίστε το εύρος IP που μπορούν να συνδεθούν οι εργαζόμενοι. Η σύνδεση δεν επιτρέπεται πέρα από το εύρος. Ισχύει μόνο για ιστοσελίδες, οι εφαρμογές κινητών δεν περιορίζονται και οι διαχειριστές δεν περιορίζονται.',
                whenAddingOrModifyingPleaseFillInTheExternalIPSegmentsameCSegmentOrAFixedExternalIPAddress: 'Κατά την προσθήκη ή την τροποποίηση, παρακαλούμε εισάγετε το τμήμα εξωτερικού δικτύου IP (το ίδιο τμήμα C) ή μια σταθερή διεύθυνση IP εξωτερικού δικτύου.',
                allowLoginIPRange: 'Επιτρέπεται εύρος IP για τη σύνδεση',
                preserve: 'Αποθήκευση',
            },
        },
        coachAdminEntry: {
            webPlugin: 'Πρόσθετο ιστού',
            speechRecognition: 'Αναγνώριση ομιλών',
        },
        billingCenter: {
            template: {
                details: 'Λεπτομέρειες',
                languageType: 'Τύπος γλώσσας',
                aSREngine: 'Κινητήρας ASR',
                voiceQualityQuota: 'Ποσοστό φωνητικής ποιότητας',
                realtimeData: 'Δεδομένα πραγματικού χρόνου',
                calculatedByDay: 'Υπολογίζεται κατά την ημέρα',
            },
            component: {
                aSRName: 'Ονοματεπώνυμο ASR',
                language: 'Γλώσσα',
                remainingQuota: 'Εναπομένουσα ποσόστωση',
                hours: 'Ώρες',
                usedQuota: 'Χρησιμοποίηση',
            },
        },
        speechRecognition: {
            component: {
                saveSuccessfully: 'Αποθήκευση με επιτυχία',
                saveSuccessful: 'Αποθήκευση με επιτυχία',
                minimumNumberOfSpeakersCannotBeGreaterThanMaximumNumber: 'Ο ελάχιστος αριθμός των ομιλητών δεν μπορεί να είναι μεγαλύτερος από τον μέγιστο αριθμό.',
                theNumberOfAgentsCannotBeGreaterThanTheMaximumNumberOfSpeakers: 'Ο αριθμός των παραγόντων δεν μπορεί να είναι μεγαλύτερος από τον μέγιστο αριθμό ομιλητών',
                pleaseImproveTheConfiguration: 'Παρακαλώ τελειοποιήστε τη διαμόρφωσης',
                operationSavedSuccessfully: 'Η λειτουργία αποθηκευμένη με επιτυχία!',
                deletedSuccessfully: 'Διαγραφή επιτυχώς!',
                pleaseSelectLanguage: 'Παρακαλώ επιλέξτε μια γλώσσα',
                pleaseConfigureRules: 'Παρακαλώ ρυθμίστε τους κανόνες',
                updateSuccessful: 'Επιτυχής ενημέρωση!',
                operationSuccessful: 'Επιχείρηση επιτυχής!',
            },
            template: {
                mixedIdentification: 'Μικτή αναγνώριση',
                whenEnabledMultilingualMixedTranscriptionIsAvailable: 'Όταν είναι ενεργοποιημένο, η πολυγλωσσική μικτή μεταγραφή είναι διαθέσιμη',
                nonmanualFiltering: 'Μη χειροκίνητη φιλτράριση',
                whenEnabledOnlyTranscribeManualCalls: 'Όταν ενεργοποιείται, μόνο μεταγράψτε χειροκίνητες κλήσεις',
                speakerIdentification: 'Ταυτοποίηση ηχείου',
                aSRLanguage: 'Γλώσσα',
                pleaseSelect: 'Παρακαλώ επιλέξτε.',
                model: 'Υπόδειγμα:',
                pleaseSelectLanguage: 'Παρακαλώ επιλέξτε μια γλώσσα',
                delete: 'Διαγραφή',
                newASRModel: 'Νέο πρότυπο ASR',
            },
            components: {
                aSRFilterMethod: {
                    components: {
                        sampleUpperLimit: {
                            index: {
                                daily: 'Καθημερινά',
                                weekly: 'Εβδομαδιαία',
                                pleaseSelectAPeriod: 'Παρακαλώ επιλέξτε μια περίοδος',
                                byQuantity: 'Κατά ποσότητα',
                                longOnTime: 'Πολύ καιρό στην ώρα του.',
                                noUpperLimit: 'Χωρίς ανώτατο όριο',
                                pleaseSelectACalculationDimension: 'Παρακαλώ επιλέξτε μια διάσταση υπολογισμού',
                                pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                                hours: 'Ώρες',
                            },
                        },
                    },
                    index: {
                        filteringMethod: 'Μέθοδος φιλτραρίσματος:',
                        allEligibleCallsPerformASR: 'Όλες οι επιλέξιμες κλήσεις εκτελούν ASR.',
                        performASRForEligiblePartialCalls: 'Εκτέλεση ASR για επιλέξιμες μερικές κλήσεις',
                        samplingRatio: 'Σχέση δειγματοληψίας:',
                        upperSamplingLimit: 'Ανώτερο όριο δειγματοληψίας:',
                    },
                },
                aSRFilterStatus: {
                    index: {
                        drawLimitNotReached: 'Δεν επιτεύχθη όριο σχεδίασης',
                        drawLimitReached: 'Όριο κλήρωσης έφθασε',
                    },
                },
                speakerRecognition: {
                    index: {
                        toAccessAThirdpartyCallRecordingThroughAPIItIsNecessaryToIdentifyWhetherTheLeftChannelIsACustomerServiceOrACustomer: 'Για να έχετε πρόσβαση σε μια κλήση τρίτων μέσω API, είναι απαραίτητο να προσδιοριστεί εάν το αριστερό κανάλι είναι εξυπηρέτηση πελατών ή πελάτης.',
                        singlechannelRecordingDefinesTheRoleOfTheAgentThroughTextRecognitionAndRoleConfiguration: 'Η καταγραφή ενός καναλιού ορίζει το ρόλο του πράκτορα μέσω αναγνώρισης κειμένου και διαμόρφωση ρόλου.',
                        aPIIdentifiesTrackRole: 'Το API αναγνωρίζει το ρόλο κομματιού',
                        textRecognition: 'Αναγνώριση κειμένου:',
                        minimumNumberOfSpeakers: 'Ελάχιστος αριθμός ομιλητών',
                        maximumNumberOfSpeakers: 'Μέγιστος αριθμός ομιλητών',
                        numberOfCustomerService: 'Αριθμός εξυπηρέτησης πελατών',
                        operator: 'Χειριστής:',
                        rules: 'Κανόνες:',
                        preserve: 'Αποθήκευση',
                    },
                },
            },
        },
        dataAnalysis: {
            customerServiceResults: 'Αποτελέσματα εξυπηρέτησης πελατών',
            qualityInspectionOverviewReport: 'Έκθεση επισκόπησης ποιότητας επιθεώρησης',
            competitiveProductAnalysis: {
                index: {
                    competitionAnalysis: 'Ανάλυση ανταγωνισμού',
                },
            },
            generalInspectionReport: {
                component: {
                    ecommerceTextSession: 'Συνεδρία κειμένου ηλεκτρονικού εμπορίου',
                    workOrder: 'Σειρά εργασίας',
                    all: 'Όλα',
                    questionnaire: 'Ερωτηματολόγο',
                },
                template: {
                    customerService: 'Υπηρεσία πελατών',
                    totalEcommerceSessions: 'Σύνολο συνεδριών ηλεκτρονικού εμπορίου',
                    totalWorkOrder: 'Συνολική σειρά εργασίας',
                    totalQuestionnaire: 'Συνολικό ερωτηματολόγιο',
                },
            },
            productInsight: {
                index: {
                    productInsights: 'Στοιχεία προϊόντων',
                },
            },
            productStatistics: {
                index: {
                    productStatistics: 'Στατιστικές προϊόντων',
                },
            },
            statisticalProfile: {
                index: {
                    statisticalOverview: 'Στατιστική επισκόπηση',
                },
            },
            userInsight: {
                index: {
                    userInsights: 'Στοιχεία χρήστη',
                },
            },
            socialMediaSentiment: {
                index: {
                    socialMediaPublicOpinion: 'Δημόσια γνώμα',
                },
            },
            qualityInspectionOverview: {
                index: {
                    qualityInspectionOverviewReport: 'Έκθεση επισκόπησης ποιότητας επιθεώρησης',
                },
            },
            customerServiceScore: {
                index: {
                    customerServiceResults: 'Αποτελέσματα εξυπηρέτησης πελατών',
                },
            },
        },
        eCommentManage: {
            template: {
                ecommerceReviewFilter: 'Φίλτρο κριτικής ηλεκτρονικής εμπορίας',
                allComments: 'Όλα τα σχόλια',
                ecommerceReviewManagement: 'Διαχείριση επανεξέτασης ηλεκτρονικού εμπορίου',
            },
            detail: {
                template: {
                    ecommerceReviewManagement: 'Διαχείριση επανεξέτασης ηλεκτρονικού εμπορίου',
                    detailsOfEcommerceComments: 'Λεπτομέρειες σχετικά με τα σχόλια ηλεκτρονικού εμπορίου',
                },
            },
        },
        mCommentManage: {
            template: {
                socialMediaReviewFilter: 'Φίλτρο κριτικής κοινωνικής δικτύωσης',
                allComments: 'Όλα τα σχόλια',
                socialMediaReviewManagement: 'Διαχείριση Social Media Αναθεώρησης',
            },
            detail: {
                template: {
                    socialMediaReviewManagement: 'Διαχείριση Social Media Αναθεώρησης',
                    detailsOfSocialMediaComments: 'Σχόλια των Social Media Σχόλια',
                },
            },
        },
        conversationAnalysisDataAnalysis: {
            statisticalOverview: 'Στατιστική επισκόπηση',
            publicOpinionAnalysis: 'Ανάλυση της κοινής γνώμης',
            userInsights: 'Στοιχεία χρήστη',
            productInsights: 'Στοιχεία προϊόντων',
            productStatistics: 'Στατιστικές προϊόντων',
            socialMediaPublicOpinion: 'Δημόσια γνώμα',
            dataAnalysis: 'Ανάλυση δεδομένων',
            competitionAnalysis: 'Ανάλυση ανταγωνισμού',
        },
        videoCallManage: {
            template: {
                videoCallFilters: 'Φίλτρα κλήσης βίντεο',
                videoCallManagement: 'Διαχείριση κλήσεων βίντεο',
                videoCallFilter: 'Φίλτρο κλήσης βίντεο',
            },
        },
        qaLanguageSetting: {
            template: {
                ecommerceTextDialogue: 'Διάλογος κειμένου ηλεκτρονικού εμπορίου',
                flyingBookGroupChat: 'Συνομιλία ομάδας ιπτάμενων βιβλίων',
                translation: 'Μετάφραση',
                questionnaire: 'Ερωτηματολόγο',
                voiceCall: 'Κλήση φωνής',
                textDialogue: 'Διάλογο κειμένου',
                workOrder: 'Σειρά εργασίας',
                videoCall: 'Κλήση βίντεο',
                enterpriseWeChatConversation: 'Πολιτική συνόδου επιχειρήσεων',
                enterpriseMicroVoice: 'Μικροφωνία του Enterprise',
                ecommerceReviewData: 'Στοιχεία επανεξέτασης ηλεκτρονικού εμπορίου',
                socialMediaReviewData: 'Στοιχεία αναθεώρησης των κοινωνικών μέσων',
                qualityInspectionLanguageSettings: 'Ρυθμίσεις γλώσσας επιθεώρησης ποιότητας',
                index: {
                    defaultASRModel: 'Προκαθορισμένο μοντέλο ASR',
                    pleaseSelectASecondaryLanguage: 'Παρακαλώ επιλέξτε μια δευτερεύουσα γλώσσα',
                    languageAdaptive: 'Προσαρμοστικό γλώσσα',
                    whenEnabledYouCanSetMultipleTranscriptionLanguagesForAVoiceTheModelAutomaticallyRecognizesAndSelectsALanguageForTranscriptionLanguageAdaptationOnlyTakesEffectWhenUsingGoogleMicrosoftAndAliParaformervOtherASREnginesDoNotTakeEffect: 'Όταν είναι ενεργοποιημένο, μπορείτε να ρυθμίσετε πολλαπλές γλώσσες μεταγραφής για μια φωνή. Το μοντέλο αναγνωρίζει αυτόματα και επιλέγει μια γλώσσα για μεταγραφή. Η προσαρμογή γλώσσας τίθεται σε ισχύ μόνο όταν χρησιμοποιείτε το Google, το Microsoft, και το Ali paraformer-v2.. Άλλοι κινητήρες ASR δεν ισχύουν.',
                    defaultPrimaryLanguage: 'Προκαθορισμένη πρωτοβάθμια γλώσσα',
                    defaultSublanguage: 'Προκαθορισμένη υπογλώσσα',
                    saveSuccessful: 'Αποθήκευση με επιτυχία',
                    deleteSuccessful: 'Διαγραφή με επιτυχία',
                    modificationSucceeded: 'Επιτυχία τροποποίησης',
                    areYouSureToDeleteIt: 'Επιθυμείτε σίγουρα τη διαγραφή;',
                    defaultLanguage: 'Προκαθορισμένη γλώσσα',
                    multilanguageSettings: 'Ρυθμίσεις πολλών γλωσσών',
                    specifyDifferentLanguagesForDifferentData: 'Καθορίστε διαφορετικές γλώσσες για διαφορετικά δεδομένα',
                },
            },
            translate: {
                template: {
                    components: {
                        rules: {
                            components: {
                                item: {
                                    index: {
                                        sourceLanguage: 'Πηγή γλώσσα',
                                        targetLanguage: 'Γλώσσα-στόχου',
                                    },
                                },
                            },
                            index: {
                                setTheCorrespondenceBetweenTheSourceLanguageAndTheTargetLanguagePleaseSetTheTranslationRulesAfterTheQualityInspectionLanguageIsSet: 'Ορίστε την αλληλογραφία μεταξύ της γλώσσας πηγής και της γλώσσας-στόχου. Παρακαλείσθε να ορίσετε τους κανόνες μετάφρασης μετά τη ρύθμιση της γλώσσας επιθεώρησης ποιότητας.',
                                newTranslationRule: 'Νέος κανόνας μετάφρασης',
                            },
                        },
                    },
                    index: {
                        translationOfTerms: 'Μετάφραση Όρων',
                        availableInSemanticIntelligenceSetTheTranslationTermInTheSmartThesaurusWhenEnabledTheSpecifiedWordsInTheTranscriptionResultCanBeTranslatedIntoProfessionalTerms: 'Διαθέσιμη σε Σημασιολογική Νοημοσύνη-\nΟρίστε τον όρο μετάφρασης στον έξυπνο θησαυρό. Όταν είναι ενεργοποιημένη, οι λέξεις που καθορίζονται στο αποτέλεσμα της μεταγραφής μπορούν να μεταφραστούν σε επαγγελματικούς όρους.',
                        saveSuccessful: 'Αποθήκευση με επιτυχία',
                        onState: 'Στην κατάσταση',
                        translateTheSourceLanguageDataIntoTheTargetLanguageAndThenPerformQualityInspectionAndSmartLabel: 'Μεταφράστε τα δεδομένα της πηγής γλώσσας στη γλώσσα-στόχο, και στη συνέχεια να εκτελέσετε επιθεώρηση ποιότητας και έξυπνη ετικέτα.',
                        dataSourceType: 'Τύπος πηγής δεδομένων',
                        translationRules: 'Κανόνες μεταφράσεων',
                        preserve: 'Αποθήκευση',
                    },
                },
            },
        },
        systemIntegration: {
            zendesk: {
                components: {
                    chat: {
                        index: {
                            authorizationSucceeded: 'Πέτυχε η άδεια',
                            cancelAuthorizationSuccessfully: 'Ακύρωση έγκρισης με επιτυχία',
                            clientID: 'ID πελάτη',
                            clientKey: 'Κλειδί πελάτης',
                            redirectURL: 'Αναπροσανατολισμός URLName',
                        },
                    },
                    ticket: {
                        index: {
                            authorizationSucceeded: 'Πέτυχε η άδεια',
                            cancelAuthorizationSuccessfully: 'Ακύρωση έγκρισης με επιτυχία',
                        },
                    },
                },
            },
            kcsDocking: {
                index: {
                    interfaceURL: 'URL διεπαφής',
                    publicKey: 'Δημόσια κλειδιά',
                    privateKey: 'Ιδιωτικό κλειδιά',
                },
            },
            feishu: {
                index: {
                    cancel: 'Ακύρωση',
                    preserve: 'Αποθήκευση',
                },
            },
            template: {
                largeModel: 'Μεγάλο μοντέλο',
                jingdong: 'Τζινγκντονγκ.',
                flyingBook: 'Ιπτάμενο Βιβλίο',
                voiceRobot: 'Ρομπότ φωνής',
            },
            voiceRobot: {
                index: {
                    domainName: 'Όνομα τομέας',
                    administratorMailbox: 'Γραμματοκιβώτιο διαχειριστής',
                    tenantAppid: 'Επίσημη ένοικος',
                    tenantSecrect: 'Μυστικός ενοικιαστής.',
                },
            },
            integrationLLM: {
                index: {
                    intelligentModel: 'Ευφυές μοντέλο',
                    smartLabel: 'Έξυπνη ετικέταName',
                    businessSummary: 'Περίληψη επιχειρήσεων',
                    problemExtraction: 'Εξαγωγή προβλήματος',
                    intelligentExtraction: 'Ευφυής εξαγωγή',
                    semanticLabel: 'Σημασιολογική ετικέτας',
                    translation: 'Μετάφραση',
                    pictureUnderstanding: 'Κατανόηση της εικόνας',
                    audioUnderstanding: 'Κατανόηση ήχου',
                    videoUnderstanding: 'Κατανόηση βίντεο',
                    saveSuccessfully: 'Αποθήκευση με επιτυχία',
                    pleaseSelectAModel: 'Παρακαλώ επιλέξτε ένα μοντέλο',
                    save: 'Αποθήκευση',
                    modelLevelChangedTip: 'Το επίπεδο του μοντέλου άλλαξε. Οι χρεώσεις θα υπολογίζονται σύμφωνα με το νέο μοντέλο.',
                },
            },
            jdShop: {
                components: {
                    configForm: {
                        index: {
                            newStore: 'Νέο κατάστημα',
                            editBasicInformation: 'Επεξεργασία βασικών πληροφοριών',
                            saveSuccessfully: 'Αποθήκευση με επιτυχία',
                            save: 'Αποθήκευση',
                            shopName: 'Όνομα καταστήματος',
                            pleaseEnter: 'Παρακαλώ εισάγετε εισόδου',
                            merchantID: 'Κωδικός ID έμπορου',
                            accountNumber: 'Αριθμός λογαριασμού',
                        },
                    },
                },
                hooks: {
                    index: {
                        authorizationSucceeded: 'Πέτυχε η άδεια',
                    },
                },
                index: {
                    accountNumber: 'Αριθμός λογαριασμού',
                    shopName: 'Όνομα καταστήματος',
                    merchantID: 'Κωδικός ID έμπορου',
                    status: 'Κατάσταση',
                    authorized: 'Επιτρεπόμενο',
                    subscriptionExpiration: 'Συνδρομή',
                    unauthorized: 'Μη εξουσιοδοτημένο',
                    creationTime: 'Χρόνος δημιουργίας',
                    editBasicInformation: 'Επεξεργασία βασικών πληροφοριών',
                    reauthorization: 'Επανεάθεση',
                    authorization: 'Έγκριση',
                    confirmDeletion: 'Επιβεβαίωση διαγραφής;',
                    delete: 'Διαγραφή',
                },
            },
        },
        surveyManage: {
            detail: {
                template: {
                    questionnaireManagement: 'Διαχείριση ερωτηματολογίου',
                    questionnaireDetails: 'Στοιχεία ερωτηματολογίας',
                },
            },
            template: {
                questionnaireFilter: 'Φίλτρο ερωτηματολογίου',
                allQuestionnaires: 'Όλα τα ερωτηματολόγια',
                questionnaireManagement: 'Διαχείριση ερωτηματολογίου',
            },
        },
        soundtrackManage: {
            template: {
                originalSoundManagement: 'Αρχική διαχείριση ήχου',
                allSonic: 'Όλα ηχητικά',
            },
        },
        feishuQa: {
            chatRecord: {
                components: {
                    filter: {
                        index: {
                            loadMore: 'Φόρτωσε περισσότερα',
                        },
                    },
                },
            },
            feishuQaEntry: {
                realtimeMessage: 'Μήνυμα πραγματικού χρόνου',
                groupChatSegmentation: 'Κατάτμηση ομάδας συνομιλίας',
                flyingBookConversation: 'Ιπτάμενος βιβλίο συζήτησης',
            },
        },
        customerService: {
            customerInformation: {
                component: {
                    status: 'Κατάσταση',
                    department: 'Υπηρεσία',
                    newEmployee: 'Νέος υπάλληλος',
                    oldStaff: 'Παλιό προσωπικό',
                    customerServiceType: 'Τύπος εξυπηρέτησης πελατών',
                    creationTime: 'Χρόνος δημιουργίας',
                },
                components: {
                    agentTypeConfig: {
                        index: {
                            saveSuccessfully: 'Αποθήκευση με επιτυχία',
                            agentTypeConfiguration: 'Ρύθμιση τύπου πράκτορας',
                            newEmployeeCycle: 'Νέος κύκλος εργαζομένων',
                            pleaseEnterNewEmployeeCycle: 'Παρακαλώ εισάγετε νέο κύκλο εργαζομένων',
                            day: 'Ημέρα',
                        },
                    },
                },
                template: {
                    pleaseSelectAStatus: 'Παρακαλώ επιλέξτε μια κατάσταση.',
                    enable: 'Ενεργοποίηση ενεργοποίησης',
                    disable: 'Απενεργοποίηση',
                    byCustomerServiceGroup: 'Από τον όμιλο εξυπηρέτησης πελατών',
                    byDepartment: 'Με τμήμα',
                    department: 'Υπηρεσία',
                },
            },
        },
        caseBase: {
            template: {
                sort: 'Ταξινόμηση',
            },
        },
        testSetList: {
            template: {
                sort: 'Ταξινόμηση',
            },
        },
    },
    columns: {
        admin: {
            user: {
                id: 'ID',
                headPortraitUrl: 'Άβαταρ',
                realname: 'Όνομα',
                nickname: 'Ψευδώνυμο',
                name: 'Όνομα',
                email: 'Αριθμός λογαριασμού (Email)',
                mobile: 'Τηλέφωνο',
                agentId: 'Αριθμός εργασίας',
                position: 'Θέση',
                role: 'Ρόλος',
                actions: 'Λειτουργία',
                createUser: 'Νέος υπάλληλος',
                editUser: 'Επεξεργασία υπαλλήλου',
                account: 'Αριθμός λογαριασμού',
                originPassword: 'Αρχικός κωδικός πρόσβασης',
                newPassword: 'Νέο κωδικό πρόσβασης',
                resumePassword: 'Επιβεβαίωση κωδικού πρόσβασης',
                userGroup: 'Ομάδα εργαζομένων',
                authorizationGroup: 'Ομάδα αδειοδότησης',
                resetPassword: 'Επαναφορά κωδικού πρόσβασης',
            },
            userGroups: {
                id: 'ID',
                name: 'Όνομα',
                userCount: 'Αριθμός απασχολουμένων',
                actions: 'Λειτουργία',
                createUserGroup: 'Προσθήκη ομάδας εργαζομένων',
                editUserGroup: 'Επεξεργασία ομάδας υπαλλήλων',
                member: 'Μέλη',
            },
            role: {
                id: 'ID',
                name: 'Όνομα',
                actions: 'Λειτουργία',
                all: 'Όλα',
                taskName: 'Καθήκοντα',
                readTask: 'Προβολή εργασιών',
                manageTemplate: 'Διαχείριση προτύπων',
                manualInspection: 'Χειροκίνητη ανασκόπηση',
                readResultAll: 'Προβολή αποτελεσμάτων',
                readResultPersonal: 'Προβολή αποτελεσμάτων (Ατομική)',
                readProcess: 'Προβολή διαδικασίας επιθεώρησης ποιότητας',
                readReport: 'Στατιστικές και εκθέσεις',
            },
        },
        download: {
            downloadCenter: {
                createTime: 'Ημερομηνία',
                taskName: 'Όνομα',
                size: 'Μέγεθος',
                status: 'Κατάσταση',
            },
        },
        tasks: {
            manage: {
                template: {
                    condition: {
                        idCode: 'ID',
                        name: 'Όνομα',
                        remark: 'Περιγραφή',
                        actions: 'Λειτουργία',
                    },
                    checkPoint: {
                        name: 'Όνομα',
                        remark: 'Περιγραφή',
                        type: 'Τύπος',
                        gradeType: 'Μέθοδος αξιολόγησης',
                        conditionLogic: 'Κανόνες',
                        predeterminedScore: 'Βαθμολογία',
                        weight: 'Βάρος',
                        status: 'Κατάσταση',
                        actions: 'Λειτουργία',
                        switchOn: 'Ενεργοποίηση ενεργοποίησης',
                        switchOff: 'Απενεργοποίηση',
                    },
                },
                workbench: {
                    qualityCheckList: {
                        time: 'Χρόνο',
                        customer: 'Πελάτη',
                        customerPhone: 'Τηλέφωνο πελατών',
                        callType: 'Τύπος κλήσης',
                        source: 'Πηγή',
                        voiceRecording: 'Καταγραφή κλήσεων',
                        graded: 'Αξιολόγηση',
                        openingGreeting: 'Έναρξη Χαιρετισμού',
                    },
                    checkPointList: {
                        name: 'Σημείο επιθεώρησης ποιότητας',
                        type: 'Τύπος',
                        deductScore: 'Κλάσματα',
                        isHit: 'Θήκη επιτυχίας',
                        status: 'Αναθεώρηση',
                        finalDeductScore: 'Επιβεβαίωση έκπτωσης πόντων',
                        hit: 'Χτύπημα.',
                        notHit: 'Αστόχηση',
                    },
                },
            },
        },
        custom: {
            keywords: 'Λέξεις κλειδιά διαλόγου',
        },
    },
    menu: {
        admin: {
            system: {
                text: 'Ρυθμίσεις συστήματος',
            },
            systemIntegration: {
                text: 'Ενσωμάτωση συστήματος',
                subTitle: {
                    udesk: 'Σύστημα εξυπηρέτησης πελατών Udesk',
                    udeskWhite: 'Σύστημα εξυπηρέτησης πελατών',
                    wechat: 'Enterprise WeChat',
                    taobao: 'Ταοβάο Κιάννου',
                    weifeng: 'Γουάιφενγκ',
                },
            },
            columnsManage: {
                text: 'Διαχείριση πεδίου επιθεώρησης ποιότητας',
            },
            customerField: {
                text: 'Πεδίο πελατών',
            },
            speechRecognition: {
                text: 'Αναγνώριση ομιλών',
            },
            user: {
                text: 'Διαχείριση εργαζομένων',
            },
            userGroups: {
                text: 'Διαχείριση των εργαζομένων ομάδων',
            },
            role: {
                text: 'Διαχείριση ρόλων',
            },
            dataMigration: {
                text: 'Μετανάστευση δεδομένων',
            },
            taskCenter: {
                text: 'Κέντρο Αποστολής',
            },
            recordUpload: {
                text: 'Τοπική αποστολή εγγραφής',
            },
            anomalousData: {
                text: 'Μη φυσιολογικά δεδομένα',
            },
            systemLog: {
                text: 'Καταγραφή μηνύματος',
            },
            msgCenter: {
                text: 'Κέντρο μηνύματος',
            },
            wechatDocking: {
                text: 'Επιχειρησιακή μικροποίηση',
            },
        },
        tasks: {
            homePage: {
                text: 'Αρχική σελίδας',
            },
            workbench: {
                text: 'Πάγκος εργασίας',
            },
            semanticIntelligence: {
                text: 'Σημασιολογική νοημοσύνη',
            },
            intelligentAnalysis: {
                text: 'Ευφυής ανάλυση',
            },
            intelligentLabel: {
                text: 'Έξυπνη ετικέταName',
            },
            admin: {
                text: 'Διαχείριση',
            },
            callManage: {
                text: 'Διαχείριση κλήσεων',
            },
            dialogueManage: {
                text: 'Διαχείριση διαλόγου',
            },
            ticketManage: {
                text: 'Διαχείριση εντολών εργασίας',
            },
            dataAnalysis: {
                text: 'Ανάλυση δεδομένων',
            },
            customerService: {
                text: 'Κέντρο Εξυπηρέτησης Πελατών',
            },
            clientCenter: {
                text: 'Κέντρο Πελατών',
            },
            insight: {
                text: 'Insight',
            },
            trainingCenter: {
                text: 'Κέντρο Εκπαίδευσης',
            },
            templates: {
                text: 'Διαχείριση προτύπων',
            },
            wechatQaTasks: {
                text: 'Enterprise WeChat πάγκο εργασίας',
            },
            wechatQaSetting: {
                text: 'Ρύθμιση ανάλυσης WeChat Enterprise',
            },
            wechatQaChartRecord: {
                text: 'Συνεδρία WeChat Enterprise',
            },
            wechatStaffCenter: {
                text: 'Επιχειρησιακό μικρό κέντρο εργαζομένων',
            },
            callAnalysis: {
                text: 'Ανάλυση συζήτησης',
            },
            caseBaseFolder: {
                text: 'Βιβλιοθήκη περίπτωσης',
            },
            coachTask: {
                text: 'Καθήκοντα καθοδήγησης',
            },
            teamAnalysis: {
                text: 'Ανάλυση ομάδας',
            },
            customer: {
                text: 'Κέντρο Πελατών',
            },
            analysisEnable: {
                text: 'Ενίσχυση ανάλυσης',
            },
            analysisHelp: {
                text: 'Ανάλυση βοήθειας',
            },
            analysisStudy: {
                text: 'Ανάλυση μάθησης',
            },
            analysisReview: {
                text: 'Ανάλυση σύνθετου δίσκους',
            },
            analysisTags: {
                text: 'Ανάλυση έξυπνης ετικέτας',
            },
            analysisSentiment: {
                text: 'Ανάλυση της κοινής γνώμης',
            },
            analysisBusiness: {
                text: 'Ανάλυση επιχειρήσεων',
            },
            groupTest: {
                text: 'Δοκιμή ομάδας',
            },
        },
        navBar: {
            billingCenter: 'Κέντρο βοήθειας',
            uploadDownload: 'Αποστολή και Λήψη Κέντρου',
            setting: 'Ρυθμίσεις συστήματος',
        },
    },
    fix: {
        selectType: 'Επιλογή τύπου:',
        all: 'Όλα',
        call: 'Κλήση',
        text: 'Διάλογος',
        wechat: 'Συνεδρία WeChat Enterprise',
        businessTrendAnalysis: 'Ανάλυση επιπέδου 1',
        noEchart: 'Δεν υπάρχουν στοιχεία για το διάγραμμα.',
        checkPointisRequired: 'Απαιτείται ρύθμιση κανόνων',
        voiceDownLoad: 'Λήψη εγγραφής',
        exportTxt: 'Εξαγωγή κειμένου TXT',
        exportWord: 'Εξαγωγή κειμένου λέξης',
        sureReRole: 'Η επιβεβαίωση αντιστρέφει το ρόλο του ομιλητή;',
        sureRecover: 'Επιβεβαίωση επανόρθωσης;',
        sureReAsr: 'Επιβεβαίωση αναγνώρισης;',
        reRole: 'Αντίστροφη ηχεία',
        recover: 'Διόρθωση επανάληψης',
        reAsr: 'Επαναγνωμόνιση',
        recordingOperation: 'Λειτουργία καταγραφής',
        onlySave30Day: '(30 ημέρες μόνο)',
        appealError: 'Παρακαλείσθε να προσφύγετε στο σημείο επιθεώρησης ποιότητας πριν από την υποβολή του.',
        exportToTaskCenter: 'Εξάγη επιτυχώς στο Κέντρο Αποστολής και Λήψης',
        caseBaseLimit: 'Η βιβλιοθήκη κεφαλαίων δεν μπορεί να υπερβαίνει τα 50.',
        unnamed: 'Χωρίς όνομα',
        wordSpeed: 'Λέξη/ελάτη',
        hit: 'Χτύπημα.',
        checkPoint: 'Σημείο επιθεώρησης ποιότητας',
        realTimeAdditionTip1: 'Πρόσθεση σε πραγματικό χρόνο: η επιθεώρηση ποιότητας ξεκινά αμέσως όταν τα δεδομένα εισέρχονται στο σύστημα επιθεώρησης ποιότητας',
        realTimeAdditionTip2: 'Χρονισμός Προσθήκη: Ο χρόνος προσθέτει αυτόματα τα δεδομένα για την ποιότητα επιθεώρησης',
        null: 'Κανένα',
        collcetedProps: 'Πεδία συλλογής',
        editingNameNow: 'Το όνομα επεξεργάζετοι',
        upToFourLevels: 'Ταξινόμηση μέχρι τέσσερα επίπεδα',
        default: 'Προκαθορισμένο',
        nameCantBeNull: 'Το όνομα δεν μπορεί να είναι κενό',
        editingNow: 'Η ενέργεια επεξεργάζεταιName',
        nameError: 'Λάθος όνομαName',
        nameMaxLength8: 'Το μέγιστο μήκος ονόματος είναι 8',
        callTime: 'Ώρα για ομιλία.',
        sentimentValue: 'Αξία συναισθημάτων πελατών',
        agentSentimentValue: 'Αξία συναισθημάτων εξυπηρέτησης πελατών',
        sentimentAnalysis: 'Ανάλυση συναισθημάτων ανάλυσης',
        associatedData: 'Στοιχεία παρακολούθησης των οδών',
        notifyTheOwner: 'Ειδοποίηση του ιδιοκτήτη της ομάδας',
        notifyTheEmployee: 'Ειδοποιήστε τον ίδιο τον υπάλληλο.',
        notifyTheOwnerTip: 'Όταν ο τύπος συνομιλίας είναι ομαδική συνομιλία, ο ιδιοκτήτης της ομάδας θα ενημερωθεί.',
        customNotifyEmployee: 'Ειδικός υπάλληλος κοινοποίησης',
        customNotifyEmployeeTip: 'Εάν ο πυροδότης είναι εργαζόμενος, ο εργαζόμενος στον οποίο ανήκει το μήνυμα θα ειδοποιηθεί.',
        clickToLearnMore: 'Κάντε κλικ για να μάθετε περισσότερα',
        repeatMarkingTip: 'Αυτή η εγγραφή έχει σηματοδοτηθεί από αυτό το σημείο επιθεώρησης ποιότητας, και δεν χρειάζεται να επαναλάβουμε τη σήμανση.',
        successfulEvaluation: 'Αξιολόγηση της επιτυχίας',
        evaluationFailed: 'Αποτυχία αξιολόγησης',
        qualityInspectionScore: 'Βαθμός επιθεώρησης ποιότητας',
        semanticTags: 'Σημασιολογική ετικέτας',
        smartTags: 'Έξυπνη ετικέταName',
        collect: 'Συλλογή πληροφοριών',
        appealRecord: 'Αρχείο Θυμάτων',
        satisfy: 'Ικανοποιημένος',
        notSatisfy: 'Μη ικανοποιημένο',
        appealPlaceHolder: 'Παρακαλείσθε να εισάγετε τον λόγο προσφυγής',
        giveUp: 'Εγκατέλειψα',
        rejectReasonPlaceHolder: 'Παρακαλώ εισάγετε λόγο απόρριψης',
        reject: 'Απορρίφθηκαν',
        changeRejectReason: 'Αναθεώρηση της Λόγου απόρριψης',
        pass: 'Απ\' τον λόγο',
        revise: 'Τροποποίηση',
        machineEvaluation: 'Αξιολόγηση μηχανών',
        poor: 'Φτωχή.',
        excellent: 'Ωραία.',
        moderate: 'Γενικός',
        mustMarked: 'Αυτό το σημείο επιθεώρησης ποιότητας πρέπει να σημειωθεί η επισήμανση',
        pleaseChoose: 'Παρακαλώ επιλέξτε.',
        manualEvaluation: 'Χειροκίνητη αξιολόγηση',
        qualityInspectionTemplate: 'Εφαρμοστέο πρότυπο επιθεώρησης ποιότητας',
        collectionTemplate: 'Εφαρμοστέο πρότυπο Αποκτήσεων',
        keywordsWordCloud: 'Λέξεις-κλειδιά λέξη cloud',
        editCategoryLabel: 'Επεξεργασία ετικέτων κατηγορίας',
        justCall: 'Κοίτα την κλήση.',
        justConversation: 'Κοίτα τον διάλογο.',
        batchOperation: 'Λειτουργία παρτίδας',
        customerServicesGroup: 'Ομάδα εξυπηρέτησης πελατών',
        joinGroup: 'Συμμετοχή ομάδας',
        removeGroup: 'Μετακίνηση εκτός ομάδας',
        enterInformationEntity: 'Παρακαλώ εισάγετε περιεχόμενο της οντότητας πληροφοριών',
        enterNotBeNull: 'Η εισαγωγή δεν μπορεί να είναι κενή',
        operationGroup: 'Ομάδα επιχειρήσεων',
        customerServiceSelected: 'Επιλεγμένη υπηρεσία πελατών',
        callAndConversation: 'Κλήση/Συνομιλία',
        conversation: 'Διάλογος',
        system: 'Σύστημα',
        customize: 'Προσαρμοσμένο',
        effective: 'Αποτελεσματικό',
        invalid: 'Μη έγκυρο',
        successfulAndToTaskCenter: 'Η εκτέλεση είναι επιτυχής, παρακαλώ πηγαίνετε στο κέντρο εργασιών για έλεγχο',
        recalculationFailed: 'Ο επανυπολογισμός απέτυχε',
        selectRecalculatedIndicator: 'Παρακαλώ επιλέξτε τον δείκτη για την επαναφορά',
        source: 'Παρακαλώ επιλέξτε μια πηγή δεδομένων',
        placeholder: 'Παρακαλώ εισάγετε μια λέξη κλειδιά',
        cumulative: 'Σωρευτικός',
        average: 'Μέσος τύπος',
        distribution: 'Δίκαιο διανομής',
        originalDataCannotEmpty: 'Τα ακατέργαστα δεδομένα δεν μπορούν να είναι κενά',
        inspection: 'Επιθεώρηση ποιότητας',
        check: 'Τυχαία επιθεώρηση',
        review: 'Αναθεώρηση',
        draftSavedSuccessfully: 'Το σχέδιο αποθηκεύτηκε με επιτυχία',
        optimization: 'Βελτιστοποίηση',
        agentName: 'Όνομα εξυπηρέτησης πελατών',
        allTasks: 'Όλες οι εργασίες επιθεώρησης ποιότητας',
        datePickerSelect: 'Επιλογή ημερομηνίας',
        callSelect: 'Επιλογή διαλόγου',
        taskSelect: 'Επιλογή εργασίας',
        genReport: 'Δημιουργία αναφοράς',
        dataSource: 'Πηγή δεδομένων',
        callsTotal: 'Σύνολο κλήσεων',
        intelligentQualityInspection: 'Ευφυής επιθεώρηση ποιότητας',
        percentage: 'Ποσοστό',
        artificialSampling: 'Χειροκίνητη δειγματοληψία',
        appealNumber: 'Ποσό καταγγελιών',
        totalConversation: 'Συνολικό ποσό διαλόγου',
        samplingReviewRate: 'Ρυθμός επανεξέτασης άντλησης',
        data: 'Δεδομένα',
        inspectionResults: 'Αποτελέσματα επιθεώρησης ποιότητας',
        inspected: 'Επιθεώρηση ποιότητας',
        totalScore: 'Συνολική βαθμολογία',
        learnMore: 'Δείτε περισσότερα',
        inspectionEffect: 'Αποτέλεσμα επιθεώρησης ποιότητας',
        allTotal: 'Σύνολο',
        manualInspection: 'Χειροκίνητη ανασκόπηση',
        artificialReview: 'Χειροκίνητη ανασκόπηση',
        approvalAmountAndRate: 'Εγκεκριμένη ποσότητα & ποσοστό έγκρισης',
        customerScore: 'Βαθμολογία εξυπηρέτησης πελατών',
        inspectionRecommendations: 'Προτάσεις επιθεώρησης ποιότητας',
        saveDraft: 'Αποθήκευση προσχέδου',
        historicalAdvice: 'Ιστορική συμβουλή',
        advicePlaceHolder: 'Παρακαλώ εισάγετε την πρόταση...',
        upload: 'Αποστολή αρχείου',
        customAdd: 'Προσθήκη φίλτρου',
        advancedConditions: 'Προχωρημένες συνθήκες',
        keyWord: 'Λέξεις-κλειδιά',
        containsAll: 'Περιέχει όλο',
        containsAny: 'Περιέχει όλο',
        matchAny: 'Ταίριασμα οποιασδήποτες',
        matchAll: 'Ταίριασμα όλων',
        smartTagsOne: 'Έξυπνη ετικέτα ένας',
        smartTagsTwo: 'Έξυπνη ετικέτα II',
        season: 'Εποχή',
        month: 'Μήνας',
        week: 'Εβδομάδα',
        day: 'Ημέρα',
        hour: 'Ποτε.',
        notMoreThan366: 'Όχι περισσότερο από 366 ημέρες.',
        propsCannotBeNull: 'Ορισμένα πεδία δεν συμπληρώνονται.',
        other: 'Άλλα',
        correlationCoefficient: 'Συντελεστής συσχέτισης',
        repetitionRate: 'Ρυθμός επανάληψης',
        configurationItemsMoreThan20: 'Προσθήκη έως και 20 αντικειμένων ρυθμίσεων',
        conversionAnalysis: 'Ανάλυση μετατροπής',
        correlationAnalysis: 'Ανάλυση συσχετισμού',
        successfulExportAndToTaskCenter: 'Η εξαγωγή είναι επιτυχής, παρακαλώ μεταβείτε στο κέντρο εργασιών για να δείτε.',
        typeSelect: 'Επιλογή τύπου',
        exportExcel: 'Εξαγωγή Excel',
        exportPng: 'Εξαγωγή png',
        noDataChart: 'Δεν υπάρχουν στοιχεία για το διάγραμμα.',
        placeOperator: 'Παρακαλώ επιλέξτε μια έξυπνη ετικέτα.',
        placeAdvancedConditions: 'Παρακαλώ επιλέξτε προηγμένα κριτήρια',
        createAdvancedConditions: 'Νέο προηγμένο φίλτρο',
        moveUp: 'Μετακίνηση πάνω',
        moveDown: 'Μετακίνηση προς τα κάτι',
        moveLeft: 'Μετακίνηση αριστερά',
        moveRight: 'Μετακίνηση δεξιά',
        statusChangeSuccess: 'Κατάσταση τροποποιήθηκε με επιτυχία',
        editSuccess: 'Επιτυχία τροποποίησης',
        saveSuccess: 'Αποθήκευση με επιτυχία',
        firstPage: 'Αρχική σελίδας',
        lastPage: 'Σελίδα ουράς',
        customerInfo: 'Πληροφορίες πελατών',
        type: 'Τύπος',
        NumberTypeErrorMessage: 'Το περιεχόμενο πληροφοριών πεδίου του τύπου αριθμού μπορεί να περιέχει μόνο αριθμούς ή "."',
        taskStartPrompt: 'Άνοιγμα εργασιών',
        startConfirm: 'Παρακαλώ κάντε κλικ στο κουμπί επιβεβαίωσης για να ανοίξετε την εργασία επιθεώρησης ποιότητας',
        continueToSubmitWithoutEvaluation: 'Συνέχιση της υποβολής χωρίς αξιολόγηση',
        rejectTip: 'Δεν εντοπίστηκαν ενέργειες αλλαγής, είστε σίγουροι ότι θα απορρίψετε όλες τις προσφυγές απευθείας;',
        unmarkedSelfLearningTip: 'Έχετε μη σηματοδοτημένα σημεία επιθεώρησης αυτο-μαθητείας',
        markedSuccessfully: 'Επιτυχία επισήμανσης',
        markingFailed: 'Η επισήμανση απέτυχε',
        exceedingLength: 'Που υπερβαίνει το μήκος',
        uncategorized: 'Μη ταξινόμηση',
        addSuccess: 'Νέα Επιτυχία',
        deleteSuccess: 'Διαγραφή με επιτυχία',
        featureName: 'Όνομα στοιχείου',
        informationEntity: 'Φορέας πληροφορίας',
        standardAnswer: 'Τυπική απάντηση',
        keyElementAnswer: 'Απάντηση',
        generalStatement: 'ΓΕΝΙΚΗ ΚΑΤΑΣΤΑΣΗ (όχι ASK)',
        generalQuestionsAndConfirmation: 'Γενικές ερωτήσεις και επιβεβαίωση',
        specialQuestionsAndAnswers: 'Ειδικές Ερωτήσεις και Απαντήσεις',
        agent: 'Υπηρεσία πελατών',
        customer: 'Πελάτη',
        semanticTagsAndInformationEntitiesCannotBeEmpty: 'Το βασικό σημασιολογικό στοιχείο και η οντότητα πληροφοριών δεν μπορεί να είναι κενή ταυτόχρονα',
        standardSentence: 'Τυποποιημένη φράση',
        acquaintance: 'Γνωριμία.',
        smartUePlaceholder: 'Παρακαλώ εισάγετε ένα έξυπνο όνομα αλληλεπίδρασης',
        typeSelectPlaceholder: 'Παρακαλώ επιλέξτε τύπος',
        keyElement: 'Βασικά στοιχεία',
        reQuerySementicTags: 'Επαναεπιλογή σημασιολογικών ετικετών',
        querySementicTags: 'Επιλογή σημασιολογικής ετικέτας',
        QATestForm: 'Έντυπο ανίχνευσης ερωτήσεων και απάντησης',
        selectNotBeNull: 'Η επιλογή δεν μπορεί να είναι κενή',
        featureDetectionTarget: 'Στόχος ανίχνευσης στοιχείων',
        categorized: 'Ταξινόμηση',
        effectiveness: 'Αποτελεσματικότητα',
        hideAdvancedSettings: 'Απόκρυψη προηγμένων ρυθμίσεων',
        showAdvancedSettings: 'Εμφάνιση προηγμένων ρυθμίσεων',
        generalStatementOnly: 'ΓΕΝΙΚΗ ΚΑΤΑΣΤΑΣΗ',
        generalQuestions: 'Γενικές ερωτήσεις',
        affirmativeExpression: 'Θετική έκφραση',
        negativeIntention: 'Αρνητική πρόθεση',
        searchSementicTags: 'Ερωτήσεις',
        choiceQuestion: 'Επιλεκτική ερωτηματική φράση',
        selectiveAnswer: 'Τύπος επιλογής απάντησης',
        sementicTagsPlaceholder: 'Παρακαλώ εισάγετε περιεχόμενο σημασιολογικής ετικέτας',
        openSpecialQuestion: 'Ανοίξτε Ειδικές Ερωτήσεις',
        openAnswer: 'Ανοιχτή απάντηση.',
        customQA: 'Προσαρμοσμένες ερωτήσεις & A',
        questions: 'Μέθοδος ζήτησης',
        dataPlaceholder: 'Παρακαλώ εισάγετε περιεχόμενο',
        reply: 'Απάντηση',
        notFindSuitableLabel: 'Δεν βρέθηκε κατάλληλη ετικέτα.',
        addSemanticTag: 'Προσθήκη μιας νέας σημασιολογικής ετικέτας',
        intelligentInteraction: 'Ευφυής αλληλεπίδρασης',
        matching: 'Ταίριασμα',
        bout: 'Χρόνια',
        keywordMatch: 'Ταιριάζουν λέξη κλειδιά',
        addFilterConditions: 'Προσθήκη κατάστασης φίλτρου',
        buttonStartCollectionTask: 'Παρακαλώ κάντε κλικ στο κουμπί OK για να ξεκινήσετε την εργασία συλλογής',
        buttonStartTask: 'Παρακαλώ κάντε κλικ στο κουμπί OK για να ανοίξετε την εργασία επιθεώρησης ποιότητας',
        ruleConfigurationIsRequired: 'Απαιτείται ρύθμιση κανόνων',
        asrRunning: 'Εκτέλεση ASR',
        errorCorrectionExecution: 'Εκτέλεση διόρθωσης σφάλματος',
        emotionalVolumeRecognition: 'Αναγνώριση όγκου του συναισθήματος',
        dataPreprocessing: 'Προεπεξεργασία δεδομένων',
        inspectionExecution: 'Εκτέλεση ποιοτικού ελέγχου',
        businessId: 'Αναγνώριση επαγγελματικής κατάστασηςName',
        businessTime: 'Χρόνος επαγγελματίας',
        createTime: 'Χρόνος δημιουργίας',
        abnormalReason: 'Μη φυσιολογικός λόγος',
        singleChat: 'Ενιαία συνομιλία',
        groupChat: 'Ομάδα συνομιλία',
        taskContent: 'Περιεχόμενο εργασίας',
        submissionTime: 'Χρόνος υποβολής',
        startTime: 'Ώρα έναρξης',
        endTime: 'Τέλος χρόνου',
        runningTime: 'Πράξη χρονοβόρου',
        totalAmountOfData: 'Συνολικός όγκος δεδομένων',
        resultsOfThe: 'Αποτελέσματα εκτέλεσης',
        operator: 'Αερομεταφορέας',
        taskDetails: 'Λεπτομέρειες εργασίας',
        executiveFunction: 'Εκτελεστική λειτουργία',
        qualityCheckTasks: 'Εργασία επιθεώρησης',
        implementationDetails: 'Λεπτομέρειες εκτέλεσης',
        conditionalRules: 'Κανόνες κατάστασης',
        smartCondition: 'Έξυπνες συνθήκες',
        goThis: 'Μετακίνηση σε αυτόν',
        pleaseMarkClassification: 'Σημειώστε την κατάταξη',
        advancedScreening: 'Προχωρημένη φιλτράριση',
        noDataToManipulate: 'Κανένα δεδομένο για χειρισμό',
        concept: 'Λέξεις έννοιας',
        checkPoint1: 'Ρυθμίσεις κανόνας',
        requiredFieldsCannotEmpty: 'Το απαιτούμενο αντικείμενο δεν μπορεί να είναι κενό',
        rule: 'Κανόνες',
        afterFixUnit: 'Λόγο',
        unmarkedSelfLearningPointsTip: 'Έχετε μη σηματοδοτημένα σημεία επιθεώρησης αυτο-μαθητείας',
        onlyReservedFor7Days: '(7 μόνο ημέρες)',
        downloadError: 'Αποτυχία λήψης',
        pause: 'Παύση',
        continue: 'Συνέχεια',
        recalcScore: 'Μόνο εκ νέου υπολογίστε τις βαθμολογίες (με αξιολογήσεις)',
        recalculatePointsAndScores: 'Επαναλογήστε τα σημεία επιθεώρησης ποιότητας και βαθμολογίας',
        recalculatePointsAndScoresWithEmtry: 'Επαναλογήστε τα σημεία επιθεώρησης ποιότητας και τις βαθμολογίες (τα σημεία επιθεώρησης ποιότητας είναι κενά)',
        inProgress: 'Σε εξέλιξη.',
        toBeExecuted: 'Εφαρμόζεται.',
        executeImmediately: 'Άμεση εκτέλεση',
        specialElements: 'Ειδικά στοιχεία',
        logicRule: 'Λογικοί κανόνες',
        every: 'Πολλαπλά αγώνες',
        hitRecall: 'Πατήστε λέξη ανακοίνωσης',
        notHitRecall: 'Αποτυχημένη λέξη ανακαλύψεων',
        hitRecallRegular: 'Χτυπήστε τακτική ανάκληση ανάκλησης',
        notHitRecallRegular: 'Αποτυχία κανονικής',
        hitRule: 'Κανόνες',
        notHitRule: 'Αποτυχία κανόνας',
        hitSimilarSentence: 'Χτύπησε παρόμοιες προτάσεις.',
        notHitSimilarSentence: 'Παρόμοιες προτάσεις',
        hitExcludeSimilarSentences: 'Χτύπημα για να αποκλείσει παρόμοιες προτάσεις',
        notHitExcludeSimilarSentences: 'Αστόχησε για να αποκλείσει παρόμοιες προτάσεις.',
        updateSuccess: 'Επιτυχία ενημέρωσης',
        qualify: 'Τακτικός',
        recallKeyWord: 'Ανάκληση λέξεων-κλειδιών',
        grammar: 'Κανόνες γραμματικής',
    },
    api: {
        putTypoDatasByIdStatusByStatus: 'Αποτυχία αλλαγής ισχύος, παρακαλώ προσπαθήστε ξανά',
        postAutoMateTasksCaseByTaskId: 'Αποτυχία αποθήκευσης ρυθμίσεων συγχρονισμού της βιβλιοθήκης περίπτωσης',
        getAutoMateTasksCaseByTaskId: 'Αποτυχία λήψης ρυθμίσεων συγχρονισμού της βιβλιοθήκης περίπτωσης',
        postInspectionRemarkModelConfigs: 'Αποτυχία αποθήκευσης πρότυπου σχολίου',
        putInspectionRemarkModelConfigsById: 'Αποτυχία αποθήκευσης πρότυπου σχολίου',
        getInspectionRemarkModelConfigsById: 'Αποτυχία λήψης δεδομένων προτύπου σχολίου',
        postKnowledgeDatas: 'Η δημιουργία βάσης γνώσεων απέτυχε, παρακαλώ προσπαθήστε ξανά',
        putKnowledgeDatasById: 'Αποτυχία τροποποίησης του αποθετηρίου, παρακαλώ προσπαθήστε ξανά',
        getLibraryFiles: 'Αποτυχία λήψης της λίστας των φακέλων τιμών.',
        getLibraryCalls: 'Αποτυχία λήψης αρχείου',
        getLibraryFilesSearch: 'Η αναζήτηση απέτυχε',
        putLibraryFilesMoveById: 'Αποτυχία μετακίνησης του φακέλου τιμής.',
        putLibraryCallsById: 'Η μετονομασία του αρχείου απέτυχε!',
        postLibraryFiles: 'Αποτυχία προσθήκης φακέλου',
        putLibraryFilesById: 'Η μετονομασία του φακέλου απέτυχε',
        deleteLibraryFilesById: 'Η διαγραφή απέτυχε',
        deleteLibraryCallsById: 'Η διαγραφή απέτυχε',
        postLibraryCalls: 'Αποτυχία προσθήκης',
        getVoiceUploadResultById: 'Η εξαγωγή αποστολής απέτυχε',
    },
};